import { jsx as A, jsxs as J, Fragment as Ct } from "react/jsx-runtime";
import * as K from "react";
import S, { useRef as An, useEffect as Sa, forwardRef as bs, createElement as Bi, useMemo as xs, useState as Vt, isValidElement as Pt, Children as Br, PureComponent as bt, useImperativeHandle as ZA, useCallback as JA, cloneElement as De, useContext as nr, createContext as Jr, Component as Xw, Fragment as QA } from "react";
import * as Je from "@radix-ui/react-alert-dialog";
import * as ti from "@radix-ui/react-avatar";
import * as xd from "@radix-ui/react-checkbox";
import * as lt from "@radix-ui/react-dialog";
import * as ft from "@radix-ui/react-dropdown-menu";
import { Slot as eP } from "@radix-ui/react-slot";
import * as Zw from "@radix-ui/react-label";
import * as Pn from "@radix-ui/react-popover";
import * as Fi from "@radix-ui/react-radio-group";
import * as Fr from "@radix-ui/react-scroll-area";
import * as rt from "@radix-ui/react-select";
import * as Jw from "@radix-ui/react-separator";
import * as wd from "@radix-ui/react-switch";
import * as Qr from "@radix-ui/react-tabs";
import * as Aa from "@radix-ui/react-tooltip";
function Qw(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (r = Qw(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function ue() {
  for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = Qw(e)) && (n && (n += " "), n += t);
  return n;
}
const Yp = "-", tP = (e) => {
  const t = nP(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (o) => {
      const s = o.split(Yp);
      return s[0] === "" && s.length !== 1 && s.shift(), e1(s, t) || rP(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const u = r[o] || [];
      return s && n[o] ? [...u, ...n[o]] : u;
    }
  };
}, e1 = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), i = n ? e1(e.slice(1), n) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const a = e.join(Yp);
  return t.validators.find(({
    validator: o
  }) => o(a))?.classGroupId;
}, bv = /^\[(.+)\]$/, rP = (e) => {
  if (bv.test(e)) {
    const t = bv.exec(e)[1], r = t?.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, nP = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return aP(Object.entries(e.classGroups), r).forEach(([a, o]) => {
    Od(o, n, a, t);
  }), n;
}, Od = (e, t, r, n) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const a = i === "" ? t : xv(t, i);
      a.classGroupId = r;
      return;
    }
    if (typeof i == "function") {
      if (iP(i)) {
        Od(i(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: r
      });
      return;
    }
    Object.entries(i).forEach(([a, o]) => {
      Od(o, xv(t, a), r, n);
    });
  });
}, xv = (e, t) => {
  let r = e;
  return t.split(Yp).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, iP = (e) => e.isThemeGetter, aP = (e, t) => t ? e.map(([r, n]) => {
  const i = n.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([o, s]) => [t + o, s])) : a);
  return [r, i];
}) : e, oP = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const i = (a, o) => {
    r.set(a, o), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let o = r.get(a);
      if (o !== void 0)
        return o;
      if ((o = n.get(a)) !== void 0)
        return i(a, o), o;
    },
    set(a, o) {
      r.has(a) ? r.set(a, o) : i(a, o);
    }
  };
}, t1 = "!", sP = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, i = t[0], a = t.length, o = (s) => {
    const u = [];
    let c = 0, l = 0, f;
    for (let h = 0; h < s.length; h++) {
      let g = s[h];
      if (c === 0) {
        if (g === i && (n || s.slice(h, h + a) === t)) {
          u.push(s.slice(l, h)), l = h + a;
          continue;
        }
        if (g === "/") {
          f = h;
          continue;
        }
      }
      g === "[" ? c++ : g === "]" && c--;
    }
    const d = u.length === 0 ? s : s.substring(l), p = d.startsWith(t1), m = p ? d.substring(1) : d, v = f && f > l ? f - l : void 0;
    return {
      modifiers: u,
      hasImportantModifier: p,
      baseClassName: m,
      maybePostfixModifierPosition: v
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: o
  }) : o;
}, uP = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, cP = (e) => ({
  cache: oP(e.cacheSize),
  parseClassName: sP(e),
  ...tP(e)
}), lP = /\s+/, fP = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: i
  } = t, a = [], o = e.trim().split(lP);
  let s = "";
  for (let u = o.length - 1; u >= 0; u -= 1) {
    const c = o[u], {
      modifiers: l,
      hasImportantModifier: f,
      baseClassName: d,
      maybePostfixModifierPosition: p
    } = r(c);
    let m = !!p, v = n(m ? d.substring(0, p) : d);
    if (!v) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (v = n(d), !v) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const h = uP(l).join(":"), g = f ? h + t1 : h, b = g + v;
    if (a.includes(b))
      continue;
    a.push(b);
    const w = i(v, m);
    for (let O = 0; O < w.length; ++O) {
      const y = w[O];
      a.push(g + y);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function dP() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = r1(t)) && (n && (n += " "), n += r);
  return n;
}
const r1 = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = r1(e[n])) && (r && (r += " "), r += t);
  return r;
};
function pP(e, ...t) {
  let r, n, i, a = o;
  function o(u) {
    const c = t.reduce((l, f) => f(l), e());
    return r = cP(c), n = r.cache.get, i = r.cache.set, a = s, s(u);
  }
  function s(u) {
    const c = n(u);
    if (c)
      return c;
    const l = fP(u, r);
    return i(u, l), l;
  }
  return function() {
    return a(dP.apply(null, arguments));
  };
}
const Pe = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, n1 = /^\[(?:([a-z-]+):)?(.+)\]$/i, hP = /^\d+\/\d+$/, vP = /* @__PURE__ */ new Set(["px", "full", "screen"]), yP = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, mP = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, gP = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, bP = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, xP = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Wt = (e) => bn(e) || vP.has(e) || hP.test(e), lr = (e) => ri(e, "length", EP), bn = (e) => !!e && !Number.isNaN(Number(e)), lu = (e) => ri(e, "number", bn), pi = (e) => !!e && Number.isInteger(Number(e)), wP = (e) => e.endsWith("%") && bn(e.slice(0, -1)), ce = (e) => n1.test(e), fr = (e) => yP.test(e), OP = /* @__PURE__ */ new Set(["length", "size", "percentage"]), _P = (e) => ri(e, OP, i1), SP = (e) => ri(e, "position", i1), AP = /* @__PURE__ */ new Set(["image", "url"]), PP = (e) => ri(e, AP, MP), TP = (e) => ri(e, "", CP), hi = () => !0, ri = (e, t, r) => {
  const n = n1.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, EP = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  mP.test(e) && !gP.test(e)
), i1 = () => !1, CP = (e) => bP.test(e), MP = (e) => xP.test(e), jP = () => {
  const e = Pe("colors"), t = Pe("spacing"), r = Pe("blur"), n = Pe("brightness"), i = Pe("borderColor"), a = Pe("borderRadius"), o = Pe("borderSpacing"), s = Pe("borderWidth"), u = Pe("contrast"), c = Pe("grayscale"), l = Pe("hueRotate"), f = Pe("invert"), d = Pe("gap"), p = Pe("gradientColorStops"), m = Pe("gradientColorStopPositions"), v = Pe("inset"), h = Pe("margin"), g = Pe("opacity"), b = Pe("padding"), w = Pe("saturate"), O = Pe("scale"), y = Pe("sepia"), x = Pe("skew"), _ = Pe("space"), P = Pe("translate"), E = () => ["auto", "contain", "none"], M = () => ["auto", "hidden", "clip", "visible", "scroll"], C = () => ["auto", ce, t], T = () => [ce, t], k = () => ["", Wt, lr], N = () => ["auto", bn, ce], I = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], R = () => ["solid", "dashed", "dotted", "double", "none"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], W = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], H = () => ["", "0", ce], $ = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], L = () => [bn, ce];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [hi],
      spacing: [Wt, lr],
      blur: ["none", "", fr, ce],
      brightness: L(),
      borderColor: [e],
      borderRadius: ["none", "", "full", fr, ce],
      borderSpacing: T(),
      borderWidth: k(),
      contrast: L(),
      grayscale: H(),
      hueRotate: L(),
      invert: H(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [wP, lr],
      inset: C(),
      margin: C(),
      opacity: L(),
      padding: T(),
      saturate: L(),
      scale: L(),
      sepia: H(),
      skew: L(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ce]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [fr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...I(), ce]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", pi, ce]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: C()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ce]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: H()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: H()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", pi, ce]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [hi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", pi, ce]
        }, ce]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": N()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": N()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [hi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [pi, ce]
        }, ce]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": N()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": N()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ce]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ce]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...W()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...W(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...W(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [h]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [h]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [h]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [h]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [h]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [h]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [h]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [h]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [h]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [_]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [_]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ce, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ce, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ce, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [fr]
        }, fr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ce, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ce, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ce, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ce, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", fr, lr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", lu]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [hi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ce]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", bn, lu]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Wt, ce]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ce]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ce]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...R(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Wt, lr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Wt, ce]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ce]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ce]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...I(), SP]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", _P]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, PP]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...R(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: R()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...R()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Wt, ce]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Wt, lr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: k()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Wt, lr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", fr, TP]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [hi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", fr, ce]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [l]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [y]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [l]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [y]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ce]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: L()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ce]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: L()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ce]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [O]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [O]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [O]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [pi, ce]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [x]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [x]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ce]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ce]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ce]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Wt, lr, lu]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, kP = /* @__PURE__ */ pP(jP);
function z(...e) {
  return kP(ue(e));
}
const $P = (e, t) => t.reduce(
  (r, n) => r && typeof r == "object" ? r[n] : void 0,
  e
), jz = (e, t, r) => {
  const n = Array.isArray(t) ? t : t.replace(/(\w)\[/g, "$1.[").split(".").map((a) => a.includes("[") ? parseInt(a.substring(1, a.length - 1), 10) : a);
  let i = e;
  for (let a = 0; a < n.length; a++) {
    const o = n[a], s = n[a + 1], u = i;
    typeof s < "u" ? u[o] = u[o] ?? (typeof s == "number" || /^\d+$/.test(String(s)) ? [] : {}) : u[o] = r, i = u[o];
  }
  return e;
}, NP = (e, t) => {
  const r = /* @__PURE__ */ new Set();
  return e.filter((n) => {
    const i = t(n);
    return r.has(i) ? !1 : (r.add(i), !0);
  });
}, kz = (e) => (t, ...r) => (t.preventDefault(), e?.(t, ...r)), $z = (e) => (t, ...r) => (t.stopPropagation(), e?.(t, ...r));
function IP(e, { rootMargin: t = "100px", threshold: r = 0.1, enabled: n = !0 } = {}) {
  const i = An(null), a = An(e);
  return a.current = e, Sa(() => {
    const o = i.current;
    if (!o || !n) return;
    const s = new IntersectionObserver(
      (u) => {
        const [c] = u;
        c?.isIntersecting && a.current();
      },
      { rootMargin: t, threshold: r }
    );
    return s.observe(o), () => {
      s.unobserve(o), s.disconnect();
    };
  }, [t, r, n]), i;
}
const wv = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ov = ue, Xp = (e, t) => (r) => {
  var n;
  if (t?.variants == null) return Ov(e, r?.class, r?.className);
  const { variants: i, defaultVariants: a } = t, o = Object.keys(i).map((c) => {
    const l = r?.[c], f = a?.[c];
    if (l === null) return null;
    const d = wv(l) || wv(f);
    return i[c][d];
  }), s = r && Object.entries(r).reduce((c, l) => {
    let [f, d] = l;
    return d === void 0 || (c[f] = d), c;
  }, {}), u = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((c, l) => {
    let { class: f, className: d, ...p } = l;
    return Object.entries(p).every((m) => {
      let [v, h] = m;
      return Array.isArray(h) ? h.includes({
        ...a,
        ...s
      }[v]) : {
        ...a,
        ...s
      }[v] === h;
    }) ? [
      ...c,
      f,
      d
    ] : c;
  }, []);
  return Ov(e, o, u, r?.class, r?.className);
}, Pa = Xp(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-button text-center text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:opacity-90 shadow",
        destructive: "bg-destructive text-destructive-foreground hover:opacity-90",
        outline: "border border-input bg-background hover:bg-surface hover:text-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:opacity-90",
        ghost: "hover:bg-surface hover:text-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-11 px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RP = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), a1 = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim();
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var DP = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LP = bs(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: i = "",
    children: a,
    iconNode: o,
    ...s
  }, u) => Bi(
    "svg",
    {
      ref: u,
      ...DP,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: a1("lucide", i),
      ...s
    },
    [
      ...o.map(([c, l]) => Bi(c, l)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xt = (e, t) => {
  const r = bs(
    ({ className: n, ...i }, a) => Bi(LP, {
      ref: a,
      iconNode: t,
      className: a1(`lucide-${RP(e)}`, n),
      ...i
    })
  );
  return r.displayName = `${e}`, r;
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o1 = xt("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s1 = xt("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qP = xt("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u1 = xt("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BP = xt("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FP = xt("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zP = xt("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WP = xt("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c1 = xt("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UP = xt("Loader", [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GP = xt("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zp = xt("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), lo = lt.Root, _v = lt.Trigger, fo = lt.Portal, Sv = lt.Close, zi = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  lt.Overlay,
  {
    ref: r,
    className: z(
      "fixed inset-0 z-50 bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
zi.displayName = lt.Overlay.displayName;
const Wi = K.forwardRef(({ className: e, children: t, showCloseButton: r = !0, ...n }, i) => /* @__PURE__ */ J(fo, { children: [
  /* @__PURE__ */ A(zi, {}),
  /* @__PURE__ */ J(
    lt.Content,
    {
      ref: i,
      className: z(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-surface p-6 shadow-lg sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        r && /* @__PURE__ */ J(lt.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none", children: [
          /* @__PURE__ */ A(Zp, { className: "h-4 w-4" }),
          /* @__PURE__ */ A("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Wi.displayName = lt.Content.displayName;
const po = ({ className: e, ...t }) => /* @__PURE__ */ A(
  "div",
  {
    className: z("flex flex-col space-y-1.5 text-center sm:text-left", e),
    ...t
  }
);
po.displayName = "DialogHeader";
const xn = ({ className: e, ...t }) => /* @__PURE__ */ A(
  "div",
  {
    className: z(
      "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
      e
    ),
    ...t
  }
);
xn.displayName = "DialogFooter";
const ho = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  lt.Title,
  {
    ref: r,
    className: z("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
ho.displayName = lt.Title.displayName;
const _d = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  lt.Description,
  {
    ref: r,
    className: z("text-sm text-muted-foreground", e),
    ...t
  }
));
_d.displayName = lt.Description.displayName;
const HP = Je.Root, VP = Je.Trigger, l1 = Je.Portal, Jp = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Je.Overlay,
  {
    className: z(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80",
      e
    ),
    ...t,
    ref: r
  }
));
Jp.displayName = Je.Overlay.displayName;
const f1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ J(l1, { children: [
  /* @__PURE__ */ A(Jp, {}),
  /* @__PURE__ */ A(
    Je.Content,
    {
      ref: r,
      className: z(
        "bg-background fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
f1.displayName = Je.Content.displayName;
const KP = ({
  className: e,
  ...t
}) => /* @__PURE__ */ A(
  "div",
  {
    className: z(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
), d1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Je.Title,
  {
    ref: r,
    className: z("text-lg font-semibold", e),
    ...t
  }
));
d1.displayName = Je.Title.displayName;
const p1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Je.Description,
  {
    ref: r,
    className: z("text-muted-foreground text-sm", e),
    ...t
  }
));
p1.displayName = Je.Description.displayName;
const h1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Je.Action,
  {
    ref: r,
    className: z(Pa(), e),
    ...t
  }
));
h1.displayName = Je.Action.displayName;
const v1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Je.Cancel,
  {
    ref: r,
    className: z(
      Pa({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
v1.displayName = Je.Cancel.displayName;
const y1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  ti.Root,
  {
    ref: r,
    className: z(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
y1.displayName = ti.Root.displayName;
const m1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  ti.Image,
  {
    ref: r,
    className: z("aspect-square h-full w-full", e),
    ...t
  }
));
m1.displayName = ti.Image.displayName;
const g1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  ti.Fallback,
  {
    ref: r,
    className: z(
      "bg-surface flex h-full w-full items-center justify-center rounded-full",
      e
    ),
    ...t
  }
));
g1.displayName = ti.Fallback.displayName;
const Qp = Xp(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        success: "border-transparent bg-success text-success-foreground",
        warning: "border-transparent bg-warning text-warning-foreground"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
function YP({ className: e, variant: t, ...r }) {
  return /* @__PURE__ */ A("div", { className: z(Qp({ variant: t }), e), ...r });
}
const b1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "div",
  {
    ref: r,
    className: z(
      "bg-surface text-muted-foreground rounded-lg border shadow-sm",
      e
    ),
    ...t
  }
));
b1.displayName = "Card";
const x1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "div",
  {
    ref: r,
    className: z("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
x1.displayName = "CardHeader";
const w1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "h3",
  {
    ref: r,
    className: z(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
w1.displayName = "CardTitle";
const O1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "p",
  {
    ref: r,
    className: z("text-muted-foreground text-sm", e),
    ...t
  }
));
O1.displayName = "CardDescription";
const _1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A("div", { ref: r, className: z("p-6 pt-0", e), ...t }));
_1.displayName = "CardContent";
const S1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "div",
  {
    ref: r,
    className: z("flex items-center p-6 pt-0", e),
    ...t
  }
));
S1.displayName = "CardFooter";
const A1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  xd.Root,
  {
    ref: r,
    className: z(
      "border-primary ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground peer h-4 w-4 shrink-0 rounded-sm border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ A(
      xd.Indicator,
      {
        className: z("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ A(o1, { className: "h-4 w-4" })
      }
    )
  }
));
A1.displayName = xd.Root.displayName;
const Tt = K.forwardRef(
  ({
    loading: e = !1,
    variant: t = "default",
    size: r,
    className: n = "",
    disabled: i = !1,
    action: a,
    title: o = "",
    children: s,
    loadingText: u,
    loadingContent: c,
    spinnerOnlyOnLoading: l = !1,
    compact: f = !1,
    type: d = "button",
    newTab: p = !1,
    onClick: m,
    ...v
  }, h) => {
    const [g, b] = K.useState(!1), w = e || g, y = t === "unstyled" ? n : z(
      Pa({
        variant: t,
        size: r ?? (f ? "sm" : "default")
      }),
      n
    ), x = u ?? c ?? s, _ = !w || !l, P = /* @__PURE__ */ J(Ct, { children: [
      w && /* @__PURE__ */ A(
        c1,
        {
          className: z("h-4 w-4 animate-spin", _ && "mr-2")
        }
      ),
      _ && (w ? x : s)
    ] });
    if (typeof a == "string")
      return /* @__PURE__ */ A(
        "a",
        {
          ref: h,
          title: o,
          href: a,
          target: p ? "_blank" : void 0,
          rel: p ? "noopener noreferrer" : void 0,
          className: y,
          onClick: (C) => {
            m?.(C), !C.defaultPrevented && (C.stopPropagation(), (i || w) && C.preventDefault());
          },
          ...v,
          children: P
        }
      );
    const E = a;
    return /* @__PURE__ */ A(
      "button",
      {
        ref: h,
        type: d,
        title: o,
        disabled: i || w,
        className: y,
        onClick: async (M) => {
          if (m?.(M), !(M.defaultPrevented || typeof E != "function")) {
            M.stopPropagation(), M.preventDefault(), b(!0);
            try {
              await E();
            } finally {
              b(!1);
            }
          }
        },
        ...v,
        children: P
      }
    );
  }
);
Tt.displayName = "Button";
function Nz({ icon: e, iconSize: t, ...r }) {
  return /* @__PURE__ */ A(Tt, { ...r, children: /* @__PURE__ */ A(e, { size: t }) });
}
function Iz({ text: e, ...t }) {
  return /* @__PURE__ */ A(Tt, { ...t, children: e });
}
const XP = ({
  actionLabel: e,
  onAction: t,
  cancelLabel: r,
  onCancel: n,
  actionVariant: i = "default",
  disabled: a,
  className: o
}) => /* @__PURE__ */ J(xn, { className: o, children: [
  r != null && n != null ? /* @__PURE__ */ A(Tt, { variant: "outline", action: n, children: r }) : null,
  /* @__PURE__ */ A(Tt, { variant: i, action: t, disabled: a, children: e })
] }), eh = ft.Root, th = ft.Trigger, ZP = ft.Group, JP = ft.Portal, ws = K.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ A(ft.Portal, { children: /* @__PURE__ */ A(
  ft.Content,
  {
    ref: n,
    sideOffset: t,
    className: z(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      e
    ),
    ...r
  }
) }));
ws.displayName = ft.Content.displayName;
const P1 = K.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ A(
  ft.Item,
  {
    ref: n,
    className: z(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r
  }
));
P1.displayName = ft.Item.displayName;
const T1 = K.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ A(
  ft.Label,
  {
    ref: n,
    className: z("px-2 py-1.5 text-sm font-semibold", t && "pl-8", e),
    ...r
  }
));
T1.displayName = ft.Label.displayName;
const E1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  ft.Separator,
  {
    ref: r,
    className: z("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
E1.displayName = ft.Separator.displayName;
var QP = (e) => e.type === "checkbox", Ti = (e) => e instanceof Date, rh = (e) => e == null;
const C1 = (e) => typeof e == "object";
var Gr = (e) => !rh(e) && !Array.isArray(e) && C1(e) && !Ti(e), eT = (e) => Gr(e) && e.target ? QP(e.target) ? e.target.checked : e.target.value : e, tT = (e, t) => t.split(".").some((r, n, i) => !isNaN(Number(r)) && e.has(i.slice(0, n).join("."))), rT = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Gr(t) && t.hasOwnProperty("isPrototypeOf");
}, nT = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function M1(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (nT && (e instanceof Blob || t))
    return e;
  const r = Array.isArray(e);
  if (!r && !(Gr(e) && rT(e)))
    return e;
  const n = r ? [] : Object.create(Object.getPrototypeOf(e));
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (n[i] = M1(e[i]));
  return n;
}
var j1 = (e) => /^\w*$/.test(e), Sd = (e) => e === void 0, iT = (e) => Array.isArray(e) ? e.filter(Boolean) : [], k1 = (e) => iT(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qe = (e, t, r) => {
  if (!t || !Gr(e))
    return r;
  const i = (j1(t) ? [t] : k1(t)).reduce((a, o) => rh(a) ? void 0 : a[o], e);
  return Sd(i) || i === e ? Sd(e[t]) ? r : e[t] : i;
}, fu = (e) => typeof e == "boolean", La = (e) => typeof e == "function", Av = (e, t, r) => {
  let n = -1;
  const i = j1(t) ? [t] : k1(t), a = i.length, o = a - 1;
  for (; ++n < a; ) {
    const s = i[n];
    let u = r;
    if (n !== o) {
      const c = e[s];
      u = Gr(c) || Array.isArray(c) ? c : isNaN(+i[n + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = u, e = e[s];
  }
};
const Pv = {
  BLUR: "blur",
  CHANGE: "change"
}, Tv = {
  all: "all"
}, nh = S.createContext(null);
nh.displayName = "HookFormControlContext";
const ih = () => S.useContext(nh);
var aT = (e, t, r, n = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(i, a, {
      get: () => {
        const o = a;
        return t._proxyFormState[o] !== Tv.all && (t._proxyFormState[o] = !n || Tv.all), r && (r[o] = !0), e[o];
      }
    });
  return i;
};
const $1 = typeof window < "u" ? S.useLayoutEffect : S.useEffect;
function oT(e) {
  const t = ih(), { control: r = t, disabled: n, name: i, exact: a } = e || {}, [o, s] = S.useState(r._formState), u = S.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return $1(() => r._subscribe({
    name: i,
    formState: u.current,
    exact: a,
    callback: (c) => {
      !n && s({
        ...r._formState,
        ...c
      });
    }
  }), [i, n, a]), S.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), S.useMemo(() => aT(o, r, u.current, !1), [o, r]);
}
var sT = (e) => typeof e == "string", Ev = (e, t, r, n, i) => sT(e) ? Qe(r, e, i) : Array.isArray(e) ? e.map((a) => Qe(r, a)) : r, Cv = (e) => rh(e) || !C1(e);
function uo(e, t, r = /* @__PURE__ */ new WeakSet()) {
  if (e === t)
    return !0;
  if (Cv(e) || Cv(t))
    return Object.is(e, t);
  if (Ti(e) && Ti(t))
    return Object.is(e.getTime(), t.getTime());
  const n = Object.keys(e), i = Object.keys(t);
  if (n.length !== i.length)
    return !1;
  if (r.has(e) || r.has(t))
    return !0;
  r.add(e), r.add(t);
  for (const a of n) {
    const o = e[a];
    if (!(a in t))
      return !1;
    if (a !== "ref") {
      const s = t[a];
      if (Ti(o) && Ti(s) || (Gr(o) || Array.isArray(o)) && (Gr(s) || Array.isArray(s)) ? !uo(o, s, r) : !Object.is(o, s))
        return !1;
    }
  }
  return !0;
}
function uT(e) {
  const t = ih(), { control: r = t, name: n, defaultValue: i, disabled: a, exact: o, compute: s } = e || {}, u = S.useRef(i), c = S.useRef(s), l = S.useRef(void 0), f = S.useRef(r), d = S.useRef(n);
  c.current = s;
  const [p, m] = S.useState(() => {
    const O = r._getWatch(n, u.current);
    return c.current ? c.current(O) : O;
  }), v = S.useCallback((O) => {
    const y = Ev(n, r._names, O || r._formValues, !1, u.current);
    return c.current ? c.current(y) : y;
  }, [r._formValues, r._names, n]), h = S.useCallback((O) => {
    if (!a) {
      const y = Ev(n, r._names, O || r._formValues, !1, u.current);
      if (c.current) {
        const x = c.current(y);
        uo(x, l.current) || (m(x), l.current = x);
      } else
        m(y);
    }
  }, [r._formValues, r._names, a, n]);
  $1(() => ((f.current !== r || !uo(d.current, n)) && (f.current = r, d.current = n, h()), r._subscribe({
    name: n,
    formState: {
      values: !0
    },
    exact: o,
    callback: (O) => {
      h(O.values);
    }
  })), [r, o, n, h]), S.useEffect(() => r._removeUnmounted());
  const g = f.current !== r, b = d.current, w = S.useMemo(() => {
    if (a)
      return null;
    const O = !g && !uo(b, n);
    return g || O ? v() : null;
  }, [a, g, n, b, v]);
  return w !== null ? w : p;
}
function cT(e) {
  const t = ih(), { name: r, disabled: n, control: i = t, shouldUnregister: a, defaultValue: o, exact: s = !0 } = e, u = tT(i._names.array, r), c = S.useMemo(() => Qe(i._formValues, r, Qe(i._defaultValues, r, o)), [i, r, o]), l = uT({
    control: i,
    name: r,
    defaultValue: c,
    exact: s
  }), f = oT({
    control: i,
    name: r,
    exact: s
  }), d = S.useRef(e), p = S.useRef(void 0), m = S.useRef(i.register(r, {
    ...e.rules,
    value: l,
    ...fu(e.disabled) ? { disabled: e.disabled } : {}
  }));
  d.current = e;
  const v = S.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(f.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(f.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(f.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(f.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(f.errors, r)
    }
  }), [f, r]), h = S.useCallback((O) => m.current.onChange({
    target: {
      value: eT(O),
      name: r
    },
    type: Pv.CHANGE
  }), [r]), g = S.useCallback(() => m.current.onBlur({
    target: {
      value: Qe(i._formValues, r),
      name: r
    },
    type: Pv.BLUR
  }), [r, i._formValues]), b = S.useCallback((O) => {
    const y = Qe(i._fields, r);
    y && y._f && O && (y._f.ref = {
      focus: () => La(O.focus) && O.focus(),
      select: () => La(O.select) && O.select(),
      setCustomValidity: (x) => La(O.setCustomValidity) && O.setCustomValidity(x),
      reportValidity: () => La(O.reportValidity) && O.reportValidity()
    });
  }, [i._fields, r]), w = S.useMemo(() => ({
    name: r,
    value: l,
    ...fu(n) || f.disabled ? { disabled: f.disabled || n } : {},
    onChange: h,
    onBlur: g,
    ref: b
  }), [r, n, f.disabled, h, g, b, l]);
  return S.useEffect(() => {
    const O = i._options.shouldUnregister || a, y = p.current;
    y && y !== r && !u && i.unregister(y), i.register(r, {
      ...d.current.rules,
      ...fu(d.current.disabled) ? { disabled: d.current.disabled } : {}
    });
    const x = (_, P) => {
      const E = Qe(i._fields, _);
      E && E._f && (E._f.mount = P);
    };
    if (x(r, !0), O) {
      const _ = M1(Qe(i._options.defaultValues, r, d.current.defaultValue));
      Av(i._defaultValues, r, _), Sd(Qe(i._formValues, r)) && Av(i._formValues, r, _);
    }
    return !u && i.register(r), p.current = r, () => {
      (u ? O && !i._state.action : O) ? i.unregister(r) : x(r, !1);
    };
  }, [r, i, u, a]), S.useEffect(() => {
    i._setDisabledField({
      disabled: n,
      name: r
    });
  }, [n, r, i]), S.useMemo(() => ({
    field: w,
    formState: f,
    fieldState: v
  }), [w, f, v]);
}
const lT = (e) => e.render(cT(e)), ah = S.createContext(null);
ah.displayName = "HookFormContext";
const fT = () => S.useContext(ah), dT = (e) => {
  const { children: t, watch: r, getValues: n, getFieldState: i, setError: a, clearErrors: o, setValue: s, trigger: u, formState: c, resetField: l, reset: f, handleSubmit: d, unregister: p, control: m, register: v, setFocus: h, subscribe: g } = e, b = S.useMemo(() => ({
    watch: r,
    getValues: n,
    getFieldState: i,
    setError: a,
    clearErrors: o,
    setValue: s,
    trigger: u,
    formState: c,
    resetField: l,
    reset: f,
    handleSubmit: d,
    unregister: p,
    control: m,
    register: v,
    setFocus: h,
    subscribe: g
  }), [
    o,
    m,
    c,
    i,
    n,
    d,
    v,
    f,
    l,
    a,
    h,
    s,
    g,
    u,
    p,
    r
  ]);
  return S.createElement(
    ah.Provider,
    { value: b },
    S.createElement(nh.Provider, { value: b.control }, t)
  );
}, pT = Xp(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), oh = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(Zw.Root, { ref: r, className: z(pT(), e), ...t }));
oh.displayName = Zw.Root.displayName;
const hT = dT, N1 = K.createContext(
  {}
), vT = ({
  ...e
}) => /* @__PURE__ */ A(N1.Provider, { value: { name: e.name }, children: /* @__PURE__ */ A(lT, { ...e }) }), I1 = K.createContext(
  {}
), Ta = () => {
  const e = K.useContext(N1), t = K.useContext(I1), { getFieldState: r, formState: n } = fT(), i = r(e.name, n);
  if (!e?.name)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...i
  };
}, R1 = K.forwardRef(({ className: e, ...t }, r) => {
  const n = K.useId();
  return /* @__PURE__ */ A(I1.Provider, { value: { id: n }, children: /* @__PURE__ */ A("div", { ref: r, className: z("space-y-2", e), ...t }) });
});
R1.displayName = "FormItem";
const D1 = K.forwardRef(({ className: e, ...t }, r) => {
  const { error: n, formItemId: i } = Ta();
  return /* @__PURE__ */ A(
    oh,
    {
      ref: r,
      className: z(n && "text-destructive", e),
      htmlFor: i,
      ...t
    }
  );
});
D1.displayName = "FormLabel";
const L1 = K.forwardRef(({ ...e }, t) => {
  const { error: r, formItemId: n, formDescriptionId: i, formMessageId: a } = Ta();
  return /* @__PURE__ */ A(
    eP,
    {
      ref: t,
      id: n,
      "aria-describedby": r ? `${i} ${a}` : i,
      "aria-invalid": !!r,
      ...e
    }
  );
});
L1.displayName = "FormControl";
const q1 = K.forwardRef(({ className: e, ...t }, r) => {
  const { formDescriptionId: n } = Ta();
  return /* @__PURE__ */ A(
    "p",
    {
      ref: r,
      id: n,
      className: z("text-muted-foreground text-sm", e),
      ...t
    }
  );
});
q1.displayName = "FormDescription";
const B1 = K.forwardRef(({ className: e, children: t, ...r }, n) => {
  const { error: i, formMessageId: a } = Ta(), o = i ? String(i.message ?? "") : t;
  return o ? /* @__PURE__ */ A(
    "p",
    {
      ref: n,
      id: a,
      className: z("text-destructive text-sm font-medium", e),
      ...r,
      children: o
    }
  ) : null;
});
B1.displayName = "FormMessage";
const sh = K.forwardRef(
  ({ className: e, type: t, error: r, ...n }, i) => /* @__PURE__ */ A(
    "input",
    {
      type: t,
      ref: i,
      className: z(
        t === "checkbox" ? "size-5 shrink-0 cursor-pointer rounded-sm border-2 border-primary bg-background accent-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" : "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium md:text-sm",
        r && "border-error focus-visible:ring-error",
        e
      ),
      ...n
    }
  )
);
sh.displayName = "Input";
const F1 = Pn.Root, z1 = Pn.Trigger, yT = Pn.Anchor, uh = K.forwardRef(({ className: e, align: t = "center", sideOffset: r = 4, ...n }, i) => /* @__PURE__ */ A(Pn.Portal, { children: /* @__PURE__ */ A(
  Pn.Content,
  {
    ref: i,
    align: t,
    sideOffset: r,
    className: z(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none",
      e
    ),
    ...n
  }
) }));
uh.displayName = Pn.Content.displayName;
const W1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(Fi.Root, { className: z("grid gap-2", e), ref: r, ...t }));
W1.displayName = Fi.Root.displayName;
const U1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Fi.Item,
  {
    ref: r,
    className: z(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ A(Fi.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ A(FP, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
U1.displayName = Fi.Item.displayName;
const G1 = K.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ J(Fr.Root, { ref: n, className: z("relative overflow-hidden", e), ...r, children: [
  /* @__PURE__ */ A(Fr.Viewport, { className: "h-full w-full rounded-[inherit]", children: t }),
  /* @__PURE__ */ A(ch, {}),
  /* @__PURE__ */ A(Fr.Corner, {})
] }));
G1.displayName = Fr.Root.displayName;
const ch = K.forwardRef(({ className: e, orientation: t = "vertical", ...r }, n) => /* @__PURE__ */ A(
  Fr.ScrollAreaScrollbar,
  {
    ref: n,
    orientation: t,
    className: z(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...r,
    children: /* @__PURE__ */ A(Fr.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })
  }
));
ch.displayName = Fr.ScrollAreaScrollbar.displayName;
const mT = rt.Root, gT = rt.Value, bT = rt.Group, H1 = K.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ J(
  rt.Trigger,
  {
    ref: n,
    className: z(
      "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus:ring-ring flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ A(rt.Icon, { asChild: !0, children: /* @__PURE__ */ A(s1, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
H1.displayName = rt.Trigger.displayName;
const V1 = K.forwardRef(({ className: e, children: t, position: r = "popper", ...n }, i) => /* @__PURE__ */ A(rt.Portal, { children: /* @__PURE__ */ A(
  rt.Content,
  {
    ref: i,
    className: z(
      "bg-popover text-popover-foreground relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border shadow-md",
      r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: r,
    ...n,
    children: /* @__PURE__ */ A(
      rt.Viewport,
      {
        className: z(
          "p-1",
          r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: t
      }
    )
  }
) }));
V1.displayName = rt.Content.displayName;
const K1 = K.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ J(
  rt.Item,
  {
    ref: n,
    className: z(
      "focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ A("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ A(rt.ItemIndicator, { children: /* @__PURE__ */ A(o1, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ A(rt.ItemText, { children: t })
    ]
  }
));
K1.displayName = rt.Item.displayName;
const Y1 = K.forwardRef(({ className: e, orientation: t = "horizontal", decorative: r = !0, ...n }, i) => /* @__PURE__ */ A(
  Jw.Root,
  {
    ref: i,
    decorative: r,
    orientation: t,
    className: z(
      "shrink-0 bg-border",
      t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      e
    ),
    ...n
  }
));
Y1.displayName = Jw.Root.displayName;
function xT({ className: e, ...t }) {
  return /* @__PURE__ */ A("div", { className: z("animate-pulse rounded-md bg-surface", e), ...t });
}
const X1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  wd.Root,
  {
    className: z(
      "focus-visible:ring-ring focus-visible:ring-offset-background data-[state=checked]:bg-primary data-[state=unchecked]:bg-input peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    ref: r,
    children: /* @__PURE__ */ A(
      wd.Thumb,
      {
        className: z(
          "bg-background pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
X1.displayName = wd.Root.displayName;
const Z1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ A("table", { ref: r, className: z("w-full caption-bottom text-sm", e), ...t }) }));
Z1.displayName = "TableRoot";
const J1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A("thead", { ref: r, className: z("[&_tr]:border-b", e), ...t }));
J1.displayName = "TableHeader";
const Q1 = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A("tbody", { ref: r, className: z("[&_tr:last-child]:border-0", e), ...t }));
Q1.displayName = "TableBody";
const eO = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "tr",
  {
    ref: r,
    className: z(
      "border-b transition-colors hover:bg-surface/50 data-[state=selected]:bg-surface",
      e
    ),
    ...t
  }
));
eO.displayName = "TableRow";
const tO = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "th",
  {
    ref: r,
    className: z(
      "h-12 px-4 text-left align-middle font-medium text-muted-foreground",
      e
    ),
    ...t
  }
));
tO.displayName = "TableHead";
const rO = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A("td", { ref: r, className: z("p-4 align-middle", e), ...t }));
rO.displayName = "TableCell";
const wT = Qr.Root, nO = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Qr.List,
  {
    ref: r,
    className: z(
      "bg-surface text-muted-foreground inline-flex h-10 items-center justify-center rounded-md p-1",
      e
    ),
    ...t
  }
));
nO.displayName = Qr.List.displayName;
const iO = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Qr.Trigger,
  {
    ref: r,
    className: z(
      "ring-offset-background focus-visible:ring-ring data-[state=active]:bg-background data-[state=active]:text-foreground inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm",
      e
    ),
    ...t
  }
));
iO.displayName = Qr.Trigger.displayName;
const aO = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Qr.Content,
  {
    ref: r,
    className: z(
      "ring-offset-background focus-visible:ring-ring mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
aO.displayName = Qr.Content.displayName;
const oO = K.forwardRef(
  ({ className: e, error: t, ...r }, n) => /* @__PURE__ */ A(
    "textarea",
    {
      ref: n,
      className: z(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background p-[3px] text-base placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-muted-foreground focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        t && "border-error focus-visible:ring-error",
        e
      ),
      ...r
    }
  )
);
oO.displayName = "Textarea";
const sO = Aa.Provider, uO = Aa.Root, cO = Aa.Trigger, lh = K.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ A(
  Aa.Content,
  {
    ref: n,
    sideOffset: t,
    className: z(
      "z-50 overflow-hidden rounded-md bg-foreground px-3 py-1.5 text-xs text-background shadow-md",
      e
    ),
    ...r
  }
));
lh.displayName = Aa.Content.displayName;
const Os = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "span",
  {
    role: "status",
    "aria-label": "Loading",
    className: z(
      // after:border-b-primary must follow after:border-transparent.
      // twMerge drops the accent if the pair is reversed, and Prettier's
      // Tailwind plugin sorts `border-b-*` before `border-transparent`.
      "border-foreground relative box-border inline-block h-12 w-12 animate-spin rounded-full border-[3px] after:absolute after:left-1/2 after:top-1/2 after:box-border after:h-10 after:w-10 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:border-[3px] after:border-transparent after:content-['']",
      "after:border-b-primary",
      e
    ),
    ref: r,
    ...t
  }
));
Os.displayName = "LoadingSpinner";
const Rz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertDialog: HP,
  AlertDialogAction: h1,
  AlertDialogCancel: v1,
  AlertDialogContent: f1,
  AlertDialogDescription: p1,
  AlertDialogFooter: xn,
  AlertDialogHeader: KP,
  AlertDialogOverlay: Jp,
  AlertDialogPortal: l1,
  AlertDialogTitle: d1,
  AlertDialogTrigger: VP,
  Avatar: y1,
  AvatarFallback: g1,
  AvatarImage: m1,
  Card: b1,
  CardContent: _1,
  CardDescription: O1,
  CardFooter: S1,
  CardHeader: x1,
  CardTitle: w1,
  Checkbox: A1,
  Dialog: lo,
  DialogActions: XP,
  DialogClose: Sv,
  DialogContent: Wi,
  DialogDescription: _d,
  DialogFooter: xn,
  DialogHeader: po,
  DialogOverlay: zi,
  DialogPortal: fo,
  DialogTitle: ho,
  DialogTrigger: _v,
  DropdownMenu: eh,
  DropdownMenuContent: ws,
  DropdownMenuGroup: ZP,
  DropdownMenuItem: P1,
  DropdownMenuLabel: T1,
  DropdownMenuPortal: JP,
  DropdownMenuSeparator: E1,
  DropdownMenuTrigger: th,
  Form: hT,
  FormControl: L1,
  FormDescription: q1,
  FormField: vT,
  FormItem: R1,
  FormLabel: D1,
  FormMessage: B1,
  Input: sh,
  Label: oh,
  LoadingSpinner: Os,
  Popover: F1,
  PopoverAnchor: yT,
  PopoverContent: uh,
  PopoverTrigger: z1,
  RadioGroup: W1,
  RadioGroupItem: U1,
  ScrollArea: G1,
  ScrollBar: ch,
  Select: mT,
  SelectContent: V1,
  SelectGroup: bT,
  SelectItem: K1,
  SelectTrigger: H1,
  SelectValue: gT,
  Separator: Y1,
  ShadcnBadge: YP,
  Sheet: lo,
  SheetClose: Sv,
  SheetContent: Wi,
  SheetDescription: _d,
  SheetFooter: xn,
  SheetHeader: po,
  SheetOverlay: zi,
  SheetPortal: fo,
  SheetTitle: ho,
  SheetTrigger: _v,
  Skeleton: xT,
  Switch: X1,
  TableBody: Q1,
  TableCell: rO,
  TableHead: tO,
  TableHeader: J1,
  TableRoot: Z1,
  TableRow: eO,
  Tabs: wT,
  TabsContent: aO,
  TabsList: nO,
  TabsTrigger: iO,
  Textarea: oO,
  TooltipContent: lh,
  TooltipProvider: sO,
  TooltipRoot: uO,
  TooltipTrigger: cO,
  badgeVariants: Qp,
  useFormField: Ta
}, Symbol.toStringTag, { value: "Module" })), OT = ({
  status: e,
  variant: t = "default",
  className: r
}) => /* @__PURE__ */ A("span", { className: z(Qp({ variant: t }), "op-badge", r), children: e }), Dz = ({ data: e }) => /* @__PURE__ */ A("div", { className: "flex flex-wrap gap-1", children: e.map(({ status: t, variant: r }, n) => /* @__PURE__ */ A(OT, { status: t, variant: r }, n)) }), _T = (e) => {
  const t = /* @__PURE__ */ new Date(), r = e instanceof Date ? e : new Date(e), n = t.getTime() - r.getTime();
  return n < -60 * 60 * 1e3 ? `on ${r.toLocaleDateString()} at ${r.toLocaleTimeString()}` : n < -60 * 1e3 ? `in ${Math.abs(Math.floor(n / 6e4))} minutes ` : n < 60 * 1e3 ? "now" : n < 60 * 60 * 1e3 ? `${Math.floor(n / 6e4)}m ago` : `${r.toLocaleDateString()} ${r.toLocaleTimeString()}`;
}, ST = (e) => {
  const t = Math.floor(e / 1e3), r = Math.floor(t / 3600), n = Math.floor(t % 3600 / 60), i = t % 60;
  return `${r.toString().padStart(2, "0")}:${n.toString().padStart(2, "0")}:${i.toString().padStart(2, "0")}`;
};
function Lz({
  date: e,
  formatter: t = _T,
  intervalMs: r = 6e4
}) {
  const [n, i] = K.useState(() => t(e));
  return K.useEffect(() => {
    i(t(e));
    const a = setInterval(() => {
      i(t(e));
    }, r);
    return () => clearInterval(a);
  }, [e, t, r]), /* @__PURE__ */ A(Ct, { children: n });
}
function qz({
  start: e,
  formatter: t = ST,
  intervalMs: r = 1e3
}) {
  const [n, i] = K.useState(
    () => t(Date.now() - new Date(e).getTime())
  );
  return K.useEffect(() => {
    i(t(Date.now() - new Date(e).getTime()));
    const a = setInterval(() => {
      i(t(Date.now() - new Date(e).getTime()));
    }, r);
    return () => clearInterval(a);
  }, [e, t, r]), /* @__PURE__ */ A(Ct, { children: n });
}
function Bz({ start: e, end: t, timeZone: r, truncate: n }) {
  const i = K.useMemo(
    () => typeof window < "u" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "UTC",
    []
  ), a = r || i, o = new Date(e), s = t ? new Date(t) : void 0, u = o.toLocaleDateString(void 0, {
    timeZone: a,
    dateStyle: "full"
  }), c = o.toLocaleTimeString(void 0, {
    timeZone: a,
    timeStyle: "short"
  }), l = s?.toLocaleDateString(void 0, {
    timeZone: a,
    dateStyle: "full"
  }), f = s?.toLocaleTimeString(void 0, {
    timeZone: a,
    timeStyle: "short"
  }), p = l ? l && u === l ? `${u}, ${c} - ${f}` : `${u}, ${c} - ${l}, ${f}` : `${u}, ${c}`;
  return /* @__PURE__ */ A(Ct, { children: n ? `${p.substring(0, n)}...` : p });
}
function Fz({ title: e, children: t, initialOpen: r = !1 }) {
  const [n, i] = K.useState(r);
  return /* @__PURE__ */ J("div", { className: "flex items-start gap-2", children: [
    /* @__PURE__ */ A(
      "button",
      {
        type: "button",
        className: "w-4",
        onClick: () => i((a) => !a),
        "aria-expanded": n,
        children: n ? /* @__PURE__ */ A(s1, {}) : /* @__PURE__ */ A(u1, {})
      }
    ),
    /* @__PURE__ */ J("div", { className: "flex-grow", children: [
      /* @__PURE__ */ A("div", { children: e }),
      n && /* @__PURE__ */ A("div", { children: t })
    ] })
  ] });
}
const AT = (e, t) => {
  if (!t) return "";
  switch (e.severity) {
    case "error":
      return "text-destructive";
    case "warning":
      return "text-warning";
    case "info":
      return "";
  }
};
function PT({
  title: e = "",
  messages: t = [],
  classes: r,
  description: n = "",
  forCheckbox: i = !1,
  inline: a = !1,
  dirty: o = !1,
  required: s = !1,
  htmlFor: u,
  children: c
}) {
  return /* @__PURE__ */ J(
    "label",
    {
      htmlFor: u,
      className: z(
        "flex",
        a ? "flex-row items-center gap-2" : "flex-col",
        r
      ),
      children: [
        e && /* @__PURE__ */ J("span", { children: [
          e,
          s && /* @__PURE__ */ A("span", { className: z(o && "text-destructive"), children: "*" })
        ] }),
        /* @__PURE__ */ J(
          "span",
          {
            className: z(
              "flex flex-grow",
              i ? "items-center gap-2" : "flex-col"
            ),
            children: [
              n && /* @__PURE__ */ A("span", { className: "text-sm", children: n }),
              c
            ]
          }
        ),
        t.map((l, f) => /* @__PURE__ */ J(
          "span",
          {
            className: z("flex items-center gap-2", AT(l, o)),
            children: [
              /* @__PURE__ */ A(WP, { className: "size-4" }),
              l.text
            ]
          },
          f
        ))
      ]
    }
  );
}
/**
 * uuidv7: A JavaScript implementation of UUID version 7
 *
 * Copyright 2021-2024 LiosK
 *
 * @license Apache-2.0
 * @packageDocumentation
 */
const qa = "0123456789abcdef";
class Nr {
  /** @param bytes - The 16-byte byte array representation. */
  constructor(t) {
    this.bytes = t;
  }
  /**
   * Creates an object from the internal representation, a 16-byte byte array
   * containing the binary UUID representation in the big-endian byte order.
   *
   * This method does NOT shallow-copy the argument, and thus the created object
   * holds the reference to the underlying buffer.
   *
   * @throws TypeError if the length of the argument is not 16.
   */
  static ofInner(t) {
    if (t.length !== 16)
      throw new TypeError("not 128-bit length");
    return new Nr(t);
  }
  /**
   * Builds a byte array from UUIDv7 field values.
   *
   * @param unixTsMs - A 48-bit `unix_ts_ms` field value.
   * @param randA - A 12-bit `rand_a` field value.
   * @param randBHi - The higher 30 bits of 62-bit `rand_b` field value.
   * @param randBLo - The lower 32 bits of 62-bit `rand_b` field value.
   * @throws RangeError if any field value is out of the specified range.
   */
  static fromFieldsV7(t, r, n, i) {
    if (!Number.isInteger(t) || !Number.isInteger(r) || !Number.isInteger(n) || !Number.isInteger(i) || t < 0 || r < 0 || n < 0 || i < 0 || t > 281474976710655 || r > 4095 || n > 1073741823 || i > 4294967295)
      throw new RangeError("invalid field value");
    const a = new Uint8Array(16);
    return a[0] = t / 2 ** 40, a[1] = t / 2 ** 32, a[2] = t / 2 ** 24, a[3] = t / 2 ** 16, a[4] = t / 2 ** 8, a[5] = t, a[6] = 112 | r >>> 8, a[7] = r, a[8] = 128 | n >>> 24, a[9] = n >>> 16, a[10] = n >>> 8, a[11] = n, a[12] = i >>> 24, a[13] = i >>> 16, a[14] = i >>> 8, a[15] = i, new Nr(a);
  }
  /**
   * Builds a byte array from a string representation.
   *
   * This method accepts the following formats:
   *
   * - 32-digit hexadecimal format without hyphens: `0189dcd553117d408db09496a2eef37b`
   * - 8-4-4-4-12 hyphenated format: `0189dcd5-5311-7d40-8db0-9496a2eef37b`
   * - Hyphenated format with surrounding braces: `{0189dcd5-5311-7d40-8db0-9496a2eef37b}`
   * - RFC 9562 URN format: `urn:uuid:0189dcd5-5311-7d40-8db0-9496a2eef37b`
   *
   * Leading and trailing whitespaces represents an error.
   *
   * @throws SyntaxError if the argument could not parse as a valid UUID string.
   */
  static parse(t) {
    var r, n, i, a;
    let o;
    switch (t.length) {
      case 32:
        o = (r = /^[0-9a-f]{32}$/i.exec(t)) === null || r === void 0 ? void 0 : r[0];
        break;
      case 36:
        o = (n = /^([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/i.exec(t)) === null || n === void 0 ? void 0 : n.slice(1, 6).join("");
        break;
      case 38:
        o = (i = /^\{([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})\}$/i.exec(t)) === null || i === void 0 ? void 0 : i.slice(1, 6).join("");
        break;
      case 45:
        o = (a = /^urn:uuid:([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/i.exec(t)) === null || a === void 0 ? void 0 : a.slice(1, 6).join("");
        break;
    }
    if (o) {
      const s = new Uint8Array(16);
      for (let u = 0; u < 16; u += 4) {
        const c = parseInt(o.substring(2 * u, 2 * u + 8), 16);
        s[u + 0] = c >>> 24, s[u + 1] = c >>> 16, s[u + 2] = c >>> 8, s[u + 3] = c;
      }
      return new Nr(s);
    } else
      throw new SyntaxError("could not parse UUID string");
  }
  /**
   * @returns The 8-4-4-4-12 canonical hexadecimal string representation
   * (`0189dcd5-5311-7d40-8db0-9496a2eef37b`).
   */
  toString() {
    let t = "";
    for (let r = 0; r < this.bytes.length; r++)
      t += qa.charAt(this.bytes[r] >>> 4), t += qa.charAt(this.bytes[r] & 15), (r === 3 || r === 5 || r === 7 || r === 9) && (t += "-");
    return t;
  }
  /**
   * @returns The 32-digit hexadecimal representation without hyphens
   * (`0189dcd553117d408db09496a2eef37b`).
   */
  toHex() {
    let t = "";
    for (let r = 0; r < this.bytes.length; r++)
      t += qa.charAt(this.bytes[r] >>> 4), t += qa.charAt(this.bytes[r] & 15);
    return t;
  }
  /** @returns The 8-4-4-4-12 canonical hexadecimal string representation. */
  toJSON() {
    return this.toString();
  }
  /**
   * Reports the variant field value of the UUID or, if appropriate, "NIL" or
   * "MAX".
   *
   * For convenience, this method reports "NIL" or "MAX" if `this` represents
   * the Nil or Max UUID, although the Nil and Max UUIDs are technically
   * subsumed under the variants `0b0` and `0b111`, respectively.
   */
  getVariant() {
    const t = this.bytes[8] >>> 4;
    if (t < 0)
      throw new Error("unreachable");
    if (t <= 7)
      return this.bytes.every((r) => r === 0) ? "NIL" : "VAR_0";
    if (t <= 11)
      return "VAR_10";
    if (t <= 13)
      return "VAR_110";
    if (t <= 15)
      return this.bytes.every((r) => r === 255) ? "MAX" : "VAR_RESERVED";
    throw new Error("unreachable");
  }
  /**
   * Returns the version field value of the UUID or `undefined` if the UUID does
   * not have the variant field value of `0b10`.
   */
  getVersion() {
    return this.getVariant() === "VAR_10" ? this.bytes[6] >>> 4 : void 0;
  }
  /** Creates an object from `this`. */
  clone() {
    return new Nr(this.bytes.slice(0));
  }
  /** Returns true if `this` is equivalent to `other`. */
  equals(t) {
    return this.compareTo(t) === 0;
  }
  /**
   * Returns a negative integer, zero, or positive integer if `this` is less
   * than, equal to, or greater than `other`, respectively.
   */
  compareTo(t) {
    for (let r = 0; r < 16; r++) {
      const n = this.bytes[r] - t.bytes[r];
      if (n !== 0)
        return Math.sign(n);
    }
    return 0;
  }
}
class TT {
  /**
   * Creates a generator object with the default random number generator, or
   * with the specified one if passed as an argument. The specified random
   * number generator should be cryptographically strong and securely seeded.
   */
  constructor(t) {
    this.timestamp = 0, this.counter = 0, this.random = t ?? ET();
  }
  /**
   * Generates a new UUIDv7 object from the current timestamp, or resets the
   * generator upon significant timestamp rollback.
   *
   * This method returns a monotonically increasing UUID by reusing the previous
   * timestamp even if the up-to-date timestamp is smaller than the immediately
   * preceding UUID's. However, when such a clock rollback is considered
   * significant (i.e., by more than ten seconds), this method resets the
   * generator and returns a new UUID based on the given timestamp, breaking the
   * increasing order of UUIDs.
   *
   * See {@link generateOrAbort} for the other mode of generation and
   * {@link generateOrResetCore} for the low-level primitive.
   */
  generate() {
    return this.generateOrResetCore(Date.now(), 1e4);
  }
  /**
   * Generates a new UUIDv7 object from the current timestamp, or returns
   * `undefined` upon significant timestamp rollback.
   *
   * This method returns a monotonically increasing UUID by reusing the previous
   * timestamp even if the up-to-date timestamp is smaller than the immediately
   * preceding UUID's. However, when such a clock rollback is considered
   * significant (i.e., by more than ten seconds), this method aborts and
   * returns `undefined` immediately.
   *
   * See {@link generate} for the other mode of generation and
   * {@link generateOrAbortCore} for the low-level primitive.
   */
  generateOrAbort() {
    return this.generateOrAbortCore(Date.now(), 1e4);
  }
  /**
   * Generates a new UUIDv7 object from the `unixTsMs` passed, or resets the
   * generator upon significant timestamp rollback.
   *
   * This method is equivalent to {@link generate} except that it takes a custom
   * timestamp and clock rollback allowance.
   *
   * @param rollbackAllowance - The amount of `unixTsMs` rollback that is
   * considered significant. A suggested value is `10_000` (milliseconds).
   * @throws RangeError if `unixTsMs` is not a 48-bit positive integer.
   */
  generateOrResetCore(t, r) {
    let n = this.generateOrAbortCore(t, r);
    return n === void 0 && (this.timestamp = 0, n = this.generateOrAbortCore(t, r)), n;
  }
  /**
   * Generates a new UUIDv7 object from the `unixTsMs` passed, or returns
   * `undefined` upon significant timestamp rollback.
   *
   * This method is equivalent to {@link generateOrAbort} except that it takes a
   * custom timestamp and clock rollback allowance.
   *
   * @param rollbackAllowance - The amount of `unixTsMs` rollback that is
   * considered significant. A suggested value is `10_000` (milliseconds).
   * @throws RangeError if `unixTsMs` is not a 48-bit positive integer.
   */
  generateOrAbortCore(t, r) {
    if (!Number.isInteger(t) || t < 1 || t > 281474976710655)
      throw new RangeError("`unixTsMs` must be a 48-bit positive integer");
    if (r < 0 || r > 281474976710655)
      throw new RangeError("`rollbackAllowance` out of reasonable range");
    if (t > this.timestamp)
      this.timestamp = t, this.resetCounter();
    else if (t + r >= this.timestamp)
      this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
    else
      return;
    return Nr.fromFieldsV7(this.timestamp, Math.trunc(this.counter / 2 ** 30), this.counter & 2 ** 30 - 1, this.random.nextUint32());
  }
  /** Initializes the counter at a 42-bit random integer. */
  resetCounter() {
    this.counter = this.random.nextUint32() * 1024 + (this.random.nextUint32() & 1023);
  }
  /**
   * Generates a new UUIDv4 object utilizing the random number generator inside.
   *
   * @internal
   */
  generateV4() {
    const t = new Uint8Array(Uint32Array.of(this.random.nextUint32(), this.random.nextUint32(), this.random.nextUint32(), this.random.nextUint32()).buffer);
    return t[6] = 64 | t[6] >>> 4, t[8] = 128 | t[8] >>> 2, Nr.ofInner(t);
  }
}
const ET = () => {
  if (typeof crypto < "u" && typeof crypto.getRandomValues < "u")
    return new CT();
  if (typeof UUIDV7_DENY_WEAK_RNG < "u" && UUIDV7_DENY_WEAK_RNG)
    throw new Error("no cryptographically strong RNG available");
  return {
    nextUint32: () => Math.trunc(Math.random() * 65536) * 65536 + Math.trunc(Math.random() * 65536)
  };
};
class CT {
  constructor() {
    this.buffer = new Uint32Array(8), this.cursor = 65535;
  }
  nextUint32() {
    return this.cursor >= this.buffer.length && (crypto.getRandomValues(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
  }
}
let Mv;
const MT = () => jT().toString(), jT = () => (Mv || (Mv = new TT())).generateV4();
function zz({
  title: e = "",
  description: t,
  disabled: r = !1,
  value: n,
  onChange: i,
  options: a,
  optionTestId: o
}) {
  const s = K.useMemo(() => `radio-select-${MT()}-`, []);
  return /* @__PURE__ */ J("div", { className: z("flex flex-col gap-y-2 px-4", r && "opacity-50"), children: [
    /* @__PURE__ */ A(PT, { classes: "text-lg font-medium", title: e }),
    t && /* @__PURE__ */ A("div", { children: t }),
    a.map((u) => {
      const c = `${s}-${u.value}`;
      return /* @__PURE__ */ J("div", { className: "flex gap-x-2", children: [
        /* @__PURE__ */ A(
          "input",
          {
            type: "radio",
            id: c,
            checked: n === u.value,
            onChange: (l) => i?.(l.currentTarget.value),
            className: "text-primary mt-1 size-4",
            value: u.value,
            disabled: r,
            "data-testid": o?.(u.value)
          }
        ),
        /* @__PURE__ */ J("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ A("label", { className: "text-foreground font-medium", htmlFor: c, children: u.title }),
          /* @__PURE__ */ A("label", { className: "text-muted-foreground text-sm", htmlFor: c, children: u.description })
        ] })
      ] }, u.value);
    })
  ] });
}
const kT = "M3.99996 8.66699C3.63329 8.66699 3.33329 8.96699 3.33329 9.33366C3.33329 9.70033 3.63329 10.0003 3.99996 10.0003C4.36663 10.0003 4.66663 9.70033 4.66663 9.33366C4.66663 8.96699 4.36663 8.66699 3.99996 8.66699ZM3.99996 11.3337C3.63329 11.3337 3.33329 11.6337 3.33329 12.0003C3.33329 12.367 3.63329 12.667 3.99996 12.667C4.36663 12.667 4.66663 12.367 4.66663 12.0003C4.66663 11.6337 4.36663 11.3337 3.99996 11.3337ZM3.99996 6.00033C3.63329 6.00033 3.33329 6.30033 3.33329 6.66699C3.33329 7.03366 3.63329 7.33366 3.99996 7.33366C4.36663 7.33366 4.66663 7.03366 4.66663 6.66699C4.66663 6.30033 4.36663 6.00033 3.99996 6.00033ZM1.99996 6.33366C1.81663 6.33366 1.66663 6.48366 1.66663 6.66699C1.66663 6.85033 1.81663 7.00033 1.99996 7.00033C2.18329 7.00033 2.33329 6.85033 2.33329 6.66699C2.33329 6.48366 2.18329 6.33366 1.99996 6.33366ZM3.99996 3.33366C3.63329 3.33366 3.33329 3.63366 3.33329 4.00033C3.33329 4.36699 3.63329 4.66699 3.99996 4.66699C4.36663 4.66699 4.66663 4.36699 4.66663 4.00033C4.66663 3.63366 4.36663 3.33366 3.99996 3.33366ZM14 7.00033C14.1833 7.00033 14.3333 6.85033 14.3333 6.66699C14.3333 6.48366 14.1833 6.33366 14 6.33366C13.8166 6.33366 13.6666 6.48366 13.6666 6.66699C13.6666 6.85033 13.8166 7.00033 14 7.00033ZM9.33329 4.66699C9.69996 4.66699 9.99996 4.36699 9.99996 4.00033C9.99996 3.63366 9.69996 3.33366 9.33329 3.33366C8.96663 3.33366 8.66663 3.63366 8.66663 4.00033C8.66663 4.36699 8.96663 4.66699 9.33329 4.66699ZM9.33329 2.33366C9.51663 2.33366 9.66663 2.18366 9.66663 2.00033C9.66663 1.81699 9.51663 1.66699 9.33329 1.66699C9.14996 1.66699 8.99996 1.81699 8.99996 2.00033C8.99996 2.18366 9.14996 2.33366 9.33329 2.33366ZM1.99996 9.00033C1.81663 9.00033 1.66663 9.15033 1.66663 9.33366C1.66663 9.51699 1.81663 9.66699 1.99996 9.66699C2.18329 9.66699 2.33329 9.51699 2.33329 9.33366C2.33329 9.15033 2.18329 9.00033 1.99996 9.00033ZM6.66663 13.667C6.48329 13.667 6.33329 13.817 6.33329 14.0003C6.33329 14.1837 6.48329 14.3337 6.66663 14.3337C6.84996 14.3337 6.99996 14.1837 6.99996 14.0003C6.99996 13.817 6.84996 13.667 6.66663 13.667ZM6.66663 2.33366C6.84996 2.33366 6.99996 2.18366 6.99996 2.00033C6.99996 1.81699 6.84996 1.66699 6.66663 1.66699C6.48329 1.66699 6.33329 1.81699 6.33329 2.00033C6.33329 2.18366 6.48329 2.33366 6.66663 2.33366ZM6.66663 4.66699C7.03329 4.66699 7.33329 4.36699 7.33329 4.00033C7.33329 3.63366 7.03329 3.33366 6.66663 3.33366C6.29996 3.33366 5.99996 3.63366 5.99996 4.00033C5.99996 4.36699 6.29996 4.66699 6.66663 4.66699ZM6.66663 8.33366C6.11329 8.33366 5.66663 8.78032 5.66663 9.33366C5.66663 9.88699 6.11329 10.3337 6.66663 10.3337C7.21996 10.3337 7.66663 9.88699 7.66663 9.33366C7.66663 8.78032 7.21996 8.33366 6.66663 8.33366ZM12 8.66699C11.6333 8.66699 11.3333 8.96699 11.3333 9.33366C11.3333 9.70033 11.6333 10.0003 12 10.0003C12.3666 10.0003 12.6666 9.70033 12.6666 9.33366C12.6666 8.96699 12.3666 8.66699 12 8.66699ZM12 11.3337C11.6333 11.3337 11.3333 11.6337 11.3333 12.0003C11.3333 12.367 11.6333 12.667 12 12.667C12.3666 12.667 12.6666 12.367 12.6666 12.0003C12.6666 11.6337 12.3666 11.3337 12 11.3337ZM12 6.00033C11.6333 6.00033 11.3333 6.30033 11.3333 6.66699C11.3333 7.03366 11.6333 7.33366 12 7.33366C12.3666 7.33366 12.6666 7.03366 12.6666 6.66699C12.6666 6.30033 12.3666 6.00033 12 6.00033ZM12 3.33366C11.6333 3.33366 11.3333 3.63366 11.3333 4.00033C11.3333 4.36699 11.6333 4.66699 12 4.66699C12.3666 4.66699 12.6666 4.36699 12.6666 4.00033C12.6666 3.63366 12.3666 3.33366 12 3.33366ZM14 9.00033C13.8166 9.00033 13.6666 9.15033 13.6666 9.33366C13.6666 9.51699 13.8166 9.66699 14 9.66699C14.1833 9.66699 14.3333 9.51699 14.3333 9.33366C14.3333 9.15033 14.1833 9.00033 14 9.00033ZM9.33329 11.3337C8.96663 11.3337 8.66663 11.6337 8.66663 12.0003C8.66663 12.367 8.96663 12.667 9.33329 12.667C9.69996 12.667 9.99996 12.367 9.99996 12.0003C9.99996 11.6337 9.69996 11.3337 9.33329 11.3337ZM9.33329 13.667C9.14996 13.667 8.99996 13.817 8.99996 14.0003C8.99996 14.1837 9.14996 14.3337 9.33329 14.3337C9.51663 14.3337 9.66663 14.1837 9.66663 14.0003C9.66663 13.817 9.51663 13.667 9.33329 13.667ZM6.66663 5.66699C6.11329 5.66699 5.66663 6.11366 5.66663 6.66699C5.66663 7.22032 6.11329 7.66699 6.66663 7.66699C7.21996 7.66699 7.66663 7.22032 7.66663 6.66699C7.66663 6.11366 7.21996 5.66699 6.66663 5.66699ZM6.66663 11.3337C6.29996 11.3337 5.99996 11.6337 5.99996 12.0003C5.99996 12.367 6.29996 12.667 6.66663 12.667C7.03329 12.667 7.33329 12.367 7.33329 12.0003C7.33329 11.6337 7.03329 11.3337 6.66663 11.3337ZM9.33329 8.33366C8.77996 8.33366 8.33329 8.78032 8.33329 9.33366C8.33329 9.88699 8.77996 10.3337 9.33329 10.3337C9.88663 10.3337 10.3333 9.88699 10.3333 9.33366C10.3333 8.78032 9.88663 8.33366 9.33329 8.33366ZM9.33329 5.66699C8.77996 5.66699 8.33329 6.11366 8.33329 6.66699C8.33329 7.22032 8.77996 7.66699 9.33329 7.66699C9.88663 7.66699 10.3333 7.22032 10.3333 6.66699C10.3333 6.11366 9.88663 5.66699 9.33329 5.66699Z";
function Wz({ size: e = 16, className: t, ...r }) {
  return /* @__PURE__ */ A(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: e,
      viewBox: "0 0 16 16",
      fill: "currentColor",
      strokeWidth: 0,
      className: t,
      "aria-hidden": "true",
      ...r,
      children: /* @__PURE__ */ A("path", { d: kT })
    }
  );
}
function Uz({
  size: e = 24,
  absoluteStrokeWidth: t,
  className: r,
  strokeWidth: n = 2,
  ...i
}) {
  const a = t ? Number(n) * 24 / Number(e) : n;
  return /* @__PURE__ */ J(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: e,
      height: e,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: a,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: r ? `lucide lucide-square-stop ${r}` : "lucide lucide-square-stop",
      "aria-hidden": "true",
      ...i,
      children: [
        /* @__PURE__ */ A("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
        /* @__PURE__ */ A("rect", { x: "9", y: "9", width: "6", height: "6", rx: "1" })
      ]
    }
  );
}
function $T({
  queries: e,
  promises: t,
  ignoreErrors: r = !1,
  loading: n,
  success: i,
  error: a,
  children: o
}) {
  const [s, u] = K.useState(
    () => t && t.length ? "pending" : "resolved"
  );
  K.useEffect(() => {
    if (!t || t.length === 0) {
      u("resolved");
      return;
    }
    let l = !1;
    return u("pending"), Promise.all(t).then(() => {
      l || u("resolved");
    }).catch(() => {
      l || u("rejected");
    }), () => {
      l = !0;
    };
  }, [t]);
  let c = null;
  return s === "pending" ? c = n : s === "rejected" ? c = r ? i : a : e?.some((l) => l.isPending) ? c = n : !e || e.every((l) => l.isSuccess) || r ? c = i : c = a, /* @__PURE__ */ J(Ct, { children: [
    c,
    o
  ] });
}
function NT({
  fullScreen: e = !1,
  loadingMessage: t = "",
  errorMessage: r = "An error occurred.",
  className: n,
  queries: i,
  promises: a,
  ignoreErrors: o = !1,
  children: s,
  loading: u,
  error: c
}) {
  const l = z(
    "z-30 flex w-full flex-col items-center justify-center bg-background/80 p-10",
    e && "fixed left-0 top-0 h-full",
    n
  );
  return /* @__PURE__ */ A(
    $T,
    {
      queries: i,
      promises: a,
      ignoreErrors: o,
      success: s,
      loading: /* @__PURE__ */ A("div", { className: l, children: u ?? /* @__PURE__ */ J(Ct, { children: [
        /* @__PURE__ */ A(Os, {}),
        t && /* @__PURE__ */ A("p", { className: "mt-3", children: t })
      ] }) }),
      error: /* @__PURE__ */ A("div", { className: l, children: c ?? /* @__PURE__ */ A("p", { children: r }) })
    }
  );
}
function jv({ query: e }) {
  const t = IP(
    () => {
      e.hasNextPage && !e.isFetchingNextPage && e.fetchNextPage();
    },
    { enabled: !!e.hasNextPage }
  );
  return /* @__PURE__ */ J(Ct, { children: [
    e.hasNextPage && /* @__PURE__ */ A("div", { ref: t, className: "h-4 w-full", "aria-hidden": "true" }),
    e.isFetchingNextPage && /* @__PURE__ */ A("div", { className: "flex items-center justify-center py-6", children: /* @__PURE__ */ A("div", { className: "text-muted-foreground flex items-center gap-2", children: /* @__PURE__ */ A("div", { className: "border-border border-t-primary h-4 w-4 animate-spin rounded-full border-2" }) }) })
  ] });
}
function Gz({
  query: e,
  children: t,
  empty: r,
  uniqueBy: n,
  scrollTop: i = !1,
  additionalItems: a = []
}) {
  const o = K.useMemo(
    () => NP(
      [...(e.data?.pages ?? []).flat(), ...a],
      n
    ),
    [e.data, a, n]
  );
  return e ? /* @__PURE__ */ A(
    NT,
    {
      queries: [
        {
          isPending: e.isPending,
          isSuccess: e.isSuccess,
          data: e.data
        }
      ],
      children: o.length ? /* @__PURE__ */ J(Ct, { children: [
        i && /* @__PURE__ */ A(jv, { query: e }),
        t({ list: o }),
        !i && /* @__PURE__ */ A(jv, { query: e })
      ] }) : r
    }
  ) : null;
}
function Hz({
  loading: e = !1,
  className: t = "",
  disabled: r = !1,
  action: n,
  mutations: i = [],
  title: a = "",
  newTab: o = !1,
  children: s
}) {
  const [u, c] = K.useState(!1), l = e || u || i.some((p) => p.isPending), f = z("op-anchor", t), d = /* @__PURE__ */ J(Ct, { children: [
    l && /* @__PURE__ */ A(c1, { className: "mr-2 inline h-4 w-4 animate-spin" }),
    s
  ] });
  return typeof n == "string" ? /* @__PURE__ */ A(
    "a",
    {
      title: a,
      href: n,
      target: o ? "_blank" : void 0,
      rel: o ? "noopener noreferrer" : void 0,
      className: f,
      onClick: (p) => {
        (l || r) && p.preventDefault();
      },
      children: d
    }
  ) : /* @__PURE__ */ A(
    "button",
    {
      type: "button",
      title: a,
      disabled: l || r,
      className: f,
      onClick: async (p) => {
        if (p.stopPropagation(), p.preventDefault(), !!n) {
          c(!0);
          try {
            await n();
          } finally {
            c(!1);
          }
        }
      },
      children: d
    }
  );
}
const Vz = ({ className: e }) => /* @__PURE__ */ A(Os, { className: e });
let Ut = [];
const Ad = /* @__PURE__ */ new Set();
let IT = 0;
const Ba = () => Ad.forEach((e) => e()), Kt = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getStack: () => Ut,
  subscribe: (e) => (Ad.add(e), () => Ad.delete(e)),
  push: (e, t, r) => {
    const n = `modal-${++IT}`;
    return Ut = [{ id: n, component: e, props: t, response: r }, ...Ut], Ba(), n;
  },
  closeTop: () => {
    if (Ut.length === 0) return;
    const [e, ...t] = Ut;
    Ut = t, Ba(), e && e.response && e.response(e.setResponseValue);
  },
  closeAll: () => {
    Ut = [], Ba();
  },
  setTopResponse: (e) => {
    if (Ut.length === 0) return;
    const t = Ut[0];
    t && (t.setResponseValue = e, Ba());
  }
};
function Kz() {
  const t = K.useSyncExternalStore(
    Kt.subscribe,
    Kt.getStack,
    Kt.getStack
  )[0];
  return /* @__PURE__ */ A(
    lo,
    {
      open: !!t,
      onOpenChange: (r) => {
        r || Kt.closeTop();
      },
      children: t && /* @__PURE__ */ J(fo, { children: [
        /* @__PURE__ */ A(zi, {}),
        /* @__PURE__ */ A(Wi, { showCloseButton: !1, className: "max-h-[90vh] overflow-y-auto p-0", children: /* @__PURE__ */ A(RT, { entry: t }) })
      ] })
    }
  );
}
function RT({ entry: e }) {
  const t = e.component, r = K.useCallback(
    (i) => Kt.setTopResponse(i),
    []
  ), n = K.useCallback(() => Kt.closeTop(), []);
  return /* @__PURE__ */ A(t, { ...e.props, close: n, setResponse: r });
}
function Yz({
  className: e,
  width: t = "w-[95vw] max-w-2xl",
  children: r
}) {
  return /* @__PURE__ */ A(
    "div",
    {
      className: z(
        "op-card max-h-[90vh] overflow-y-auto bg-surface shadow-xl",
        t,
        e
      ),
      children: r
    }
  );
}
const DT = () => ({
  show: (e, t, r) => Kt.push(
    e,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t ?? {},
    r
  ),
  close: () => Kt.closeTop(),
  closeAll: () => Kt.closeAll()
}), LT = () => xs(() => DT(), []);
function Xz({
  title: e = "",
  hasCloseButton: t = !0,
  isCustomTitle: r = !1,
  children: n
}) {
  const i = LT();
  return /* @__PURE__ */ J("header", { className: "bg-surface sticky top-0 z-10 flex items-center justify-between border-b px-4 py-2 text-2xl font-bold", children: [
    r ? n : /* @__PURE__ */ A("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ A("p", { className: "text-lg font-medium", children: e }) }),
    t && /* @__PURE__ */ A(
      Tt,
      {
        title: "Close",
        action: () => i.close(),
        className: "op-btn flex h-12 w-12 items-center justify-center",
        children: /* @__PURE__ */ A(Zp, {})
      }
    )
  ] });
}
function Zz({
  variant: e,
  className: t,
  icon: r = zP,
  iconSize: n = 16,
  placement: i = "bottom",
  compact: a = !1,
  menuButton: o,
  children: s,
  title: u = "Open menu",
  width: c,
  text: l
}) {
  const [f, d] = qT(i);
  return /* @__PURE__ */ J(eh, { children: [
    /* @__PURE__ */ A(th, { asChild: !0, children: /* @__PURE__ */ J(
      "button",
      {
        type: "button",
        title: u,
        className: z(
          "rounded-button inline-flex items-center justify-center gap-1",
          e && Pa({ variant: e }),
          t
        ),
        onClick: (p) => {
          p.stopPropagation(), p.preventDefault();
        },
        children: [
          o ?? /* @__PURE__ */ A(r, { size: n }),
          l && /* @__PURE__ */ A("span", { className: "text-sm", children: l })
        ]
      }
    ) }),
    /* @__PURE__ */ A(
      ws,
      {
        side: f,
        align: d,
        className: z(
          "flex flex-col items-start p-2 text-left",
          a ? "w-16" : c ?? "w-52"
        ),
        children: s
      }
    )
  ] });
}
function qT(e) {
  const [t, r] = e.split("-");
  return [t, r ?? "center"];
}
function Jz({
  variant: e,
  action: t,
  title: r = "",
  children: n,
  menuChildren: i,
  menuTitle: a = "Change",
  placement: o = "top-start",
  chevronIcon: s = BP,
  chevronSize: u = 20,
  className: c,
  menuWidth: l,
  disabled: f = !1
}) {
  const [d, p] = BT(o), m = (v) => {
    v.stopPropagation(), v.preventDefault(), !f && typeof t == "function" && t();
  };
  return /* @__PURE__ */ J("div", { className: z("flex items-center", c), children: [
    /* @__PURE__ */ A(
      "button",
      {
        type: "button",
        title: r,
        disabled: f,
        onClick: m,
        className: z(
          Pa({ variant: e ?? "secondary", size: "icon" }),
          "rounded-button size-10 transition-opacity"
        ),
        children: n
      }
    ),
    /* @__PURE__ */ J(eh, { children: [
      /* @__PURE__ */ A(th, { asChild: !0, children: /* @__PURE__ */ A(
        "button",
        {
          type: "button",
          title: a,
          className: "hover:bg-surface rounded-r-button text-foreground -ml-1 flex h-10 items-center justify-center pl-0.5 pr-1.5 transition-colors",
          onClick: (v) => v.stopPropagation(),
          children: /* @__PURE__ */ A(s, { size: u })
        }
      ) }),
      /* @__PURE__ */ A(
        ws,
        {
          side: d,
          align: p,
          className: z(
            "flex max-h-[60vh] flex-col items-start overflow-y-auto p-2 text-left",
            l ?? "w-56"
          ),
          children: i
        }
      )
    ] })
  ] });
}
function BT(e) {
  const [t, r] = e.split("-");
  return [t, r ?? "center"];
}
const kv = "flex w-full items-center gap-x-2 rounded-button p-2 text-left transition-colors hover:bg-surface disabled:opacity-60";
function Qz({
  action: e,
  text: t = "",
  loadingText: r = "",
  icon: n,
  danger: i = !1,
  compact: a = !1,
  title: o = "",
  textSlot: s
}) {
  const [u, c] = K.useState(!1), l = u ? /* @__PURE__ */ J(Ct, { children: [
    /* @__PURE__ */ A(UP, { size: 16, className: "shrink-0" }),
    !a && /* @__PURE__ */ A("span", { children: r || t })
  ] }) : /* @__PURE__ */ J(Ct, { children: [
    n && /* @__PURE__ */ A(n, { size: 16, className: "shrink-0" }),
    !a && (s ?? /* @__PURE__ */ A("span", { className: "text-left", children: t }))
  ] });
  return typeof e == "string" ? /* @__PURE__ */ A(
    "a",
    {
      title: o,
      href: e,
      className: z(
        kv,
        i && "text-error",
        a && "justify-center"
      ),
      onClick: (f) => {
        f.stopPropagation(), c(!0);
      },
      children: l
    }
  ) : /* @__PURE__ */ A(
    "button",
    {
      type: "button",
      title: o,
      disabled: u,
      className: z(
        kv,
        i && "text-error",
        a && "justify-center"
      ),
      onClick: async (f) => {
        f.stopPropagation(), f.preventDefault(), c(!0);
        try {
          await e();
        } finally {
          c(!1);
        }
      },
      children: l
    }
  );
}
function eW({ title: e }) {
  return /* @__PURE__ */ A("div", { className: "w-full p-2 font-semibold", children: e });
}
function tW() {
  return /* @__PURE__ */ A("div", { className: "my-1 h-[1px] w-full border-b border-border" });
}
function rW({
  search: e = "",
  onSearchChange: t,
  placeholder: r = "Search",
  className: n,
  debounceTimeMs: i = 800,
  hideIcon: a = !1,
  minLength: o = 3
}) {
  const [s, u] = K.useState(e);
  return K.useEffect(() => {
    if (!t) return;
    const c = setTimeout(() => {
      s.length < o ? t("") : t(s);
    }, i);
    return () => clearTimeout(c);
  }, [s, i, o, t]), /* @__PURE__ */ A("div", { className: n, children: /* @__PURE__ */ J(
    "div",
    {
      className: z("border-border-2 flex items-center rounded-md border"),
      children: [
        !a && /* @__PURE__ */ A(
          "button",
          {
            type: "button",
            className: "flex items-center justify-center rounded-l-md px-2 py-1",
            tabIndex: -1,
            "aria-hidden": "true",
            children: /* @__PURE__ */ A(GP, {})
          }
        ),
        /* @__PURE__ */ A(
          sh,
          {
            placeholder: r,
            value: s,
            onChange: (c) => u(c.target.value),
            className: "h-10 flex-grow border-0 bg-inherit px-2 py-1 outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
          }
        )
      ]
    }
  ) });
}
function nW({
  data: e = [],
  columnDefinitions: t,
  filter: r = () => !0,
  className: n
}) {
  const i = "break-words px-2 py-4 align-top";
  return /* @__PURE__ */ A("div", { className: "min-w-0 overflow-x-auto", children: /* @__PURE__ */ J("table", { className: `mt-2 w-full ${n ?? ""}`, children: [
    /* @__PURE__ */ A("thead", { children: /* @__PURE__ */ A("tr", { className: "border-b-2 border-t-2", children: t.map((a) => /* @__PURE__ */ A(
      "th",
      {
        className: "py-4 pl-4 text-left align-top",
        children: typeof a.header == "string" ? a.header : typeof a.header == "function" ? K.createElement(a.header) : a.header
      },
      String(a.id)
    )) }) }),
    /* @__PURE__ */ A("tbody", { children: e.filter(r).map((a, o) => /* @__PURE__ */ A("tr", { className: "border-b-2 border-t-2", children: t.map((s) => {
      const u = String(s.id);
      if (s.type === "property")
        return /* @__PURE__ */ A("td", { className: i, children: String(
          a[s.id] ?? ""
        ) }, u);
      if (s.type === "path")
        return /* @__PURE__ */ A("td", { className: i, children: String($P(a, s.path) ?? "") }, u);
      if (s.type === "text")
        return /* @__PURE__ */ A("td", { className: i, children: s.render(a) }, u);
      const { component: c, props: l } = s.render(a);
      return /* @__PURE__ */ A("td", { className: i, children: /* @__PURE__ */ A(c, { ...l }) }, u);
    }) }, o)) })
  ] }) });
}
const FT = {
  success: "bg-success text-success-foreground border-success",
  error: "bg-error text-error-foreground border-error"
};
function iW({
  children: e,
  variant: t = "success",
  duration: r,
  onDismiss: n,
  testId: i,
  inline: a = !1
}) {
  const [o, s] = Vt(!0), u = r ?? (t === "error" ? 0 : 5e3);
  if (Sa(() => {
    if (!u) return;
    const f = setTimeout(() => {
      s(!1), n?.();
    }, u);
    return () => clearTimeout(f);
  }, [u, n]), !o) return null;
  const c = () => {
    s(!1), n?.();
  }, l = /* @__PURE__ */ J(
    "div",
    {
      role: t === "error" ? "alert" : "status",
      "data-testid": i,
      className: z(
        "flex items-start gap-2 rounded-md border p-3 text-sm font-medium shadow-md",
        FT[t]
      ),
      children: [
        /* @__PURE__ */ A("span", { className: "min-w-0 flex-1", children: e }),
        /* @__PURE__ */ A(
          "button",
          {
            type: "button",
            "aria-label": "Dismiss",
            onClick: c,
            className: "-mr-1 -mt-0.5 shrink-0 opacity-80 hover:opacity-100",
            children: /* @__PURE__ */ A(Zp, { className: "size-4" })
          }
        )
      ]
    }
  );
  return a ? l : /* @__PURE__ */ A("div", { className: "fixed right-4 top-4 z-50 flex max-w-sm flex-col gap-2", children: l });
}
function aW({
  position: e = "top",
  children: t,
  trigger: r,
  delayDuration: n = 200
}) {
  return r ? /* @__PURE__ */ A(sO, { delayDuration: n, children: /* @__PURE__ */ J(uO, { children: [
    /* @__PURE__ */ A(cO, { asChild: !0, children: r }),
    /* @__PURE__ */ A(lh, { side: e, children: t })
  ] }) }) : /* @__PURE__ */ A("span", { className: "absolute z-50 whitespace-nowrap rounded bg-foreground px-2 py-1 text-xs text-background", children: t });
}
const zT = ({
  label: e,
  info: t,
  className: r
}) => /* @__PURE__ */ J(F1, { children: [
  /* @__PURE__ */ A(z1, { asChild: !0, children: /* @__PURE__ */ A(
    "button",
    {
      type: "button",
      className: z(
        "text-muted-foreground hover:text-foreground hover:border-foreground/30 inline-flex size-4 shrink-0 items-center justify-center rounded-full border border-current text-[10px] font-semibold leading-none transition-colors",
        r
      ),
      "aria-label": `About ${e}`,
      onClick: (n) => n.stopPropagation(),
      children: "i"
    }
  ) }),
  /* @__PURE__ */ J(
    uh,
    {
      align: "end",
      className: "w-72 p-3 text-sm leading-relaxed",
      onClick: (n) => n.stopPropagation(),
      children: [
        /* @__PURE__ */ A("p", { className: "text-foreground font-medium", children: e }),
        /* @__PURE__ */ A("p", { className: "text-muted-foreground mt-1.5 whitespace-pre-wrap", children: t })
      ]
    }
  )
] }), WT = (e) => {
  if (e == null) return null;
  const t = Math.round(e);
  return `${t > 0 ? "+" : ""}${t}%`;
}, UT = new Intl.NumberFormat(void 0, {
  notation: "compact",
  maximumFractionDigits: 1
}), oW = ({
  label: e,
  value: t,
  deltaPct: r,
  subtitle: n,
  info: i,
  className: a
}) => {
  const o = WT(r), s = r == null ? "text-muted-foreground" : r >= 0 ? "text-emerald-600" : "text-rose-600";
  return /* @__PURE__ */ J(
    "div",
    {
      className: z(
        // min-w-0 lets grid columns shrink below the intrinsic width of
        // large numbers + deltas; overflow-hidden clips anything left over.
        // Safe for the info badge because its popover renders in a portal.
        "bg-background relative flex min-h-28 min-w-0 flex-col justify-between overflow-hidden rounded-xl border p-4 shadow-sm",
        a
      ),
      children: [
        i ? /* @__PURE__ */ A("div", { className: "absolute right-3 top-3", children: /* @__PURE__ */ A(zT, { label: e, info: i }) }) : null,
        /* @__PURE__ */ A(
          "div",
          {
            className: z(
              "text-muted-foreground text-xs font-medium uppercase tracking-wide",
              i && "pr-5"
            ),
            children: e
          }
        ),
        /* @__PURE__ */ J("div", { className: "mt-2 min-w-0", children: [
          /* @__PURE__ */ J("div", { className: "flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5", children: [
            /* @__PURE__ */ A(
              "div",
              {
                className: "min-w-0 truncate text-3xl font-semibold tabular-nums tracking-tight",
                title: typeof t == "number" ? t.toLocaleString() : t,
                children: typeof t == "number" ? UT.format(t) : t
              }
            ),
            o != null ? /* @__PURE__ */ J(
              "span",
              {
                className: z(
                  "inline-flex shrink-0 items-center gap-0.5 text-sm font-medium tabular-nums",
                  s
                ),
                children: [
                  /* @__PURE__ */ A("span", { "aria-hidden": !0, className: "text-[0.65rem] leading-none", children: r != null && r >= 0 ? "▲" : "▼" }),
                  o
                ]
              }
            ) : null
          ] }),
          n ? /* @__PURE__ */ A("div", { className: "text-muted-foreground mt-1 text-xs", children: n }) : null
        ] })
      ]
    }
  );
}, lO = 6048e5, GT = 864e5, fO = 6e4, dO = 36e5, $v = Symbol.for("constructDateFrom");
function dt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && $v in e ? e[$v](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Me(e, t) {
  return dt(t || e, e);
}
function HT(e, t, r) {
  const n = Me(e, r?.in);
  return isNaN(t) ? dt(e, NaN) : (n.setDate(n.getDate() + t), n);
}
function pO(e, t, r) {
  const n = Me(e, r?.in);
  if (isNaN(t)) return dt(e, NaN);
  if (!t)
    return n;
  const i = n.getDate(), a = dt(e, n.getTime());
  a.setMonth(n.getMonth() + t + 1, 0);
  const o = a.getDate();
  return i >= o ? a : (n.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    i
  ), n);
}
let VT = {};
function _s() {
  return VT;
}
function Tn(e, t) {
  const r = _s(), n = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, i = Me(e, t?.in), a = i.getDay(), o = (a < n ? 7 : 0) + a - n;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function vo(e, t) {
  return Tn(e, { ...t, weekStartsOn: 1 });
}
function hO(e, t) {
  const r = Me(e, t?.in), n = r.getFullYear(), i = dt(r, 0);
  i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const a = vo(i), o = dt(r, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = vo(o);
  return r.getTime() >= a.getTime() ? n + 1 : r.getTime() >= s.getTime() ? n : n - 1;
}
function Nv(e) {
  const t = Me(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function Ss(e, ...t) {
  const r = dt.bind(
    null,
    t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function br(e, t) {
  const r = Me(e, t?.in);
  return r.setHours(0, 0, 0, 0), r;
}
function KT(e, t, r) {
  const [n, i] = Ss(
    r?.in,
    e,
    t
  ), a = br(n), o = br(i), s = +a - Nv(a), u = +o - Nv(o);
  return Math.round((s - u) / GT);
}
function YT(e, t) {
  const r = hO(e, t), n = dt(e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), vo(n);
}
function XT(e, t, r) {
  const [n, i] = Ss(
    r?.in,
    e,
    t
  );
  return +br(n) == +br(i);
}
function ZT(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function JT(e) {
  return !(!ZT(e) && typeof e != "number" || isNaN(+Me(e)));
}
function QT(e, t) {
  const r = Me(e, t?.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function eE(e, t) {
  const [r, n] = Ss(e, t.start, t.end);
  return { start: r, end: n };
}
function tE(e, t) {
  const { start: r, end: n } = eE(t?.in, e);
  let i = +r > +n;
  const a = i ? +r : +n, o = i ? n : r;
  o.setHours(0, 0, 0, 0);
  let s = 1;
  const u = [];
  for (; +o <= a; )
    u.push(dt(r, o)), o.setDate(o.getDate() + s), o.setHours(0, 0, 0, 0);
  return i ? u.reverse() : u;
}
function Ei(e, t) {
  const r = Me(e, t?.in);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function rE(e, t) {
  const r = Me(e, t?.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function nE(e, t) {
  const r = t?.weekStartsOn, n = Me(e, t?.in), i = n.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return n.setDate(n.getDate() + a), n.setHours(23, 59, 59, 999), n;
}
const iE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, aE = (e, t, r) => {
  let n;
  const i = iE[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function du(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const oE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, sE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, uE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, cE = {
  date: du({
    formats: oE,
    defaultWidth: "full"
  }),
  time: du({
    formats: sE,
    defaultWidth: "full"
  }),
  dateTime: du({
    formats: uE,
    defaultWidth: "full"
  })
}, lE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, fE = (e, t, r, n) => lE[e];
function vi(e) {
  return (t, r) => {
    const n = r?.context ? String(r.context) : "standalone";
    let i;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r?.width ? String(r.width) : o;
      i = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r?.width ? String(r.width) : e.defaultWidth;
      i = e.values[s] || e.values[o];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[a];
  };
}
const dE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, pE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, hE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, vE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, yE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, mE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, gE = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, bE = {
  ordinalNumber: gE,
  era: vi({
    values: dE,
    defaultWidth: "wide"
  }),
  quarter: vi({
    values: pE,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: vi({
    values: hE,
    defaultWidth: "wide"
  }),
  day: vi({
    values: vE,
    defaultWidth: "wide"
  }),
  dayPeriod: vi({
    values: yE,
    defaultWidth: "wide",
    formattingValues: mE,
    defaultFormattingWidth: "wide"
  })
};
function yi(e) {
  return (t, r = {}) => {
    const n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    const o = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? wE(s, (f) => f.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      xE(s, (f) => f.test(o))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(u) : u, c = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(c)
    ) : c;
    const l = t.slice(o.length);
    return { value: c, rest: l };
  };
}
function xE(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function wE(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function OE(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const i = n[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(i.length);
    return { value: o, rest: s };
  };
}
const _E = /^(\d+)(th|st|nd|rd)?/i, SE = /\d+/i, AE = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, PE = {
  any: [/^b/i, /^(a|c)/i]
}, TE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, EE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, CE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ME = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jE = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, kE = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, $E = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, NE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, IE = {
  ordinalNumber: OE({
    matchPattern: _E,
    parsePattern: SE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: yi({
    matchPatterns: AE,
    defaultMatchWidth: "wide",
    parsePatterns: PE,
    defaultParseWidth: "any"
  }),
  quarter: yi({
    matchPatterns: TE,
    defaultMatchWidth: "wide",
    parsePatterns: EE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: yi({
    matchPatterns: CE,
    defaultMatchWidth: "wide",
    parsePatterns: ME,
    defaultParseWidth: "any"
  }),
  day: yi({
    matchPatterns: jE,
    defaultMatchWidth: "wide",
    parsePatterns: kE,
    defaultParseWidth: "any"
  }),
  dayPeriod: yi({
    matchPatterns: $E,
    defaultMatchWidth: "any",
    parsePatterns: NE,
    defaultParseWidth: "any"
  })
}, RE = {
  code: "en-US",
  formatDistance: aE,
  formatLong: cE,
  formatRelative: fE,
  localize: bE,
  match: IE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function DE(e, t) {
  const r = Me(e, t?.in);
  return KT(r, rE(r)) + 1;
}
function LE(e, t) {
  const r = Me(e, t?.in), n = +vo(r) - +YT(r);
  return Math.round(n / lO) + 1;
}
function vO(e, t) {
  const r = Me(e, t?.in), n = r.getFullYear(), i = _s(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = dt(t?.in || e, 0);
  o.setFullYear(n + 1, 0, a), o.setHours(0, 0, 0, 0);
  const s = Tn(o, t), u = dt(t?.in || e, 0);
  u.setFullYear(n, 0, a), u.setHours(0, 0, 0, 0);
  const c = Tn(u, t);
  return +r >= +s ? n + 1 : +r >= +c ? n : n - 1;
}
function qE(e, t) {
  const r = _s(), n = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = vO(e, t), a = dt(t?.in || e, 0);
  return a.setFullYear(i, 0, n), a.setHours(0, 0, 0, 0), Tn(a, t);
}
function BE(e, t) {
  const r = Me(e, t?.in), n = +Tn(r, t) - +qE(r, t);
  return Math.round(n / lO) + 1;
}
function de(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const dr = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return de(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : de(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return de(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return de(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return de(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return de(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return de(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), i = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return de(i, t.length);
  }
}, cn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Iv = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), i = n > 0 ? n : 1 - n;
      return r.ordinalNumber(i, { unit: "year" });
    }
    return dr.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const i = vO(e, n), a = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const o = a % 100;
      return de(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(a, { unit: "year" }) : de(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = hO(e);
    return de(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return de(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return de(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return de(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return dr.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return de(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const i = BE(e, n);
    return t === "wo" ? r.ordinalNumber(i, { unit: "week" }) : de(i, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = LE(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : de(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : dr.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = DE(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : de(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const i = e.getDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return de(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(a, { unit: "day" });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const i = e.getDay(), a = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return de(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), i = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return de(i, t.length);
      // 2nd
      case "io":
        return r.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n === 12 ? i = cn.noon : n === 0 ? i = cn.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n >= 17 ? i = cn.evening : n >= 12 ? i = cn.afternoon : n >= 4 ? i = cn.morning : i = cn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return dr.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : dr.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : de(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : de(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : dr.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : dr.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return dr.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Dv(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Mr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Mr(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Dv(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Mr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Mr(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Rv(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Mr(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Rv(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Mr(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return de(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return de(+e, t.length);
  }
};
function Rv(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.trunc(n / 60), a = n % 60;
  return a === 0 ? r + String(i) : r + String(i) + t + de(a, 2);
}
function Dv(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + de(Math.abs(e) / 60, 2) : Mr(e, t);
}
function Mr(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = de(Math.trunc(n / 60), 2), a = de(n % 60, 2);
  return r + i + t + a;
}
const Lv = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, yO = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, FE = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
  if (!i)
    return Lv(e, t);
  let a;
  switch (n) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Lv(n, t)).replace("{{time}}", yO(i, t));
}, zE = {
  p: yO,
  P: FE
}, WE = /^D+$/, UE = /^Y+$/, GE = ["D", "DD", "YY", "YYYY"];
function HE(e) {
  return WE.test(e);
}
function VE(e) {
  return UE.test(e);
}
function KE(e, t, r) {
  const n = YE(e, t, r);
  if (console.warn(n), GE.includes(e)) throw new RangeError(n);
}
function YE(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const XE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ZE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, JE = /^'([^]*?)'?$/, QE = /''/g, eC = /[a-zA-Z]/;
function qv(e, t, r) {
  const n = _s(), i = n.locale ?? RE, a = n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, s = Me(e, r?.in);
  if (!JT(s))
    throw new RangeError("Invalid time value");
  let u = t.match(ZE).map((l) => {
    const f = l[0];
    if (f === "p" || f === "P") {
      const d = zE[f];
      return d(l, i.formatLong);
    }
    return l;
  }).join("").match(XE).map((l) => {
    if (l === "''")
      return { isToken: !1, value: "'" };
    const f = l[0];
    if (f === "'")
      return { isToken: !1, value: tC(l) };
    if (Iv[f])
      return { isToken: !0, value: l };
    if (f.match(eC))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: l };
  });
  i.localize.preprocessor && (u = i.localize.preprocessor(s, u));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: i
  };
  return u.map((l) => {
    if (!l.isToken) return l.value;
    const f = l.value;
    (VE(f) || HE(f)) && KE(f, t, String(e));
    const d = Iv[f[0]];
    return d(s, f, i.localize, c);
  }).join("");
}
function tC(e) {
  const t = e.match(JE);
  return t ? t[1].replace(QE, "'") : e;
}
function rC(e, t) {
  const r = Me(e, t?.in);
  if (isNaN(+r))
    throw new RangeError("Invalid time value");
  const n = t?.format ?? "extended";
  let i = "";
  const a = n === "extended" ? "-" : "";
  {
    const o = de(r.getDate(), 2), s = de(r.getMonth() + 1, 2);
    i = `${de(r.getFullYear(), 4)}${a}${s}${a}${o}`;
  }
  return i;
}
function mO(e, t) {
  return +Me(e) > +Me(t);
}
function gO(e, t) {
  return +Me(e) < +Me(t);
}
function nC(e, t, r) {
  const [n, i] = Ss(
    r?.in,
    e,
    t
  );
  return n.getFullYear() === i.getFullYear() && n.getMonth() === i.getMonth();
}
function Bv(e, t, r) {
  return HT(e, -29, r);
}
function Ci(e, t) {
  const r = () => dt(t?.in, NaN), i = sC(e);
  let a;
  if (i.date) {
    const c = uC(i.date, 2);
    a = cC(c.restDateString, c.year);
  }
  if (!a || isNaN(+a)) return r();
  const o = +a;
  let s = 0, u;
  if (i.time && (s = lC(i.time), isNaN(s)))
    return r();
  if (i.timezone) {
    if (u = fC(i.timezone), isNaN(u)) return r();
  } else {
    const c = new Date(o + s), l = Me(0, t?.in);
    return l.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), l.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), l;
  }
  return Me(o + s + u, t?.in);
}
const Fa = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, iC = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, aC = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, oC = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function sC(e) {
  const t = {}, r = e.split(Fa.dateTimeDelimiter);
  let n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], Fa.timeZoneDelimiter.test(t.date) && (t.date = e.split(Fa.timeZoneDelimiter)[0], n = e.substr(
    t.date.length,
    e.length
  ))), n) {
    const i = Fa.timezone.exec(n);
    i ? (t.time = n.replace(i[1], ""), t.timezone = i[1]) : t.time = n;
  }
  return t;
}
function uC(e, t) {
  const r = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), n = e.match(r);
  if (!n) return { year: NaN, restDateString: "" };
  const i = n[1] ? parseInt(n[1]) : null, a = n[2] ? parseInt(n[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function cC(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const r = e.match(iC);
  if (!r) return /* @__PURE__ */ new Date(NaN);
  const n = !!r[4], i = mi(r[1]), a = mi(r[2]) - 1, o = mi(r[3]), s = mi(r[4]), u = mi(r[5]) - 1;
  if (n)
    return yC(t, s, u) ? dC(t, s, u) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !hC(t, a, o) || !vC(t, i) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, a, Math.max(i, o)), c);
  }
}
function mi(e) {
  return e ? parseInt(e) : 1;
}
function lC(e) {
  const t = e.match(aC);
  if (!t) return NaN;
  const r = pu(t[1]), n = pu(t[2]), i = pu(t[3]);
  return mC(r, n, i) ? r * dO + n * fO + i * 1e3 : NaN;
}
function pu(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function fC(e) {
  if (e === "Z") return 0;
  const t = e.match(oC);
  if (!t) return 0;
  const r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return gC(n, i) ? r * (n * dO + i * fO) : NaN;
}
function dC(e, t, r) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const i = n.getUTCDay() || 7, a = (t - 1) * 7 + r + 1 - i;
  return n.setUTCDate(n.getUTCDate() + a), n;
}
const pC = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function bO(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function hC(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (pC[t] || (bO(e) ? 29 : 28));
}
function vC(e, t) {
  return t >= 1 && t <= (bO(e) ? 366 : 365);
}
function yC(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function mC(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function gC(e, t) {
  return t >= 0 && t <= 59;
}
function bC(e, t, r) {
  return pO(e, -1, r);
}
const xC = [
  { key: "7d", label: "7d" },
  { key: "30d", label: "30d" },
  { key: "3m", label: "3m" },
  { key: "6m", label: "6m" },
  { key: "12m", label: "12m" },
  { key: "all", label: "All" },
  { key: "custom", label: "Custom" }
], za = (e) => rC(br(e), {}), Wa = (e) => e ? br(Ci(e)) : void 0, Fv = ({
  title: e,
  month: t,
  onMonthChange: r,
  selected: n,
  onSelect: i,
  rangeStart: a,
  rangeEnd: o
}) => {
  const s = xs(() => {
    const u = Tn(Ei(t), { weekStartsOn: 1 }), c = nE(QT(t), { weekStartsOn: 1 });
    return tE({ start: u, end: c });
  }, [t]);
  return /* @__PURE__ */ J("div", { className: "w-[252px]", children: [
    /* @__PURE__ */ A("div", { className: "text-muted-foreground mb-2 text-xs font-semibold uppercase tracking-wide", children: e }),
    /* @__PURE__ */ J("div", { className: "mb-2 flex items-center justify-between", children: [
      /* @__PURE__ */ A(
        Tt,
        {
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "size-8 p-0",
          "aria-label": "Previous month",
          onClick: () => r(bC(t)),
          children: /* @__PURE__ */ A(qP, { className: "size-4" })
        }
      ),
      /* @__PURE__ */ A("div", { className: "text-sm font-medium", children: qv(t, "MMMM yyyy") }),
      /* @__PURE__ */ A(
        Tt,
        {
          type: "button",
          size: "sm",
          variant: "ghost",
          className: "size-8 p-0",
          "aria-label": "Next month",
          onClick: () => r(pO(t, 1)),
          children: /* @__PURE__ */ A(u1, { className: "size-4" })
        }
      )
    ] }),
    /* @__PURE__ */ A("div", { className: "text-muted-foreground mb-1 grid grid-cols-7 gap-0.5 text-center text-[10px] font-medium uppercase", children: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((u) => /* @__PURE__ */ A("div", { className: "py-1", children: u }, u)) }),
    /* @__PURE__ */ A("div", { className: "grid grid-cols-7 gap-0.5", children: s.map((u) => {
      const c = nC(u, t), l = n ? XT(u, n) : !1, f = a && o && !gO(u, a) && !mO(u, o);
      return /* @__PURE__ */ A(
        "button",
        {
          type: "button",
          disabled: !c,
          onClick: () => i(u),
          className: z(
            "h-8 rounded-md text-sm tabular-nums transition-colors",
            !c && "invisible",
            c && !l && "hover:bg-accent",
            f && !l && "bg-accent/60",
            l && "bg-foreground text-background hover:bg-foreground"
          ),
          children: qv(u, "d")
        },
        u.toISOString()
      );
    }) })
  ] });
}, sW = ({
  value: e,
  onChange: t,
  className: r,
  compact: n = !1
}) => {
  const [i, a] = Vt(!1), [o, s] = Vt(e.from), [u, c] = Vt(e.to), [l, f] = Vt(
    () => Ei(Wa(e.from) ?? Bv(/* @__PURE__ */ new Date()))
  ), [d, p] = Vt(
    () => Ei(Wa(e.to) ?? /* @__PURE__ */ new Date())
  ), m = e.preset ?? (e.from && e.to ? "custom" : "30d"), v = () => {
    const w = e.from ?? za(Bv(br(/* @__PURE__ */ new Date()))), O = e.to ?? za(br(/* @__PURE__ */ new Date()));
    s(w), c(O), f(Ei(Ci(w))), p(Ei(Ci(O))), a(!0);
  }, h = Wa(o), g = Wa(u), b = !!(o && u);
  return /* @__PURE__ */ J(
    "div",
    {
      className: z(
        "flex flex-col gap-2",
        n ? "items-end" : void 0,
        r
      ),
      children: [
        /* @__PURE__ */ A(
          "div",
          {
            className: z(
              "bg-background flex flex-wrap gap-0.5 rounded-lg border p-0.5",
              n ? "justify-end" : void 0
            ),
            children: xC.map((w) => /* @__PURE__ */ A(
              Tt,
              {
                type: "button",
                size: "sm",
                variant: m === w.key ? "default" : "ghost",
                className: z(
                  "h-7 px-2.5 text-xs",
                  m === w.key ? void 0 : "text-muted-foreground"
                ),
                onClick: () => {
                  if (w.key === "custom") {
                    v();
                    return;
                  }
                  a(!1), t({ preset: w.key });
                },
                children: w.label
              },
              w.key
            ))
          }
        ),
        /* @__PURE__ */ A(lo, { open: i, onOpenChange: a, children: /* @__PURE__ */ J(Wi, { className: "max-w-fit", children: [
          /* @__PURE__ */ A(po, { children: /* @__PURE__ */ A(ho, { children: "Custom date range" }) }),
          /* @__PURE__ */ J("div", { className: "flex flex-col gap-6 sm:flex-row sm:gap-8", children: [
            /* @__PURE__ */ A(
              Fv,
              {
                title: "Start",
                month: l,
                onMonthChange: f,
                selected: h,
                rangeStart: h,
                rangeEnd: g,
                onSelect: (w) => {
                  const O = za(w);
                  s(O), u && mO(w, Ci(u)) && c(O);
                }
              }
            ),
            /* @__PURE__ */ A(
              Fv,
              {
                title: "End",
                month: d,
                onMonthChange: p,
                selected: g,
                rangeStart: h,
                rangeEnd: g,
                onSelect: (w) => {
                  const O = za(w);
                  c(O), o && gO(w, Ci(o)) && s(O);
                }
              }
            )
          ] }),
          /* @__PURE__ */ J(xn, { className: "gap-2 sm:justify-between", children: [
            /* @__PURE__ */ J("p", { className: "text-muted-foreground self-center text-sm tabular-nums", children: [
              o ?? "—",
              " → ",
              u ?? "—"
            ] }),
            /* @__PURE__ */ J("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ A(
                Tt,
                {
                  type: "button",
                  variant: "outline",
                  onClick: () => a(!1),
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ A(
                Tt,
                {
                  type: "button",
                  disabled: !b,
                  onClick: () => {
                    !o || !u || (t({ from: o, to: u }), a(!1));
                  },
                  children: "Apply"
                }
              )
            ] })
          ] })
        ] }) })
      ]
    }
  );
};
var Ua = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var hu, zv;
function nt() {
  if (zv) return hu;
  zv = 1;
  var e = Array.isArray;
  return hu = e, hu;
}
var vu, Wv;
function xO() {
  if (Wv) return vu;
  Wv = 1;
  var e = typeof Ua == "object" && Ua && Ua.Object === Object && Ua;
  return vu = e, vu;
}
var yu, Uv;
function Bt() {
  if (Uv) return yu;
  Uv = 1;
  var e = xO(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return yu = r, yu;
}
var mu, Gv;
function Ea() {
  if (Gv) return mu;
  Gv = 1;
  var e = Bt(), t = e.Symbol;
  return mu = t, mu;
}
var gu, Hv;
function wC() {
  if (Hv) return gu;
  Hv = 1;
  var e = Ea(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, i = e ? e.toStringTag : void 0;
  function a(o) {
    var s = r.call(o, i), u = o[i];
    try {
      o[i] = void 0;
      var c = !0;
    } catch {
    }
    var l = n.call(o);
    return c && (s ? o[i] = u : delete o[i]), l;
  }
  return gu = a, gu;
}
var bu, Vv;
function OC() {
  if (Vv) return bu;
  Vv = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return bu = r, bu;
}
var xu, Kv;
function ir() {
  if (Kv) return xu;
  Kv = 1;
  var e = Ea(), t = wC(), r = OC(), n = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? i : n : a && a in Object(s) ? t(s) : r(s);
  }
  return xu = o, xu;
}
var wu, Yv;
function ar() {
  if (Yv) return wu;
  Yv = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return wu = e, wu;
}
var Ou, Xv;
function ni() {
  if (Xv) return Ou;
  Xv = 1;
  var e = ir(), t = ar(), r = "[object Symbol]";
  function n(i) {
    return typeof i == "symbol" || t(i) && e(i) == r;
  }
  return Ou = n, Ou;
}
var _u, Zv;
function fh() {
  if (Zv) return _u;
  Zv = 1;
  var e = nt(), t = ni(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function i(a, o) {
    if (e(a))
      return !1;
    var s = typeof a;
    return s == "number" || s == "symbol" || s == "boolean" || a == null || t(a) ? !0 : n.test(a) || !r.test(a) || o != null && a in Object(o);
  }
  return _u = i, _u;
}
var Su, Jv;
function xr() {
  if (Jv) return Su;
  Jv = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Su = e, Su;
}
var Au, Qv;
function dh() {
  if (Qv) return Au;
  Qv = 1;
  var e = ir(), t = xr(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var u = e(s);
    return u == n || u == i || u == r || u == a;
  }
  return Au = o, Au;
}
var Pu, ey;
function _C() {
  if (ey) return Pu;
  ey = 1;
  var e = Bt(), t = e["__core-js_shared__"];
  return Pu = t, Pu;
}
var Tu, ty;
function SC() {
  if (ty) return Tu;
  ty = 1;
  var e = _C(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return Tu = r, Tu;
}
var Eu, ry;
function wO() {
  if (ry) return Eu;
  ry = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Eu = r, Eu;
}
var Cu, ny;
function AC() {
  if (ny) return Cu;
  ny = 1;
  var e = dh(), t = SC(), r = xr(), n = wO(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, u = o.toString, c = s.hasOwnProperty, l = RegExp(
    "^" + u.call(c).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(d) {
    if (!r(d) || t(d))
      return !1;
    var p = e(d) ? l : a;
    return p.test(n(d));
  }
  return Cu = f, Cu;
}
var Mu, iy;
function PC() {
  if (iy) return Mu;
  iy = 1;
  function e(t, r) {
    return t?.[r];
  }
  return Mu = e, Mu;
}
var ju, ay;
function en() {
  if (ay) return ju;
  ay = 1;
  var e = AC(), t = PC();
  function r(n, i) {
    var a = t(n, i);
    return e(a) ? a : void 0;
  }
  return ju = r, ju;
}
var ku, oy;
function As() {
  if (oy) return ku;
  oy = 1;
  var e = en(), t = e(Object, "create");
  return ku = t, ku;
}
var $u, sy;
function TC() {
  if (sy) return $u;
  sy = 1;
  var e = As();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return $u = t, $u;
}
var Nu, uy;
function EC() {
  if (uy) return Nu;
  uy = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Nu = e, Nu;
}
var Iu, cy;
function CC() {
  if (cy) return Iu;
  cy = 1;
  var e = As(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    if (e) {
      var s = o[a];
      return s === t ? void 0 : s;
    }
    return n.call(o, a) ? o[a] : void 0;
  }
  return Iu = i, Iu;
}
var Ru, ly;
function MC() {
  if (ly) return Ru;
  ly = 1;
  var e = As(), t = Object.prototype, r = t.hasOwnProperty;
  function n(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : r.call(a, i);
  }
  return Ru = n, Ru;
}
var Du, fy;
function jC() {
  if (fy) return Du;
  fy = 1;
  var e = As(), t = "__lodash_hash_undefined__";
  function r(n, i) {
    var a = this.__data__;
    return this.size += this.has(n) ? 0 : 1, a[n] = e && i === void 0 ? t : i, this;
  }
  return Du = r, Du;
}
var Lu, dy;
function kC() {
  if (dy) return Lu;
  dy = 1;
  var e = TC(), t = EC(), r = CC(), n = MC(), i = jC();
  function a(o) {
    var s = -1, u = o == null ? 0 : o.length;
    for (this.clear(); ++s < u; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Lu = a, Lu;
}
var qu, py;
function $C() {
  if (py) return qu;
  py = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return qu = e, qu;
}
var Bu, hy;
function ph() {
  if (hy) return Bu;
  hy = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Bu = e, Bu;
}
var Fu, vy;
function Ps() {
  if (vy) return Fu;
  vy = 1;
  var e = ph();
  function t(r, n) {
    for (var i = r.length; i--; )
      if (e(r[i][0], n))
        return i;
    return -1;
  }
  return Fu = t, Fu;
}
var zu, yy;
function NC() {
  if (yy) return zu;
  yy = 1;
  var e = Ps(), t = Array.prototype, r = t.splice;
  function n(i) {
    var a = this.__data__, o = e(a, i);
    if (o < 0)
      return !1;
    var s = a.length - 1;
    return o == s ? a.pop() : r.call(a, o, 1), --this.size, !0;
  }
  return zu = n, zu;
}
var Wu, my;
function IC() {
  if (my) return Wu;
  my = 1;
  var e = Ps();
  function t(r) {
    var n = this.__data__, i = e(n, r);
    return i < 0 ? void 0 : n[i][1];
  }
  return Wu = t, Wu;
}
var Uu, gy;
function RC() {
  if (gy) return Uu;
  gy = 1;
  var e = Ps();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Uu = t, Uu;
}
var Gu, by;
function DC() {
  if (by) return Gu;
  by = 1;
  var e = Ps();
  function t(r, n) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? (++this.size, i.push([r, n])) : i[a][1] = n, this;
  }
  return Gu = t, Gu;
}
var Hu, xy;
function Ts() {
  if (xy) return Hu;
  xy = 1;
  var e = $C(), t = NC(), r = IC(), n = RC(), i = DC();
  function a(o) {
    var s = -1, u = o == null ? 0 : o.length;
    for (this.clear(); ++s < u; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Hu = a, Hu;
}
var Vu, wy;
function hh() {
  if (wy) return Vu;
  wy = 1;
  var e = en(), t = Bt(), r = e(t, "Map");
  return Vu = r, Vu;
}
var Ku, Oy;
function LC() {
  if (Oy) return Ku;
  Oy = 1;
  var e = kC(), t = Ts(), r = hh();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Ku = n, Ku;
}
var Yu, _y;
function qC() {
  if (_y) return Yu;
  _y = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Yu = e, Yu;
}
var Xu, Sy;
function Es() {
  if (Sy) return Xu;
  Sy = 1;
  var e = qC();
  function t(r, n) {
    var i = r.__data__;
    return e(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
  }
  return Xu = t, Xu;
}
var Zu, Ay;
function BC() {
  if (Ay) return Zu;
  Ay = 1;
  var e = Es();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Zu = t, Zu;
}
var Ju, Py;
function FC() {
  if (Py) return Ju;
  Py = 1;
  var e = Es();
  function t(r) {
    return e(this, r).get(r);
  }
  return Ju = t, Ju;
}
var Qu, Ty;
function zC() {
  if (Ty) return Qu;
  Ty = 1;
  var e = Es();
  function t(r) {
    return e(this, r).has(r);
  }
  return Qu = t, Qu;
}
var ec, Ey;
function WC() {
  if (Ey) return ec;
  Ey = 1;
  var e = Es();
  function t(r, n) {
    var i = e(this, r), a = i.size;
    return i.set(r, n), this.size += i.size == a ? 0 : 1, this;
  }
  return ec = t, ec;
}
var tc, Cy;
function vh() {
  if (Cy) return tc;
  Cy = 1;
  var e = LC(), t = BC(), r = FC(), n = zC(), i = WC();
  function a(o) {
    var s = -1, u = o == null ? 0 : o.length;
    for (this.clear(); ++s < u; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, tc = a, tc;
}
var rc, My;
function OO() {
  if (My) return rc;
  My = 1;
  var e = vh(), t = "Expected a function";
  function r(n, i) {
    if (typeof n != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var a = function() {
      var o = arguments, s = i ? i.apply(this, o) : o[0], u = a.cache;
      if (u.has(s))
        return u.get(s);
      var c = n.apply(this, o);
      return a.cache = u.set(s, c) || u, c;
    };
    return a.cache = new (r.Cache || e)(), a;
  }
  return r.Cache = e, rc = r, rc;
}
var nc, jy;
function UC() {
  if (jy) return nc;
  jy = 1;
  var e = OO(), t = 500;
  function r(n) {
    var i = e(n, function(o) {
      return a.size === t && a.clear(), o;
    }), a = i.cache;
    return i;
  }
  return nc = r, nc;
}
var ic, ky;
function GC() {
  if (ky) return ic;
  ky = 1;
  var e = UC(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(i) {
    var a = [];
    return i.charCodeAt(0) === 46 && a.push(""), i.replace(t, function(o, s, u, c) {
      a.push(u ? c.replace(r, "$1") : s || o);
    }), a;
  });
  return ic = n, ic;
}
var ac, $y;
function yh() {
  if ($y) return ac;
  $y = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, a = Array(i); ++n < i; )
      a[n] = r(t[n], n, t);
    return a;
  }
  return ac = e, ac;
}
var oc, Ny;
function HC() {
  if (Ny) return oc;
  Ny = 1;
  var e = Ea(), t = yh(), r = nt(), n = ni(), i = e ? e.prototype : void 0, a = i ? i.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, o) + "";
    if (n(s))
      return a ? a.call(s) : "";
    var u = s + "";
    return u == "0" && 1 / s == -1 / 0 ? "-0" : u;
  }
  return oc = o, oc;
}
var sc, Iy;
function _O() {
  if (Iy) return sc;
  Iy = 1;
  var e = HC();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return sc = t, sc;
}
var uc, Ry;
function SO() {
  if (Ry) return uc;
  Ry = 1;
  var e = nt(), t = fh(), r = GC(), n = _O();
  function i(a, o) {
    return e(a) ? a : t(a, o) ? [a] : r(n(a));
  }
  return uc = i, uc;
}
var cc, Dy;
function Cs() {
  if (Dy) return cc;
  Dy = 1;
  var e = ni();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return cc = t, cc;
}
var lc, Ly;
function mh() {
  if (Ly) return lc;
  Ly = 1;
  var e = SO(), t = Cs();
  function r(n, i) {
    i = e(i, n);
    for (var a = 0, o = i.length; n != null && a < o; )
      n = n[t(i[a++])];
    return a && a == o ? n : void 0;
  }
  return lc = r, lc;
}
var fc, qy;
function AO() {
  if (qy) return fc;
  qy = 1;
  var e = mh();
  function t(r, n, i) {
    var a = r == null ? void 0 : e(r, n);
    return a === void 0 ? i : a;
  }
  return fc = t, fc;
}
var VC = AO();
const ut = /* @__PURE__ */ xe(VC);
var dc, By;
function KC() {
  if (By) return dc;
  By = 1;
  function e(t) {
    return t == null;
  }
  return dc = e, dc;
}
var YC = KC();
const se = /* @__PURE__ */ xe(YC);
var pc, Fy;
function XC() {
  if (Fy) return pc;
  Fy = 1;
  var e = ir(), t = nt(), r = ar(), n = "[object String]";
  function i(a) {
    return typeof a == "string" || !t(a) && r(a) && e(a) == n;
  }
  return pc = i, pc;
}
var ZC = XC();
const Hr = /* @__PURE__ */ xe(ZC);
var JC = dh();
const ie = /* @__PURE__ */ xe(JC);
var QC = xr();
const ii = /* @__PURE__ */ xe(QC);
var Ga = { exports: {} }, he = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zy;
function e3() {
  if (zy) return he;
  zy = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(h) {
    if (typeof h == "object" && h !== null) {
      var g = h.$$typeof;
      switch (g) {
        case e:
          switch (h = h.type, h) {
            case r:
            case i:
            case n:
            case c:
            case l:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case s:
                case o:
                case u:
                case d:
                case f:
                case a:
                  return h;
                default:
                  return g;
              }
          }
        case t:
          return g;
      }
    }
  }
  return he.ContextConsumer = o, he.ContextProvider = a, he.Element = e, he.ForwardRef = u, he.Fragment = r, he.Lazy = d, he.Memo = f, he.Portal = t, he.Profiler = i, he.StrictMode = n, he.Suspense = c, he.SuspenseList = l, he.isAsyncMode = function() {
    return !1;
  }, he.isConcurrentMode = function() {
    return !1;
  }, he.isContextConsumer = function(h) {
    return v(h) === o;
  }, he.isContextProvider = function(h) {
    return v(h) === a;
  }, he.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, he.isForwardRef = function(h) {
    return v(h) === u;
  }, he.isFragment = function(h) {
    return v(h) === r;
  }, he.isLazy = function(h) {
    return v(h) === d;
  }, he.isMemo = function(h) {
    return v(h) === f;
  }, he.isPortal = function(h) {
    return v(h) === t;
  }, he.isProfiler = function(h) {
    return v(h) === i;
  }, he.isStrictMode = function(h) {
    return v(h) === n;
  }, he.isSuspense = function(h) {
    return v(h) === c;
  }, he.isSuspenseList = function(h) {
    return v(h) === l;
  }, he.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === i || h === n || h === c || h === l || h === p || typeof h == "object" && h !== null && (h.$$typeof === d || h.$$typeof === f || h.$$typeof === a || h.$$typeof === o || h.$$typeof === u || h.$$typeof === m || h.getModuleId !== void 0);
  }, he.typeOf = v, he;
}
var ve = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wy;
function t3() {
  return Wy || (Wy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = !1, v = !1, h = !1, g = !1, b = !1, w;
    w = Symbol.for("react.module.reference");
    function O(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === r || G === i || b || G === n || G === c || G === l || g || G === p || m || v || h || typeof G == "object" && G !== null && (G.$$typeof === d || G.$$typeof === f || G.$$typeof === a || G.$$typeof === o || G.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === w || G.getModuleId !== void 0));
    }
    function y(G) {
      if (typeof G == "object" && G !== null) {
        var Oe = G.$$typeof;
        switch (Oe) {
          case e:
            var Ee = G.type;
            switch (Ee) {
              case r:
              case i:
              case n:
              case c:
              case l:
                return Ee;
              default:
                var Ue = Ee && Ee.$$typeof;
                switch (Ue) {
                  case s:
                  case o:
                  case u:
                  case d:
                  case f:
                  case a:
                    return Ue;
                  default:
                    return Oe;
                }
            }
          case t:
            return Oe;
        }
      }
    }
    var x = o, _ = a, P = e, E = u, M = r, C = d, T = f, k = t, N = i, I = n, R = c, q = l, W = !1, H = !1;
    function $(G) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(G) {
      return H || (H = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(G) {
      return y(G) === o;
    }
    function V(G) {
      return y(G) === a;
    }
    function X(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function te(G) {
      return y(G) === u;
    }
    function re(G) {
      return y(G) === r;
    }
    function oe(G) {
      return y(G) === d;
    }
    function ae(G) {
      return y(G) === f;
    }
    function F(G) {
      return y(G) === t;
    }
    function Y(G) {
      return y(G) === i;
    }
    function ee(G) {
      return y(G) === n;
    }
    function j(G) {
      return y(G) === c;
    }
    function fe(G) {
      return y(G) === l;
    }
    ve.ContextConsumer = x, ve.ContextProvider = _, ve.Element = P, ve.ForwardRef = E, ve.Fragment = M, ve.Lazy = C, ve.Memo = T, ve.Portal = k, ve.Profiler = N, ve.StrictMode = I, ve.Suspense = R, ve.SuspenseList = q, ve.isAsyncMode = $, ve.isConcurrentMode = L, ve.isContextConsumer = B, ve.isContextProvider = V, ve.isElement = X, ve.isForwardRef = te, ve.isFragment = re, ve.isLazy = oe, ve.isMemo = ae, ve.isPortal = F, ve.isProfiler = Y, ve.isStrictMode = ee, ve.isSuspense = j, ve.isSuspenseList = fe, ve.isValidElementType = O, ve.typeOf = y;
  }()), ve;
}
var Uy;
function r3() {
  return Uy || (Uy = 1, process.env.NODE_ENV === "production" ? Ga.exports = e3() : Ga.exports = t3()), Ga.exports;
}
var n3 = r3(), hc, Gy;
function PO() {
  if (Gy) return hc;
  Gy = 1;
  var e = ir(), t = ar(), r = "[object Number]";
  function n(i) {
    return typeof i == "number" || t(i) && e(i) == r;
  }
  return hc = n, hc;
}
var vc, Hy;
function i3() {
  if (Hy) return vc;
  Hy = 1;
  var e = PO();
  function t(r) {
    return e(r) && r != +r;
  }
  return vc = t, vc;
}
var a3 = i3();
const ai = /* @__PURE__ */ xe(a3);
var o3 = PO();
const s3 = /* @__PURE__ */ xe(o3);
var Ye = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, Ir = function(t) {
  return Hr(t) && t.indexOf("%") === t.length - 1;
}, U = function(t) {
  return s3(t) && !ai(t);
}, u3 = function(t) {
  return se(t);
}, qe = function(t) {
  return U(t) || Hr(t);
}, c3 = 0, tn = function(t) {
  var r = ++c3;
  return "".concat(t || "").concat(r);
}, Xe = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!U(t) && !Hr(t))
    return n;
  var a;
  if (Ir(t)) {
    var o = t.indexOf("%");
    a = r * parseFloat(t.slice(0, o)) / 100;
  } else
    a = +t;
  return ai(a) && (a = n), i && a > r && (a = r), a;
}, vr = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, l3 = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, i = 0; i < r; i++)
    if (!n[t[i]])
      n[t[i]] = !0;
    else
      return !0;
  return !1;
}, Le = function(t, r) {
  return U(t) && U(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function yo(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : ut(n, t)) === r;
  });
}
var f3 = function(t, r) {
  return U(t) && U(r) ? t - r : Hr(t) && Hr(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
};
function wn(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function Pd(e) {
  "@babel/helpers - typeof";
  return Pd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pd(e);
}
var d3 = ["viewBox", "children"], p3 = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], Vy = ["points", "pathLength"], yc = {
  svg: d3,
  polygon: Vy,
  polyline: Vy
}, gh = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], mo = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ Pt(t) && (n = t.props), !ii(n))
    return null;
  var i = {};
  return Object.keys(n).forEach(function(a) {
    gh.includes(a) && (i[a] = r || function(o) {
      return n[a](n, o);
    });
  }), i;
}, h3 = function(t, r, n) {
  return function(i) {
    return t(r, n, i), null;
  };
}, Vr = function(t, r, n) {
  if (!ii(t) || Pd(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(a) {
    var o = t[a];
    gh.includes(a) && typeof o == "function" && (i || (i = {}), i[a] = h3(o, r, n));
  }), i;
}, v3 = ["children"], y3 = ["children"];
function Ky(e, t) {
  if (e == null) return {};
  var r = m3(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function m3(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Td(e) {
  "@babel/helpers - typeof";
  return Td = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Td(e);
}
var Yy = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Jt = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, Xy = null, mc = null, bh = function e(t) {
  if (t === Xy && Array.isArray(mc))
    return mc;
  var r = [];
  return Br.forEach(t, function(n) {
    se(n) || (n3.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), mc = r, Xy = t, r;
};
function ct(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(i) {
    return Jt(i);
  }) : n = [Jt(t)], bh(e).forEach(function(i) {
    var a = ut(i, "type.displayName") || ut(i, "type.name");
    n.indexOf(a) !== -1 && r.push(i);
  }), r;
}
function ot(e, t) {
  var r = ct(e, t);
  return r && r[0];
}
var Zy = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, i = r.height;
  return !(!U(n) || n <= 0 || !U(i) || i <= 0);
}, g3 = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], b3 = function(t) {
  return t && t.type && Hr(t.type) && g3.indexOf(t.type) >= 0;
}, TO = function(t) {
  return t && Td(t) === "object" && "clipDot" in t;
}, x3 = function(t, r, n, i) {
  var a, o = (a = yc?.[i]) !== null && a !== void 0 ? a : [];
  return r.startsWith("data-") || !ie(t) && (i && o.includes(r) || p3.includes(r)) || n && gh.includes(r);
}, Q = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ Pt(t) && (i = t.props), !ii(i))
    return null;
  var a = {};
  return Object.keys(i).forEach(function(o) {
    var s;
    x3((s = i) === null || s === void 0 ? void 0 : s[o], o, r, n) && (a[o] = i[o]);
  }), a;
}, Ed = function e(t, r) {
  if (t === r)
    return !0;
  var n = Br.count(t);
  if (n !== Br.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return Jy(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var i = 0; i < n; i++) {
    var a = t[i], o = r[i];
    if (Array.isArray(a) || Array.isArray(o)) {
      if (!e(a, o))
        return !1;
    } else if (!Jy(a, o))
      return !1;
  }
  return !0;
}, Jy = function(t, r) {
  if (se(t) && se(r))
    return !0;
  if (!se(t) && !se(r)) {
    var n = t.props || {}, i = n.children, a = Ky(n, v3), o = r.props || {}, s = o.children, u = Ky(o, y3);
    return i && s ? wn(a, u) && Ed(i, s) : !i && !s ? wn(a, u) : !1;
  }
  return !1;
}, Qy = function(t, r) {
  var n = [], i = {};
  return bh(t).forEach(function(a, o) {
    if (b3(a))
      n.push(a);
    else if (a) {
      var s = Jt(a.type), u = r[s] || {}, c = u.handler, l = u.once;
      if (c && (!l || !i[s])) {
        var f = c(a, s, o);
        n.push(f), i[s] = !0;
      }
    }
  }), n;
}, w3 = function(t) {
  var r = t && t.type;
  return r && Yy[r] ? Yy[r] : null;
}, O3 = function(t, r) {
  return bh(r).indexOf(t);
}, _3 = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function Cd() {
  return Cd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cd.apply(this, arguments);
}
function S3(e, t) {
  if (e == null) return {};
  var r = A3(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function A3(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Md(e) {
  var t = e.children, r = e.width, n = e.height, i = e.viewBox, a = e.className, o = e.style, s = e.title, u = e.desc, c = S3(e, _3), l = i || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = ue("recharts-surface", a);
  return /* @__PURE__ */ S.createElement("svg", Cd({}, Q(c, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(l.x, " ").concat(l.y, " ").concat(l.width, " ").concat(l.height)
  }), /* @__PURE__ */ S.createElement("title", null, s), /* @__PURE__ */ S.createElement("desc", null, u), t);
}
var P3 = ["children", "className"];
function jd() {
  return jd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jd.apply(this, arguments);
}
function T3(e, t) {
  if (e == null) return {};
  var r = E3(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function E3(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var le = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.children, n = e.className, i = T3(e, P3), a = ue("recharts-layer", n);
  return /* @__PURE__ */ S.createElement("g", jd({
    className: a
  }, Q(i, !0), {
    ref: t
  }), r);
}), C3 = process.env.NODE_ENV !== "production", Et = function(t, r) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    i[a - 2] = arguments[a];
  if (C3 && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return i[o++];
      }));
    }
}, gc, em;
function M3() {
  if (em) return gc;
  em = 1;
  function e(t, r, n) {
    var i = -1, a = t.length;
    r < 0 && (r = -r > a ? 0 : a + r), n = n > a ? a : n, n < 0 && (n += a), a = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(a); ++i < a; )
      o[i] = t[i + r];
    return o;
  }
  return gc = e, gc;
}
var bc, tm;
function j3() {
  if (tm) return bc;
  tm = 1;
  var e = M3();
  function t(r, n, i) {
    var a = r.length;
    return i = i === void 0 ? a : i, !n && i >= a ? r : e(r, n, i);
  }
  return bc = t, bc;
}
var xc, rm;
function EO() {
  if (rm) return xc;
  rm = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, a = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + i + a + "]");
  function u(c) {
    return s.test(c);
  }
  return xc = u, xc;
}
var wc, nm;
function k3() {
  if (nm) return wc;
  nm = 1;
  function e(t) {
    return t.split("");
  }
  return wc = e, wc;
}
var Oc, im;
function $3() {
  if (im) return Oc;
  im = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, a = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + i + "]", u = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + s + "|" + u + ")", l = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", d = "[\\ud800-\\udbff][\\udc00-\\udfff]", p = "\\u200d", m = c + "?", v = "[" + a + "]?", h = "(?:" + p + "(?:" + [l, f, d].join("|") + ")" + v + m + ")*", g = v + m + h, b = "(?:" + [l + s + "?", s, f, d, o].join("|") + ")", w = RegExp(u + "(?=" + u + ")|" + b + g, "g");
  function O(y) {
    return y.match(w) || [];
  }
  return Oc = O, Oc;
}
var _c, am;
function N3() {
  if (am) return _c;
  am = 1;
  var e = k3(), t = EO(), r = $3();
  function n(i) {
    return t(i) ? r(i) : e(i);
  }
  return _c = n, _c;
}
var Sc, om;
function I3() {
  if (om) return Sc;
  om = 1;
  var e = j3(), t = EO(), r = N3(), n = _O();
  function i(a) {
    return function(o) {
      o = n(o);
      var s = t(o) ? r(o) : void 0, u = s ? s[0] : o.charAt(0), c = s ? e(s, 1).join("") : o.slice(1);
      return u[a]() + c;
    };
  }
  return Sc = i, Sc;
}
var Ac, sm;
function R3() {
  if (sm) return Ac;
  sm = 1;
  var e = I3(), t = e("toUpperCase");
  return Ac = t, Ac;
}
var D3 = R3();
const Ms = /* @__PURE__ */ xe(D3);
function Se(e) {
  return function() {
    return e;
  };
}
const CO = Math.cos, go = Math.sin, jt = Math.sqrt, bo = Math.PI, js = 2 * bo, kd = Math.PI, $d = 2 * kd, jr = 1e-6, L3 = $d - jr;
function MO(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function q3(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return MO;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let i = 1, a = n.length; i < a; ++i)
      this._ += Math.round(arguments[i] * r) / r + n[i];
  };
}
class B3 {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? MO : q3(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, i) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +i}`;
  }
  bezierCurveTo(t, r, n, i, a, o) {
    this._append`C${+t},${+r},${+n},${+i},${this._x1 = +a},${this._y1 = +o}`;
  }
  arcTo(t, r, n, i, a) {
    if (t = +t, r = +r, n = +n, i = +i, a = +a, a < 0) throw new Error(`negative radius: ${a}`);
    let o = this._x1, s = this._y1, u = n - t, c = i - r, l = o - t, f = s - r, d = l * l + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > jr) if (!(Math.abs(f * u - c * l) > jr) || !a)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let p = n - o, m = i - s, v = u * u + c * c, h = p * p + m * m, g = Math.sqrt(v), b = Math.sqrt(d), w = a * Math.tan((kd - Math.acos((v + d - h) / (2 * g * b))) / 2), O = w / b, y = w / g;
      Math.abs(O - 1) > jr && this._append`L${t + O * l},${r + O * f}`, this._append`A${a},${a},0,0,${+(f * p > l * m)},${this._x1 = t + y * u},${this._y1 = r + y * c}`;
    }
  }
  arc(t, r, n, i, a, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(i), u = n * Math.sin(i), c = t + s, l = r + u, f = 1 ^ o, d = o ? i - a : a - i;
    this._x1 === null ? this._append`M${c},${l}` : (Math.abs(this._x1 - c) > jr || Math.abs(this._y1 - l) > jr) && this._append`L${c},${l}`, n && (d < 0 && (d = d % $d + $d), d > L3 ? this._append`A${n},${n},0,1,${f},${t - s},${r - u}A${n},${n},0,1,${f},${this._x1 = c},${this._y1 = l}` : d > jr && this._append`A${n},${n},0,${+(d >= kd)},${f},${this._x1 = t + n * Math.cos(a)},${this._y1 = r + n * Math.sin(a)}`);
  }
  rect(t, r, n, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+i}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function xh(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new B3(t);
}
function wh(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function jO(e) {
  this._context = e;
}
jO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function ks(e) {
  return new jO(e);
}
function kO(e) {
  return e[0];
}
function $O(e) {
  return e[1];
}
function NO(e, t) {
  var r = Se(!0), n = null, i = ks, a = null, o = xh(s);
  e = typeof e == "function" ? e : e === void 0 ? kO : Se(e), t = typeof t == "function" ? t : t === void 0 ? $O : Se(t);
  function s(u) {
    var c, l = (u = wh(u)).length, f, d = !1, p;
    for (n == null && (a = i(p = o())), c = 0; c <= l; ++c)
      !(c < l && r(f = u[c], c, u)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(f, c, u), +t(f, c, u));
    if (p) return a = null, p + "" || null;
  }
  return s.x = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : Se(+u), s) : e;
  }, s.y = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : Se(+u), s) : t;
  }, s.defined = function(u) {
    return arguments.length ? (r = typeof u == "function" ? u : Se(!!u), s) : r;
  }, s.curve = function(u) {
    return arguments.length ? (i = u, n != null && (a = i(n)), s) : i;
  }, s.context = function(u) {
    return arguments.length ? (u == null ? n = a = null : a = i(n = u), s) : n;
  }, s;
}
function Ha(e, t, r) {
  var n = null, i = Se(!0), a = null, o = ks, s = null, u = xh(c);
  e = typeof e == "function" ? e : e === void 0 ? kO : Se(+e), t = typeof t == "function" ? t : Se(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? $O : Se(+r);
  function c(f) {
    var d, p, m, v = (f = wh(f)).length, h, g = !1, b, w = new Array(v), O = new Array(v);
    for (a == null && (s = o(b = u())), d = 0; d <= v; ++d) {
      if (!(d < v && i(h = f[d], d, f)) === g)
        if (g = !g)
          p = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), m = d - 1; m >= p; --m)
            s.point(w[m], O[m]);
          s.lineEnd(), s.areaEnd();
        }
      g && (w[d] = +e(h, d, f), O[d] = +t(h, d, f), s.point(n ? +n(h, d, f) : w[d], r ? +r(h, d, f) : O[d]));
    }
    if (b) return s = null, b + "" || null;
  }
  function l() {
    return NO().defined(i).curve(o).context(a);
  }
  return c.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Se(+f), n = null, c) : e;
  }, c.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Se(+f), c) : e;
  }, c.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : Se(+f), c) : n;
  }, c.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Se(+f), r = null, c) : t;
  }, c.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Se(+f), c) : t;
  }, c.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : Se(+f), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return l().x(e).y(t);
  }, c.lineY1 = function() {
    return l().x(e).y(r);
  }, c.lineX1 = function() {
    return l().x(n).y(t);
  }, c.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : Se(!!f), c) : i;
  }, c.curve = function(f) {
    return arguments.length ? (o = f, a != null && (s = o(a)), c) : o;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? a = s = null : s = o(a = f), c) : a;
  }, c;
}
class IO {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function F3(e) {
  return new IO(e, !0);
}
function z3(e) {
  return new IO(e, !1);
}
const Oh = {
  draw(e, t) {
    const r = jt(t / bo);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, js);
  }
}, W3 = {
  draw(e, t) {
    const r = jt(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, RO = jt(1 / 3), U3 = RO * 2, G3 = {
  draw(e, t) {
    const r = jt(t / U3), n = r * RO;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, H3 = {
  draw(e, t) {
    const r = jt(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, V3 = 0.8908130915292852, DO = go(bo / 10) / go(7 * bo / 10), K3 = go(js / 10) * DO, Y3 = -CO(js / 10) * DO, X3 = {
  draw(e, t) {
    const r = jt(t * V3), n = K3 * r, i = Y3 * r;
    e.moveTo(0, -r), e.lineTo(n, i);
    for (let a = 1; a < 5; ++a) {
      const o = js * a / 5, s = CO(o), u = go(o);
      e.lineTo(u * r, -s * r), e.lineTo(s * n - u * i, u * n + s * i);
    }
    e.closePath();
  }
}, Pc = jt(3), Z3 = {
  draw(e, t) {
    const r = -jt(t / (Pc * 3));
    e.moveTo(0, r * 2), e.lineTo(-Pc * r, -r), e.lineTo(Pc * r, -r), e.closePath();
  }
}, pt = -0.5, ht = jt(3) / 2, Nd = 1 / jt(12), J3 = (Nd / 2 + 1) * 3, Q3 = {
  draw(e, t) {
    const r = jt(t / J3), n = r / 2, i = r * Nd, a = n, o = r * Nd + r, s = -a, u = o;
    e.moveTo(n, i), e.lineTo(a, o), e.lineTo(s, u), e.lineTo(pt * n - ht * i, ht * n + pt * i), e.lineTo(pt * a - ht * o, ht * a + pt * o), e.lineTo(pt * s - ht * u, ht * s + pt * u), e.lineTo(pt * n + ht * i, pt * i - ht * n), e.lineTo(pt * a + ht * o, pt * o - ht * a), e.lineTo(pt * s + ht * u, pt * u - ht * s), e.closePath();
  }
};
function e6(e, t) {
  let r = null, n = xh(i);
  e = typeof e == "function" ? e : Se(e || Oh), t = typeof t == "function" ? t : Se(t === void 0 ? 64 : +t);
  function i() {
    let a;
    if (r || (r = a = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), a) return r = null, a + "" || null;
  }
  return i.type = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Se(a), i) : e;
  }, i.size = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Se(+a), i) : t;
  }, i.context = function(a) {
    return arguments.length ? (r = a ?? null, i) : r;
  }, i;
}
function xo() {
}
function wo(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function LO(e) {
  this._context = e;
}
LO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        wo(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        wo(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function t6(e) {
  return new LO(e);
}
function qO(e) {
  this._context = e;
}
qO.prototype = {
  areaStart: xo,
  areaEnd: xo,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        wo(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function r6(e) {
  return new qO(e);
}
function BO(e) {
  this._context = e;
}
BO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        wo(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function n6(e) {
  return new BO(e);
}
function FO(e) {
  this._context = e;
}
FO.prototype = {
  areaStart: xo,
  areaEnd: xo,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function i6(e) {
  return new FO(e);
}
function um(e) {
  return e < 0 ? -1 : 1;
}
function cm(e, t, r) {
  var n = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (n || i < 0 && -0), o = (r - e._y1) / (i || n < 0 && -0), s = (a * i + o * n) / (n + i);
  return (um(a) + um(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function lm(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function Tc(e, t, r) {
  var n = e._x0, i = e._y0, a = e._x1, o = e._y1, s = (a - n) / 3;
  e._context.bezierCurveTo(n + s, i + s * t, a - s, o - s * r, a, o);
}
function Oo(e) {
  this._context = e;
}
Oo.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Tc(this, this._t0, lm(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Tc(this, lm(this, r = cm(this, e, t)), r);
          break;
        default:
          Tc(this, this._t0, r = cm(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function zO(e) {
  this._context = new WO(e);
}
(zO.prototype = Object.create(Oo.prototype)).point = function(e, t) {
  Oo.prototype.point.call(this, t, e);
};
function WO(e) {
  this._context = e;
}
WO.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, i, a) {
    this._context.bezierCurveTo(t, e, n, r, a, i);
  }
};
function a6(e) {
  return new Oo(e);
}
function o6(e) {
  return new zO(e);
}
function UO(e) {
  this._context = e;
}
UO.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = fm(e), i = fm(t), a = 0, o = 1; o < r; ++a, ++o)
          this._context.bezierCurveTo(n[0][a], i[0][a], n[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function fm(e) {
  var t, r = e.length - 1, n, i = new Array(r), a = new Array(r), o = new Array(r);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = i[t] / a[t - 1], a[t] -= n, o[t] -= n * o[t - 1];
  for (i[r - 1] = o[r - 1] / a[r - 1], t = r - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[r - 1] = (e[r] + i[r - 1]) / 2, t = 0; t < r - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function s6(e) {
  return new UO(e);
}
function $s(e, t) {
  this._context = e, this._t = t;
}
$s.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function u6(e) {
  return new $s(e, 0.5);
}
function c6(e) {
  return new $s(e, 0);
}
function l6(e) {
  return new $s(e, 1);
}
function En(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, i, a = e[t[0]], o, s = a.length; r < o; ++r)
      for (i = a, a = e[t[r]], n = 0; n < s; ++n)
        a[n][1] += a[n][0] = isNaN(i[n][1]) ? i[n][0] : i[n][1];
}
function Id(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function f6(e, t) {
  return e[t];
}
function d6(e) {
  const t = [];
  return t.key = e, t;
}
function p6() {
  var e = Se([]), t = Id, r = En, n = f6;
  function i(a) {
    var o = Array.from(e.apply(this, arguments), d6), s, u = o.length, c = -1, l;
    for (const f of a)
      for (s = 0, ++c; s < u; ++s)
        (o[s][c] = [0, +n(f, o[s].key, c, a)]).data = f;
    for (s = 0, l = wh(t(o)); s < u; ++s)
      o[l[s]].index = s;
    return r(o, l), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Se(Array.from(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : Se(+a), i) : n;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? Id : typeof a == "function" ? a : Se(Array.from(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (r = a ?? En, i) : r;
  }, i;
}
function h6(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = r = 0; r < n; ++r) o += e[r][i][1] || 0;
      if (o) for (r = 0; r < n; ++r) e[r][i][1] /= o;
    }
    En(e, t);
  }
}
function v6(e, t) {
  if ((i = e.length) > 0) {
    for (var r = 0, n = e[t[0]], i, a = n.length; r < a; ++r) {
      for (var o = 0, s = 0; o < i; ++o) s += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    En(e, t);
  }
}
function y6(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, i, a, o; n < a; ++n) {
      for (var s = 0, u = 0, c = 0; s < o; ++s) {
        for (var l = e[t[s]], f = l[n][1] || 0, d = l[n - 1][1] || 0, p = (f - d) / 2, m = 0; m < s; ++m) {
          var v = e[t[m]], h = v[n][1] || 0, g = v[n - 1][1] || 0;
          p += h - g;
        }
        u += f, c += p * f;
      }
      i[n - 1][1] += i[n - 1][0] = r, u && (r -= c / u);
    }
    i[n - 1][1] += i[n - 1][0] = r, En(e, t);
  }
}
function Ui(e) {
  "@babel/helpers - typeof";
  return Ui = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ui(e);
}
var m6 = ["type", "size", "sizeType"];
function Rd() {
  return Rd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rd.apply(this, arguments);
}
function dm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dm(Object(r), !0).forEach(function(n) {
      g6(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function g6(e, t, r) {
  return t = b6(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function b6(e) {
  var t = x6(e, "string");
  return Ui(t) == "symbol" ? t : t + "";
}
function x6(e, t) {
  if (Ui(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ui(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function w6(e, t) {
  if (e == null) return {};
  var r = O6(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function O6(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var GO = {
  symbolCircle: Oh,
  symbolCross: W3,
  symbolDiamond: G3,
  symbolSquare: H3,
  symbolStar: X3,
  symbolTriangle: Z3,
  symbolWye: Q3
}, _6 = Math.PI / 180, S6 = function(t) {
  var r = "symbol".concat(Ms(t));
  return GO[r] || Oh;
}, A6 = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * _6;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, P6 = function(t, r) {
  GO["symbol".concat(Ms(t))] = r;
}, _h = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, i = t.size, a = i === void 0 ? 64 : i, o = t.sizeType, s = o === void 0 ? "area" : o, u = w6(t, m6), c = pm(pm({}, u), {}, {
    type: n,
    size: a,
    sizeType: s
  }), l = function() {
    var h = S6(n), g = e6().type(h).size(A6(a, s, n));
    return g();
  }, f = c.className, d = c.cx, p = c.cy, m = Q(c, !0);
  return d === +d && p === +p && a === +a ? /* @__PURE__ */ S.createElement("path", Rd({}, m, {
    className: ue("recharts-symbols", f),
    transform: "translate(".concat(d, ", ").concat(p, ")"),
    d: l()
  })) : null;
};
_h.registerSymbol = P6;
function Cn(e) {
  "@babel/helpers - typeof";
  return Cn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cn(e);
}
function Dd() {
  return Dd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dd.apply(this, arguments);
}
function hm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function T6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hm(Object(r), !0).forEach(function(n) {
      Gi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function E6(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function C6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VO(n.key), n);
  }
}
function M6(e, t, r) {
  return t && C6(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function j6(e, t, r) {
  return t = _o(t), k6(e, HO() ? Reflect.construct(t, r || [], _o(e).constructor) : t.apply(e, r));
}
function k6(e, t) {
  if (t && (Cn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $6(e);
}
function $6(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function HO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (HO = function() {
    return !!e;
  })();
}
function _o(e) {
  return _o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _o(e);
}
function N6(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ld(e, t);
}
function Ld(e, t) {
  return Ld = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ld(e, t);
}
function Gi(e, t, r) {
  return t = VO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function VO(e) {
  var t = I6(e, "string");
  return Cn(t) == "symbol" ? t : t + "";
}
function I6(e, t) {
  if (Cn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Cn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var vt = 32, Sh = /* @__PURE__ */ function(e) {
  function t() {
    return E6(this, t), j6(this, t, arguments);
  }
  return N6(t, e), M6(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var i = this.props.inactiveColor, a = vt / 2, o = vt / 6, s = vt / 3, u = n.inactive ? i : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ S.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: u,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: a,
            x2: vt,
            y2: a,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ S.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: u,
            d: "M0,".concat(a, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(a, `
            H`).concat(vt, "M").concat(2 * s, ",").concat(a, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(a),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ S.createElement("path", {
            stroke: "none",
            fill: u,
            d: "M0,".concat(vt / 8, "h").concat(vt, "v").concat(vt * 3 / 4, "h").concat(-vt, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ S.isValidElement(n.legendIcon)) {
          var c = T6({}, n);
          return delete c.legendIcon, /* @__PURE__ */ S.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ S.createElement(_h, {
          fill: u,
          cx: a,
          cy: a,
          size: vt,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, i = this.props, a = i.payload, o = i.iconSize, s = i.layout, u = i.formatter, c = i.inactiveColor, l = {
        x: 0,
        y: 0,
        width: vt,
        height: vt
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, d = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return a.map(function(p, m) {
        var v = p.formatter || u, h = ue(Gi(Gi({
          "recharts-legend-item": !0
        }, "legend-item-".concat(m), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var g = ie(p.value) ? null : p.value;
        Et(
          !ie(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var b = p.inactive ? c : p.color;
        return /* @__PURE__ */ S.createElement("li", Dd({
          className: h,
          style: f,
          key: "legend-item-".concat(m)
        }, Vr(n.props, p, m)), /* @__PURE__ */ S.createElement(Md, {
          width: o,
          height: o,
          viewBox: l,
          style: d
        }, n.renderIcon(p)), /* @__PURE__ */ S.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: b
          }
        }, v ? v(g, p, m) : g));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.payload, a = n.layout, o = n.align;
      if (!i || !i.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: a === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ S.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(bt);
Gi(Sh, "displayName", "Legend");
Gi(Sh, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Ec, vm;
function R6() {
  if (vm) return Ec;
  vm = 1;
  var e = Ts();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Ec = t, Ec;
}
var Cc, ym;
function D6() {
  if (ym) return Cc;
  ym = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return Cc = e, Cc;
}
var Mc, mm;
function L6() {
  if (mm) return Mc;
  mm = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Mc = e, Mc;
}
var jc, gm;
function q6() {
  if (gm) return jc;
  gm = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return jc = e, jc;
}
var kc, bm;
function B6() {
  if (bm) return kc;
  bm = 1;
  var e = Ts(), t = hh(), r = vh(), n = 200;
  function i(a, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var u = s.__data__;
      if (!t || u.length < n - 1)
        return u.push([a, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(u);
    }
    return s.set(a, o), this.size = s.size, this;
  }
  return kc = i, kc;
}
var $c, xm;
function KO() {
  if (xm) return $c;
  xm = 1;
  var e = Ts(), t = R6(), r = D6(), n = L6(), i = q6(), a = B6();
  function o(s) {
    var u = this.__data__ = new e(s);
    this.size = u.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = i, o.prototype.set = a, $c = o, $c;
}
var Nc, wm;
function F6() {
  if (wm) return Nc;
  wm = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Nc = t, Nc;
}
var Ic, Om;
function z6() {
  if (Om) return Ic;
  Om = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Ic = e, Ic;
}
var Rc, _m;
function YO() {
  if (_m) return Rc;
  _m = 1;
  var e = vh(), t = F6(), r = z6();
  function n(i) {
    var a = -1, o = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++a < o; )
      this.add(i[a]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Rc = n, Rc;
}
var Dc, Sm;
function XO() {
  if (Sm) return Dc;
  Sm = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Dc = e, Dc;
}
var Lc, Am;
function ZO() {
  if (Am) return Lc;
  Am = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Lc = e, Lc;
}
var qc, Pm;
function JO() {
  if (Pm) return qc;
  Pm = 1;
  var e = YO(), t = XO(), r = ZO(), n = 1, i = 2;
  function a(o, s, u, c, l, f) {
    var d = u & n, p = o.length, m = s.length;
    if (p != m && !(d && m > p))
      return !1;
    var v = f.get(o), h = f.get(s);
    if (v && h)
      return v == s && h == o;
    var g = -1, b = !0, w = u & i ? new e() : void 0;
    for (f.set(o, s), f.set(s, o); ++g < p; ) {
      var O = o[g], y = s[g];
      if (c)
        var x = d ? c(y, O, g, s, o, f) : c(O, y, g, o, s, f);
      if (x !== void 0) {
        if (x)
          continue;
        b = !1;
        break;
      }
      if (w) {
        if (!t(s, function(_, P) {
          if (!r(w, P) && (O === _ || l(O, _, u, c, f)))
            return w.push(P);
        })) {
          b = !1;
          break;
        }
      } else if (!(O === y || l(O, y, u, c, f))) {
        b = !1;
        break;
      }
    }
    return f.delete(o), f.delete(s), b;
  }
  return qc = a, qc;
}
var Bc, Tm;
function W6() {
  if (Tm) return Bc;
  Tm = 1;
  var e = Bt(), t = e.Uint8Array;
  return Bc = t, Bc;
}
var Fc, Em;
function U6() {
  if (Em) return Fc;
  Em = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i, a) {
      n[++r] = [a, i];
    }), n;
  }
  return Fc = e, Fc;
}
var zc, Cm;
function Ah() {
  if (Cm) return zc;
  Cm = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i) {
      n[++r] = i;
    }), n;
  }
  return zc = e, zc;
}
var Wc, Mm;
function G6() {
  if (Mm) return Wc;
  Mm = 1;
  var e = Ea(), t = W6(), r = ph(), n = JO(), i = U6(), a = Ah(), o = 1, s = 2, u = "[object Boolean]", c = "[object Date]", l = "[object Error]", f = "[object Map]", d = "[object Number]", p = "[object RegExp]", m = "[object Set]", v = "[object String]", h = "[object Symbol]", g = "[object ArrayBuffer]", b = "[object DataView]", w = e ? e.prototype : void 0, O = w ? w.valueOf : void 0;
  function y(x, _, P, E, M, C, T) {
    switch (P) {
      case b:
        if (x.byteLength != _.byteLength || x.byteOffset != _.byteOffset)
          return !1;
        x = x.buffer, _ = _.buffer;
      case g:
        return !(x.byteLength != _.byteLength || !C(new t(x), new t(_)));
      case u:
      case c:
      case d:
        return r(+x, +_);
      case l:
        return x.name == _.name && x.message == _.message;
      case p:
      case v:
        return x == _ + "";
      case f:
        var k = i;
      case m:
        var N = E & o;
        if (k || (k = a), x.size != _.size && !N)
          return !1;
        var I = T.get(x);
        if (I)
          return I == _;
        E |= s, T.set(x, _);
        var R = n(k(x), k(_), E, M, C, T);
        return T.delete(x), R;
      case h:
        if (O)
          return O.call(x) == O.call(_);
    }
    return !1;
  }
  return Wc = y, Wc;
}
var Uc, jm;
function QO() {
  if (jm) return Uc;
  jm = 1;
  function e(t, r) {
    for (var n = -1, i = r.length, a = t.length; ++n < i; )
      t[a + n] = r[n];
    return t;
  }
  return Uc = e, Uc;
}
var Gc, km;
function H6() {
  if (km) return Gc;
  km = 1;
  var e = QO(), t = nt();
  function r(n, i, a) {
    var o = i(n);
    return t(n) ? o : e(o, a(n));
  }
  return Gc = r, Gc;
}
var Hc, $m;
function V6() {
  if ($m) return Hc;
  $m = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, a = 0, o = []; ++n < i; ) {
      var s = t[n];
      r(s, n, t) && (o[a++] = s);
    }
    return o;
  }
  return Hc = e, Hc;
}
var Vc, Nm;
function K6() {
  if (Nm) return Vc;
  Nm = 1;
  function e() {
    return [];
  }
  return Vc = e, Vc;
}
var Kc, Im;
function Y6() {
  if (Im) return Kc;
  Im = 1;
  var e = V6(), t = K6(), r = Object.prototype, n = r.propertyIsEnumerable, i = Object.getOwnPropertySymbols, a = i ? function(o) {
    return o == null ? [] : (o = Object(o), e(i(o), function(s) {
      return n.call(o, s);
    }));
  } : t;
  return Kc = a, Kc;
}
var Yc, Rm;
function X6() {
  if (Rm) return Yc;
  Rm = 1;
  function e(t, r) {
    for (var n = -1, i = Array(t); ++n < t; )
      i[n] = r(n);
    return i;
  }
  return Yc = e, Yc;
}
var Xc, Dm;
function Z6() {
  if (Dm) return Xc;
  Dm = 1;
  var e = ir(), t = ar(), r = "[object Arguments]";
  function n(i) {
    return t(i) && e(i) == r;
  }
  return Xc = n, Xc;
}
var Zc, Lm;
function Ph() {
  if (Lm) return Zc;
  Lm = 1;
  var e = Z6(), t = ar(), r = Object.prototype, n = r.hasOwnProperty, i = r.propertyIsEnumerable, a = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !i.call(o, "callee");
  };
  return Zc = a, Zc;
}
var Mi = { exports: {} }, Jc, qm;
function J6() {
  if (qm) return Jc;
  qm = 1;
  function e() {
    return !1;
  }
  return Jc = e, Jc;
}
Mi.exports;
var Bm;
function e_() {
  return Bm || (Bm = 1, function(e, t) {
    var r = Bt(), n = J6(), i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, u = s ? s.isBuffer : void 0, c = u || n;
    e.exports = c;
  }(Mi, Mi.exports)), Mi.exports;
}
var Qc, Fm;
function Th() {
  if (Fm) return Qc;
  Fm = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, i) {
    var a = typeof n;
    return i = i ?? e, !!i && (a == "number" || a != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < i;
  }
  return Qc = r, Qc;
}
var el, zm;
function Eh() {
  if (zm) return el;
  zm = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return el = t, el;
}
var tl, Wm;
function Q6() {
  if (Wm) return tl;
  Wm = 1;
  var e = ir(), t = Eh(), r = ar(), n = "[object Arguments]", i = "[object Array]", a = "[object Boolean]", o = "[object Date]", s = "[object Error]", u = "[object Function]", c = "[object Map]", l = "[object Number]", f = "[object Object]", d = "[object RegExp]", p = "[object Set]", m = "[object String]", v = "[object WeakMap]", h = "[object ArrayBuffer]", g = "[object DataView]", b = "[object Float32Array]", w = "[object Float64Array]", O = "[object Int8Array]", y = "[object Int16Array]", x = "[object Int32Array]", _ = "[object Uint8Array]", P = "[object Uint8ClampedArray]", E = "[object Uint16Array]", M = "[object Uint32Array]", C = {};
  C[b] = C[w] = C[O] = C[y] = C[x] = C[_] = C[P] = C[E] = C[M] = !0, C[n] = C[i] = C[h] = C[a] = C[g] = C[o] = C[s] = C[u] = C[c] = C[l] = C[f] = C[d] = C[p] = C[m] = C[v] = !1;
  function T(k) {
    return r(k) && t(k.length) && !!C[e(k)];
  }
  return tl = T, tl;
}
var rl, Um;
function t_() {
  if (Um) return rl;
  Um = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return rl = e, rl;
}
var ji = { exports: {} };
ji.exports;
var Gm;
function eM() {
  return Gm || (Gm = 1, function(e, t) {
    var r = xO(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, a = i && i.exports === n, o = a && r.process, s = function() {
      try {
        var u = i && i.require && i.require("util").types;
        return u || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(ji, ji.exports)), ji.exports;
}
var nl, Hm;
function r_() {
  if (Hm) return nl;
  Hm = 1;
  var e = Q6(), t = t_(), r = eM(), n = r && r.isTypedArray, i = n ? t(n) : e;
  return nl = i, nl;
}
var il, Vm;
function tM() {
  if (Vm) return il;
  Vm = 1;
  var e = X6(), t = Ph(), r = nt(), n = e_(), i = Th(), a = r_(), o = Object.prototype, s = o.hasOwnProperty;
  function u(c, l) {
    var f = r(c), d = !f && t(c), p = !f && !d && n(c), m = !f && !d && !p && a(c), v = f || d || p || m, h = v ? e(c.length, String) : [], g = h.length;
    for (var b in c)
      (l || s.call(c, b)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      m && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
      i(b, g))) && h.push(b);
    return h;
  }
  return il = u, il;
}
var al, Km;
function rM() {
  if (Km) return al;
  Km = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, i = typeof n == "function" && n.prototype || e;
    return r === i;
  }
  return al = t, al;
}
var ol, Ym;
function n_() {
  if (Ym) return ol;
  Ym = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return ol = e, ol;
}
var sl, Xm;
function nM() {
  if (Xm) return sl;
  Xm = 1;
  var e = n_(), t = e(Object.keys, Object);
  return sl = t, sl;
}
var ul, Zm;
function iM() {
  if (Zm) return ul;
  Zm = 1;
  var e = rM(), t = nM(), r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return t(a);
    var o = [];
    for (var s in Object(a))
      n.call(a, s) && s != "constructor" && o.push(s);
    return o;
  }
  return ul = i, ul;
}
var cl, Jm;
function Ca() {
  if (Jm) return cl;
  Jm = 1;
  var e = dh(), t = Eh();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return cl = r, cl;
}
var ll, Qm;
function Ns() {
  if (Qm) return ll;
  Qm = 1;
  var e = tM(), t = iM(), r = Ca();
  function n(i) {
    return r(i) ? e(i) : t(i);
  }
  return ll = n, ll;
}
var fl, eg;
function aM() {
  if (eg) return fl;
  eg = 1;
  var e = H6(), t = Y6(), r = Ns();
  function n(i) {
    return e(i, r, t);
  }
  return fl = n, fl;
}
var dl, tg;
function oM() {
  if (tg) return dl;
  tg = 1;
  var e = aM(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function i(a, o, s, u, c, l) {
    var f = s & t, d = e(a), p = d.length, m = e(o), v = m.length;
    if (p != v && !f)
      return !1;
    for (var h = p; h--; ) {
      var g = d[h];
      if (!(f ? g in o : n.call(o, g)))
        return !1;
    }
    var b = l.get(a), w = l.get(o);
    if (b && w)
      return b == o && w == a;
    var O = !0;
    l.set(a, o), l.set(o, a);
    for (var y = f; ++h < p; ) {
      g = d[h];
      var x = a[g], _ = o[g];
      if (u)
        var P = f ? u(_, x, g, o, a, l) : u(x, _, g, a, o, l);
      if (!(P === void 0 ? x === _ || c(x, _, s, u, l) : P)) {
        O = !1;
        break;
      }
      y || (y = g == "constructor");
    }
    if (O && !y) {
      var E = a.constructor, M = o.constructor;
      E != M && "constructor" in a && "constructor" in o && !(typeof E == "function" && E instanceof E && typeof M == "function" && M instanceof M) && (O = !1);
    }
    return l.delete(a), l.delete(o), O;
  }
  return dl = i, dl;
}
var pl, rg;
function sM() {
  if (rg) return pl;
  rg = 1;
  var e = en(), t = Bt(), r = e(t, "DataView");
  return pl = r, pl;
}
var hl, ng;
function uM() {
  if (ng) return hl;
  ng = 1;
  var e = en(), t = Bt(), r = e(t, "Promise");
  return hl = r, hl;
}
var vl, ig;
function i_() {
  if (ig) return vl;
  ig = 1;
  var e = en(), t = Bt(), r = e(t, "Set");
  return vl = r, vl;
}
var yl, ag;
function cM() {
  if (ag) return yl;
  ag = 1;
  var e = en(), t = Bt(), r = e(t, "WeakMap");
  return yl = r, yl;
}
var ml, og;
function lM() {
  if (og) return ml;
  og = 1;
  var e = sM(), t = hh(), r = uM(), n = i_(), i = cM(), a = ir(), o = wO(), s = "[object Map]", u = "[object Object]", c = "[object Promise]", l = "[object Set]", f = "[object WeakMap]", d = "[object DataView]", p = o(e), m = o(t), v = o(r), h = o(n), g = o(i), b = a;
  return (e && b(new e(new ArrayBuffer(1))) != d || t && b(new t()) != s || r && b(r.resolve()) != c || n && b(new n()) != l || i && b(new i()) != f) && (b = function(w) {
    var O = a(w), y = O == u ? w.constructor : void 0, x = y ? o(y) : "";
    if (x)
      switch (x) {
        case p:
          return d;
        case m:
          return s;
        case v:
          return c;
        case h:
          return l;
        case g:
          return f;
      }
    return O;
  }), ml = b, ml;
}
var gl, sg;
function fM() {
  if (sg) return gl;
  sg = 1;
  var e = KO(), t = JO(), r = G6(), n = oM(), i = lM(), a = nt(), o = e_(), s = r_(), u = 1, c = "[object Arguments]", l = "[object Array]", f = "[object Object]", d = Object.prototype, p = d.hasOwnProperty;
  function m(v, h, g, b, w, O) {
    var y = a(v), x = a(h), _ = y ? l : i(v), P = x ? l : i(h);
    _ = _ == c ? f : _, P = P == c ? f : P;
    var E = _ == f, M = P == f, C = _ == P;
    if (C && o(v)) {
      if (!o(h))
        return !1;
      y = !0, E = !1;
    }
    if (C && !E)
      return O || (O = new e()), y || s(v) ? t(v, h, g, b, w, O) : r(v, h, _, g, b, w, O);
    if (!(g & u)) {
      var T = E && p.call(v, "__wrapped__"), k = M && p.call(h, "__wrapped__");
      if (T || k) {
        var N = T ? v.value() : v, I = k ? h.value() : h;
        return O || (O = new e()), w(N, I, g, b, O);
      }
    }
    return C ? (O || (O = new e()), n(v, h, g, b, w, O)) : !1;
  }
  return gl = m, gl;
}
var bl, ug;
function Ch() {
  if (ug) return bl;
  ug = 1;
  var e = fM(), t = ar();
  function r(n, i, a, o, s) {
    return n === i ? !0 : n == null || i == null || !t(n) && !t(i) ? n !== n && i !== i : e(n, i, a, o, r, s);
  }
  return bl = r, bl;
}
var xl, cg;
function dM() {
  if (cg) return xl;
  cg = 1;
  var e = KO(), t = Ch(), r = 1, n = 2;
  function i(a, o, s, u) {
    var c = s.length, l = c, f = !u;
    if (a == null)
      return !l;
    for (a = Object(a); c--; ) {
      var d = s[c];
      if (f && d[2] ? d[1] !== a[d[0]] : !(d[0] in a))
        return !1;
    }
    for (; ++c < l; ) {
      d = s[c];
      var p = d[0], m = a[p], v = d[1];
      if (f && d[2]) {
        if (m === void 0 && !(p in a))
          return !1;
      } else {
        var h = new e();
        if (u)
          var g = u(m, v, p, a, o, h);
        if (!(g === void 0 ? t(v, m, r | n, u, h) : g))
          return !1;
      }
    }
    return !0;
  }
  return xl = i, xl;
}
var wl, lg;
function a_() {
  if (lg) return wl;
  lg = 1;
  var e = xr();
  function t(r) {
    return r === r && !e(r);
  }
  return wl = t, wl;
}
var Ol, fg;
function pM() {
  if (fg) return Ol;
  fg = 1;
  var e = a_(), t = Ns();
  function r(n) {
    for (var i = t(n), a = i.length; a--; ) {
      var o = i[a], s = n[o];
      i[a] = [o, s, e(s)];
    }
    return i;
  }
  return Ol = r, Ol;
}
var _l, dg;
function o_() {
  if (dg) return _l;
  dg = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return _l = e, _l;
}
var Sl, pg;
function hM() {
  if (pg) return Sl;
  pg = 1;
  var e = dM(), t = pM(), r = o_();
  function n(i) {
    var a = t(i);
    return a.length == 1 && a[0][2] ? r(a[0][0], a[0][1]) : function(o) {
      return o === i || e(o, i, a);
    };
  }
  return Sl = n, Sl;
}
var Al, hg;
function vM() {
  if (hg) return Al;
  hg = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return Al = e, Al;
}
var Pl, vg;
function yM() {
  if (vg) return Pl;
  vg = 1;
  var e = SO(), t = Ph(), r = nt(), n = Th(), i = Eh(), a = Cs();
  function o(s, u, c) {
    u = e(u, s);
    for (var l = -1, f = u.length, d = !1; ++l < f; ) {
      var p = a(u[l]);
      if (!(d = s != null && c(s, p)))
        break;
      s = s[p];
    }
    return d || ++l != f ? d : (f = s == null ? 0 : s.length, !!f && i(f) && n(p, f) && (r(s) || t(s)));
  }
  return Pl = o, Pl;
}
var Tl, yg;
function mM() {
  if (yg) return Tl;
  yg = 1;
  var e = vM(), t = yM();
  function r(n, i) {
    return n != null && t(n, i, e);
  }
  return Tl = r, Tl;
}
var El, mg;
function gM() {
  if (mg) return El;
  mg = 1;
  var e = Ch(), t = AO(), r = mM(), n = fh(), i = a_(), a = o_(), o = Cs(), s = 1, u = 2;
  function c(l, f) {
    return n(l) && i(f) ? a(o(l), f) : function(d) {
      var p = t(d, l);
      return p === void 0 && p === f ? r(d, l) : e(f, p, s | u);
    };
  }
  return El = c, El;
}
var Cl, gg;
function oi() {
  if (gg) return Cl;
  gg = 1;
  function e(t) {
    return t;
  }
  return Cl = e, Cl;
}
var Ml, bg;
function bM() {
  if (bg) return Ml;
  bg = 1;
  function e(t) {
    return function(r) {
      return r?.[t];
    };
  }
  return Ml = e, Ml;
}
var jl, xg;
function xM() {
  if (xg) return jl;
  xg = 1;
  var e = mh();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return jl = t, jl;
}
var kl, wg;
function wM() {
  if (wg) return kl;
  wg = 1;
  var e = bM(), t = xM(), r = fh(), n = Cs();
  function i(a) {
    return r(a) ? e(n(a)) : t(a);
  }
  return kl = i, kl;
}
var $l, Og;
function Ft() {
  if (Og) return $l;
  Og = 1;
  var e = hM(), t = gM(), r = oi(), n = nt(), i = wM();
  function a(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : i(o);
  }
  return $l = a, $l;
}
var Nl, _g;
function s_() {
  if (_g) return Nl;
  _g = 1;
  function e(t, r, n, i) {
    for (var a = t.length, o = n + (i ? 1 : -1); i ? o-- : ++o < a; )
      if (r(t[o], o, t))
        return o;
    return -1;
  }
  return Nl = e, Nl;
}
var Il, Sg;
function OM() {
  if (Sg) return Il;
  Sg = 1;
  function e(t) {
    return t !== t;
  }
  return Il = e, Il;
}
var Rl, Ag;
function _M() {
  if (Ag) return Rl;
  Ag = 1;
  function e(t, r, n) {
    for (var i = n - 1, a = t.length; ++i < a; )
      if (t[i] === r)
        return i;
    return -1;
  }
  return Rl = e, Rl;
}
var Dl, Pg;
function SM() {
  if (Pg) return Dl;
  Pg = 1;
  var e = s_(), t = OM(), r = _M();
  function n(i, a, o) {
    return a === a ? r(i, a, o) : e(i, t, o);
  }
  return Dl = n, Dl;
}
var Ll, Tg;
function AM() {
  if (Tg) return Ll;
  Tg = 1;
  var e = SM();
  function t(r, n) {
    var i = r == null ? 0 : r.length;
    return !!i && e(r, n, 0) > -1;
  }
  return Ll = t, Ll;
}
var ql, Eg;
function PM() {
  if (Eg) return ql;
  Eg = 1;
  function e(t, r, n) {
    for (var i = -1, a = t == null ? 0 : t.length; ++i < a; )
      if (n(r, t[i]))
        return !0;
    return !1;
  }
  return ql = e, ql;
}
var Bl, Cg;
function TM() {
  if (Cg) return Bl;
  Cg = 1;
  function e() {
  }
  return Bl = e, Bl;
}
var Fl, Mg;
function EM() {
  if (Mg) return Fl;
  Mg = 1;
  var e = i_(), t = TM(), r = Ah(), n = 1 / 0, i = e && 1 / r(new e([, -0]))[1] == n ? function(a) {
    return new e(a);
  } : t;
  return Fl = i, Fl;
}
var zl, jg;
function CM() {
  if (jg) return zl;
  jg = 1;
  var e = YO(), t = AM(), r = PM(), n = ZO(), i = EM(), a = Ah(), o = 200;
  function s(u, c, l) {
    var f = -1, d = t, p = u.length, m = !0, v = [], h = v;
    if (l)
      m = !1, d = r;
    else if (p >= o) {
      var g = c ? null : i(u);
      if (g)
        return a(g);
      m = !1, d = n, h = new e();
    } else
      h = c ? [] : v;
    e:
      for (; ++f < p; ) {
        var b = u[f], w = c ? c(b) : b;
        if (b = l || b !== 0 ? b : 0, m && w === w) {
          for (var O = h.length; O--; )
            if (h[O] === w)
              continue e;
          c && h.push(w), v.push(b);
        } else d(h, w, l) || (h !== v && h.push(w), v.push(b));
      }
    return v;
  }
  return zl = s, zl;
}
var Wl, kg;
function MM() {
  if (kg) return Wl;
  kg = 1;
  var e = Ft(), t = CM();
  function r(n, i) {
    return n && n.length ? t(n, e(i, 2)) : [];
  }
  return Wl = r, Wl;
}
var jM = MM();
const $g = /* @__PURE__ */ xe(jM);
function u_(e, t, r) {
  return t === !0 ? $g(e, r) : ie(t) ? $g(e, t) : e;
}
function Mn(e) {
  "@babel/helpers - typeof";
  return Mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mn(e);
}
var kM = ["ref"];
function Ng(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ng(Object(r), !0).forEach(function(n) {
      Is(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ng(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $M(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ig(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, l_(n.key), n);
  }
}
function NM(e, t, r) {
  return t && Ig(e.prototype, t), r && Ig(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function IM(e, t, r) {
  return t = So(t), RM(e, c_() ? Reflect.construct(t, r || [], So(e).constructor) : t.apply(e, r));
}
function RM(e, t) {
  if (t && (Mn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return DM(e);
}
function DM(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function c_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (c_ = function() {
    return !!e;
  })();
}
function So(e) {
  return So = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, So(e);
}
function LM(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qd(e, t);
}
function qd(e, t) {
  return qd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, qd(e, t);
}
function Is(e, t, r) {
  return t = l_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function l_(e) {
  var t = qM(e, "string");
  return Mn(t) == "symbol" ? t : t + "";
}
function qM(e, t) {
  if (Mn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Mn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function BM(e, t) {
  if (e == null) return {};
  var r = FM(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function FM(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function zM(e) {
  return e.value;
}
function WM(e, t) {
  if (/* @__PURE__ */ S.isValidElement(e))
    return /* @__PURE__ */ S.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ S.createElement(e, t);
  t.ref;
  var r = BM(t, kM);
  return /* @__PURE__ */ S.createElement(Sh, r);
}
var Rg = 1, On = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    $M(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = IM(this, t, [].concat(i)), Is(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return LM(t, e), NM(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > Rg || Math.abs(i.height - this.lastBoundingBox.height) > Rg) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, n && n(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Gt({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var i = this.props, a = i.layout, o = i.align, s = i.verticalAlign, u = i.margin, c = i.chartWidth, l = i.chartHeight, f, d;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && a === "vertical") {
          var p = this.getBBoxSnapshot();
          f = {
            left: ((c || 0) - p.width) / 2
          };
        } else
          f = o === "right" ? {
            right: u && u.right || 0
          } : {
            left: u && u.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var m = this.getBBoxSnapshot();
          d = {
            top: ((l || 0) - m.height) / 2
          };
        } else
          d = s === "bottom" ? {
            bottom: u && u.bottom || 0
          } : {
            top: u && u.top || 0
          };
      return Gt(Gt({}, f), d);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.content, o = i.width, s = i.height, u = i.wrapperStyle, c = i.payloadUniqBy, l = i.payload, f = Gt(Gt({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(u)), u);
      return /* @__PURE__ */ S.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(p) {
          n.wrapperNode = p;
        }
      }, WM(a, Gt(Gt({}, this.props), {}, {
        payload: u_(l, c, zM)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, i) {
      var a = Gt(Gt({}, this.defaultProps), n.props), o = a.layout;
      return o === "vertical" && U(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || i
      } : null;
    }
  }]);
}(bt);
Is(On, "displayName", "Legend");
Is(On, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Ul, Dg;
function UM() {
  if (Dg) return Ul;
  Dg = 1;
  var e = Ea(), t = Ph(), r = nt(), n = e ? e.isConcatSpreadable : void 0;
  function i(a) {
    return r(a) || t(a) || !!(n && a && a[n]);
  }
  return Ul = i, Ul;
}
var Gl, Lg;
function f_() {
  if (Lg) return Gl;
  Lg = 1;
  var e = QO(), t = UM();
  function r(n, i, a, o, s) {
    var u = -1, c = n.length;
    for (a || (a = t), s || (s = []); ++u < c; ) {
      var l = n[u];
      i > 0 && a(l) ? i > 1 ? r(l, i - 1, a, o, s) : e(s, l) : o || (s[s.length] = l);
    }
    return s;
  }
  return Gl = r, Gl;
}
var Hl, qg;
function GM() {
  if (qg) return Hl;
  qg = 1;
  function e(t) {
    return function(r, n, i) {
      for (var a = -1, o = Object(r), s = i(r), u = s.length; u--; ) {
        var c = s[t ? u : ++a];
        if (n(o[c], c, o) === !1)
          break;
      }
      return r;
    };
  }
  return Hl = e, Hl;
}
var Vl, Bg;
function HM() {
  if (Bg) return Vl;
  Bg = 1;
  var e = GM(), t = e();
  return Vl = t, Vl;
}
var Kl, Fg;
function d_() {
  if (Fg) return Kl;
  Fg = 1;
  var e = HM(), t = Ns();
  function r(n, i) {
    return n && e(n, i, t);
  }
  return Kl = r, Kl;
}
var Yl, zg;
function VM() {
  if (zg) return Yl;
  zg = 1;
  var e = Ca();
  function t(r, n) {
    return function(i, a) {
      if (i == null)
        return i;
      if (!e(i))
        return r(i, a);
      for (var o = i.length, s = n ? o : -1, u = Object(i); (n ? s-- : ++s < o) && a(u[s], s, u) !== !1; )
        ;
      return i;
    };
  }
  return Yl = t, Yl;
}
var Xl, Wg;
function Mh() {
  if (Wg) return Xl;
  Wg = 1;
  var e = d_(), t = VM(), r = t(e);
  return Xl = r, Xl;
}
var Zl, Ug;
function p_() {
  if (Ug) return Zl;
  Ug = 1;
  var e = Mh(), t = Ca();
  function r(n, i) {
    var a = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(s, u, c) {
      o[++a] = i(s, u, c);
    }), o;
  }
  return Zl = r, Zl;
}
var Jl, Gg;
function KM() {
  if (Gg) return Jl;
  Gg = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Jl = e, Jl;
}
var Ql, Hg;
function YM() {
  if (Hg) return Ql;
  Hg = 1;
  var e = ni();
  function t(r, n) {
    if (r !== n) {
      var i = r !== void 0, a = r === null, o = r === r, s = e(r), u = n !== void 0, c = n === null, l = n === n, f = e(n);
      if (!c && !f && !s && r > n || s && u && l && !c && !f || a && u && l || !i && l || !o)
        return 1;
      if (!a && !s && !f && r < n || f && i && o && !a && !s || c && i && o || !u && o || !l)
        return -1;
    }
    return 0;
  }
  return Ql = t, Ql;
}
var ef, Vg;
function XM() {
  if (Vg) return ef;
  Vg = 1;
  var e = YM();
  function t(r, n, i) {
    for (var a = -1, o = r.criteria, s = n.criteria, u = o.length, c = i.length; ++a < u; ) {
      var l = e(o[a], s[a]);
      if (l) {
        if (a >= c)
          return l;
        var f = i[a];
        return l * (f == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return ef = t, ef;
}
var tf, Kg;
function ZM() {
  if (Kg) return tf;
  Kg = 1;
  var e = yh(), t = mh(), r = Ft(), n = p_(), i = KM(), a = t_(), o = XM(), s = oi(), u = nt();
  function c(l, f, d) {
    f.length ? f = e(f, function(v) {
      return u(v) ? function(h) {
        return t(h, v.length === 1 ? v[0] : v);
      } : v;
    }) : f = [s];
    var p = -1;
    f = e(f, a(r));
    var m = n(l, function(v, h, g) {
      var b = e(f, function(w) {
        return w(v);
      });
      return { criteria: b, index: ++p, value: v };
    });
    return i(m, function(v, h) {
      return o(v, h, d);
    });
  }
  return tf = c, tf;
}
var rf, Yg;
function JM() {
  if (Yg) return rf;
  Yg = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return rf = e, rf;
}
var nf, Xg;
function QM() {
  if (Xg) return nf;
  Xg = 1;
  var e = JM(), t = Math.max;
  function r(n, i, a) {
    return i = t(i === void 0 ? n.length - 1 : i, 0), function() {
      for (var o = arguments, s = -1, u = t(o.length - i, 0), c = Array(u); ++s < u; )
        c[s] = o[i + s];
      s = -1;
      for (var l = Array(i + 1); ++s < i; )
        l[s] = o[s];
      return l[i] = a(c), e(n, this, l);
    };
  }
  return nf = r, nf;
}
var af, Zg;
function ej() {
  if (Zg) return af;
  Zg = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return af = e, af;
}
var of, Jg;
function h_() {
  if (Jg) return of;
  Jg = 1;
  var e = en(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return of = t, of;
}
var sf, Qg;
function tj() {
  if (Qg) return sf;
  Qg = 1;
  var e = ej(), t = h_(), r = oi(), n = t ? function(i, a) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(a),
      writable: !0
    });
  } : r;
  return sf = n, sf;
}
var uf, eb;
function rj() {
  if (eb) return uf;
  eb = 1;
  var e = 800, t = 16, r = Date.now;
  function n(i) {
    var a = 0, o = 0;
    return function() {
      var s = r(), u = t - (s - o);
      if (o = s, u > 0) {
        if (++a >= e)
          return arguments[0];
      } else
        a = 0;
      return i.apply(void 0, arguments);
    };
  }
  return uf = n, uf;
}
var cf, tb;
function nj() {
  if (tb) return cf;
  tb = 1;
  var e = tj(), t = rj(), r = t(e);
  return cf = r, cf;
}
var lf, rb;
function ij() {
  if (rb) return lf;
  rb = 1;
  var e = oi(), t = QM(), r = nj();
  function n(i, a) {
    return r(t(i, a, e), i + "");
  }
  return lf = n, lf;
}
var ff, nb;
function Rs() {
  if (nb) return ff;
  nb = 1;
  var e = ph(), t = Ca(), r = Th(), n = xr();
  function i(a, o, s) {
    if (!n(s))
      return !1;
    var u = typeof o;
    return (u == "number" ? t(s) && r(o, s.length) : u == "string" && o in s) ? e(s[o], a) : !1;
  }
  return ff = i, ff;
}
var df, ib;
function aj() {
  if (ib) return df;
  ib = 1;
  var e = f_(), t = ZM(), r = ij(), n = Rs(), i = r(function(a, o) {
    if (a == null)
      return [];
    var s = o.length;
    return s > 1 && n(a, o[0], o[1]) ? o = [] : s > 2 && n(o[0], o[1], o[2]) && (o = [o[0]]), t(a, e(o, 1), []);
  });
  return df = i, df;
}
var oj = aj();
const jh = /* @__PURE__ */ xe(oj);
function Hi(e) {
  "@babel/helpers - typeof";
  return Hi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hi(e);
}
function Bd() {
  return Bd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bd.apply(this, arguments);
}
function sj(e, t) {
  return fj(e) || lj(e, t) || cj(e, t) || uj();
}
function uj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cj(e, t) {
  if (e) {
    if (typeof e == "string") return ab(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ab(e, t);
  }
}
function ab(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function lj(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function fj(e) {
  if (Array.isArray(e)) return e;
}
function ob(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ob(Object(r), !0).forEach(function(n) {
      dj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ob(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dj(e, t, r) {
  return t = pj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pj(e) {
  var t = hj(e, "string");
  return Hi(t) == "symbol" ? t : t + "";
}
function hj(e, t) {
  if (Hi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Hi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vj(e) {
  return Array.isArray(e) && qe(e[0]) && qe(e[1]) ? e.join(" ~ ") : e;
}
var yj = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, i = t.contentStyle, a = i === void 0 ? {} : i, o = t.itemStyle, s = o === void 0 ? {} : o, u = t.labelStyle, c = u === void 0 ? {} : u, l = t.payload, f = t.formatter, d = t.itemSorter, p = t.wrapperClassName, m = t.labelClassName, v = t.label, h = t.labelFormatter, g = t.accessibilityLayer, b = g === void 0 ? !1 : g, w = function() {
    if (l && l.length) {
      var T = {
        padding: 0,
        margin: 0
      }, k = (d ? jh(l, d) : l).map(function(N, I) {
        if (N.type === "none")
          return null;
        var R = pf({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: N.color || "#000"
        }, s), q = N.formatter || f || vj, W = N.value, H = N.name, $ = W, L = H;
        if (q && $ != null && L != null) {
          var B = q(W, H, N, I, l);
          if (Array.isArray(B)) {
            var V = sj(B, 2);
            $ = V[0], L = V[1];
          } else
            $ = B;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ S.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(I),
            style: R
          }, qe(L) ? /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, L) : null, qe(L) ? /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, $), /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, N.unit || ""))
        );
      });
      return /* @__PURE__ */ S.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: T
      }, k);
    }
    return null;
  }, O = pf({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, a), y = pf({
    margin: 0
  }, c), x = !se(v), _ = x ? v : "", P = ue("recharts-default-tooltip", p), E = ue("recharts-tooltip-label", m);
  x && h && l !== void 0 && l !== null && (_ = h(v, l));
  var M = b ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ S.createElement("div", Bd({
    className: P,
    style: O
  }, M), /* @__PURE__ */ S.createElement("p", {
    className: E,
    style: y
  }, /* @__PURE__ */ S.isValidElement(_) ? _ : "".concat(_)), w());
};
function Vi(e) {
  "@babel/helpers - typeof";
  return Vi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vi(e);
}
function Va(e, t, r) {
  return t = mj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mj(e) {
  var t = gj(e, "string");
  return Vi(t) == "symbol" ? t : t + "";
}
function gj(e, t) {
  if (Vi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Vi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gi = "recharts-tooltip-wrapper", bj = {
  visibility: "hidden"
};
function xj(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return ue(gi, Va(Va(Va(Va({}, "".concat(gi, "-right"), U(r) && t && U(t.x) && r >= t.x), "".concat(gi, "-left"), U(r) && t && U(t.x) && r < t.x), "".concat(gi, "-bottom"), U(n) && t && U(t.y) && n >= t.y), "".concat(gi, "-top"), U(n) && t && U(t.y) && n < t.y));
}
function sb(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, i = e.offsetTopLeft, a = e.position, o = e.reverseDirection, s = e.tooltipDimension, u = e.viewBox, c = e.viewBoxDimension;
  if (a && U(a[n]))
    return a[n];
  var l = r[n] - s - i, f = r[n] + i;
  if (t[n])
    return o[n] ? l : f;
  if (o[n]) {
    var d = l, p = u[n];
    return d < p ? Math.max(f, u[n]) : Math.max(l, u[n]);
  }
  var m = f + s, v = u[n] + c;
  return m > v ? Math.max(l, u[n]) : Math.max(f, u[n]);
}
function wj(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function Oj(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, i = e.position, a = e.reverseDirection, o = e.tooltipBox, s = e.useTranslate3d, u = e.viewBox, c, l, f;
  return o.height > 0 && o.width > 0 && r ? (l = sb({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.width,
    viewBox: u,
    viewBoxDimension: u.width
  }), f = sb({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.height,
    viewBox: u,
    viewBoxDimension: u.height
  }), c = wj({
    translateX: l,
    translateY: f,
    useTranslate3d: s
  })) : c = bj, {
    cssProperties: c,
    cssClasses: xj({
      translateX: l,
      translateY: f,
      coordinate: r
    })
  };
}
function jn(e) {
  "@babel/helpers - typeof";
  return jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jn(e);
}
function ub(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ub(Object(r), !0).forEach(function(n) {
      zd(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ub(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _j(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Sj(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, y_(n.key), n);
  }
}
function Aj(e, t, r) {
  return t && Sj(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Pj(e, t, r) {
  return t = Ao(t), Tj(e, v_() ? Reflect.construct(t, r || [], Ao(e).constructor) : t.apply(e, r));
}
function Tj(e, t) {
  if (t && (jn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ej(e);
}
function Ej(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function v_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (v_ = function() {
    return !!e;
  })();
}
function Ao(e) {
  return Ao = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ao(e);
}
function Cj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fd(e, t);
}
function Fd(e, t) {
  return Fd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Fd(e, t);
}
function zd(e, t, r) {
  return t = y_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function y_(e) {
  var t = Mj(e, "string");
  return jn(t) == "symbol" ? t : t + "";
}
function Mj(e, t) {
  if (jn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (jn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var lb = 1, jj = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    _j(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = Pj(this, t, [].concat(i)), zd(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), zd(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, u, c, l;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (u = r.props.coordinate) === null || u === void 0 ? void 0 : u.x) !== null && s !== void 0 ? s : 0,
            y: (c = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return Cj(t, e), Aj(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > lb || Math.abs(n.height - this.state.lastBoundingBox.height) > lb) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, s = i.animationDuration, u = i.animationEasing, c = i.children, l = i.coordinate, f = i.hasPayload, d = i.isAnimationActive, p = i.offset, m = i.position, v = i.reverseDirection, h = i.useTranslate3d, g = i.viewBox, b = i.wrapperStyle, w = Oj({
        allowEscapeViewBox: o,
        coordinate: l,
        offsetTopLeft: p,
        position: m,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: h,
        viewBox: g
      }), O = w.cssClasses, y = w.cssProperties, x = cb(cb({
        transition: d && a ? "transform ".concat(s, "ms ").concat(u) : void 0
      }, y), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && a && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, b);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ S.createElement("div", {
          tabIndex: -1,
          className: O,
          style: x,
          ref: function(P) {
            n.wrapperNode = P;
          }
        }, c)
      );
    }
  }]);
}(bt), kj = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, wr = {
  isSsr: kj()
};
function kn(e) {
  "@babel/helpers - typeof";
  return kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kn(e);
}
function fb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function db(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fb(Object(r), !0).forEach(function(n) {
      kh(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $j(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nj(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, g_(n.key), n);
  }
}
function Ij(e, t, r) {
  return t && Nj(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Rj(e, t, r) {
  return t = Po(t), Dj(e, m_() ? Reflect.construct(t, r || [], Po(e).constructor) : t.apply(e, r));
}
function Dj(e, t) {
  if (t && (kn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lj(e);
}
function Lj(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function m_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (m_ = function() {
    return !!e;
  })();
}
function Po(e) {
  return Po = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Po(e);
}
function qj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Wd(e, t);
}
function Wd(e, t) {
  return Wd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Wd(e, t);
}
function kh(e, t, r) {
  return t = g_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function g_(e) {
  var t = Bj(e, "string");
  return kn(t) == "symbol" ? t : t + "";
}
function Bj(e, t) {
  if (kn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (kn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Fj(e) {
  return e.dataKey;
}
function zj(e, t) {
  return /* @__PURE__ */ S.isValidElement(e) ? /* @__PURE__ */ S.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ S.createElement(e, t) : /* @__PURE__ */ S.createElement(yj, t);
}
var Ve = /* @__PURE__ */ function(e) {
  function t() {
    return $j(this, t), Rj(this, t, arguments);
  }
  return qj(t, e), Ij(t, [{
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, s = i.animationDuration, u = i.animationEasing, c = i.content, l = i.coordinate, f = i.filterNull, d = i.isAnimationActive, p = i.offset, m = i.payload, v = i.payloadUniqBy, h = i.position, g = i.reverseDirection, b = i.useTranslate3d, w = i.viewBox, O = i.wrapperStyle, y = m ?? [];
      f && y.length && (y = u_(m.filter(function(_) {
        return _.value != null && (_.hide !== !0 || n.props.includeHidden);
      }), v, Fj));
      var x = y.length > 0;
      return /* @__PURE__ */ S.createElement(jj, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: u,
        isAnimationActive: d,
        active: a,
        coordinate: l,
        hasPayload: x,
        offset: p,
        position: h,
        reverseDirection: g,
        useTranslate3d: b,
        viewBox: w,
        wrapperStyle: O
      }, zj(c, db(db({}, this.props), {}, {
        payload: y
      })));
    }
  }]);
}(bt);
kh(Ve, "displayName", "Tooltip");
kh(Ve, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !wr.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var hf, pb;
function Wj() {
  if (pb) return hf;
  pb = 1;
  var e = Bt(), t = function() {
    return e.Date.now();
  };
  return hf = t, hf;
}
var vf, hb;
function Uj() {
  if (hb) return vf;
  hb = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return vf = t, vf;
}
var yf, vb;
function Gj() {
  if (vb) return yf;
  vb = 1;
  var e = Uj(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return yf = r, yf;
}
var mf, yb;
function b_() {
  if (yb) return mf;
  yb = 1;
  var e = Gj(), t = xr(), r = ni(), n = NaN, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function u(c) {
    if (typeof c == "number")
      return c;
    if (r(c))
      return n;
    if (t(c)) {
      var l = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = t(l) ? l + "" : l;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = e(c);
    var f = a.test(c);
    return f || o.test(c) ? s(c.slice(2), f ? 2 : 8) : i.test(c) ? n : +c;
  }
  return mf = u, mf;
}
var gf, mb;
function Hj() {
  if (mb) return gf;
  mb = 1;
  var e = xr(), t = Wj(), r = b_(), n = "Expected a function", i = Math.max, a = Math.min;
  function o(s, u, c) {
    var l, f, d, p, m, v, h = 0, g = !1, b = !1, w = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    u = r(u) || 0, e(c) && (g = !!c.leading, b = "maxWait" in c, d = b ? i(r(c.maxWait) || 0, u) : d, w = "trailing" in c ? !!c.trailing : w);
    function O(k) {
      var N = l, I = f;
      return l = f = void 0, h = k, p = s.apply(I, N), p;
    }
    function y(k) {
      return h = k, m = setTimeout(P, u), g ? O(k) : p;
    }
    function x(k) {
      var N = k - v, I = k - h, R = u - N;
      return b ? a(R, d - I) : R;
    }
    function _(k) {
      var N = k - v, I = k - h;
      return v === void 0 || N >= u || N < 0 || b && I >= d;
    }
    function P() {
      var k = t();
      if (_(k))
        return E(k);
      m = setTimeout(P, x(k));
    }
    function E(k) {
      return m = void 0, w && l ? O(k) : (l = f = void 0, p);
    }
    function M() {
      m !== void 0 && clearTimeout(m), h = 0, l = v = f = m = void 0;
    }
    function C() {
      return m === void 0 ? p : E(t());
    }
    function T() {
      var k = t(), N = _(k);
      if (l = arguments, f = this, v = k, N) {
        if (m === void 0)
          return y(v);
        if (b)
          return clearTimeout(m), m = setTimeout(P, u), O(v);
      }
      return m === void 0 && (m = setTimeout(P, u)), p;
    }
    return T.cancel = M, T.flush = C, T;
  }
  return gf = o, gf;
}
var bf, gb;
function Vj() {
  if (gb) return bf;
  gb = 1;
  var e = Hj(), t = xr(), r = "Expected a function";
  function n(i, a, o) {
    var s = !0, u = !0;
    if (typeof i != "function")
      throw new TypeError(r);
    return t(o) && (s = "leading" in o ? !!o.leading : s, u = "trailing" in o ? !!o.trailing : u), e(i, a, {
      leading: s,
      maxWait: a,
      trailing: u
    });
  }
  return bf = n, bf;
}
var Kj = Vj();
const x_ = /* @__PURE__ */ xe(Kj);
function Ki(e) {
  "@babel/helpers - typeof";
  return Ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ki(e);
}
function bb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ka(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bb(Object(r), !0).forEach(function(n) {
      Yj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Yj(e, t, r) {
  return t = Xj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Xj(e) {
  var t = Zj(e, "string");
  return Ki(t) == "symbol" ? t : t + "";
}
function Zj(e, t) {
  if (Ki(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ki(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Jj(e, t) {
  return rk(e) || tk(e, t) || ek(e, t) || Qj();
}
function Qj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ek(e, t) {
  if (e) {
    if (typeof e == "string") return xb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return xb(e, t);
  }
}
function xb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function tk(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function rk(e) {
  if (Array.isArray(e)) return e;
}
var rn = /* @__PURE__ */ bs(function(e, t) {
  var r = e.aspect, n = e.initialDimension, i = n === void 0 ? {
    width: -1,
    height: -1
  } : n, a = e.width, o = a === void 0 ? "100%" : a, s = e.height, u = s === void 0 ? "100%" : s, c = e.minWidth, l = c === void 0 ? 0 : c, f = e.minHeight, d = e.maxHeight, p = e.children, m = e.debounce, v = m === void 0 ? 0 : m, h = e.id, g = e.className, b = e.onResize, w = e.style, O = w === void 0 ? {} : w, y = An(null), x = An();
  x.current = b, ZA(t, function() {
    return Object.defineProperty(y.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), y.current;
      },
      configurable: !0
    });
  });
  var _ = Vt({
    containerWidth: i.width,
    containerHeight: i.height
  }), P = Jj(_, 2), E = P[0], M = P[1], C = JA(function(k, N) {
    M(function(I) {
      var R = Math.round(k), q = Math.round(N);
      return I.containerWidth === R && I.containerHeight === q ? I : {
        containerWidth: R,
        containerHeight: q
      };
    });
  }, []);
  Sa(function() {
    var k = function(H) {
      var $, L = H[0].contentRect, B = L.width, V = L.height;
      C(B, V), ($ = x.current) === null || $ === void 0 || $.call(x, B, V);
    };
    v > 0 && (k = x_(k, v, {
      trailing: !0,
      leading: !1
    }));
    var N = new ResizeObserver(k), I = y.current.getBoundingClientRect(), R = I.width, q = I.height;
    return C(R, q), N.observe(y.current), function() {
      N.disconnect();
    };
  }, [C, v]);
  var T = xs(function() {
    var k = E.containerWidth, N = E.containerHeight;
    if (k < 0 || N < 0)
      return null;
    Et(Ir(o) || Ir(u), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, u), Et(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var I = Ir(o) ? k : o, R = Ir(u) ? N : u;
    r && r > 0 && (I ? R = I / r : R && (I = R * r), d && R > d && (R = d)), Et(I > 0 || R > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, I, R, o, u, l, f, r);
    var q = !Array.isArray(p) && Jt(p.type).endsWith("Chart");
    return S.Children.map(p, function(W) {
      return /* @__PURE__ */ S.isValidElement(W) ? /* @__PURE__ */ De(W, Ka({
        width: I,
        height: R
      }, q ? {
        style: Ka({
          height: "100%",
          width: "100%",
          maxHeight: R,
          maxWidth: I
        }, W.props.style)
      } : {})) : W;
    });
  }, [r, p, u, d, f, l, E, o]);
  return /* @__PURE__ */ S.createElement("div", {
    id: h ? "".concat(h) : void 0,
    className: ue("recharts-responsive-container", g),
    style: Ka(Ka({}, O), {}, {
      width: o,
      height: u,
      minWidth: l,
      minHeight: f,
      maxHeight: d
    }),
    ref: y
  }, T);
}), Ds = function(t) {
  return null;
};
Ds.displayName = "Cell";
function Yi(e) {
  "@babel/helpers - typeof";
  return Yi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yi(e);
}
function wb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ud(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wb(Object(r), !0).forEach(function(n) {
      nk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nk(e, t, r) {
  return t = ik(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ik(e) {
  var t = ak(e, "string");
  return Yi(t) == "symbol" ? t : t + "";
}
function ak(e, t) {
  if (Yi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Yi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ln = {
  widthCache: {},
  cacheCount: 0
}, ok = 2e3, sk = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, Ob = "recharts_measurement_span";
function uk(e) {
  var t = Ud({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var $i = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || wr.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = uk(r), i = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (ln.widthCache[i])
    return ln.widthCache[i];
  try {
    var a = document.getElementById(Ob);
    a || (a = document.createElement("span"), a.setAttribute("id", Ob), a.setAttribute("aria-hidden", "true"), document.body.appendChild(a));
    var o = Ud(Ud({}, sk), n);
    Object.assign(a.style, o), a.textContent = "".concat(t);
    var s = a.getBoundingClientRect(), u = {
      width: s.width,
      height: s.height
    };
    return ln.widthCache[i] = u, ++ln.cacheCount > ok && (ln.cacheCount = 0, ln.widthCache = {}), u;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, ck = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Xi(e) {
  "@babel/helpers - typeof";
  return Xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xi(e);
}
function To(e, t) {
  return pk(e) || dk(e, t) || fk(e, t) || lk();
}
function lk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fk(e, t) {
  if (e) {
    if (typeof e == "string") return _b(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _b(e, t);
  }
}
function _b(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function dk(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        u = !1;
      } else for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function pk(e) {
  if (Array.isArray(e)) return e;
}
function hk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Sb(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yk(n.key), n);
  }
}
function vk(e, t, r) {
  return t && Sb(e.prototype, t), r && Sb(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function yk(e) {
  var t = mk(e, "string");
  return Xi(t) == "symbol" ? t : t + "";
}
function mk(e, t) {
  if (Xi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Xi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ab = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Pb = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, gk = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, bk = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, w_ = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, xk = Object.keys(w_), hn = "NaN";
function wk(e, t) {
  return e * w_[t];
}
var Ya = /* @__PURE__ */ function() {
  function e(t, r) {
    hk(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !gk.test(r) && (this.num = NaN, this.unit = ""), xk.includes(r) && (this.num = wk(t, r), this.unit = "px");
  }
  return vk(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, i = (n = bk.exec(r)) !== null && n !== void 0 ? n : [], a = To(i, 3), o = a[1], s = a[2];
      return new e(parseFloat(o), s ?? "");
    }
  }]);
}();
function O_(e) {
  if (e.includes(hn))
    return hn;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = Ab.exec(t)) !== null && r !== void 0 ? r : [], i = To(n, 4), a = i[1], o = i[2], s = i[3], u = Ya.parse(a ?? ""), c = Ya.parse(s ?? ""), l = o === "*" ? u.multiply(c) : u.divide(c);
    if (l.isNaN())
      return hn;
    t = t.replace(Ab, l.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, d = (f = Pb.exec(t)) !== null && f !== void 0 ? f : [], p = To(d, 4), m = p[1], v = p[2], h = p[3], g = Ya.parse(m ?? ""), b = Ya.parse(h ?? ""), w = v === "+" ? g.add(b) : g.subtract(b);
    if (w.isNaN())
      return hn;
    t = t.replace(Pb, w.toString());
  }
  return t;
}
var Tb = /\(([^()]*)\)/;
function Ok(e) {
  for (var t = e; t.includes("("); ) {
    var r = Tb.exec(t), n = To(r, 2), i = n[1];
    t = t.replace(Tb, O_(i));
  }
  return t;
}
function _k(e) {
  var t = e.replace(/\s+/g, "");
  return t = Ok(t), t = O_(t), t;
}
function Sk(e) {
  try {
    return _k(e);
  } catch {
    return hn;
  }
}
function xf(e) {
  var t = Sk(e.slice(5, -1));
  return t === hn ? "" : t;
}
var Ak = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], Pk = ["dx", "dy", "angle", "className", "breakAll"];
function Gd() {
  return Gd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gd.apply(this, arguments);
}
function Eb(e, t) {
  if (e == null) return {};
  var r = Tk(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Tk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Cb(e, t) {
  return jk(e) || Mk(e, t) || Ck(e, t) || Ek();
}
function Ek() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ck(e, t) {
  if (e) {
    if (typeof e == "string") return Mb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mb(e, t);
  }
}
function Mb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Mk(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        u = !1;
      } else for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function jk(e) {
  if (Array.isArray(e)) return e;
}
var __ = /[ \f\n\r\t\v\u2028\u2029]+/, S_ = function(t) {
  var r = t.children, n = t.breakAll, i = t.style;
  try {
    var a = [];
    se(r) || (n ? a = r.toString().split("") : a = r.toString().split(__));
    var o = a.map(function(u) {
      return {
        word: u,
        width: $i(u, i).width
      };
    }), s = n ? 0 : $i(" ", i).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, kk = function(t, r, n, i, a) {
  var o = t.maxLines, s = t.children, u = t.style, c = t.breakAll, l = U(o), f = s, d = function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return I.reduce(function(R, q) {
      var W = q.word, H = q.width, $ = R[R.length - 1];
      if ($ && (i == null || a || $.width + H + n < Number(i)))
        $.words.push(W), $.width += H + n;
      else {
        var L = {
          words: [W],
          width: H
        };
        R.push(L);
      }
      return R;
    }, []);
  }, p = d(r), m = function(I) {
    return I.reduce(function(R, q) {
      return R.width > q.width ? R : q;
    });
  };
  if (!l)
    return p;
  for (var v = "…", h = function(I) {
    var R = f.slice(0, I), q = S_({
      breakAll: c,
      style: u,
      children: R + v
    }).wordsWithComputedWidth, W = d(q), H = W.length > o || m(W).width > Number(i);
    return [H, W];
  }, g = 0, b = f.length - 1, w = 0, O; g <= b && w <= f.length - 1; ) {
    var y = Math.floor((g + b) / 2), x = y - 1, _ = h(x), P = Cb(_, 2), E = P[0], M = P[1], C = h(y), T = Cb(C, 1), k = T[0];
    if (!E && !k && (g = y + 1), E && k && (b = y - 1), !E && k) {
      O = M;
      break;
    }
    w++;
  }
  return O || p;
}, jb = function(t) {
  var r = se(t) ? [] : t.toString().split(__);
  return [{
    words: r
  }];
}, $k = function(t) {
  var r = t.width, n = t.scaleToFit, i = t.children, a = t.style, o = t.breakAll, s = t.maxLines;
  if ((r || n) && !wr.isSsr) {
    var u, c, l = S_({
      breakAll: o,
      children: i,
      style: a
    });
    if (l) {
      var f = l.wordsWithComputedWidth, d = l.spaceWidth;
      u = f, c = d;
    } else
      return jb(i);
    return kk({
      breakAll: o,
      children: i,
      maxLines: s,
      style: a
    }, u, c, r, n);
  }
  return jb(i);
}, kb = "#808080", Kr = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, i = t.y, a = i === void 0 ? 0 : i, o = t.lineHeight, s = o === void 0 ? "1em" : o, u = t.capHeight, c = u === void 0 ? "0.71em" : u, l = t.scaleToFit, f = l === void 0 ? !1 : l, d = t.textAnchor, p = d === void 0 ? "start" : d, m = t.verticalAnchor, v = m === void 0 ? "end" : m, h = t.fill, g = h === void 0 ? kb : h, b = Eb(t, Ak), w = xs(function() {
    return $k({
      breakAll: b.breakAll,
      children: b.children,
      maxLines: b.maxLines,
      scaleToFit: f,
      style: b.style,
      width: b.width
    });
  }, [b.breakAll, b.children, b.maxLines, f, b.style, b.width]), O = b.dx, y = b.dy, x = b.angle, _ = b.className, P = b.breakAll, E = Eb(b, Pk);
  if (!qe(n) || !qe(a))
    return null;
  var M = n + (U(O) ? O : 0), C = a + (U(y) ? y : 0), T;
  switch (v) {
    case "start":
      T = xf("calc(".concat(c, ")"));
      break;
    case "middle":
      T = xf("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      T = xf("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var k = [];
  if (f) {
    var N = w[0].width, I = b.width;
    k.push("scale(".concat((U(I) ? I / N : 1) / N, ")"));
  }
  return x && k.push("rotate(".concat(x, ", ").concat(M, ", ").concat(C, ")")), k.length && (E.transform = k.join(" ")), /* @__PURE__ */ S.createElement("text", Gd({}, Q(E, !0), {
    x: M,
    y: C,
    className: ue("recharts-text", _),
    textAnchor: p,
    fill: g.includes("url") ? kb : g
  }), w.map(function(R, q) {
    var W = R.words.join(P ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ S.createElement("tspan", {
        x: M,
        dy: q === 0 ? T : s,
        key: "".concat(W, "-").concat(q)
      }, W)
    );
  }));
};
function gr(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Nk(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function $h(e) {
  let t, r, n;
  e.length !== 2 ? (t = gr, r = (s, u) => gr(e(s), u), n = (s, u) => e(s) - u) : (t = e === gr || e === Nk ? e : Ik, r = e, n = e);
  function i(s, u, c = 0, l = s.length) {
    if (c < l) {
      if (t(u, u) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(s[f], u) < 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function a(s, u, c = 0, l = s.length) {
    if (c < l) {
      if (t(u, u) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(s[f], u) <= 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function o(s, u, c = 0, l = s.length) {
    const f = i(s, u, c, l - 1);
    return f > c && n(s[f - 1], u) > -n(s[f], u) ? f - 1 : f;
  }
  return { left: i, center: o, right: a };
}
function Ik() {
  return 0;
}
function A_(e) {
  return e === null ? NaN : +e;
}
function* Rk(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const Dk = $h(gr), Ma = Dk.right;
$h(A_).center;
class $b extends Map {
  constructor(t, r = Bk) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, i] of t) this.set(n, i);
  }
  get(t) {
    return super.get(Nb(this, t));
  }
  has(t) {
    return super.has(Nb(this, t));
  }
  set(t, r) {
    return super.set(Lk(this, t), r);
  }
  delete(t) {
    return super.delete(qk(this, t));
  }
}
function Nb({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function Lk({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function qk({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function Bk(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function Fk(e = gr) {
  if (e === gr) return P_;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function P_(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const zk = Math.sqrt(50), Wk = Math.sqrt(10), Uk = Math.sqrt(2);
function Eo(e, t, r) {
  const n = (t - e) / Math.max(0, r), i = Math.floor(Math.log10(n)), a = n / Math.pow(10, i), o = a >= zk ? 10 : a >= Wk ? 5 : a >= Uk ? 2 : 1;
  let s, u, c;
  return i < 0 ? (c = Math.pow(10, -i) / o, s = Math.round(e * c), u = Math.round(t * c), s / c < e && ++s, u / c > t && --u, c = -c) : (c = Math.pow(10, i) * o, s = Math.round(e / c), u = Math.round(t / c), s * c < e && ++s, u * c > t && --u), u < s && 0.5 <= r && r < 2 ? Eo(e, t, r * 2) : [s, u, c];
}
function Hd(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [i, a, o] = n ? Eo(t, e, r) : Eo(e, t, r);
  if (!(a >= i)) return [];
  const s = a - i + 1, u = new Array(s);
  if (n)
    if (o < 0) for (let c = 0; c < s; ++c) u[c] = (a - c) / -o;
    else for (let c = 0; c < s; ++c) u[c] = (a - c) * o;
  else if (o < 0) for (let c = 0; c < s; ++c) u[c] = (i + c) / -o;
  else for (let c = 0; c < s; ++c) u[c] = (i + c) * o;
  return u;
}
function Vd(e, t, r) {
  return t = +t, e = +e, r = +r, Eo(e, t, r)[2];
}
function Kd(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, i = n ? Vd(t, e, r) : Vd(e, t, r);
  return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function Ib(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Rb(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function T_(e, t, r = 0, n = 1 / 0, i) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (i = i === void 0 ? P_ : Fk(i); n > r; ) {
    if (n - r > 600) {
      const u = n - r + 1, c = t - r + 1, l = Math.log(u), f = 0.5 * Math.exp(2 * l / 3), d = 0.5 * Math.sqrt(l * f * (u - f) / u) * (c - u / 2 < 0 ? -1 : 1), p = Math.max(r, Math.floor(t - c * f / u + d)), m = Math.min(n, Math.floor(t + (u - c) * f / u + d));
      T_(e, t, p, m, i);
    }
    const a = e[t];
    let o = r, s = n;
    for (bi(e, r, t), i(e[n], a) > 0 && bi(e, r, n); o < s; ) {
      for (bi(e, o, s), ++o, --s; i(e[o], a) < 0; ) ++o;
      for (; i(e[s], a) > 0; ) --s;
    }
    i(e[r], a) === 0 ? bi(e, r, s) : (++s, bi(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function bi(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function Gk(e, t, r) {
  if (e = Float64Array.from(Rk(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return Rb(e);
    if (t >= 1) return Ib(e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = Ib(T_(e, a).subarray(0, a + 1)), s = Rb(e.subarray(a + 1));
    return o + (s - o) * (i - a);
  }
}
function Hk(e, t, r = A_) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = +r(e[a], a, e), s = +r(e[a + 1], a + 1, e);
    return o + (s - o) * (i - a);
  }
}
function Vk(e, t, r) {
  e = +e, t = +t, r = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +r;
  for (var n = -1, i = Math.max(0, Math.ceil((t - e) / r)) | 0, a = new Array(i); ++n < i; )
    a[n] = e + n * r;
  return a;
}
function wt(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function or(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Yd = Symbol("implicit");
function Nh() {
  var e = new $b(), t = [], r = [], n = Yd;
  function i(a) {
    let o = e.get(a);
    if (o === void 0) {
      if (n !== Yd) return n;
      e.set(a, o = t.push(a) - 1);
    }
    return r[o % r.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = new $b();
    for (const o of a)
      e.has(o) || e.set(o, t.push(o) - 1);
    return i;
  }, i.range = function(a) {
    return arguments.length ? (r = Array.from(a), i) : r.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return Nh(t, r).unknown(n);
  }, wt.apply(i, arguments), i;
}
function Zi() {
  var e = Nh().unknown(void 0), t = e.domain, r = e.range, n = 0, i = 1, a, o, s = !1, u = 0, c = 0, l = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, p = i < n, m = p ? i : n, v = p ? n : i;
    a = (v - m) / Math.max(1, d - u + c * 2), s && (a = Math.floor(a)), m += (v - m - a * (d - u)) * l, o = a * (1 - u), s && (m = Math.round(m), o = Math.round(o));
    var h = Vk(d).map(function(g) {
      return m + a * g;
    });
    return r(p ? h.reverse() : h);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, i] = d, n = +n, i = +i, f()) : [n, i];
  }, e.rangeRound = function(d) {
    return [n, i] = d, n = +n, i = +i, s = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return a;
  }, e.round = function(d) {
    return arguments.length ? (s = !!d, f()) : s;
  }, e.padding = function(d) {
    return arguments.length ? (u = Math.min(1, c = +d), f()) : u;
  }, e.paddingInner = function(d) {
    return arguments.length ? (u = Math.min(1, d), f()) : u;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (c = +d, f()) : c;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), f()) : l;
  }, e.copy = function() {
    return Zi(t(), [n, i]).round(s).paddingInner(u).paddingOuter(c).align(l);
  }, wt.apply(f(), arguments);
}
function E_(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return E_(t());
  }, e;
}
function Ni() {
  return E_(Zi.apply(null, arguments).paddingInner(1));
}
function Ih(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function C_(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function ja() {
}
var Ji = 0.7, Co = 1 / Ji, _n = "\\s*([+-]?\\d+)\\s*", Qi = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Rt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Kk = /^#([0-9a-f]{3,8})$/, Yk = new RegExp(`^rgb\\(${_n},${_n},${_n}\\)$`), Xk = new RegExp(`^rgb\\(${Rt},${Rt},${Rt}\\)$`), Zk = new RegExp(`^rgba\\(${_n},${_n},${_n},${Qi}\\)$`), Jk = new RegExp(`^rgba\\(${Rt},${Rt},${Rt},${Qi}\\)$`), Qk = new RegExp(`^hsl\\(${Qi},${Rt},${Rt}\\)$`), e$ = new RegExp(`^hsla\\(${Qi},${Rt},${Rt},${Qi}\\)$`), Db = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Ih(ja, ea, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Lb,
  // Deprecated! Use color.formatHex.
  formatHex: Lb,
  formatHex8: t$,
  formatHsl: r$,
  formatRgb: qb,
  toString: qb
});
function Lb() {
  return this.rgb().formatHex();
}
function t$() {
  return this.rgb().formatHex8();
}
function r$() {
  return M_(this).formatHsl();
}
function qb() {
  return this.rgb().formatRgb();
}
function ea(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = Kk.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? Bb(t) : r === 3 ? new et(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Xa(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Xa(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Yk.exec(e)) ? new et(t[1], t[2], t[3], 1) : (t = Xk.exec(e)) ? new et(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Zk.exec(e)) ? Xa(t[1], t[2], t[3], t[4]) : (t = Jk.exec(e)) ? Xa(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Qk.exec(e)) ? Wb(t[1], t[2] / 100, t[3] / 100, 1) : (t = e$.exec(e)) ? Wb(t[1], t[2] / 100, t[3] / 100, t[4]) : Db.hasOwnProperty(e) ? Bb(Db[e]) : e === "transparent" ? new et(NaN, NaN, NaN, 0) : null;
}
function Bb(e) {
  return new et(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Xa(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new et(e, t, r, n);
}
function n$(e) {
  return e instanceof ja || (e = ea(e)), e ? (e = e.rgb(), new et(e.r, e.g, e.b, e.opacity)) : new et();
}
function Xd(e, t, r, n) {
  return arguments.length === 1 ? n$(e) : new et(e, t, r, n ?? 1);
}
function et(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
Ih(et, Xd, C_(ja, {
  brighter(e) {
    return e = e == null ? Co : Math.pow(Co, e), new et(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ji : Math.pow(Ji, e), new et(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new et(zr(this.r), zr(this.g), zr(this.b), Mo(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Fb,
  // Deprecated! Use color.formatHex.
  formatHex: Fb,
  formatHex8: i$,
  formatRgb: zb,
  toString: zb
}));
function Fb() {
  return `#${Rr(this.r)}${Rr(this.g)}${Rr(this.b)}`;
}
function i$() {
  return `#${Rr(this.r)}${Rr(this.g)}${Rr(this.b)}${Rr((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function zb() {
  const e = Mo(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${zr(this.r)}, ${zr(this.g)}, ${zr(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Mo(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function zr(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Rr(e) {
  return e = zr(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Wb(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new At(e, t, r, n);
}
function M_(e) {
  if (e instanceof At) return new At(e.h, e.s, e.l, e.opacity);
  if (e instanceof ja || (e = ea(e)), !e) return new At();
  if (e instanceof At) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = NaN, s = a - i, u = (a + i) / 2;
  return s ? (t === a ? o = (r - n) / s + (r < n) * 6 : r === a ? o = (n - t) / s + 2 : o = (t - r) / s + 4, s /= u < 0.5 ? a + i : 2 - a - i, o *= 60) : s = u > 0 && u < 1 ? 0 : o, new At(o, s, u, e.opacity);
}
function a$(e, t, r, n) {
  return arguments.length === 1 ? M_(e) : new At(e, t, r, n ?? 1);
}
function At(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
Ih(At, a$, C_(ja, {
  brighter(e) {
    return e = e == null ? Co : Math.pow(Co, e), new At(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ji : Math.pow(Ji, e), new At(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, i = 2 * r - n;
    return new et(
      wf(e >= 240 ? e - 240 : e + 120, i, n),
      wf(e, i, n),
      wf(e < 120 ? e + 240 : e - 120, i, n),
      this.opacity
    );
  },
  clamp() {
    return new At(Ub(this.h), Za(this.s), Za(this.l), Mo(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Mo(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Ub(this.h)}, ${Za(this.s) * 100}%, ${Za(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Ub(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Za(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function wf(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const Rh = (e) => () => e;
function o$(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function s$(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function u$(e) {
  return (e = +e) == 1 ? j_ : function(t, r) {
    return r - t ? s$(t, r, e) : Rh(isNaN(t) ? r : t);
  };
}
function j_(e, t) {
  var r = t - e;
  return r ? o$(e, r) : Rh(isNaN(e) ? t : e);
}
const Gb = function e(t) {
  var r = u$(t);
  function n(i, a) {
    var o = r((i = Xd(i)).r, (a = Xd(a)).r), s = r(i.g, a.g), u = r(i.b, a.b), c = j_(i.opacity, a.opacity);
    return function(l) {
      return i.r = o(l), i.g = s(l), i.b = u(l), i.opacity = c(l), i + "";
    };
  }
  return n.gamma = e, n;
}(1);
function c$(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
  return function(a) {
    for (i = 0; i < r; ++i) n[i] = e[i] * (1 - a) + t[i] * a;
    return n;
  };
}
function l$(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function f$(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), a = new Array(r), o;
  for (o = 0; o < n; ++o) i[o] = si(e[o], t[o]);
  for (; o < r; ++o) a[o] = t[o];
  return function(s) {
    for (o = 0; o < n; ++o) a[o] = i[o](s);
    return a;
  };
}
function d$(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function jo(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function p$(e, t) {
  var r = {}, n = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? r[i] = si(e[i], t[i]) : n[i] = t[i];
  return function(a) {
    for (i in r) n[i] = r[i](a);
    return n;
  };
}
var Zd = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Of = new RegExp(Zd.source, "g");
function h$(e) {
  return function() {
    return e;
  };
}
function v$(e) {
  return function(t) {
    return e(t) + "";
  };
}
function y$(e, t) {
  var r = Zd.lastIndex = Of.lastIndex = 0, n, i, a, o = -1, s = [], u = [];
  for (e = e + "", t = t + ""; (n = Zd.exec(e)) && (i = Of.exec(t)); )
    (a = i.index) > r && (a = t.slice(r, a), s[o] ? s[o] += a : s[++o] = a), (n = n[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, u.push({ i: o, x: jo(n, i) })), r = Of.lastIndex;
  return r < t.length && (a = t.slice(r), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? u[0] ? v$(u[0].x) : h$(t) : (t = u.length, function(c) {
    for (var l = 0, f; l < t; ++l) s[(f = u[l]).i] = f.x(c);
    return s.join("");
  });
}
function si(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? Rh(t) : (r === "number" ? jo : r === "string" ? (n = ea(t)) ? (t = n, Gb) : y$ : t instanceof ea ? Gb : t instanceof Date ? d$ : l$(t) ? c$ : Array.isArray(t) ? f$ : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? p$ : jo)(e, t);
}
function Dh(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function m$(e, t) {
  t === void 0 && (t = e, e = si);
  for (var r = 0, n = t.length - 1, i = t[0], a = new Array(n < 0 ? 0 : n); r < n; ) a[r] = e(i, i = t[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return a[s](o - s);
  };
}
function g$(e) {
  return function() {
    return e;
  };
}
function ko(e) {
  return +e;
}
var Hb = [0, 1];
function Ze(e) {
  return e;
}
function Jd(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : g$(isNaN(t) ? NaN : 0.5);
}
function b$(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function x$(e, t, r) {
  var n = e[0], i = e[1], a = t[0], o = t[1];
  return i < n ? (n = Jd(i, n), a = r(o, a)) : (n = Jd(n, i), a = r(a, o)), function(s) {
    return a(n(s));
  };
}
function w$(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, i = new Array(n), a = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    i[o] = Jd(e[o], e[o + 1]), a[o] = r(t[o], t[o + 1]);
  return function(s) {
    var u = Ma(e, s, 1, n) - 1;
    return a[u](i[u](s));
  };
}
function ka(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Ls() {
  var e = Hb, t = Hb, r = si, n, i, a, o = Ze, s, u, c;
  function l() {
    var d = Math.min(e.length, t.length);
    return o !== Ze && (o = b$(e[0], e[d - 1])), s = d > 2 ? w$ : x$, u = c = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? a : (u || (u = s(e.map(n), t, r)))(n(o(d)));
  }
  return f.invert = function(d) {
    return o(i((c || (c = s(t, e.map(n), jo)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, ko), l()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), l()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), r = Dh, l();
  }, f.clamp = function(d) {
    return arguments.length ? (o = d ? !0 : Ze, l()) : o !== Ze;
  }, f.interpolate = function(d) {
    return arguments.length ? (r = d, l()) : r;
  }, f.unknown = function(d) {
    return arguments.length ? (a = d, f) : a;
  }, function(d, p) {
    return n = d, i = p, l();
  };
}
function Lh() {
  return Ls()(Ze, Ze);
}
function O$(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function $o(e, t) {
  if (!isFinite(e) || e === 0) return null;
  var r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e"), n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function $n(e) {
  return e = $o(Math.abs(e)), e ? e[1] : NaN;
}
function _$(e, t) {
  return function(r, n) {
    for (var i = r.length, a = [], o = 0, s = e[0], u = 0; i > 0 && s > 0 && (u + s + 1 > n && (s = Math.max(1, n - u)), a.push(r.substring(i -= s, i + s)), !((u += s + 1) > n)); )
      s = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function S$(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var A$ = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function ta(e) {
  if (!(t = A$.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new qh({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
ta.prototype = qh.prototype;
function qh(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
qh.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function P$(e) {
  e: for (var t = e.length, r = 1, n = -1, i; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = i = r;
        break;
      case "0":
        n === 0 && (n = r), i = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(i + 1) : e;
}
var No;
function T$(e, t) {
  var r = $o(e, t);
  if (!r) return No = void 0, e.toPrecision(t);
  var n = r[0], i = r[1], a = i - (No = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = n.length;
  return a === o ? n : a > o ? n + new Array(a - o + 1).join("0") : a > 0 ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + $o(e, Math.max(0, t + a - 1))[0];
}
function Vb(e, t) {
  var r = $o(e, t);
  if (!r) return e + "";
  var n = r[0], i = r[1];
  return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
}
const Kb = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: O$,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Vb(e * 100, t),
  r: Vb,
  s: T$,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function Yb(e) {
  return e;
}
var Xb = Array.prototype.map, Zb = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function E$(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? Yb : _$(Xb.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? Yb : S$(Xb.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", u = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f, d) {
    f = ta(f);
    var p = f.fill, m = f.align, v = f.sign, h = f.symbol, g = f.zero, b = f.width, w = f.comma, O = f.precision, y = f.trim, x = f.type;
    x === "n" ? (w = !0, x = "g") : Kb[x] || (O === void 0 && (O = 12), y = !0, x = "g"), (g || p === "0" && m === "=") && (g = !0, p = "0", m = "=");
    var _ = (d && d.prefix !== void 0 ? d.prefix : "") + (h === "$" ? r : h === "#" && /[boxX]/.test(x) ? "0" + x.toLowerCase() : ""), P = (h === "$" ? n : /[%p]/.test(x) ? o : "") + (d && d.suffix !== void 0 ? d.suffix : ""), E = Kb[x], M = /[defgprs%]/.test(x);
    O = O === void 0 ? 6 : /[gprs]/.test(x) ? Math.max(1, Math.min(21, O)) : Math.max(0, Math.min(20, O));
    function C(T) {
      var k = _, N = P, I, R, q;
      if (x === "c")
        N = E(T) + N, T = "";
      else {
        T = +T;
        var W = T < 0 || 1 / T < 0;
        if (T = isNaN(T) ? u : E(Math.abs(T), O), y && (T = P$(T)), W && +T == 0 && v !== "+" && (W = !1), k = (W ? v === "(" ? v : s : v === "-" || v === "(" ? "" : v) + k, N = (x === "s" && !isNaN(T) && No !== void 0 ? Zb[8 + No / 3] : "") + N + (W && v === "(" ? ")" : ""), M) {
          for (I = -1, R = T.length; ++I < R; )
            if (q = T.charCodeAt(I), 48 > q || q > 57) {
              N = (q === 46 ? i + T.slice(I + 1) : T.slice(I)) + N, T = T.slice(0, I);
              break;
            }
        }
      }
      w && !g && (T = t(T, 1 / 0));
      var H = k.length + T.length + N.length, $ = H < b ? new Array(b - H + 1).join(p) : "";
      switch (w && g && (T = t($ + T, $.length ? b - N.length : 1 / 0), $ = ""), m) {
        case "<":
          T = k + T + N + $;
          break;
        case "=":
          T = k + $ + T + N;
          break;
        case "^":
          T = $.slice(0, H = $.length >> 1) + k + T + N + $.slice(H);
          break;
        default:
          T = $ + k + T + N;
          break;
      }
      return a(T);
    }
    return C.toString = function() {
      return f + "";
    }, C;
  }
  function l(f, d) {
    var p = Math.max(-8, Math.min(8, Math.floor($n(d) / 3))) * 3, m = Math.pow(10, -p), v = c((f = ta(f), f.type = "f", f), { suffix: Zb[8 + p / 3] });
    return function(h) {
      return v(m * h);
    };
  }
  return {
    format: c,
    formatPrefix: l
  };
}
var Ja, Bh, k_;
C$({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function C$(e) {
  return Ja = E$(e), Bh = Ja.format, k_ = Ja.formatPrefix, Ja;
}
function M$(e) {
  return Math.max(0, -$n(Math.abs(e)));
}
function j$(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor($n(t) / 3))) * 3 - $n(Math.abs(e)));
}
function k$(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, $n(t) - $n(e)) + 1;
}
function $_(e, t, r, n) {
  var i = Kd(e, t, r), a;
  switch (n = ta(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(a = j$(i, o)) && (n.precision = a), k_(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(a = k$(i, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = a - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(a = M$(i)) && (n.precision = a - (n.type === "%") * 2);
      break;
    }
  }
  return Bh(n);
}
function Or(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return Hd(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var i = t();
    return $_(i[0], i[i.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), i = 0, a = n.length - 1, o = n[i], s = n[a], u, c, l = 10;
    for (s < o && (c = o, o = s, s = c, c = i, i = a, a = c); l-- > 0; ) {
      if (c = Vd(o, s, r), c === u)
        return n[i] = o, n[a] = s, t(n);
      if (c > 0)
        o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      u = c;
    }
    return e;
  }, e;
}
function Io() {
  var e = Lh();
  return e.copy = function() {
    return ka(e, Io());
  }, wt.apply(e, arguments), Or(e);
}
function N_(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, ko), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return N_(e).unknown(t);
  }, e = arguments.length ? Array.from(e, ko) : [0, 1], Or(r);
}
function I_(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, i = e[r], a = e[n], o;
  return a < i && (o = r, r = n, n = o, o = i, i = a, a = o), e[r] = t.floor(i), e[n] = t.ceil(a), e;
}
function Jb(e) {
  return Math.log(e);
}
function Qb(e) {
  return Math.exp(e);
}
function $$(e) {
  return -Math.log(-e);
}
function N$(e) {
  return -Math.exp(-e);
}
function I$(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function R$(e) {
  return e === 10 ? I$ : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function D$(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function e0(e) {
  return (t, r) => -e(-t, r);
}
function Fh(e) {
  const t = e(Jb, Qb), r = t.domain;
  let n = 10, i, a;
  function o() {
    return i = D$(n), a = R$(n), r()[0] < 0 ? (i = e0(i), a = e0(a), e($$, N$)) : e(Jb, Qb), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, t.ticks = (s) => {
    const u = r();
    let c = u[0], l = u[u.length - 1];
    const f = l < c;
    f && ([c, l] = [l, c]);
    let d = i(c), p = i(l), m, v;
    const h = s == null ? 10 : +s;
    let g = [];
    if (!(n % 1) && p - d < h) {
      if (d = Math.floor(d), p = Math.ceil(p), c > 0) {
        for (; d <= p; ++d)
          for (m = 1; m < n; ++m)
            if (v = d < 0 ? m / a(-d) : m * a(d), !(v < c)) {
              if (v > l) break;
              g.push(v);
            }
      } else for (; d <= p; ++d)
        for (m = n - 1; m >= 1; --m)
          if (v = d > 0 ? m / a(-d) : m * a(d), !(v < c)) {
            if (v > l) break;
            g.push(v);
          }
      g.length * 2 < h && (g = Hd(c, l, h));
    } else
      g = Hd(d, p, Math.min(p - d, h)).map(a);
    return f ? g.reverse() : g;
  }, t.tickFormat = (s, u) => {
    if (s == null && (s = 10), u == null && (u = n === 10 ? "s" : ","), typeof u != "function" && (!(n % 1) && (u = ta(u)).precision == null && (u.trim = !0), u = Bh(u)), s === 1 / 0) return u;
    const c = Math.max(1, n * s / t.ticks().length);
    return (l) => {
      let f = l / a(Math.round(i(l)));
      return f * n < n - 0.5 && (f *= n), f <= c ? u(l) : "";
    };
  }, t.nice = () => r(I_(r(), {
    floor: (s) => a(Math.floor(i(s))),
    ceil: (s) => a(Math.ceil(i(s)))
  })), t;
}
function R_() {
  const e = Fh(Ls()).domain([1, 10]);
  return e.copy = () => ka(e, R_()).base(e.base()), wt.apply(e, arguments), e;
}
function t0(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function r0(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function zh(e) {
  var t = 1, r = e(t0(t), r0(t));
  return r.constant = function(n) {
    return arguments.length ? e(t0(t = +n), r0(t)) : t;
  }, Or(r);
}
function D_() {
  var e = zh(Ls());
  return e.copy = function() {
    return ka(e, D_()).constant(e.constant());
  }, wt.apply(e, arguments);
}
function n0(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function L$(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function q$(e) {
  return e < 0 ? -e * e : e * e;
}
function Wh(e) {
  var t = e(Ze, Ze), r = 1;
  function n() {
    return r === 1 ? e(Ze, Ze) : r === 0.5 ? e(L$, q$) : e(n0(r), n0(1 / r));
  }
  return t.exponent = function(i) {
    return arguments.length ? (r = +i, n()) : r;
  }, Or(t);
}
function Uh() {
  var e = Wh(Ls());
  return e.copy = function() {
    return ka(e, Uh()).exponent(e.exponent());
  }, wt.apply(e, arguments), e;
}
function B$() {
  return Uh.apply(null, arguments).exponent(0.5);
}
function i0(e) {
  return Math.sign(e) * e * e;
}
function F$(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function L_() {
  var e = Lh(), t = [0, 1], r = !1, n;
  function i(a) {
    var o = F$(e(a));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return i.invert = function(a) {
    return e.invert(i0(a));
  }, i.domain = function(a) {
    return arguments.length ? (e.domain(a), i) : e.domain();
  }, i.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, ko)).map(i0)), i) : t.slice();
  }, i.rangeRound = function(a) {
    return i.range(a).round(!0);
  }, i.round = function(a) {
    return arguments.length ? (r = !!a, i) : r;
  }, i.clamp = function(a) {
    return arguments.length ? (e.clamp(a), i) : e.clamp();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return L_(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, wt.apply(i, arguments), Or(i);
}
function q_() {
  var e = [], t = [], r = [], n;
  function i() {
    var o = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++o < s; ) r[o - 1] = Hk(e, o / s);
    return a;
  }
  function a(o) {
    return o == null || isNaN(o = +o) ? n : t[Ma(r, o)];
  }
  return a.invertExtent = function(o) {
    var s = t.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of o) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(gr), i();
  }, a.range = function(o) {
    return arguments.length ? (t = Array.from(o), i()) : t.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.quantiles = function() {
    return r.slice();
  }, a.copy = function() {
    return q_().domain(e).range(t).unknown(n);
  }, wt.apply(a, arguments);
}
function B_() {
  var e = 0, t = 1, r = 1, n = [0.5], i = [0, 1], a;
  function o(u) {
    return u != null && u <= u ? i[Ma(n, u, 0, r)] : a;
  }
  function s() {
    var u = -1;
    for (n = new Array(r); ++u < r; ) n[u] = ((u + 1) * t - (u - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(u) {
    return arguments.length ? ([e, t] = u, e = +e, t = +t, s()) : [e, t];
  }, o.range = function(u) {
    return arguments.length ? (r = (i = Array.from(u)).length - 1, s()) : i.slice();
  }, o.invertExtent = function(u) {
    var c = i.indexOf(u);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, n[0]] : c >= r ? [n[r - 1], t] : [n[c - 1], n[c]];
  }, o.unknown = function(u) {
    return arguments.length && (a = u), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return B_().domain([e, t]).range(i).unknown(a);
  }, wt.apply(Or(o), arguments);
}
function F_() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function i(a) {
    return a != null && a <= a ? t[Ma(e, a, 0, n)] : r;
  }
  return i.domain = function(a) {
    return arguments.length ? (e = Array.from(a), n = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(a) {
    return arguments.length ? (t = Array.from(a), n = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return [e[o - 1], e[o]];
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return F_().domain(e).range(t).unknown(r);
  }, wt.apply(i, arguments);
}
const _f = /* @__PURE__ */ new Date(), Sf = /* @__PURE__ */ new Date();
function Be(e, t, r, n) {
  function i(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), i.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), i.round = (a) => {
    const o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = (a, o) => (t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a), i.range = (a, o, s) => {
    const u = [];
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return u;
    let c;
    do
      u.push(c = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (c < a && a < o);
    return u;
  }, i.filter = (a) => Be((o) => {
    if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0) for (; ++s <= 0; )
        for (; t(o, -1), !a(o); )
          ;
      else for (; --s >= 0; )
        for (; t(o, 1), !a(o); )
          ;
  }), r && (i.count = (a, o) => (_f.setTime(+a), Sf.setTime(+o), e(_f), e(Sf), Math.floor(r(_f, Sf))), i.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(n ? (o) => n(o) % a === 0 : (o) => i.count(0, o) % a === 0) : i)), i;
}
const Ro = Be(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Ro.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Be((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Ro);
Ro.range;
const Yt = 1e3, mt = Yt * 60, Xt = mt * 60, er = Xt * 24, Gh = er * 7, a0 = er * 30, Af = er * 365, Dr = Be((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Yt);
}, (e, t) => (t - e) / Yt, (e) => e.getUTCSeconds());
Dr.range;
const Hh = Be((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Yt);
}, (e, t) => {
  e.setTime(+e + t * mt);
}, (e, t) => (t - e) / mt, (e) => e.getMinutes());
Hh.range;
const Vh = Be((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * mt);
}, (e, t) => (t - e) / mt, (e) => e.getUTCMinutes());
Vh.range;
const Kh = Be((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Yt - e.getMinutes() * mt);
}, (e, t) => {
  e.setTime(+e + t * Xt);
}, (e, t) => (t - e) / Xt, (e) => e.getHours());
Kh.range;
const Yh = Be((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Xt);
}, (e, t) => (t - e) / Xt, (e) => e.getUTCHours());
Yh.range;
const $a = Be(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * mt) / er,
  (e) => e.getDate() - 1
);
$a.range;
const qs = Be((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / er, (e) => e.getUTCDate() - 1);
qs.range;
const z_ = Be((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / er, (e) => Math.floor(e / er));
z_.range;
function nn(e) {
  return Be((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * mt) / Gh);
}
const Bs = nn(0), Do = nn(1), z$ = nn(2), W$ = nn(3), Nn = nn(4), U$ = nn(5), G$ = nn(6);
Bs.range;
Do.range;
z$.range;
W$.range;
Nn.range;
U$.range;
G$.range;
function an(e) {
  return Be((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / Gh);
}
const Fs = an(0), Lo = an(1), H$ = an(2), V$ = an(3), In = an(4), K$ = an(5), Y$ = an(6);
Fs.range;
Lo.range;
H$.range;
V$.range;
In.range;
K$.range;
Y$.range;
const Xh = Be((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Xh.range;
const Zh = Be((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Zh.range;
const tr = Be((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
tr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Be((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
tr.range;
const rr = Be((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
rr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Be((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
rr.range;
function W_(e, t, r, n, i, a) {
  const o = [
    [Dr, 1, Yt],
    [Dr, 5, 5 * Yt],
    [Dr, 15, 15 * Yt],
    [Dr, 30, 30 * Yt],
    [a, 1, mt],
    [a, 5, 5 * mt],
    [a, 15, 15 * mt],
    [a, 30, 30 * mt],
    [i, 1, Xt],
    [i, 3, 3 * Xt],
    [i, 6, 6 * Xt],
    [i, 12, 12 * Xt],
    [n, 1, er],
    [n, 2, 2 * er],
    [r, 1, Gh],
    [t, 1, a0],
    [t, 3, 3 * a0],
    [e, 1, Af]
  ];
  function s(c, l, f) {
    const d = l < c;
    d && ([c, l] = [l, c]);
    const p = f && typeof f.range == "function" ? f : u(c, l, f), m = p ? p.range(c, +l + 1) : [];
    return d ? m.reverse() : m;
  }
  function u(c, l, f) {
    const d = Math.abs(l - c) / f, p = $h(([, , h]) => h).right(o, d);
    if (p === o.length) return e.every(Kd(c / Af, l / Af, f));
    if (p === 0) return Ro.every(Math.max(Kd(c, l, f), 1));
    const [m, v] = o[d / o[p - 1][2] < o[p][2] / d ? p - 1 : p];
    return m.every(v);
  }
  return [s, u];
}
const [X$, Z$] = W_(rr, Zh, Fs, z_, Yh, Vh), [J$, Q$] = W_(tr, Xh, Bs, $a, Kh, Hh);
function Pf(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Tf(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function xi(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function eN(e) {
  var t = e.dateTime, r = e.date, n = e.time, i = e.periods, a = e.days, o = e.shortDays, s = e.months, u = e.shortMonths, c = wi(i), l = Oi(i), f = wi(a), d = Oi(a), p = wi(o), m = Oi(o), v = wi(s), h = Oi(s), g = wi(u), b = Oi(u), w = {
    a: q,
    A: W,
    b: H,
    B: $,
    c: null,
    d: f0,
    e: f0,
    f: _N,
    g: $N,
    G: IN,
    H: xN,
    I: wN,
    j: ON,
    L: U_,
    m: SN,
    M: AN,
    p: L,
    q: B,
    Q: h0,
    s: v0,
    S: PN,
    u: TN,
    U: EN,
    V: CN,
    w: MN,
    W: jN,
    x: null,
    X: null,
    y: kN,
    Y: NN,
    Z: RN,
    "%": p0
  }, O = {
    a: V,
    A: X,
    b: te,
    B: re,
    c: null,
    d: d0,
    e: d0,
    f: BN,
    g: XN,
    G: JN,
    H: DN,
    I: LN,
    j: qN,
    L: H_,
    m: FN,
    M: zN,
    p: oe,
    q: ae,
    Q: h0,
    s: v0,
    S: WN,
    u: UN,
    U: GN,
    V: HN,
    w: VN,
    W: KN,
    x: null,
    X: null,
    y: YN,
    Y: ZN,
    Z: QN,
    "%": p0
  }, y = {
    a: M,
    A: C,
    b: T,
    B: k,
    c: N,
    d: c0,
    e: c0,
    f: yN,
    g: u0,
    G: s0,
    H: l0,
    I: l0,
    j: dN,
    L: vN,
    m: fN,
    M: pN,
    p: E,
    q: lN,
    Q: gN,
    s: bN,
    S: hN,
    u: aN,
    U: oN,
    V: sN,
    w: iN,
    W: uN,
    x: I,
    X: R,
    y: u0,
    Y: s0,
    Z: cN,
    "%": mN
  };
  w.x = x(r, w), w.X = x(n, w), w.c = x(t, w), O.x = x(r, O), O.X = x(n, O), O.c = x(t, O);
  function x(F, Y) {
    return function(ee) {
      var j = [], fe = -1, G = 0, Oe = F.length, Ee, Ue, cr;
      for (ee instanceof Date || (ee = /* @__PURE__ */ new Date(+ee)); ++fe < Oe; )
        F.charCodeAt(fe) === 37 && (j.push(F.slice(G, fe)), (Ue = o0[Ee = F.charAt(++fe)]) != null ? Ee = F.charAt(++fe) : Ue = Ee === "e" ? " " : "0", (cr = Y[Ee]) && (Ee = cr(ee, Ue)), j.push(Ee), G = fe + 1);
      return j.push(F.slice(G, fe)), j.join("");
    };
  }
  function _(F, Y) {
    return function(ee) {
      var j = xi(1900, void 0, 1), fe = P(j, F, ee += "", 0), G, Oe;
      if (fe != ee.length) return null;
      if ("Q" in j) return new Date(j.Q);
      if ("s" in j) return new Date(j.s * 1e3 + ("L" in j ? j.L : 0));
      if (Y && !("Z" in j) && (j.Z = 0), "p" in j && (j.H = j.H % 12 + j.p * 12), j.m === void 0 && (j.m = "q" in j ? j.q : 0), "V" in j) {
        if (j.V < 1 || j.V > 53) return null;
        "w" in j || (j.w = 1), "Z" in j ? (G = Tf(xi(j.y, 0, 1)), Oe = G.getUTCDay(), G = Oe > 4 || Oe === 0 ? Lo.ceil(G) : Lo(G), G = qs.offset(G, (j.V - 1) * 7), j.y = G.getUTCFullYear(), j.m = G.getUTCMonth(), j.d = G.getUTCDate() + (j.w + 6) % 7) : (G = Pf(xi(j.y, 0, 1)), Oe = G.getDay(), G = Oe > 4 || Oe === 0 ? Do.ceil(G) : Do(G), G = $a.offset(G, (j.V - 1) * 7), j.y = G.getFullYear(), j.m = G.getMonth(), j.d = G.getDate() + (j.w + 6) % 7);
      } else ("W" in j || "U" in j) && ("w" in j || (j.w = "u" in j ? j.u % 7 : "W" in j ? 1 : 0), Oe = "Z" in j ? Tf(xi(j.y, 0, 1)).getUTCDay() : Pf(xi(j.y, 0, 1)).getDay(), j.m = 0, j.d = "W" in j ? (j.w + 6) % 7 + j.W * 7 - (Oe + 5) % 7 : j.w + j.U * 7 - (Oe + 6) % 7);
      return "Z" in j ? (j.H += j.Z / 100 | 0, j.M += j.Z % 100, Tf(j)) : Pf(j);
    };
  }
  function P(F, Y, ee, j) {
    for (var fe = 0, G = Y.length, Oe = ee.length, Ee, Ue; fe < G; ) {
      if (j >= Oe) return -1;
      if (Ee = Y.charCodeAt(fe++), Ee === 37) {
        if (Ee = Y.charAt(fe++), Ue = y[Ee in o0 ? Y.charAt(fe++) : Ee], !Ue || (j = Ue(F, ee, j)) < 0) return -1;
      } else if (Ee != ee.charCodeAt(j++))
        return -1;
    }
    return j;
  }
  function E(F, Y, ee) {
    var j = c.exec(Y.slice(ee));
    return j ? (F.p = l.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function M(F, Y, ee) {
    var j = p.exec(Y.slice(ee));
    return j ? (F.w = m.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function C(F, Y, ee) {
    var j = f.exec(Y.slice(ee));
    return j ? (F.w = d.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function T(F, Y, ee) {
    var j = g.exec(Y.slice(ee));
    return j ? (F.m = b.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function k(F, Y, ee) {
    var j = v.exec(Y.slice(ee));
    return j ? (F.m = h.get(j[0].toLowerCase()), ee + j[0].length) : -1;
  }
  function N(F, Y, ee) {
    return P(F, t, Y, ee);
  }
  function I(F, Y, ee) {
    return P(F, r, Y, ee);
  }
  function R(F, Y, ee) {
    return P(F, n, Y, ee);
  }
  function q(F) {
    return o[F.getDay()];
  }
  function W(F) {
    return a[F.getDay()];
  }
  function H(F) {
    return u[F.getMonth()];
  }
  function $(F) {
    return s[F.getMonth()];
  }
  function L(F) {
    return i[+(F.getHours() >= 12)];
  }
  function B(F) {
    return 1 + ~~(F.getMonth() / 3);
  }
  function V(F) {
    return o[F.getUTCDay()];
  }
  function X(F) {
    return a[F.getUTCDay()];
  }
  function te(F) {
    return u[F.getUTCMonth()];
  }
  function re(F) {
    return s[F.getUTCMonth()];
  }
  function oe(F) {
    return i[+(F.getUTCHours() >= 12)];
  }
  function ae(F) {
    return 1 + ~~(F.getUTCMonth() / 3);
  }
  return {
    format: function(F) {
      var Y = x(F += "", w);
      return Y.toString = function() {
        return F;
      }, Y;
    },
    parse: function(F) {
      var Y = _(F += "", !1);
      return Y.toString = function() {
        return F;
      }, Y;
    },
    utcFormat: function(F) {
      var Y = x(F += "", O);
      return Y.toString = function() {
        return F;
      }, Y;
    },
    utcParse: function(F) {
      var Y = _(F += "", !0);
      return Y.toString = function() {
        return F;
      }, Y;
    }
  };
}
var o0 = { "-": "", _: " ", 0: "0" }, We = /^\s*\d+/, tN = /^%/, rN = /[\\^$*+?|[\]().{}]/g;
function pe(e, t, r) {
  var n = e < 0 ? "-" : "", i = (n ? -e : e) + "", a = i.length;
  return n + (a < r ? new Array(r - a + 1).join(t) + i : i);
}
function nN(e) {
  return e.replace(rN, "\\$&");
}
function wi(e) {
  return new RegExp("^(?:" + e.map(nN).join("|") + ")", "i");
}
function Oi(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function iN(e, t, r) {
  var n = We.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function aN(e, t, r) {
  var n = We.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function oN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function sN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function uN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function s0(e, t, r) {
  var n = We.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function u0(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function cN(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function lN(e, t, r) {
  var n = We.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function fN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function c0(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function dN(e, t, r) {
  var n = We.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function l0(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function pN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function hN(e, t, r) {
  var n = We.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function vN(e, t, r) {
  var n = We.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function yN(e, t, r) {
  var n = We.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function mN(e, t, r) {
  var n = tN.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function gN(e, t, r) {
  var n = We.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function bN(e, t, r) {
  var n = We.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function f0(e, t) {
  return pe(e.getDate(), t, 2);
}
function xN(e, t) {
  return pe(e.getHours(), t, 2);
}
function wN(e, t) {
  return pe(e.getHours() % 12 || 12, t, 2);
}
function ON(e, t) {
  return pe(1 + $a.count(tr(e), e), t, 3);
}
function U_(e, t) {
  return pe(e.getMilliseconds(), t, 3);
}
function _N(e, t) {
  return U_(e, t) + "000";
}
function SN(e, t) {
  return pe(e.getMonth() + 1, t, 2);
}
function AN(e, t) {
  return pe(e.getMinutes(), t, 2);
}
function PN(e, t) {
  return pe(e.getSeconds(), t, 2);
}
function TN(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function EN(e, t) {
  return pe(Bs.count(tr(e) - 1, e), t, 2);
}
function G_(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Nn(e) : Nn.ceil(e);
}
function CN(e, t) {
  return e = G_(e), pe(Nn.count(tr(e), e) + (tr(e).getDay() === 4), t, 2);
}
function MN(e) {
  return e.getDay();
}
function jN(e, t) {
  return pe(Do.count(tr(e) - 1, e), t, 2);
}
function kN(e, t) {
  return pe(e.getFullYear() % 100, t, 2);
}
function $N(e, t) {
  return e = G_(e), pe(e.getFullYear() % 100, t, 2);
}
function NN(e, t) {
  return pe(e.getFullYear() % 1e4, t, 4);
}
function IN(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? Nn(e) : Nn.ceil(e), pe(e.getFullYear() % 1e4, t, 4);
}
function RN(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + pe(t / 60 | 0, "0", 2) + pe(t % 60, "0", 2);
}
function d0(e, t) {
  return pe(e.getUTCDate(), t, 2);
}
function DN(e, t) {
  return pe(e.getUTCHours(), t, 2);
}
function LN(e, t) {
  return pe(e.getUTCHours() % 12 || 12, t, 2);
}
function qN(e, t) {
  return pe(1 + qs.count(rr(e), e), t, 3);
}
function H_(e, t) {
  return pe(e.getUTCMilliseconds(), t, 3);
}
function BN(e, t) {
  return H_(e, t) + "000";
}
function FN(e, t) {
  return pe(e.getUTCMonth() + 1, t, 2);
}
function zN(e, t) {
  return pe(e.getUTCMinutes(), t, 2);
}
function WN(e, t) {
  return pe(e.getUTCSeconds(), t, 2);
}
function UN(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function GN(e, t) {
  return pe(Fs.count(rr(e) - 1, e), t, 2);
}
function V_(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? In(e) : In.ceil(e);
}
function HN(e, t) {
  return e = V_(e), pe(In.count(rr(e), e) + (rr(e).getUTCDay() === 4), t, 2);
}
function VN(e) {
  return e.getUTCDay();
}
function KN(e, t) {
  return pe(Lo.count(rr(e) - 1, e), t, 2);
}
function YN(e, t) {
  return pe(e.getUTCFullYear() % 100, t, 2);
}
function XN(e, t) {
  return e = V_(e), pe(e.getUTCFullYear() % 100, t, 2);
}
function ZN(e, t) {
  return pe(e.getUTCFullYear() % 1e4, t, 4);
}
function JN(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? In(e) : In.ceil(e), pe(e.getUTCFullYear() % 1e4, t, 4);
}
function QN() {
  return "+0000";
}
function p0() {
  return "%";
}
function h0(e) {
  return +e;
}
function v0(e) {
  return Math.floor(+e / 1e3);
}
var fn, K_, Y_;
eI({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function eI(e) {
  return fn = eN(e), K_ = fn.format, fn.parse, Y_ = fn.utcFormat, fn.utcParse, fn;
}
function tI(e) {
  return new Date(e);
}
function rI(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Jh(e, t, r, n, i, a, o, s, u, c) {
  var l = Lh(), f = l.invert, d = l.domain, p = c(".%L"), m = c(":%S"), v = c("%I:%M"), h = c("%I %p"), g = c("%a %d"), b = c("%b %d"), w = c("%B"), O = c("%Y");
  function y(x) {
    return (u(x) < x ? p : s(x) < x ? m : o(x) < x ? v : a(x) < x ? h : n(x) < x ? i(x) < x ? g : b : r(x) < x ? w : O)(x);
  }
  return l.invert = function(x) {
    return new Date(f(x));
  }, l.domain = function(x) {
    return arguments.length ? d(Array.from(x, rI)) : d().map(tI);
  }, l.ticks = function(x) {
    var _ = d();
    return e(_[0], _[_.length - 1], x ?? 10);
  }, l.tickFormat = function(x, _) {
    return _ == null ? y : c(_);
  }, l.nice = function(x) {
    var _ = d();
    return (!x || typeof x.range != "function") && (x = t(_[0], _[_.length - 1], x ?? 10)), x ? d(I_(_, x)) : l;
  }, l.copy = function() {
    return ka(l, Jh(e, t, r, n, i, a, o, s, u, c));
  }, l;
}
function nI() {
  return wt.apply(Jh(J$, Q$, tr, Xh, Bs, $a, Kh, Hh, Dr, K_).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function iI() {
  return wt.apply(Jh(X$, Z$, rr, Zh, Fs, qs, Yh, Vh, Dr, Y_).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function zs() {
  var e = 0, t = 1, r, n, i, a, o = Ze, s = !1, u;
  function c(f) {
    return f == null || isNaN(f = +f) ? u : o(i === 0 ? 0.5 : (f = (a(f) - r) * i, s ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = a(e = +e), n = a(t = +t), i = r === n ? 0 : 1 / (n - r), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (s = !!f, c) : s;
  }, c.interpolator = function(f) {
    return arguments.length ? (o = f, c) : o;
  };
  function l(f) {
    return function(d) {
      var p, m;
      return arguments.length ? ([p, m] = d, o = f(p, m), c) : [o(0), o(1)];
    };
  }
  return c.range = l(si), c.rangeRound = l(Dh), c.unknown = function(f) {
    return arguments.length ? (u = f, c) : u;
  }, function(f) {
    return a = f, r = f(e), n = f(t), i = r === n ? 0 : 1 / (n - r), c;
  };
}
function _r(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function X_() {
  var e = Or(zs()(Ze));
  return e.copy = function() {
    return _r(e, X_());
  }, or.apply(e, arguments);
}
function Z_() {
  var e = Fh(zs()).domain([1, 10]);
  return e.copy = function() {
    return _r(e, Z_()).base(e.base());
  }, or.apply(e, arguments);
}
function J_() {
  var e = zh(zs());
  return e.copy = function() {
    return _r(e, J_()).constant(e.constant());
  }, or.apply(e, arguments);
}
function Qh() {
  var e = Wh(zs());
  return e.copy = function() {
    return _r(e, Qh()).exponent(e.exponent());
  }, or.apply(e, arguments);
}
function aI() {
  return Qh.apply(null, arguments).exponent(0.5);
}
function Q_() {
  var e = [], t = Ze;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((Ma(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of n) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(gr), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, i) => t(i / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (i, a) => Gk(e, a / n));
  }, r.copy = function() {
    return Q_(t).domain(e);
  }, or.apply(r, arguments);
}
function Ws() {
  var e = 0, t = 0.5, r = 1, n = 1, i, a, o, s, u, c = Ze, l, f = !1, d;
  function p(v) {
    return isNaN(v = +v) ? d : (v = 0.5 + ((v = +l(v)) - a) * (n * v < n * a ? s : u), c(f ? Math.max(0, Math.min(1, v)) : v));
  }
  p.domain = function(v) {
    return arguments.length ? ([e, t, r] = v, i = l(e = +e), a = l(t = +t), o = l(r = +r), s = i === a ? 0 : 0.5 / (a - i), u = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, p) : [e, t, r];
  }, p.clamp = function(v) {
    return arguments.length ? (f = !!v, p) : f;
  }, p.interpolator = function(v) {
    return arguments.length ? (c = v, p) : c;
  };
  function m(v) {
    return function(h) {
      var g, b, w;
      return arguments.length ? ([g, b, w] = h, c = m$(v, [g, b, w]), p) : [c(0), c(0.5), c(1)];
    };
  }
  return p.range = m(si), p.rangeRound = m(Dh), p.unknown = function(v) {
    return arguments.length ? (d = v, p) : d;
  }, function(v) {
    return l = v, i = v(e), a = v(t), o = v(r), s = i === a ? 0 : 0.5 / (a - i), u = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, p;
  };
}
function eS() {
  var e = Or(Ws()(Ze));
  return e.copy = function() {
    return _r(e, eS());
  }, or.apply(e, arguments);
}
function tS() {
  var e = Fh(Ws()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return _r(e, tS()).base(e.base());
  }, or.apply(e, arguments);
}
function rS() {
  var e = zh(Ws());
  return e.copy = function() {
    return _r(e, rS()).constant(e.constant());
  }, or.apply(e, arguments);
}
function ev() {
  var e = Wh(Ws());
  return e.copy = function() {
    return _r(e, ev()).exponent(e.exponent());
  }, or.apply(e, arguments);
}
function oI() {
  return ev.apply(null, arguments).exponent(0.5);
}
const y0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Zi,
  scaleDiverging: eS,
  scaleDivergingLog: tS,
  scaleDivergingPow: ev,
  scaleDivergingSqrt: oI,
  scaleDivergingSymlog: rS,
  scaleIdentity: N_,
  scaleImplicit: Yd,
  scaleLinear: Io,
  scaleLog: R_,
  scaleOrdinal: Nh,
  scalePoint: Ni,
  scalePow: Uh,
  scaleQuantile: q_,
  scaleQuantize: B_,
  scaleRadial: L_,
  scaleSequential: X_,
  scaleSequentialLog: Z_,
  scaleSequentialPow: Qh,
  scaleSequentialQuantile: Q_,
  scaleSequentialSqrt: aI,
  scaleSequentialSymlog: J_,
  scaleSqrt: B$,
  scaleSymlog: D_,
  scaleThreshold: F_,
  scaleTime: nI,
  scaleUtc: iI,
  tickFormat: $_
}, Symbol.toStringTag, { value: "Module" }));
var Ef, m0;
function Us() {
  if (m0) return Ef;
  m0 = 1;
  var e = ni();
  function t(r, n, i) {
    for (var a = -1, o = r.length; ++a < o; ) {
      var s = r[a], u = n(s);
      if (u != null && (c === void 0 ? u === u && !e(u) : i(u, c)))
        var c = u, l = s;
    }
    return l;
  }
  return Ef = t, Ef;
}
var Cf, g0;
function nS() {
  if (g0) return Cf;
  g0 = 1;
  function e(t, r) {
    return t > r;
  }
  return Cf = e, Cf;
}
var Mf, b0;
function sI() {
  if (b0) return Mf;
  b0 = 1;
  var e = Us(), t = nS(), r = oi();
  function n(i) {
    return i && i.length ? e(i, r, t) : void 0;
  }
  return Mf = n, Mf;
}
var uI = sI();
const yr = /* @__PURE__ */ xe(uI);
var jf, x0;
function iS() {
  if (x0) return jf;
  x0 = 1;
  function e(t, r) {
    return t < r;
  }
  return jf = e, jf;
}
var kf, w0;
function cI() {
  if (w0) return kf;
  w0 = 1;
  var e = Us(), t = iS(), r = oi();
  function n(i) {
    return i && i.length ? e(i, r, t) : void 0;
  }
  return kf = n, kf;
}
var lI = cI();
const Gs = /* @__PURE__ */ xe(lI);
var $f, O0;
function fI() {
  if (O0) return $f;
  O0 = 1;
  var e = yh(), t = Ft(), r = p_(), n = nt();
  function i(a, o) {
    var s = n(a) ? e : r;
    return s(a, t(o, 3));
  }
  return $f = i, $f;
}
var Nf, _0;
function dI() {
  if (_0) return Nf;
  _0 = 1;
  var e = f_(), t = fI();
  function r(n, i) {
    return e(t(n, i), 1);
  }
  return Nf = r, Nf;
}
var pI = dI();
const hI = /* @__PURE__ */ xe(pI);
var If, S0;
function vI() {
  if (S0) return If;
  S0 = 1;
  var e = Ch();
  function t(r, n) {
    return e(r, n);
  }
  return If = t, If;
}
var yI = vI();
const Yr = /* @__PURE__ */ xe(yI);
var ui = 1e9, mI = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, rv, Ce = !0, gt = "[DecimalError] ", Wr = gt + "Invalid argument: ", tv = gt + "Exponent out of range: ", ci = Math.floor, kr = Math.pow, gI = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, st, Fe = 1e7, Te = 7, aS = 9007199254740991, qo = ci(aS / Te), Z = {};
Z.absoluteValue = Z.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Z.comparedTo = Z.cmp = function(e) {
  var t, r, n, i, a = this;
  if (e = new a.constructor(e), a.s !== e.s) return a.s || -e.s;
  if (a.e !== e.e) return a.e > e.e ^ a.s < 0 ? 1 : -1;
  for (n = a.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (a.d[t] !== e.d[t]) return a.d[t] > e.d[t] ^ a.s < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ a.s < 0 ? 1 : -1;
};
Z.decimalPlaces = Z.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * Te;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
Z.dividedBy = Z.div = function(e) {
  return Qt(this, new this.constructor(e));
};
Z.dividedToIntegerBy = Z.idiv = function(e) {
  var t = this, r = t.constructor;
  return we(Qt(t, new r(e), 0, 1), r.precision);
};
Z.equals = Z.eq = function(e) {
  return !this.cmp(e);
};
Z.exponent = function() {
  return Ne(this);
};
Z.greaterThan = Z.gt = function(e) {
  return this.cmp(e) > 0;
};
Z.greaterThanOrEqualTo = Z.gte = function(e) {
  return this.cmp(e) >= 0;
};
Z.isInteger = Z.isint = function() {
  return this.e > this.d.length - 2;
};
Z.isNegative = Z.isneg = function() {
  return this.s < 0;
};
Z.isPositive = Z.ispos = function() {
  return this.s > 0;
};
Z.isZero = function() {
  return this.s === 0;
};
Z.lessThan = Z.lt = function(e) {
  return this.cmp(e) < 0;
};
Z.lessThanOrEqualTo = Z.lte = function(e) {
  return this.cmp(e) < 1;
};
Z.logarithm = Z.log = function(e) {
  var t, r = this, n = r.constructor, i = n.precision, a = i + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(st)) throw Error(gt + "NaN");
  if (r.s < 1) throw Error(gt + (r.s ? "NaN" : "-Infinity"));
  return r.eq(st) ? new n(0) : (Ce = !1, t = Qt(ra(r, a), ra(e, a), a), Ce = !0, we(t, i));
};
Z.minus = Z.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? uS(t, e) : oS(t, (e.s = -e.s, e));
};
Z.modulo = Z.mod = function(e) {
  var t, r = this, n = r.constructor, i = n.precision;
  if (e = new n(e), !e.s) throw Error(gt + "NaN");
  return r.s ? (Ce = !1, t = Qt(r, e, 0, 1).times(e), Ce = !0, r.minus(t)) : we(new n(r), i);
};
Z.naturalExponential = Z.exp = function() {
  return sS(this);
};
Z.naturalLogarithm = Z.ln = function() {
  return ra(this);
};
Z.negated = Z.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Z.plus = Z.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? oS(t, e) : uS(t, (e.s = -e.s, e));
};
Z.precision = Z.sd = function(e) {
  var t, r, n, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Wr + e);
  if (t = Ne(i) + 1, n = i.d.length - 1, r = n * Te + 1, n = i.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = i.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
Z.squareRoot = Z.sqrt = function() {
  var e, t, r, n, i, a, o, s = this, u = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new u(0);
    throw Error(gt + "NaN");
  }
  for (e = Ne(s), Ce = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = Nt(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = ci((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new u(t)) : n = new u(i.toString()), r = u.precision, i = o = r + 3; ; )
    if (a = n, n = a.plus(Qt(s, a, o + 2)).times(0.5), Nt(a.d).slice(0, o) === (t = Nt(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), i == o && t == "4999") {
        if (we(a, r + 1, 0), a.times(a).eq(s)) {
          n = a;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return Ce = !0, we(n, r);
};
Z.times = Z.mul = function(e) {
  var t, r, n, i, a, o, s, u, c, l = this, f = l.constructor, d = l.d, p = (e = new f(e)).d;
  if (!l.s || !e.s) return new f(0);
  for (e.s *= l.s, r = l.e + e.e, u = d.length, c = p.length, u < c && (a = d, d = p, p = a, o = u, u = c, c = o), a = [], o = u + c, n = o; n--; ) a.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, i = u + n; i > n; )
      s = a[i] + p[n] * d[i - n - 1] + t, a[i--] = s % Fe | 0, t = s / Fe | 0;
    a[i] = (a[i] + t) % Fe | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t ? ++r : a.shift(), e.d = a, e.e = r, Ce ? we(e, f.precision) : e;
};
Z.toDecimalPlaces = Z.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (qt(e, 0, ui), t === void 0 ? t = n.rounding : qt(t, 0, 8), we(r, e + Ne(r) + 1, t));
};
Z.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = Xr(n, !0) : (qt(e, 0, ui), t === void 0 ? t = i.rounding : qt(t, 0, 8), n = we(new i(n), e + 1, t), r = Xr(n, !0, e + 1)), r;
};
Z.toFixed = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? Xr(i) : (qt(e, 0, ui), t === void 0 ? t = a.rounding : qt(t, 0, 8), n = we(new a(i), e + Ne(i) + 1, t), r = Xr(n.abs(), !1, e + Ne(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
};
Z.toInteger = Z.toint = function() {
  var e = this, t = e.constructor;
  return we(new t(e), Ne(e) + 1, t.rounding);
};
Z.toNumber = function() {
  return +this;
};
Z.toPower = Z.pow = function(e) {
  var t, r, n, i, a, o, s = this, u = s.constructor, c = 12, l = +(e = new u(e));
  if (!e.s) return new u(st);
  if (s = new u(s), !s.s) {
    if (e.s < 1) throw Error(gt + "Infinity");
    return s;
  }
  if (s.eq(st)) return s;
  if (n = u.precision, e.eq(st)) return we(s, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, a = s.s, o) {
    if ((r = l < 0 ? -l : l) <= aS) {
      for (i = new u(st), t = Math.ceil(n / Te + 4), Ce = !1; r % 2 && (i = i.times(s), P0(i.d, t)), r = ci(r / 2), r !== 0; )
        s = s.times(s), P0(s.d, t);
      return Ce = !0, e.s < 0 ? new u(st).div(i) : we(i, n);
    }
  } else if (a < 0) throw Error(gt + "NaN");
  return a = a < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, Ce = !1, i = e.times(ra(s, n + c)), Ce = !0, i = sS(i), i.s = a, i;
};
Z.toPrecision = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? (r = Ne(i), n = Xr(i, r <= a.toExpNeg || r >= a.toExpPos)) : (qt(e, 1, ui), t === void 0 ? t = a.rounding : qt(t, 0, 8), i = we(new a(i), e, t), r = Ne(i), n = Xr(i, e <= r || r <= a.toExpNeg, e)), n;
};
Z.toSignificantDigits = Z.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (qt(e, 1, ui), t === void 0 ? t = n.rounding : qt(t, 0, 8)), we(new n(r), e, t);
};
Z.toString = Z.valueOf = Z.val = Z.toJSON = Z[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Ne(e), r = e.constructor;
  return Xr(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function oS(e, t) {
  var r, n, i, a, o, s, u, c, l = e.constructor, f = l.precision;
  if (!e.s || !t.s)
    return t.s || (t = new l(e)), Ce ? we(t, f) : t;
  if (u = e.d, c = t.d, o = e.e, i = t.e, u = u.slice(), a = o - i, a) {
    for (a < 0 ? (n = u, a = -a, s = c.length) : (n = c, i = o, s = u.length), o = Math.ceil(f / Te), s = o > s ? o + 1 : s + 1, a > s && (a = s, n.length = 1), n.reverse(); a--; ) n.push(0);
    n.reverse();
  }
  for (s = u.length, a = c.length, s - a < 0 && (a = s, n = c, c = u, u = n), r = 0; a; )
    r = (u[--a] = u[a] + c[a] + r) / Fe | 0, u[a] %= Fe;
  for (r && (u.unshift(r), ++i), s = u.length; u[--s] == 0; ) u.pop();
  return t.d = u, t.e = i, Ce ? we(t, f) : t;
}
function qt(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Wr + e);
}
function Nt(e) {
  var t, r, n, i = e.length - 1, a = "", o = e[0];
  if (i > 0) {
    for (a += o, t = 1; t < i; t++)
      n = e[t] + "", r = Te - n.length, r && (a += hr(r)), a += n;
    o = e[t], n = o + "", r = Te - n.length, r && (a += hr(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return a + o;
}
var Qt = /* @__PURE__ */ function() {
  function e(n, i) {
    var a, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      a = n[s] * i + o, n[s] = a % Fe | 0, o = a / Fe | 0;
    return o && n.unshift(o), n;
  }
  function t(n, i, a, o) {
    var s, u;
    if (a != o)
      u = a > o ? 1 : -1;
    else
      for (s = u = 0; s < a; s++)
        if (n[s] != i[s]) {
          u = n[s] > i[s] ? 1 : -1;
          break;
        }
    return u;
  }
  function r(n, i, a) {
    for (var o = 0; a--; )
      n[a] -= o, o = n[a] < i[a] ? 1 : 0, n[a] = o * Fe + n[a] - i[a];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, a, o) {
    var s, u, c, l, f, d, p, m, v, h, g, b, w, O, y, x, _, P, E = n.constructor, M = n.s == i.s ? 1 : -1, C = n.d, T = i.d;
    if (!n.s) return new E(n);
    if (!i.s) throw Error(gt + "Division by zero");
    for (u = n.e - i.e, _ = T.length, y = C.length, p = new E(M), m = p.d = [], c = 0; T[c] == (C[c] || 0); ) ++c;
    if (T[c] > (C[c] || 0) && --u, a == null ? b = a = E.precision : o ? b = a + (Ne(n) - Ne(i)) + 1 : b = a, b < 0) return new E(0);
    if (b = b / Te + 2 | 0, c = 0, _ == 1)
      for (l = 0, T = T[0], b++; (c < y || l) && b--; c++)
        w = l * Fe + (C[c] || 0), m[c] = w / T | 0, l = w % T | 0;
    else {
      for (l = Fe / (T[0] + 1) | 0, l > 1 && (T = e(T, l), C = e(C, l), _ = T.length, y = C.length), O = _, v = C.slice(0, _), h = v.length; h < _; ) v[h++] = 0;
      P = T.slice(), P.unshift(0), x = T[0], T[1] >= Fe / 2 && ++x;
      do
        l = 0, s = t(T, v, _, h), s < 0 ? (g = v[0], _ != h && (g = g * Fe + (v[1] || 0)), l = g / x | 0, l > 1 ? (l >= Fe && (l = Fe - 1), f = e(T, l), d = f.length, h = v.length, s = t(f, v, d, h), s == 1 && (l--, r(f, _ < d ? P : T, d))) : (l == 0 && (s = l = 1), f = T.slice()), d = f.length, d < h && f.unshift(0), r(v, f, h), s == -1 && (h = v.length, s = t(T, v, _, h), s < 1 && (l++, r(v, _ < h ? P : T, h))), h = v.length) : s === 0 && (l++, v = [0]), m[c++] = l, s && v[0] ? v[h++] = C[O] || 0 : (v = [C[O]], h = 1);
      while ((O++ < y || v[0] !== void 0) && b--);
    }
    return m[0] || m.shift(), p.e = u, we(p, o ? a + Ne(p) + 1 : a);
  };
}();
function sS(e, t) {
  var r, n, i, a, o, s, u = 0, c = 0, l = e.constructor, f = l.precision;
  if (Ne(e) > 16) throw Error(tv + Ne(e));
  if (!e.s) return new l(st);
  for (Ce = !1, s = f, o = new l(0.03125); e.abs().gte(0.1); )
    e = e.times(o), c += 5;
  for (n = Math.log(kr(2, c)) / Math.LN10 * 2 + 5 | 0, s += n, r = i = a = new l(st), l.precision = s; ; ) {
    if (i = we(i.times(e), s), r = r.times(++u), o = a.plus(Qt(i, r, s)), Nt(o.d).slice(0, s) === Nt(a.d).slice(0, s)) {
      for (; c--; ) a = we(a.times(a), s);
      return l.precision = f, t == null ? (Ce = !0, we(a, f)) : a;
    }
    a = o;
  }
}
function Ne(e) {
  for (var t = e.e * Te, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function Rf(e, t, r) {
  if (t > e.LN10.sd())
    throw Ce = !0, r && (e.precision = r), Error(gt + "LN10 precision limit exceeded");
  return we(new e(e.LN10), t);
}
function hr(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function ra(e, t) {
  var r, n, i, a, o, s, u, c, l, f = 1, d = 10, p = e, m = p.d, v = p.constructor, h = v.precision;
  if (p.s < 1) throw Error(gt + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(st)) return new v(0);
  if (t == null ? (Ce = !1, c = h) : c = t, p.eq(10))
    return t == null && (Ce = !0), Rf(v, c);
  if (c += d, v.precision = c, r = Nt(m), n = r.charAt(0), a = Ne(p), Math.abs(a) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      p = p.times(e), r = Nt(p.d), n = r.charAt(0), f++;
    a = Ne(p), n > 1 ? (p = new v("0." + r), a++) : p = new v(n + "." + r.slice(1));
  } else
    return u = Rf(v, c + 2, h).times(a + ""), p = ra(new v(n + "." + r.slice(1)), c - d).plus(u), v.precision = h, t == null ? (Ce = !0, we(p, h)) : p;
  for (s = o = p = Qt(p.minus(st), p.plus(st), c), l = we(p.times(p), c), i = 3; ; ) {
    if (o = we(o.times(l), c), u = s.plus(Qt(o, new v(i), c)), Nt(u.d).slice(0, c) === Nt(s.d).slice(0, c))
      return s = s.times(2), a !== 0 && (s = s.plus(Rf(v, c + 2, h).times(a + ""))), s = Qt(s, new v(f), c), v.precision = h, t == null ? (Ce = !0, we(s, h)) : s;
    s = u, i += 2;
  }
}
function A0(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(n, i), t) {
    if (i -= n, r = r - n - 1, e.e = ci(r / Te), e.d = [], n = (r + 1) % Te, r < 0 && (n += Te), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= Te; n < i; ) e.d.push(+t.slice(n, n += Te));
      t = t.slice(n), n = Te - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    if (e.d.push(+t), Ce && (e.e > qo || e.e < -qo)) throw Error(tv + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function we(e, t, r) {
  var n, i, a, o, s, u, c, l, f = e.d;
  for (o = 1, a = f[0]; a >= 10; a /= 10) o++;
  if (n = t - o, n < 0)
    n += Te, i = t, c = f[l = 0];
  else {
    if (l = Math.ceil((n + 1) / Te), a = f.length, l >= a) return e;
    for (c = a = f[l], o = 1; a >= 10; a /= 10) o++;
    n %= Te, i = n - Te + o;
  }
  if (r !== void 0 && (a = kr(10, o - i - 1), s = c / a % 10 | 0, u = t < 0 || f[l + 1] !== void 0 || c % a, u = r < 4 ? (s || u) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || u || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? i > 0 ? c / kr(10, o - i) : 0 : f[l - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return u ? (a = Ne(e), f.length = 1, t = t - a - 1, f[0] = kr(10, (Te - t % Te) % Te), e.e = ci(-t / Te) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = l, a = 1, l--) : (f.length = l + 1, a = kr(10, Te - n), f[l] = i > 0 ? (c / kr(10, o - i) % kr(10, i) | 0) * a : 0), u)
    for (; ; )
      if (l == 0) {
        (f[0] += a) == Fe && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[l] += a, f[l] != Fe) break;
        f[l--] = 0, a = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (Ce && (e.e > qo || e.e < -qo))
    throw Error(tv + Ne(e));
  return e;
}
function uS(e, t) {
  var r, n, i, a, o, s, u, c, l, f, d = e.constructor, p = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), Ce ? we(t, p) : t;
  if (u = e.d, f = t.d, n = t.e, c = e.e, u = u.slice(), o = c - n, o) {
    for (l = o < 0, l ? (r = u, o = -o, s = f.length) : (r = f, n = c, s = u.length), i = Math.max(Math.ceil(p / Te), s) + 2, o > i && (o = i, r.length = 1), r.reverse(), i = o; i--; ) r.push(0);
    r.reverse();
  } else {
    for (i = u.length, s = f.length, l = i < s, l && (s = i), i = 0; i < s; i++)
      if (u[i] != f[i]) {
        l = u[i] < f[i];
        break;
      }
    o = 0;
  }
  for (l && (r = u, u = f, f = r, t.s = -t.s), s = u.length, i = f.length - s; i > 0; --i) u[s++] = 0;
  for (i = f.length; i > o; ) {
    if (u[--i] < f[i]) {
      for (a = i; a && u[--a] === 0; ) u[a] = Fe - 1;
      --u[a], u[i] += Fe;
    }
    u[i] -= f[i];
  }
  for (; u[--s] === 0; ) u.pop();
  for (; u[0] === 0; u.shift()) --n;
  return u[0] ? (t.d = u, t.e = n, Ce ? we(t, p) : t) : new d(0);
}
function Xr(e, t, r) {
  var n, i = Ne(e), a = Nt(e.d), o = a.length;
  return t ? (r && (n = r - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + hr(n) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (i < 0 ? "e" : "e+") + i) : i < 0 ? (a = "0." + hr(-i - 1) + a, r && (n = r - o) > 0 && (a += hr(n))) : i >= o ? (a += hr(i + 1 - o), r && (n = r - i - 1) > 0 && (a = a + "." + hr(n))) : ((n = i + 1) < o && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - o) > 0 && (i + 1 === o && (a += "."), a += hr(n))), e.s < 0 ? "-" + a : a;
}
function P0(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function cS(e) {
  var t, r, n;
  function i(a) {
    var o = this;
    if (!(o instanceof i)) return new i(a);
    if (o.constructor = i, a instanceof i) {
      o.s = a.s, o.e = a.e, o.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(Wr + a);
      if (a > 0)
        o.s = 1;
      else if (a < 0)
        a = -a, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        o.e = 0, o.d = [a];
        return;
      }
      return A0(o, a.toString());
    } else if (typeof a != "string")
      throw Error(Wr + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), o.s = -1) : o.s = 1, gI.test(a)) A0(o, a);
    else throw Error(Wr + a);
  }
  if (i.prototype = Z, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = cS, i.config = i.set = bI, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function bI(e) {
  if (!e || typeof e != "object")
    throw Error(gt + "Object expected");
  var t, r, n, i = [
    "precision",
    1,
    ui,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((n = e[r = i[t]]) !== void 0)
      if (ci(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(Wr + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Wr + r + ": " + n);
  return this;
}
var rv = cS(mI);
st = new rv(1);
const be = rv;
function xI(e) {
  return SI(e) || _I(e) || OI(e) || wI();
}
function wI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function OI(e, t) {
  if (e) {
    if (typeof e == "string") return Qd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Qd(e, t);
  }
}
function _I(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function SI(e) {
  if (Array.isArray(e)) return Qd(e);
}
function Qd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var AI = function(t) {
  return t;
}, lS = {}, fS = function(t) {
  return t === lS;
}, T0 = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && fS(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, PI = function e(t, r) {
  return t === 1 ? r : T0(function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = i.filter(function(s) {
      return s !== lS;
    }).length;
    return o >= t ? r.apply(void 0, i) : e(t - o, T0(function() {
      for (var s = arguments.length, u = new Array(s), c = 0; c < s; c++)
        u[c] = arguments[c];
      var l = i.map(function(f) {
        return fS(f) ? u.shift() : f;
      });
      return r.apply(void 0, xI(l).concat(u));
    }));
  });
}, Hs = function(t) {
  return PI(t.length, t);
}, ep = function(t, r) {
  for (var n = [], i = t; i < r; ++i)
    n[i - t] = i;
  return n;
}, TI = Hs(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), EI = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return AI;
  var i = r.reverse(), a = i[0], o = i.slice(1);
  return function() {
    return o.reduce(function(s, u) {
      return u(s);
    }, a.apply(void 0, arguments));
  };
}, tp = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, dS = function(t) {
  var r = null, n = null;
  return function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r && a.every(function(s, u) {
      return s === r[u];
    }) || (r = a, n = t.apply(void 0, a)), n;
  };
};
function CI(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new be(e).abs().log(10).toNumber()) + 1, t;
}
function MI(e, t, r) {
  for (var n = new be(e), i = 0, a = []; n.lt(t) && i < 1e5; )
    a.push(n.toNumber()), n = n.add(r), i++;
  return a;
}
var jI = Hs(function(e, t, r) {
  var n = +e, i = +t;
  return n + r * (i - n);
}), kI = Hs(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), $I = Hs(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const Vs = {
  rangeStep: MI,
  getDigitCount: CI,
  interpolateNumber: jI,
  uninterpolateNumber: kI,
  uninterpolateTruncation: $I
};
function rp(e) {
  return RI(e) || II(e) || pS(e) || NI();
}
function NI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function II(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function RI(e) {
  if (Array.isArray(e)) return np(e);
}
function na(e, t) {
  return qI(e) || LI(e, t) || pS(e, t) || DI();
}
function DI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pS(e, t) {
  if (e) {
    if (typeof e == "string") return np(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return np(e, t);
  }
}
function np(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function LI(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, i = !1, a = void 0;
    try {
      for (var o = e[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (u) {
      i = !0, a = u;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (i) throw a;
      }
    }
    return r;
  }
}
function qI(e) {
  if (Array.isArray(e)) return e;
}
function hS(e) {
  var t = na(e, 2), r = t[0], n = t[1], i = r, a = n;
  return r > n && (i = n, a = r), [i, a];
}
function vS(e, t, r) {
  if (e.lte(0))
    return new be(0);
  var n = Vs.getDigitCount(e.toNumber()), i = new be(10).pow(n), a = e.div(i), o = n !== 1 ? 0.05 : 0.1, s = new be(Math.ceil(a.div(o).toNumber())).add(r).mul(o), u = s.mul(i);
  return t ? u : new be(Math.ceil(u));
}
function BI(e, t, r) {
  var n = 1, i = new be(e);
  if (!i.isint() && r) {
    var a = Math.abs(e);
    a < 1 ? (n = new be(10).pow(Vs.getDigitCount(e) - 1), i = new be(Math.floor(i.div(n).toNumber())).mul(n)) : a > 1 && (i = new be(Math.floor(e)));
  } else e === 0 ? i = new be(Math.floor((t - 1) / 2)) : r || (i = new be(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), s = EI(TI(function(u) {
    return i.add(new be(u - o).mul(n)).toNumber();
  }), ep);
  return s(0, t);
}
function yS(e, t, r, n) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new be(0),
      tickMin: new be(0),
      tickMax: new be(0)
    };
  var a = vS(new be(t).sub(e).div(r - 1), n, i), o;
  e <= 0 && t >= 0 ? o = new be(0) : (o = new be(e).add(t).div(2), o = o.sub(new be(o).mod(a)));
  var s = Math.ceil(o.sub(e).div(a).toNumber()), u = Math.ceil(new be(t).sub(o).div(a).toNumber()), c = s + u + 1;
  return c > r ? yS(e, t, r, n, i + 1) : (c < r && (u = t > 0 ? u + (r - c) : u, s = t > 0 ? s : s + (r - c)), {
    step: a,
    tickMin: o.sub(new be(s).mul(a)),
    tickMax: o.add(new be(u).mul(a))
  });
}
function FI(e) {
  var t = na(e, 2), r = t[0], n = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(i, 2), s = hS([r, n]), u = na(s, 2), c = u[0], l = u[1];
  if (c === -1 / 0 || l === 1 / 0) {
    var f = l === 1 / 0 ? [c].concat(rp(ep(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(rp(ep(0, i - 1).map(function() {
      return -1 / 0;
    })), [l]);
    return r > n ? tp(f) : f;
  }
  if (c === l)
    return BI(c, i, a);
  var d = yS(c, l, o, a), p = d.step, m = d.tickMin, v = d.tickMax, h = Vs.rangeStep(m, v.add(new be(0.1).mul(p)), p);
  return r > n ? tp(h) : h;
}
function zI(e, t) {
  var r = na(e, 2), n = r[0], i = r[1], a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = hS([n, i]), s = na(o, 2), u = s[0], c = s[1];
  if (u === -1 / 0 || c === 1 / 0)
    return [n, i];
  if (u === c)
    return [u];
  var l = Math.max(t, 2), f = vS(new be(c).sub(u).div(l - 1), a, 0), d = [].concat(rp(Vs.rangeStep(new be(u), new be(c).sub(new be(0.99).mul(f)), f)), [c]);
  return n > i ? tp(d) : d;
}
var WI = dS(FI), UI = dS(zI), GI = process.env.NODE_ENV === "production", Df = "Invariant failed";
function tt(e, t) {
  if (GI)
    throw new Error(Df);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat(Df, ": ").concat(r) : Df;
  throw new Error(n);
}
var HI = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Rn(e) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rn(e);
}
function Bo() {
  return Bo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bo.apply(this, arguments);
}
function VI(e, t) {
  return ZI(e) || XI(e, t) || YI(e, t) || KI();
}
function KI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YI(e, t) {
  if (e) {
    if (typeof e == "string") return E0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return E0(e, t);
  }
}
function E0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function XI(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function ZI(e) {
  if (Array.isArray(e)) return e;
}
function JI(e, t) {
  if (e == null) return {};
  var r = QI(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function QI(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function e2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function t2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bS(n.key), n);
  }
}
function r2(e, t, r) {
  return t && t2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function n2(e, t, r) {
  return t = Fo(t), i2(e, mS() ? Reflect.construct(t, r || [], Fo(e).constructor) : t.apply(e, r));
}
function i2(e, t) {
  if (t && (Rn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return a2(e);
}
function a2(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function mS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mS = function() {
    return !!e;
  })();
}
function Fo(e) {
  return Fo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fo(e);
}
function o2(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ip(e, t);
}
function ip(e, t) {
  return ip = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, ip(e, t);
}
function gS(e, t, r) {
  return t = bS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bS(e) {
  var t = s2(e, "string");
  return Rn(t) == "symbol" ? t : t + "";
}
function s2(e, t) {
  if (Rn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Rn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Na = /* @__PURE__ */ function(e) {
  function t() {
    return e2(this, t), n2(this, t, arguments);
  }
  return o2(t, e), r2(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.offset, a = n.layout, o = n.width, s = n.dataKey, u = n.data, c = n.dataPointFormatter, l = n.xAxis, f = n.yAxis, d = JI(n, HI), p = Q(d, !1);
      this.props.direction === "x" && l.type !== "number" && (process.env.NODE_ENV !== "production" ? tt(!1, 'ErrorBar requires Axis type property to be "number".') : tt());
      var m = u.map(function(v) {
        var h = c(v, s), g = h.x, b = h.y, w = h.value, O = h.errorVal;
        if (!O)
          return null;
        var y = [], x, _;
        if (Array.isArray(O)) {
          var P = VI(O, 2);
          x = P[0], _ = P[1];
        } else
          x = _ = O;
        if (a === "vertical") {
          var E = l.scale, M = b + i, C = M + o, T = M - o, k = E(w - x), N = E(w + _);
          y.push({
            x1: N,
            y1: C,
            x2: N,
            y2: T
          }), y.push({
            x1: k,
            y1: M,
            x2: N,
            y2: M
          }), y.push({
            x1: k,
            y1: C,
            x2: k,
            y2: T
          });
        } else if (a === "horizontal") {
          var I = f.scale, R = g + i, q = R - o, W = R + o, H = I(w - x), $ = I(w + _);
          y.push({
            x1: q,
            y1: $,
            x2: W,
            y2: $
          }), y.push({
            x1: R,
            y1: H,
            x2: R,
            y2: $
          }), y.push({
            x1: q,
            y1: H,
            x2: W,
            y2: H
          });
        }
        return /* @__PURE__ */ S.createElement(le, Bo({
          className: "recharts-errorBar",
          key: "bar-".concat(y.map(function(L) {
            return "".concat(L.x1, "-").concat(L.x2, "-").concat(L.y1, "-").concat(L.y2);
          }))
        }, p), y.map(function(L) {
          return /* @__PURE__ */ S.createElement("line", Bo({}, L, {
            key: "line-".concat(L.x1, "-").concat(L.x2, "-").concat(L.y1, "-").concat(L.y2)
          }));
        }));
      });
      return /* @__PURE__ */ S.createElement(le, {
        className: "recharts-errorBars"
      }, m);
    }
  }]);
}(S.Component);
gS(Na, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
gS(Na, "displayName", "ErrorBar");
function ia(e) {
  "@babel/helpers - typeof";
  return ia = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ia(e);
}
function C0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C0(Object(r), !0).forEach(function(n) {
      u2(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : C0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function u2(e, t, r) {
  return t = c2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function c2(e) {
  var t = l2(e, "string");
  return ia(t) == "symbol" ? t : t + "";
}
function l2(e, t) {
  if (ia(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ia(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var xS = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, i = t.legendWidth, a = t.legendContent, o = ot(r, On);
  if (!o)
    return null;
  var s = On.defaultProps, u = s !== void 0 ? Tr(Tr({}, s), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : a === "children" ? c = (n || []).reduce(function(l, f) {
    var d = f.item, p = f.props, m = p.sectors || p.data || [];
    return l.concat(m.map(function(v) {
      return {
        type: o.props.iconType || d.props.legendType,
        value: v.name,
        color: v.fill,
        payload: v
      };
    }));
  }, []) : c = (n || []).map(function(l) {
    var f = l.item, d = f.type.defaultProps, p = d !== void 0 ? Tr(Tr({}, d), f.props) : {}, m = p.dataKey, v = p.name, h = p.legendType, g = p.hide;
    return {
      inactive: g,
      dataKey: m,
      type: u.iconType || h || "square",
      color: nv(f),
      value: v || m,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: p
    };
  }), Tr(Tr(Tr({}, u), On.getWithHeight(o, i)), {}, {
    payload: c,
    item: o
  });
};
function aa(e) {
  "@babel/helpers - typeof";
  return aa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, aa(e);
}
function M0(e) {
  return h2(e) || p2(e) || d2(e) || f2();
}
function f2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function d2(e, t) {
  if (e) {
    if (typeof e == "string") return ap(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ap(e, t);
  }
}
function p2(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function h2(e) {
  if (Array.isArray(e)) return ap(e);
}
function ap(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function j0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j0(Object(r), !0).forEach(function(n) {
      Sn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : j0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Sn(e, t, r) {
  return t = v2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function v2(e) {
  var t = y2(e, "string");
  return aa(t) == "symbol" ? t : t + "";
}
function y2(e, t) {
  if (aa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (aa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ke(e, t, r) {
  return se(e) || se(t) ? r : qe(t) ? ut(e, t, r) : ie(t) ? t(e) : r;
}
function Ii(e, t, r, n) {
  var i = hI(e, function(s) {
    return ke(s, t);
  });
  if (r === "number") {
    var a = i.filter(function(s) {
      return U(s) || parseFloat(s);
    });
    return a.length ? [Gs(a), yr(a)] : [1 / 0, -1 / 0];
  }
  var o = n ? i.filter(function(s) {
    return !se(s);
  }) : i;
  return o.map(function(s) {
    return qe(s) || s instanceof Date ? s : "";
  });
}
var m2 = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, a = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n?.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (a && a.axisType === "angleAxis" && Math.abs(Math.abs(a.range[1] - a.range[0]) - 360) <= 1e-6)
    for (var u = a.range, c = 0; c < s; c++) {
      var l = c > 0 ? i[c - 1].coordinate : i[s - 1].coordinate, f = i[c].coordinate, d = c >= s - 1 ? i[0].coordinate : i[c + 1].coordinate, p = void 0;
      if (Ye(f - l) !== Ye(d - f)) {
        var m = [];
        if (Ye(d - f) === Ye(u[1] - u[0])) {
          p = d;
          var v = f + u[1] - u[0];
          m[0] = Math.min(v, (v + l) / 2), m[1] = Math.max(v, (v + l) / 2);
        } else {
          p = l;
          var h = d + u[1] - u[0];
          m[0] = Math.min(f, (h + f) / 2), m[1] = Math.max(f, (h + f) / 2);
        }
        var g = [Math.min(f, (p + f) / 2), Math.max(f, (p + f) / 2)];
        if (t > g[0] && t <= g[1] || t >= m[0] && t <= m[1]) {
          o = i[c].index;
          break;
        }
      } else {
        var b = Math.min(l, d), w = Math.max(l, d);
        if (t > (b + f) / 2 && t <= (w + f) / 2) {
          o = i[c].index;
          break;
        }
      }
    }
  else
    for (var O = 0; O < s; O++)
      if (O === 0 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O > 0 && O < s - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O === s - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2) {
        o = n[O].index;
        break;
      }
  return o;
}, nv = function(t) {
  var r, n = t, i = n.type.displayName, a = (r = t.type) !== null && r !== void 0 && r.defaultProps ? je(je({}, t.type.defaultProps), t.props) : t.props, o = a.stroke, s = a.fill, u;
  switch (i) {
    case "Line":
      u = o;
      break;
    case "Area":
    case "Radar":
      u = o && o !== "none" ? o : s;
      break;
    default:
      u = s;
      break;
  }
  return u;
}, g2 = function(t) {
  var r = t.barSize, n = t.totalSize, i = t.stackGroups, a = i === void 0 ? {} : i;
  if (!a)
    return {};
  for (var o = {}, s = Object.keys(a), u = 0, c = s.length; u < c; u++)
    for (var l = a[s[u]].stackGroups, f = Object.keys(l), d = 0, p = f.length; d < p; d++) {
      var m = l[f[d]], v = m.items, h = m.cateAxisId, g = v.filter(function(_) {
        return Jt(_.type).indexOf("Bar") >= 0;
      });
      if (g && g.length) {
        var b = g[0].type.defaultProps, w = b !== void 0 ? je(je({}, b), g[0].props) : g[0].props, O = w.barSize, y = w[h];
        o[y] || (o[y] = []);
        var x = se(O) ? r : O;
        o[y].push({
          item: g[0],
          stackList: g.slice(1),
          barSize: se(x) ? void 0 : Xe(x, n, 0)
        });
      }
    }
  return o;
}, b2 = function(t) {
  var r = t.barGap, n = t.barCategoryGap, i = t.bandSize, a = t.sizeList, o = a === void 0 ? [] : a, s = t.maxBarSize, u = o.length;
  if (u < 1) return null;
  var c = Xe(r, i, 0, !0), l, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var d = !1, p = i / u, m = o.reduce(function(O, y) {
      return O + y.barSize || 0;
    }, 0);
    m += (u - 1) * c, m >= i && (m -= (u - 1) * c, c = 0), m >= i && p > 0 && (d = !0, p *= 0.9, m = u * p);
    var v = (i - m) / 2 >> 0, h = {
      offset: v - c,
      size: 0
    };
    l = o.reduce(function(O, y) {
      var x = {
        item: y.item,
        position: {
          offset: h.offset + h.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: d ? p : y.barSize
        }
      }, _ = [].concat(M0(O), [x]);
      return h = _[_.length - 1].position, y.stackList && y.stackList.length && y.stackList.forEach(function(P) {
        _.push({
          item: P,
          position: h
        });
      }), _;
    }, f);
  } else {
    var g = Xe(n, i, 0, !0);
    i - 2 * g - (u - 1) * c <= 0 && (c = 0);
    var b = (i - 2 * g - (u - 1) * c) / u;
    b > 1 && (b >>= 0);
    var w = s === +s ? Math.min(b, s) : b;
    l = o.reduce(function(O, y, x) {
      var _ = [].concat(M0(O), [{
        item: y.item,
        position: {
          offset: g + (b + c) * x + (b - w) / 2,
          size: w
        }
      }]);
      return y.stackList && y.stackList.length && y.stackList.forEach(function(P) {
        _.push({
          item: P,
          position: _[_.length - 1].position
        });
      }), _;
    }, f);
  }
  return l;
}, x2 = function(t, r, n, i) {
  var a = n.children, o = n.width, s = n.margin, u = o - (s.left || 0) - (s.right || 0), c = xS({
    children: a,
    legendWidth: u
  });
  if (c) {
    var l = i || {}, f = l.width, d = l.height, p = c.align, m = c.verticalAlign, v = c.layout;
    if ((v === "vertical" || v === "horizontal" && m === "middle") && p !== "center" && U(t[p]))
      return je(je({}, t), {}, Sn({}, p, t[p] + (f || 0)));
    if ((v === "horizontal" || v === "vertical" && p === "center") && m !== "middle" && U(t[m]))
      return je(je({}, t), {}, Sn({}, m, t[m] + (d || 0)));
  }
  return t;
}, w2 = function(t, r, n) {
  return se(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, wS = function(t, r, n, i, a) {
  var o = r.props.children, s = ct(o, Na).filter(function(c) {
    return w2(i, a, c.props.direction);
  });
  if (s && s.length) {
    var u = s.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, l) {
      var f = ke(l, n);
      if (se(f)) return c;
      var d = Array.isArray(f) ? [Gs(f), yr(f)] : [f, f], p = u.reduce(function(m, v) {
        var h = ke(l, v, 0), g = d[0] - Math.abs(Array.isArray(h) ? h[0] : h), b = d[1] + Math.abs(Array.isArray(h) ? h[1] : h);
        return [Math.min(g, m[0]), Math.max(b, m[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], c[0]), Math.max(p[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, O2 = function(t, r, n, i, a) {
  var o = r.map(function(s) {
    return wS(t, s, n, a, i);
  }).filter(function(s) {
    return !se(s);
  });
  return o && o.length ? o.reduce(function(s, u) {
    return [Math.min(s[0], u[0]), Math.max(s[1], u[1])];
  }, [1 / 0, -1 / 0]) : null;
}, OS = function(t, r, n, i, a) {
  var o = r.map(function(u) {
    var c = u.props.dataKey;
    return n === "number" && c && wS(t, u, c, i) || Ii(t, c, n, a);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(u, c) {
        return [Math.min(u[0], c[0]), Math.max(u[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(u, c) {
    for (var l = 0, f = c.length; l < f; l++)
      s[c[l]] || (s[c[l]] = !0, u.push(c[l]));
    return u;
  }, []);
}, _S = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, SS = function(t, r, n, i) {
  if (i)
    return t.map(function(u) {
      return u.coordinate;
    });
  var a, o, s = t.map(function(u) {
    return u.coordinate === r && (a = !0), u.coordinate === n && (o = !0), u.coordinate;
  });
  return a || s.push(r), o || s.push(n), s;
}, Zt = function(t, r, n) {
  if (!t) return null;
  var i = t.scale, a = t.duplicateDomain, o = t.type, s = t.range, u = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, c = (r || n) && o === "category" && i.bandwidth ? i.bandwidth() / u : 0;
  if (c = t.axisType === "angleAxis" && s?.length >= 2 ? Ye(s[0] - s[1]) * 2 * c : c, r && (t.ticks || t.niceTicks)) {
    var l = (t.ticks || t.niceTicks).map(function(f) {
      var d = a ? a.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(d) + c,
        value: f,
        offset: c
      };
    });
    return l.filter(function(f) {
      return !ai(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, d) {
    return {
      coordinate: i(f) + c,
      value: f,
      index: d,
      offset: c
    };
  }) : i.ticks && !n ? i.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: i(f) + c,
      value: f,
      offset: c
    };
  }) : i.domain().map(function(f, d) {
    return {
      coordinate: i(f) + c,
      value: a ? a[f] : f,
      index: d,
      offset: c
    };
  });
}, Lf = /* @__PURE__ */ new WeakMap(), Qa = function(t, r) {
  if (typeof r != "function")
    return t;
  Lf.has(t) || Lf.set(t, /* @__PURE__ */ new WeakMap());
  var n = Lf.get(t);
  if (n.has(r))
    return n.get(r);
  var i = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, i), i;
}, AS = function(t, r, n) {
  var i = t.scale, a = t.type, o = t.layout, s = t.axisType;
  if (i === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: Zi(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: Io(),
      realScaleType: "linear"
    } : a === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Ni(),
      realScaleType: "point"
    } : a === "category" ? {
      scale: Zi(),
      realScaleType: "band"
    } : {
      scale: Io(),
      realScaleType: "linear"
    };
  if (Hr(i)) {
    var u = "scale".concat(Ms(i));
    return {
      scale: (y0[u] || Ni)(),
      realScaleType: y0[u] ? u : "point"
    };
  }
  return ie(i) ? {
    scale: i
  } : {
    scale: Ni(),
    realScaleType: "point"
  };
}, k0 = 1e-4, PS = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, i = t.range(), a = Math.min(i[0], i[1]) - k0, o = Math.max(i[0], i[1]) + k0, s = t(r[0]), u = t(r[n - 1]);
    (s < a || s > o || u < a || u > o) && t.domain([r[0], r[n - 1]]);
  }
}, _2 = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, i = t.length; n < i; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, S2 = function(t, r) {
  if (!r || r.length !== 2 || !U(r[0]) || !U(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]), a = [t[0], t[1]];
  return (!U(t[0]) || t[0] < n) && (a[0] = n), (!U(t[1]) || t[1] > i) && (a[1] = i), a[0] > i && (a[0] = i), a[1] < n && (a[1] = n), a;
}, A2 = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, i = t[0].length; n < i; ++n)
      for (var a = 0, o = 0, s = 0; s < r; ++s) {
        var u = ai(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        u >= 0 ? (t[s][n][0] = a, t[s][n][1] = a + u, a = t[s][n][1]) : (t[s][n][0] = o, t[s][n][1] = o + u, o = t[s][n][1]);
      }
}, P2 = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, i = t[0].length; n < i; ++n)
      for (var a = 0, o = 0; o < r; ++o) {
        var s = ai(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        s >= 0 ? (t[o][n][0] = a, t[o][n][1] = a + s, a = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, T2 = {
  sign: A2,
  // @ts-expect-error definitelytyped types are incorrect
  expand: h6,
  // @ts-expect-error definitelytyped types are incorrect
  none: En,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: v6,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: y6,
  positive: P2
}, E2 = function(t, r, n) {
  var i = r.map(function(s) {
    return s.props.dataKey;
  }), a = T2[n], o = p6().keys(i).value(function(s, u) {
    return +ke(s, u, 0);
  }).order(Id).offset(a);
  return o(t);
}, C2 = function(t, r, n, i, a, o) {
  if (!t)
    return null;
  var s = o ? r.reverse() : r, u = {}, c = s.reduce(function(f, d) {
    var p, m = (p = d.type) !== null && p !== void 0 && p.defaultProps ? je(je({}, d.type.defaultProps), d.props) : d.props, v = m.stackId, h = m.hide;
    if (h)
      return f;
    var g = m[n], b = f[g] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (qe(v)) {
      var w = b.stackGroups[v] || {
        numericAxisId: n,
        cateAxisId: i,
        items: []
      };
      w.items.push(d), b.hasStack = !0, b.stackGroups[v] = w;
    } else
      b.stackGroups[tn("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: i,
        items: [d]
      };
    return je(je({}, f), {}, Sn({}, g, b));
  }, u), l = {};
  return Object.keys(c).reduce(function(f, d) {
    var p = c[d];
    if (p.hasStack) {
      var m = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(v, h) {
        var g = p.stackGroups[h];
        return je(je({}, v), {}, Sn({}, h, {
          numericAxisId: n,
          cateAxisId: i,
          items: g.items,
          stackedData: E2(t, g.items, a)
        }));
      }, m);
    }
    return je(je({}, f), {}, Sn({}, d, p));
  }, l);
}, TS = function(t, r) {
  var n = r.realScaleType, i = r.type, a = r.tickCount, o = r.originalDomain, s = r.allowDecimals, u = n || r.scale;
  if (u !== "auto" && u !== "linear")
    return null;
  if (a && i === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var l = WI(c, a, s);
    return t.domain([Gs(l), yr(l)]), {
      niceTicks: l
    };
  }
  if (a && i === "number") {
    var f = t.domain(), d = UI(f, a, s);
    return {
      niceTicks: d
    };
  }
  return null;
};
function zo(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, i = e.entry, a = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !se(i[t.dataKey])) {
      var s = yo(r, "value", i[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[a] ? r[a].coordinate + n / 2 : null;
  }
  var u = ke(i, se(o) ? t.dataKey : o);
  return se(u) ? null : t.scale(u);
}
var $0 = function(t) {
  var r = t.axis, n = t.ticks, i = t.offset, a = t.bandSize, o = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + i : null;
  var u = ke(o, r.dataKey, r.domain[s]);
  return se(u) ? null : r.scale(u) - a / 2 + i;
}, M2 = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var i = Math.min(n[0], n[1]), a = Math.max(n[0], n[1]);
    return i <= 0 && a >= 0 ? 0 : a < 0 ? a : i;
  }
  return n[0];
}, j2 = function(t, r) {
  var n, i = (n = t.type) !== null && n !== void 0 && n.defaultProps ? je(je({}, t.type.defaultProps), t.props) : t.props, a = i.stackId;
  if (qe(a)) {
    var o = r[a];
    if (o) {
      var s = o.items.indexOf(t);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, k2 = function(t) {
  return t.reduce(function(r, n) {
    return [Gs(n.concat([r[0]]).filter(U)), yr(n.concat([r[1]]).filter(U))];
  }, [1 / 0, -1 / 0]);
}, ES = function(t, r, n) {
  return Object.keys(t).reduce(function(i, a) {
    var o = t[a], s = o.stackedData, u = s.reduce(function(c, l) {
      var f = k2(l.slice(r, n + 1));
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(u[0], i[0]), Math.max(u[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, N0 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, I0 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, op = function(t, r, n) {
  if (ie(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var i = [];
  if (U(t[0]))
    i[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (N0.test(t[0])) {
    var a = +N0.exec(t[0])[1];
    i[0] = r[0] - a;
  } else ie(t[0]) ? i[0] = t[0](r[0]) : i[0] = r[0];
  if (U(t[1]))
    i[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (I0.test(t[1])) {
    var o = +I0.exec(t[1])[1];
    i[1] = r[1] + o;
  } else ie(t[1]) ? i[1] = t[1](r[1]) : i[1] = r[1];
  return i;
}, Wo = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!n || i > 0)
      return i;
  }
  if (t && r && r.length >= 2) {
    for (var a = jh(r, function(f) {
      return f.coordinate;
    }), o = 1 / 0, s = 1, u = a.length; s < u; s++) {
      var c = a[s], l = a[s - 1];
      o = Math.min((c.coordinate || 0) - (l.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, R0 = function(t, r, n) {
  return !t || !t.length || Yr(t, ut(n, "type.defaultProps.domain")) ? r : t;
}, CS = function(t, r) {
  var n = t.type.defaultProps ? je(je({}, t.type.defaultProps), t.props) : t.props, i = n.dataKey, a = n.name, o = n.unit, s = n.formatter, u = n.tooltipType, c = n.chartType, l = n.hide;
  return je(je({}, Q(t, !1)), {}, {
    dataKey: i,
    unit: o,
    formatter: s,
    name: a || i,
    color: nv(t),
    value: ke(r, i),
    type: u,
    payload: r,
    chartType: c,
    hide: l
  });
};
function oa(e) {
  "@babel/helpers - typeof";
  return oa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oa(e);
}
function D0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D0(Object(r), !0).forEach(function(n) {
      MS(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : D0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function MS(e, t, r) {
  return t = $2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $2(e) {
  var t = N2(e, "string");
  return oa(t) == "symbol" ? t : t + "";
}
function N2(e, t) {
  if (oa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (oa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function I2(e, t) {
  return q2(e) || L2(e, t) || D2(e, t) || R2();
}
function R2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function D2(e, t) {
  if (e) {
    if (typeof e == "string") return L0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return L0(e, t);
  }
}
function L0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function L2(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function q2(e) {
  if (Array.isArray(e)) return e;
}
var Uo = Math.PI / 180, B2 = function(t) {
  return t * 180 / Math.PI;
}, Ae = function(t, r, n, i) {
  return {
    x: t + Math.cos(-Uo * i) * n,
    y: r + Math.sin(-Uo * i) * n
  };
}, jS = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, F2 = function(t, r, n, i, a) {
  var o = t.width, s = t.height, u = t.startAngle, c = t.endAngle, l = Xe(t.cx, o, o / 2), f = Xe(t.cy, s, s / 2), d = jS(o, s, n), p = Xe(t.innerRadius, d, 0), m = Xe(t.outerRadius, d, d * 0.8), v = Object.keys(r);
  return v.reduce(function(h, g) {
    var b = r[g], w = b.domain, O = b.reversed, y;
    if (se(b.range))
      i === "angleAxis" ? y = [u, c] : i === "radiusAxis" && (y = [p, m]), O && (y = [y[1], y[0]]);
    else {
      y = b.range;
      var x = y, _ = I2(x, 2);
      u = _[0], c = _[1];
    }
    var P = AS(b, a), E = P.realScaleType, M = P.scale;
    M.domain(w).range(y), PS(M);
    var C = TS(M, Ht(Ht({}, b), {}, {
      realScaleType: E
    })), T = Ht(Ht(Ht({}, b), C), {}, {
      range: y,
      radius: m,
      realScaleType: E,
      scale: M,
      cx: l,
      cy: f,
      innerRadius: p,
      outerRadius: m,
      startAngle: u,
      endAngle: c
    });
    return Ht(Ht({}, h), {}, MS({}, g, T));
  }, {});
}, z2 = function(t, r) {
  var n = t.x, i = t.y, a = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - a, 2) + Math.pow(i - o, 2));
}, W2 = function(t, r) {
  var n = t.x, i = t.y, a = r.cx, o = r.cy, s = z2({
    x: n,
    y: i
  }, {
    x: a,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var u = (n - a) / s, c = Math.acos(u);
  return i > o && (c = 2 * Math.PI - c), {
    radius: s,
    angle: B2(c),
    angleInRadian: c
  };
}, U2 = function(t) {
  var r = t.startAngle, n = t.endAngle, i = Math.floor(r / 360), a = Math.floor(n / 360), o = Math.min(i, a);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, G2 = function(t, r) {
  var n = r.startAngle, i = r.endAngle, a = Math.floor(n / 360), o = Math.floor(i / 360), s = Math.min(a, o);
  return t + s * 360;
}, q0 = function(t, r) {
  var n = t.x, i = t.y, a = W2({
    x: n,
    y: i
  }, r), o = a.radius, s = a.angle, u = r.innerRadius, c = r.outerRadius;
  if (o < u || o > c)
    return !1;
  if (o === 0)
    return !0;
  var l = U2(r), f = l.startAngle, d = l.endAngle, p = s, m;
  if (f <= d) {
    for (; p > d; )
      p -= 360;
    for (; p < f; )
      p += 360;
    m = p >= f && p <= d;
  } else {
    for (; p > f; )
      p -= 360;
    for (; p < d; )
      p += 360;
    m = p >= d && p <= f;
  }
  return m ? Ht(Ht({}, r), {}, {
    radius: o,
    angle: G2(p, r)
  }) : null;
}, kS = function(t) {
  return !/* @__PURE__ */ Pt(t) && !ie(t) && typeof t != "boolean" ? t.className : "";
};
function sa(e) {
  "@babel/helpers - typeof";
  return sa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sa(e);
}
var H2 = ["offset"];
function V2(e) {
  return Z2(e) || X2(e) || Y2(e) || K2();
}
function K2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y2(e, t) {
  if (e) {
    if (typeof e == "string") return sp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return sp(e, t);
  }
}
function X2(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Z2(e) {
  if (Array.isArray(e)) return sp(e);
}
function sp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function J2(e, t) {
  if (e == null) return {};
  var r = Q2(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Q2(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function B0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? B0(Object(r), !0).forEach(function(n) {
      eR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : B0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function eR(e, t, r) {
  return t = tR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function tR(e) {
  var t = rR(e, "string");
  return sa(t) == "symbol" ? t : t + "";
}
function rR(e, t) {
  if (sa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (sa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ua() {
  return ua = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ua.apply(this, arguments);
}
var nR = function(t) {
  var r = t.value, n = t.formatter, i = se(t.children) ? r : t.children;
  return ie(n) ? n(i) : i;
}, iR = function(t, r) {
  var n = Ye(r - t), i = Math.min(Math.abs(r - t), 360);
  return n * i;
}, aR = function(t, r, n) {
  var i = t.position, a = t.viewBox, o = t.offset, s = t.className, u = a, c = u.cx, l = u.cy, f = u.innerRadius, d = u.outerRadius, p = u.startAngle, m = u.endAngle, v = u.clockWise, h = (f + d) / 2, g = iR(p, m), b = g >= 0 ? 1 : -1, w, O;
  i === "insideStart" ? (w = p + b * o, O = v) : i === "insideEnd" ? (w = m - b * o, O = !v) : i === "end" && (w = m + b * o, O = v), O = g <= 0 ? O : !O;
  var y = Ae(c, l, h, w), x = Ae(c, l, h, w + (O ? 1 : -1) * 359), _ = "M".concat(y.x, ",").concat(y.y, `
    A`).concat(h, ",").concat(h, ",0,1,").concat(O ? 0 : 1, `,
    `).concat(x.x, ",").concat(x.y), P = se(t.id) ? tn("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ S.createElement("text", ua({}, n, {
    dominantBaseline: "central",
    className: ue("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("path", {
    id: P,
    d: _
  })), /* @__PURE__ */ S.createElement("textPath", {
    xlinkHref: "#".concat(P)
  }, r));
}, oR = function(t) {
  var r = t.viewBox, n = t.offset, i = t.position, a = r, o = a.cx, s = a.cy, u = a.innerRadius, c = a.outerRadius, l = a.startAngle, f = a.endAngle, d = (l + f) / 2;
  if (i === "outside") {
    var p = Ae(o, s, c + n, d), m = p.x, v = p.y;
    return {
      x: m,
      y: v,
      textAnchor: m >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var h = (u + c) / 2, g = Ae(o, s, h, d), b = g.x, w = g.y;
  return {
    x: b,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, sR = function(t) {
  var r = t.viewBox, n = t.parentViewBox, i = t.offset, a = t.position, o = r, s = o.x, u = o.y, c = o.width, l = o.height, f = l >= 0 ? 1 : -1, d = f * i, p = f > 0 ? "end" : "start", m = f > 0 ? "start" : "end", v = c >= 0 ? 1 : -1, h = v * i, g = v > 0 ? "end" : "start", b = v > 0 ? "start" : "end";
  if (a === "top") {
    var w = {
      x: s + c / 2,
      y: u - f * i,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return Re(Re({}, w), n ? {
      height: Math.max(u - n.y, 0),
      width: c
    } : {});
  }
  if (a === "bottom") {
    var O = {
      x: s + c / 2,
      y: u + l + d,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return Re(Re({}, O), n ? {
      height: Math.max(n.y + n.height - (u + l), 0),
      width: c
    } : {});
  }
  if (a === "left") {
    var y = {
      x: s - h,
      y: u + l / 2,
      textAnchor: g,
      verticalAnchor: "middle"
    };
    return Re(Re({}, y), n ? {
      width: Math.max(y.x - n.x, 0),
      height: l
    } : {});
  }
  if (a === "right") {
    var x = {
      x: s + c + h,
      y: u + l / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return Re(Re({}, x), n ? {
      width: Math.max(n.x + n.width - x.x, 0),
      height: l
    } : {});
  }
  var _ = n ? {
    width: c,
    height: l
  } : {};
  return a === "insideLeft" ? Re({
    x: s + h,
    y: u + l / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, _) : a === "insideRight" ? Re({
    x: s + c - h,
    y: u + l / 2,
    textAnchor: g,
    verticalAnchor: "middle"
  }, _) : a === "insideTop" ? Re({
    x: s + c / 2,
    y: u + d,
    textAnchor: "middle",
    verticalAnchor: m
  }, _) : a === "insideBottom" ? Re({
    x: s + c / 2,
    y: u + l - d,
    textAnchor: "middle",
    verticalAnchor: p
  }, _) : a === "insideTopLeft" ? Re({
    x: s + h,
    y: u + d,
    textAnchor: b,
    verticalAnchor: m
  }, _) : a === "insideTopRight" ? Re({
    x: s + c - h,
    y: u + d,
    textAnchor: g,
    verticalAnchor: m
  }, _) : a === "insideBottomLeft" ? Re({
    x: s + h,
    y: u + l - d,
    textAnchor: b,
    verticalAnchor: p
  }, _) : a === "insideBottomRight" ? Re({
    x: s + c - h,
    y: u + l - d,
    textAnchor: g,
    verticalAnchor: p
  }, _) : ii(a) && (U(a.x) || Ir(a.x)) && (U(a.y) || Ir(a.y)) ? Re({
    x: s + Xe(a.x, c),
    y: u + Xe(a.y, l),
    textAnchor: "end",
    verticalAnchor: "end"
  }, _) : Re({
    x: s + c / 2,
    y: u + l / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, _);
}, uR = function(t) {
  return "cx" in t && U(t.cx);
};
function ze(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = J2(e, H2), i = Re({
    offset: r
  }, n), a = i.viewBox, o = i.position, s = i.value, u = i.children, c = i.content, l = i.className, f = l === void 0 ? "" : l, d = i.textBreakAll;
  if (!a || se(s) && se(u) && !/* @__PURE__ */ Pt(c) && !ie(c))
    return null;
  if (/* @__PURE__ */ Pt(c))
    return /* @__PURE__ */ De(c, i);
  var p;
  if (ie(c)) {
    if (p = /* @__PURE__ */ Bi(c, i), /* @__PURE__ */ Pt(p))
      return p;
  } else
    p = nR(i);
  var m = uR(a), v = Q(i, !0);
  if (m && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return aR(i, p, v);
  var h = m ? oR(i) : sR(i);
  return /* @__PURE__ */ S.createElement(Kr, ua({
    className: ue("recharts-label", f)
  }, v, h, {
    breakAll: d
  }), p);
}
ze.displayName = "Label";
var $S = function(t) {
  var r = t.cx, n = t.cy, i = t.angle, a = t.startAngle, o = t.endAngle, s = t.r, u = t.radius, c = t.innerRadius, l = t.outerRadius, f = t.x, d = t.y, p = t.top, m = t.left, v = t.width, h = t.height, g = t.clockWise, b = t.labelViewBox;
  if (b)
    return b;
  if (U(v) && U(h)) {
    if (U(f) && U(d))
      return {
        x: f,
        y: d,
        width: v,
        height: h
      };
    if (U(p) && U(m))
      return {
        x: p,
        y: m,
        width: v,
        height: h
      };
  }
  return U(f) && U(d) ? {
    x: f,
    y: d,
    width: 0,
    height: 0
  } : U(r) && U(n) ? {
    cx: r,
    cy: n,
    startAngle: a || i || 0,
    endAngle: o || i || 0,
    innerRadius: c || 0,
    outerRadius: l || u || s || 0,
    clockWise: g
  } : t.viewBox ? t.viewBox : {};
}, cR = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ S.createElement(ze, {
    key: "label-implicit",
    viewBox: r
  }) : qe(t) ? /* @__PURE__ */ S.createElement(ze, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ Pt(t) ? t.type === ze ? /* @__PURE__ */ De(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ S.createElement(ze, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : ie(t) ? /* @__PURE__ */ S.createElement(ze, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : ii(t) ? /* @__PURE__ */ S.createElement(ze, ua({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, lR = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var i = t.children, a = $S(t), o = ct(i, ze).map(function(u, c) {
    return /* @__PURE__ */ De(u, {
      viewBox: r || a,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var s = cR(t.label, r || a);
  return [s].concat(V2(o));
};
ze.parseViewBox = $S;
ze.renderCallByParent = lR;
var qf, F0;
function fR() {
  if (F0) return qf;
  F0 = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return qf = e, qf;
}
var dR = fR();
const pR = /* @__PURE__ */ xe(dR);
function ca(e) {
  "@babel/helpers - typeof";
  return ca = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ca(e);
}
var hR = ["valueAccessor"], vR = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function yR(e) {
  return xR(e) || bR(e) || gR(e) || mR();
}
function mR() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gR(e, t) {
  if (e) {
    if (typeof e == "string") return up(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return up(e, t);
  }
}
function bR(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function xR(e) {
  if (Array.isArray(e)) return up(e);
}
function up(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Go() {
  return Go = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Go.apply(this, arguments);
}
function z0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function W0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z0(Object(r), !0).forEach(function(n) {
      wR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : z0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wR(e, t, r) {
  return t = OR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function OR(e) {
  var t = _R(e, "string");
  return ca(t) == "symbol" ? t : t + "";
}
function _R(e, t) {
  if (ca(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ca(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function U0(e, t) {
  if (e == null) return {};
  var r = SR(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function SR(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var AR = function(t) {
  return Array.isArray(t.value) ? pR(t.value) : t.value;
};
function Dt(e) {
  var t = e.valueAccessor, r = t === void 0 ? AR : t, n = U0(e, hR), i = n.data, a = n.dataKey, o = n.clockWise, s = n.id, u = n.textBreakAll, c = U0(n, vR);
  return !i || !i.length ? null : /* @__PURE__ */ S.createElement(le, {
    className: "recharts-label-list"
  }, i.map(function(l, f) {
    var d = se(a) ? r(l, f) : ke(l && l.payload, a), p = se(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ S.createElement(ze, Go({}, Q(l, !0), c, p, {
      parentViewBox: l.parentViewBox,
      value: d,
      textBreakAll: u,
      viewBox: ze.parseViewBox(se(o) ? l : W0(W0({}, l), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
Dt.displayName = "LabelList";
function PR(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ S.createElement(Dt, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ S.isValidElement(e) || ie(e) ? /* @__PURE__ */ S.createElement(Dt, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : ii(e) ? /* @__PURE__ */ S.createElement(Dt, Go({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function TR(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, i = ct(n, Dt).map(function(o, s) {
    return /* @__PURE__ */ De(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return i;
  var a = PR(e.label, t);
  return [a].concat(yR(i));
}
Dt.renderCallByParent = TR;
function la(e) {
  "@babel/helpers - typeof";
  return la = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, la(e);
}
function cp() {
  return cp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cp.apply(this, arguments);
}
function G0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function H0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G0(Object(r), !0).forEach(function(n) {
      ER(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ER(e, t, r) {
  return t = CR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function CR(e) {
  var t = MR(e, "string");
  return la(t) == "symbol" ? t : t + "";
}
function MR(e, t) {
  if (la(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (la(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var jR = function(t, r) {
  var n = Ye(r - t), i = Math.min(Math.abs(r - t), 359.999);
  return n * i;
}, eo = function(t) {
  var r = t.cx, n = t.cy, i = t.radius, a = t.angle, o = t.sign, s = t.isExternal, u = t.cornerRadius, c = t.cornerIsExternal, l = u * (s ? 1 : -1) + i, f = Math.asin(u / l) / Uo, d = c ? a : a + o * f, p = Ae(r, n, l, d), m = Ae(r, n, i, d), v = c ? a - o * f : a, h = Ae(r, n, l * Math.cos(f * Uo), v);
  return {
    center: p,
    circleTangency: m,
    lineTangency: h,
    theta: f
  };
}, NS = function(t) {
  var r = t.cx, n = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.startAngle, s = t.endAngle, u = jR(o, s), c = o + u, l = Ae(r, n, a, o), f = Ae(r, n, a, c), d = "M ".concat(l.x, ",").concat(l.y, `
    A `).concat(a, ",").concat(a, `,0,
    `).concat(+(Math.abs(u) > 180), ",").concat(+(o > c), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (i > 0) {
    var p = Ae(r, n, i, o), m = Ae(r, n, i, c);
    d += "L ".concat(m.x, ",").concat(m.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(u) > 180), ",").concat(+(o <= c), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    d += "L ".concat(r, ",").concat(n, " Z");
  return d;
}, kR = function(t) {
  var r = t.cx, n = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.cornerRadius, s = t.forceCornerRadius, u = t.cornerIsExternal, c = t.startAngle, l = t.endAngle, f = Ye(l - c), d = eo({
    cx: r,
    cy: n,
    radius: a,
    angle: c,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: u
  }), p = d.circleTangency, m = d.lineTangency, v = d.theta, h = eo({
    cx: r,
    cy: n,
    radius: a,
    angle: l,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: u
  }), g = h.circleTangency, b = h.lineTangency, w = h.theta, O = u ? Math.abs(c - l) : Math.abs(c - l) - v - w;
  if (O < 0)
    return s ? "M ".concat(m.x, ",").concat(m.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : NS({
      cx: r,
      cy: n,
      innerRadius: i,
      outerRadius: a,
      startAngle: c,
      endAngle: l
    });
  var y = "M ".concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(a, ",").concat(a, ",0,").concat(+(O > 180), ",").concat(+(f < 0), ",").concat(g.x, ",").concat(g.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(b.x, ",").concat(b.y, `
  `);
  if (i > 0) {
    var x = eo({
      cx: r,
      cy: n,
      radius: i,
      angle: c,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: u
    }), _ = x.circleTangency, P = x.lineTangency, E = x.theta, M = eo({
      cx: r,
      cy: n,
      radius: i,
      angle: l,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: u
    }), C = M.circleTangency, T = M.lineTangency, k = M.theta, N = u ? Math.abs(c - l) : Math.abs(c - l) - E - k;
    if (N < 0 && o === 0)
      return "".concat(y, "L").concat(r, ",").concat(n, "Z");
    y += "L".concat(T.x, ",").concat(T.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(C.x, ",").concat(C.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(N > 180), ",").concat(+(f > 0), ",").concat(_.x, ",").concat(_.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(P.x, ",").concat(P.y, "Z");
  } else
    y += "L".concat(r, ",").concat(n, "Z");
  return y;
}, $R = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, IS = function(t) {
  var r = H0(H0({}, $R), t), n = r.cx, i = r.cy, a = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, u = r.forceCornerRadius, c = r.cornerIsExternal, l = r.startAngle, f = r.endAngle, d = r.className;
  if (o < a || l === f)
    return null;
  var p = ue("recharts-sector", d), m = o - a, v = Xe(s, m, 0, !0), h;
  return v > 0 && Math.abs(l - f) < 360 ? h = kR({
    cx: n,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    cornerRadius: Math.min(v, m / 2),
    forceCornerRadius: u,
    cornerIsExternal: c,
    startAngle: l,
    endAngle: f
  }) : h = NS({
    cx: n,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    startAngle: l,
    endAngle: f
  }), /* @__PURE__ */ S.createElement("path", cp({}, Q(r, !0), {
    className: p,
    d: h,
    role: "img"
  }));
};
function fa(e) {
  "@babel/helpers - typeof";
  return fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fa(e);
}
function lp() {
  return lp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lp.apply(this, arguments);
}
function V0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function K0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? V0(Object(r), !0).forEach(function(n) {
      NR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : V0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function NR(e, t, r) {
  return t = IR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function IR(e) {
  var t = RR(e, "string");
  return fa(t) == "symbol" ? t : t + "";
}
function RR(e, t) {
  if (fa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Y0 = {
  curveBasisClosed: r6,
  curveBasisOpen: n6,
  curveBasis: t6,
  curveBumpX: F3,
  curveBumpY: z3,
  curveLinearClosed: i6,
  curveLinear: ks,
  curveMonotoneX: a6,
  curveMonotoneY: o6,
  curveNatural: s6,
  curveStep: u6,
  curveStepAfter: l6,
  curveStepBefore: c6
}, to = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, _i = function(t) {
  return t.x;
}, Si = function(t) {
  return t.y;
}, DR = function(t, r) {
  if (ie(t))
    return t;
  var n = "curve".concat(Ms(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? Y0["".concat(n).concat(r === "vertical" ? "Y" : "X")] : Y0[n] || ks;
}, LR = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, i = t.points, a = i === void 0 ? [] : i, o = t.baseLine, s = t.layout, u = t.connectNulls, c = u === void 0 ? !1 : u, l = DR(n, s), f = c ? a.filter(function(v) {
    return to(v);
  }) : a, d;
  if (Array.isArray(o)) {
    var p = c ? o.filter(function(v) {
      return to(v);
    }) : o, m = f.map(function(v, h) {
      return K0(K0({}, v), {}, {
        base: p[h]
      });
    });
    return s === "vertical" ? d = Ha().y(Si).x1(_i).x0(function(v) {
      return v.base.x;
    }) : d = Ha().x(_i).y1(Si).y0(function(v) {
      return v.base.y;
    }), d.defined(to).curve(l), d(m);
  }
  return s === "vertical" && U(o) ? d = Ha().y(Si).x1(_i).x0(o) : U(o) ? d = Ha().x(_i).y1(Si).y0(o) : d = NO().x(_i).y(Si), d.defined(to).curve(l), d(f);
}, Ur = function(t) {
  var r = t.className, n = t.points, i = t.path, a = t.pathRef;
  if ((!n || !n.length) && !i)
    return null;
  var o = n && n.length ? LR(t) : i;
  return /* @__PURE__ */ K.createElement("path", lp({}, Q(t, !1), mo(t), {
    className: ue("recharts-curve", r),
    d: o,
    ref: a
  }));
}, ro = { exports: {} }, no = { exports: {} }, ye = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var X0;
function qR() {
  if (X0) return ye;
  X0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function w(y) {
    if (typeof y == "object" && y !== null) {
      var x = y.$$typeof;
      switch (x) {
        case t:
          switch (y = y.type, y) {
            case u:
            case c:
            case n:
            case a:
            case i:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case l:
                case m:
                case p:
                case o:
                  return y;
                default:
                  return x;
              }
          }
        case r:
          return x;
      }
    }
  }
  function O(y) {
    return w(y) === c;
  }
  return ye.AsyncMode = u, ye.ConcurrentMode = c, ye.ContextConsumer = s, ye.ContextProvider = o, ye.Element = t, ye.ForwardRef = l, ye.Fragment = n, ye.Lazy = m, ye.Memo = p, ye.Portal = r, ye.Profiler = a, ye.StrictMode = i, ye.Suspense = f, ye.isAsyncMode = function(y) {
    return O(y) || w(y) === u;
  }, ye.isConcurrentMode = O, ye.isContextConsumer = function(y) {
    return w(y) === s;
  }, ye.isContextProvider = function(y) {
    return w(y) === o;
  }, ye.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, ye.isForwardRef = function(y) {
    return w(y) === l;
  }, ye.isFragment = function(y) {
    return w(y) === n;
  }, ye.isLazy = function(y) {
    return w(y) === m;
  }, ye.isMemo = function(y) {
    return w(y) === p;
  }, ye.isPortal = function(y) {
    return w(y) === r;
  }, ye.isProfiler = function(y) {
    return w(y) === a;
  }, ye.isStrictMode = function(y) {
    return w(y) === i;
  }, ye.isSuspense = function(y) {
    return w(y) === f;
  }, ye.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === c || y === a || y === i || y === f || y === d || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === p || y.$$typeof === o || y.$$typeof === s || y.$$typeof === l || y.$$typeof === h || y.$$typeof === g || y.$$typeof === b || y.$$typeof === v);
  }, ye.typeOf = w, ye;
}
var me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z0;
function BR() {
  return Z0 || (Z0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === n || j === c || j === a || j === i || j === f || j === d || typeof j == "object" && j !== null && (j.$$typeof === m || j.$$typeof === p || j.$$typeof === o || j.$$typeof === s || j.$$typeof === l || j.$$typeof === h || j.$$typeof === g || j.$$typeof === b || j.$$typeof === v);
    }
    function O(j) {
      if (typeof j == "object" && j !== null) {
        var fe = j.$$typeof;
        switch (fe) {
          case t:
            var G = j.type;
            switch (G) {
              case u:
              case c:
              case n:
              case a:
              case i:
              case f:
                return G;
              default:
                var Oe = G && G.$$typeof;
                switch (Oe) {
                  case s:
                  case l:
                  case m:
                  case p:
                  case o:
                    return Oe;
                  default:
                    return fe;
                }
            }
          case r:
            return fe;
        }
      }
    }
    var y = u, x = c, _ = s, P = o, E = t, M = l, C = n, T = m, k = p, N = r, I = a, R = i, q = f, W = !1;
    function H(j) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(j) || O(j) === u;
    }
    function $(j) {
      return O(j) === c;
    }
    function L(j) {
      return O(j) === s;
    }
    function B(j) {
      return O(j) === o;
    }
    function V(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function X(j) {
      return O(j) === l;
    }
    function te(j) {
      return O(j) === n;
    }
    function re(j) {
      return O(j) === m;
    }
    function oe(j) {
      return O(j) === p;
    }
    function ae(j) {
      return O(j) === r;
    }
    function F(j) {
      return O(j) === a;
    }
    function Y(j) {
      return O(j) === i;
    }
    function ee(j) {
      return O(j) === f;
    }
    me.AsyncMode = y, me.ConcurrentMode = x, me.ContextConsumer = _, me.ContextProvider = P, me.Element = E, me.ForwardRef = M, me.Fragment = C, me.Lazy = T, me.Memo = k, me.Portal = N, me.Profiler = I, me.StrictMode = R, me.Suspense = q, me.isAsyncMode = H, me.isConcurrentMode = $, me.isContextConsumer = L, me.isContextProvider = B, me.isElement = V, me.isForwardRef = X, me.isFragment = te, me.isLazy = re, me.isMemo = oe, me.isPortal = ae, me.isProfiler = F, me.isStrictMode = Y, me.isSuspense = ee, me.isValidElementType = w, me.typeOf = O;
  }()), me;
}
var J0;
function RS() {
  return J0 || (J0 = 1, process.env.NODE_ENV === "production" ? no.exports = qR() : no.exports = BR()), no.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Bf, Q0;
function FR() {
  if (Q0) return Bf;
  Q0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Bf = i() ? Object.assign : function(a, o) {
    for (var s, u = n(a), c, l = 1; l < arguments.length; l++) {
      s = Object(arguments[l]);
      for (var f in s)
        t.call(s, f) && (u[f] = s[f]);
      if (e) {
        c = e(s);
        for (var d = 0; d < c.length; d++)
          r.call(s, c[d]) && (u[c[d]] = s[c[d]]);
      }
    }
    return u;
  }, Bf;
}
var Ff, ex;
function iv() {
  if (ex) return Ff;
  ex = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ff = e, Ff;
}
var zf, tx;
function DS() {
  return tx || (tx = 1, zf = Function.call.bind(Object.prototype.hasOwnProperty)), zf;
}
var Wf, rx;
function zR() {
  if (rx) return Wf;
  rx = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ iv(), r = {}, n = /* @__PURE__ */ DS();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in a)
        if (n(a, l)) {
          var f;
          try {
            if (typeof a[l] != "function") {
              var d = Error(
                (u || "React class") + ": " + s + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = a[l](o, l, u, s, null, t);
          } catch (m) {
            f = m;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Wf = i, Wf;
}
var Uf, nx;
function WR() {
  if (nx) return Uf;
  nx = 1;
  var e = RS(), t = FR(), r = /* @__PURE__ */ iv(), n = /* @__PURE__ */ DS(), i = /* @__PURE__ */ zR(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Uf = function(s, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f($) {
      var L = $ && (c && $[c] || $[l]);
      if (typeof L == "function")
        return L;
    }
    var d = "<<anonymous>>", p = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: b(),
      arrayOf: w,
      element: O(),
      elementType: y(),
      instanceOf: x,
      node: M(),
      objectOf: P,
      oneOf: _,
      oneOfType: E,
      shape: T,
      exact: k
    };
    function m($, L) {
      return $ === L ? $ !== 0 || 1 / $ === 1 / L : $ !== $ && L !== L;
    }
    function v($, L) {
      this.message = $, this.data = L && typeof L == "object" ? L : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function h($) {
      if (process.env.NODE_ENV !== "production")
        var L = {}, B = 0;
      function V(te, re, oe, ae, F, Y, ee) {
        if (ae = ae || d, Y = Y || oe, ee !== r) {
          if (u) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = ae + ":" + oe;
            !L[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            B < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), L[fe] = !0, B++);
          }
        }
        return re[oe] == null ? te ? re[oe] === null ? new v("The " + F + " `" + Y + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new v("The " + F + " `" + Y + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : $(re, oe, ae, F, Y);
      }
      var X = V.bind(null, !1);
      return X.isRequired = V.bind(null, !0), X;
    }
    function g($) {
      function L(B, V, X, te, re, oe) {
        var ae = B[V], F = R(ae);
        if (F !== $) {
          var Y = q(ae);
          return new v(
            "Invalid " + te + " `" + re + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return h(L);
    }
    function b() {
      return h(o);
    }
    function w($) {
      function L(B, V, X, te, re) {
        if (typeof $ != "function")
          return new v("Property `" + re + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var oe = B[V];
        if (!Array.isArray(oe)) {
          var ae = R(oe);
          return new v("Invalid " + te + " `" + re + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected an array."));
        }
        for (var F = 0; F < oe.length; F++) {
          var Y = $(oe, F, X, te, re + "[" + F + "]", r);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return h(L);
    }
    function O() {
      function $(L, B, V, X, te) {
        var re = L[B];
        if (!s(re)) {
          var oe = R(re);
          return new v("Invalid " + X + " `" + te + "` of type " + ("`" + oe + "` supplied to `" + V + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h($);
    }
    function y() {
      function $(L, B, V, X, te) {
        var re = L[B];
        if (!e.isValidElementType(re)) {
          var oe = R(re);
          return new v("Invalid " + X + " `" + te + "` of type " + ("`" + oe + "` supplied to `" + V + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h($);
    }
    function x($) {
      function L(B, V, X, te, re) {
        if (!(B[V] instanceof $)) {
          var oe = $.name || d, ae = H(B[V]);
          return new v("Invalid " + te + " `" + re + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected ") + ("instance of `" + oe + "`."));
        }
        return null;
      }
      return h(L);
    }
    function _($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function L(B, V, X, te, re) {
        for (var oe = B[V], ae = 0; ae < $.length; ae++)
          if (m(oe, $[ae]))
            return null;
        var F = JSON.stringify($, function(ee, j) {
          var fe = q(j);
          return fe === "symbol" ? String(j) : j;
        });
        return new v("Invalid " + te + " `" + re + "` of value `" + String(oe) + "` " + ("supplied to `" + X + "`, expected one of " + F + "."));
      }
      return h(L);
    }
    function P($) {
      function L(B, V, X, te, re) {
        if (typeof $ != "function")
          return new v("Property `" + re + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var oe = B[V], ae = R(oe);
        if (ae !== "object")
          return new v("Invalid " + te + " `" + re + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected an object."));
        for (var F in oe)
          if (n(oe, F)) {
            var Y = $(oe, F, X, te, re + "." + F, r);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return h(L);
    }
    function E($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var L = 0; L < $.length; L++) {
        var B = $[L];
        if (typeof B != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(B) + " at index " + L + "."
          ), o;
      }
      function V(X, te, re, oe, ae) {
        for (var F = [], Y = 0; Y < $.length; Y++) {
          var ee = $[Y], j = ee(X, te, re, oe, ae, r);
          if (j == null)
            return null;
          j.data && n(j.data, "expectedType") && F.push(j.data.expectedType);
        }
        var fe = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new v("Invalid " + oe + " `" + ae + "` supplied to " + ("`" + re + "`" + fe + "."));
      }
      return h(V);
    }
    function M() {
      function $(L, B, V, X, te) {
        return N(L[B]) ? null : new v("Invalid " + X + " `" + te + "` supplied to " + ("`" + V + "`, expected a ReactNode."));
      }
      return h($);
    }
    function C($, L, B, V, X) {
      return new v(
        ($ || "React class") + ": " + L + " type `" + B + "." + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function T($) {
      function L(B, V, X, te, re) {
        var oe = B[V], ae = R(oe);
        if (ae !== "object")
          return new v("Invalid " + te + " `" + re + "` of type `" + ae + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var F in $) {
          var Y = $[F];
          if (typeof Y != "function")
            return C(X, te, re, F, q(Y));
          var ee = Y(oe, F, X, te, re + "." + F, r);
          if (ee)
            return ee;
        }
        return null;
      }
      return h(L);
    }
    function k($) {
      function L(B, V, X, te, re) {
        var oe = B[V], ae = R(oe);
        if (ae !== "object")
          return new v("Invalid " + te + " `" + re + "` of type `" + ae + "` " + ("supplied to `" + X + "`, expected `object`."));
        var F = t({}, B[V], $);
        for (var Y in F) {
          var ee = $[Y];
          if (n($, Y) && typeof ee != "function")
            return C(X, te, re, Y, q(ee));
          if (!ee)
            return new v(
              "Invalid " + te + " `" + re + "` key `" + Y + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(B[V], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var j = ee(oe, Y, X, te, re + "." + Y, r);
          if (j)
            return j;
        }
        return null;
      }
      return h(L);
    }
    function N($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(N);
          if ($ === null || s($))
            return !0;
          var L = f($);
          if (L) {
            var B = L.call($), V;
            if (L !== $.entries) {
              for (; !(V = B.next()).done; )
                if (!N(V.value))
                  return !1;
            } else
              for (; !(V = B.next()).done; ) {
                var X = V.value;
                if (X && !N(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I($, L) {
      return $ === "symbol" ? !0 : L ? L["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && L instanceof Symbol : !1;
    }
    function R($) {
      var L = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : I(L, $) ? "symbol" : L;
    }
    function q($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var L = R($);
      if (L === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return L;
    }
    function W($) {
      var L = q($);
      switch (L) {
        case "array":
        case "object":
          return "an " + L;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + L;
        default:
          return L;
      }
    }
    function H($) {
      return !$.constructor || !$.constructor.name ? d : $.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, Uf;
}
var Gf, ix;
function UR() {
  if (ix) return Gf;
  ix = 1;
  var e = /* @__PURE__ */ iv();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Gf = function() {
    function n(o, s, u, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Gf;
}
var ax;
function GR() {
  if (ax) return ro.exports;
  if (ax = 1, process.env.NODE_ENV !== "production") {
    var e = RS(), t = !0;
    ro.exports = /* @__PURE__ */ WR()(e.isElement, t);
  } else
    ro.exports = /* @__PURE__ */ UR()();
  return ro.exports;
}
var HR = /* @__PURE__ */ GR();
const ge = /* @__PURE__ */ xe(HR), { getOwnPropertyNames: VR, getOwnPropertySymbols: KR } = Object, { hasOwnProperty: YR } = Object.prototype;
function Hf(e, t) {
  return function(n, i, a) {
    return e(n, i, a) && t(n, i, a);
  };
}
function io(e) {
  return function(r, n, i) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, i);
    const { cache: a } = i, o = a.get(r), s = a.get(n);
    if (o && s)
      return o === n && s === r;
    a.set(r, n), a.set(n, r);
    const u = e(r, n, i);
    return a.delete(r), a.delete(n), u;
  };
}
function XR(e) {
  return e?.[Symbol.toStringTag];
}
function ox(e) {
  return VR(e).concat(KR(e));
}
const ZR = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((e, t) => YR.call(e, t))
);
function on(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
const JR = "__v", QR = "__o", eD = "_owner", { getOwnPropertyDescriptor: sx, keys: ux } = Object;
function tD(e, t) {
  return e.byteLength === t.byteLength && Ho(new Uint8Array(e), new Uint8Array(t));
}
function rD(e, t, r) {
  let n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function nD(e, t) {
  return e.byteLength === t.byteLength && Ho(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
}
function iD(e, t) {
  return on(e.getTime(), t.getTime());
}
function aD(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function oD(e, t) {
  return e === t;
}
function cx(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const i = new Array(n), a = e.entries();
  let o, s, u = 0;
  for (; (o = a.next()) && !o.done; ) {
    const c = t.entries();
    let l = !1, f = 0;
    for (; (s = c.next()) && !s.done; ) {
      if (i[f]) {
        f++;
        continue;
      }
      const d = o.value, p = s.value;
      if (r.equals(d[0], p[0], u, f, e, t, r) && r.equals(d[1], p[1], d[0], p[0], e, t, r)) {
        l = i[f] = !0;
        break;
      }
      f++;
    }
    if (!l)
      return !1;
    u++;
  }
  return !0;
}
const sD = on;
function uD(e, t, r) {
  const n = ux(e);
  let i = n.length;
  if (ux(t).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!LS(e, t, r, n[i]))
      return !1;
  return !0;
}
function Ai(e, t, r) {
  const n = ox(e);
  let i = n.length;
  if (ox(t).length !== i)
    return !1;
  let a, o, s;
  for (; i-- > 0; )
    if (a = n[i], !LS(e, t, r, a) || (o = sx(e, a), s = sx(t, a), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function cD(e, t) {
  return on(e.valueOf(), t.valueOf());
}
function lD(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function lx(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const i = new Array(n), a = e.values();
  let o, s;
  for (; (o = a.next()) && !o.done; ) {
    const u = t.values();
    let c = !1, l = 0;
    for (; (s = u.next()) && !s.done; ) {
      if (!i[l] && r.equals(o.value, s.value, o.value, s.value, e, t, r)) {
        c = i[l] = !0;
        break;
      }
      l++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function Ho(e, t) {
  let r = e.byteLength;
  if (t.byteLength !== r || e.byteOffset !== t.byteOffset)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function fD(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function LS(e, t, r, n) {
  return (n === eD || n === QR || n === JR) && (e.$$typeof || t.$$typeof) ? !0 : ZR(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
}
const dD = "[object ArrayBuffer]", pD = "[object Arguments]", hD = "[object Boolean]", vD = "[object DataView]", yD = "[object Date]", mD = "[object Error]", gD = "[object Map]", bD = "[object Number]", xD = "[object Object]", wD = "[object RegExp]", OD = "[object Set]", _D = "[object String]", SD = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, AD = "[object URL]", PD = Object.prototype.toString;
function TD({ areArrayBuffersEqual: e, areArraysEqual: t, areDataViewsEqual: r, areDatesEqual: n, areErrorsEqual: i, areFunctionsEqual: a, areMapsEqual: o, areNumbersEqual: s, areObjectsEqual: u, arePrimitiveWrappersEqual: c, areRegExpsEqual: l, areSetsEqual: f, areTypedArraysEqual: d, areUrlsEqual: p, unknownTagComparators: m }) {
  return function(h, g, b) {
    if (h === g)
      return !0;
    if (h == null || g == null)
      return !1;
    const w = typeof h;
    if (w !== typeof g)
      return !1;
    if (w !== "object")
      return w === "number" ? s(h, g, b) : w === "function" ? a(h, g, b) : !1;
    const O = h.constructor;
    if (O !== g.constructor)
      return !1;
    if (O === Object)
      return u(h, g, b);
    if (Array.isArray(h))
      return t(h, g, b);
    if (O === Date)
      return n(h, g, b);
    if (O === RegExp)
      return l(h, g, b);
    if (O === Map)
      return o(h, g, b);
    if (O === Set)
      return f(h, g, b);
    const y = PD.call(h);
    if (y === yD)
      return n(h, g, b);
    if (y === wD)
      return l(h, g, b);
    if (y === gD)
      return o(h, g, b);
    if (y === OD)
      return f(h, g, b);
    if (y === xD)
      return typeof h.then != "function" && typeof g.then != "function" && u(h, g, b);
    if (y === AD)
      return p(h, g, b);
    if (y === mD)
      return i(h, g, b);
    if (y === pD)
      return u(h, g, b);
    if (SD[y])
      return d(h, g, b);
    if (y === dD)
      return e(h, g, b);
    if (y === vD)
      return r(h, g, b);
    if (y === hD || y === bD || y === _D)
      return c(h, g, b);
    if (m) {
      let x = m[y];
      if (!x) {
        const _ = XR(h);
        _ && (x = m[_]);
      }
      if (x)
        return x(h, g, b);
    }
    return !1;
  };
}
function ED({ circular: e, createCustomConfig: t, strict: r }) {
  let n = {
    areArrayBuffersEqual: tD,
    areArraysEqual: r ? Ai : rD,
    areDataViewsEqual: nD,
    areDatesEqual: iD,
    areErrorsEqual: aD,
    areFunctionsEqual: oD,
    areMapsEqual: r ? Hf(cx, Ai) : cx,
    areNumbersEqual: sD,
    areObjectsEqual: r ? Ai : uD,
    arePrimitiveWrappersEqual: cD,
    areRegExpsEqual: lD,
    areSetsEqual: r ? Hf(lx, Ai) : lx,
    areTypedArraysEqual: r ? Hf(Ho, Ai) : Ho,
    areUrlsEqual: fD,
    unknownTagComparators: void 0
  };
  if (t && (n = Object.assign({}, n, t(n))), e) {
    const i = io(n.areArraysEqual), a = io(n.areMapsEqual), o = io(n.areObjectsEqual), s = io(n.areSetsEqual);
    n = Object.assign({}, n, {
      areArraysEqual: i,
      areMapsEqual: a,
      areObjectsEqual: o,
      areSetsEqual: s
    });
  }
  return n;
}
function CD(e) {
  return function(t, r, n, i, a, o, s) {
    return e(t, r, s);
  };
}
function MD({ circular: e, comparator: t, createState: r, equals: n, strict: i }) {
  if (r)
    return function(s, u) {
      const { cache: c = e ? /* @__PURE__ */ new WeakMap() : void 0, meta: l } = r();
      return t(s, u, {
        cache: c,
        equals: n,
        meta: l,
        strict: i
      });
    };
  if (e)
    return function(s, u) {
      return t(s, u, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: n,
        meta: void 0,
        strict: i
      });
    };
  const a = {
    cache: void 0,
    equals: n,
    meta: void 0,
    strict: i
  };
  return function(s, u) {
    return t(s, u, a);
  };
}
const jD = Sr();
Sr({ strict: !0 });
Sr({ circular: !0 });
Sr({
  circular: !0,
  strict: !0
});
Sr({
  createInternalComparator: () => on
});
Sr({
  strict: !0,
  createInternalComparator: () => on
});
Sr({
  circular: !0,
  createInternalComparator: () => on
});
Sr({
  circular: !0,
  createInternalComparator: () => on,
  strict: !0
});
function Sr(e = {}) {
  const { circular: t = !1, createInternalComparator: r, createState: n, strict: i = !1 } = e, a = ED(e), o = TD(a), s = r ? r(o) : CD(o);
  return MD({ circular: t, comparator: o, createState: n, equals: s, strict: i });
}
function kD(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function fx(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function i(a) {
    r < 0 && (r = a), a - r > t ? (e(a), r = -1) : kD(i);
  };
  requestAnimationFrame(n);
}
function fp(e) {
  "@babel/helpers - typeof";
  return fp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fp(e);
}
function $D(e) {
  return DD(e) || RD(e) || ID(e) || ND();
}
function ND() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ID(e, t) {
  if (e) {
    if (typeof e == "string") return dx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dx(e, t);
  }
}
function dx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function RD(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function DD(e) {
  if (Array.isArray(e)) return e;
}
function LD() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function i(a) {
    if (!r) {
      if (Array.isArray(a)) {
        if (!a.length)
          return;
        var o = a, s = $D(o), u = s[0], c = s.slice(1);
        if (typeof u == "number") {
          fx(i.bind(null, c), u);
          return;
        }
        i(u), fx(i.bind(null, c));
        return;
      }
      fp(a) === "object" && (e = a, t(e)), typeof a == "function" && a();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(a) {
      r = !1, n(a);
    },
    subscribe: function(a) {
      return t = a, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function da(e) {
  "@babel/helpers - typeof";
  return da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, da(e);
}
function px(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? px(Object(r), !0).forEach(function(n) {
      qS(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : px(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qS(e, t, r) {
  return t = qD(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qD(e) {
  var t = BD(e, "string");
  return da(t) === "symbol" ? t : String(t);
}
function BD(e, t) {
  if (da(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (da(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var FD = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, i) {
    return n.filter(function(a) {
      return i.includes(a);
    });
  });
}, zD = function(t) {
  return t;
}, WD = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Ri = function(t, r) {
  return Object.keys(r).reduce(function(n, i) {
    return hx(hx({}, n), {}, qS({}, i, t(i, r[i])));
  }, {});
}, vx = function(t, r, n) {
  return t.map(function(i) {
    return "".concat(WD(i), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, UD = process.env.NODE_ENV !== "production", Vo = function(t, r, n, i, a, o, s, u) {
  if (UD && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, i, a, o, s, u], l = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[l++];
      }));
    }
};
function GD(e, t) {
  return KD(e) || VD(e, t) || BS(e, t) || HD();
}
function HD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VD(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function KD(e) {
  if (Array.isArray(e)) return e;
}
function YD(e) {
  return JD(e) || ZD(e) || BS(e) || XD();
}
function XD() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BS(e, t) {
  if (e) {
    if (typeof e == "string") return dp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dp(e, t);
  }
}
function ZD(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function JD(e) {
  if (Array.isArray(e)) return dp(e);
}
function dp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Ko = 1e-4, FS = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, zS = function(t, r) {
  return t.map(function(n, i) {
    return n * Math.pow(r, i);
  }).reduce(function(n, i) {
    return n + i;
  });
}, yx = function(t, r) {
  return function(n) {
    var i = FS(t, r);
    return zS(i, n);
  };
}, QD = function(t, r) {
  return function(n) {
    var i = FS(t, r), a = [].concat(YD(i.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return zS(a, n);
  };
}, mx = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r[0], a = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        i = 0, a = 0, o = 1, s = 1;
        break;
      case "ease":
        i = 0.25, a = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        i = 0.42, a = 0, o = 1, s = 1;
        break;
      case "ease-out":
        i = 0.42, a = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        i = 0, a = 0, o = 0.58, s = 1;
        break;
      default: {
        var u = r[0].split("(");
        if (u[0] === "cubic-bezier" && u[1].split(")")[0].split(",").length === 4) {
          var c = u[1].split(")")[0].split(",").map(function(h) {
            return parseFloat(h);
          }), l = GD(c, 4);
          i = l[0], a = l[1], o = l[2], s = l[3];
        } else
          Vo(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Vo([i, o, a, s].every(function(h) {
    return typeof h == "number" && h >= 0 && h <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = yx(i, o), d = yx(a, s), p = QD(i, o), m = function(g) {
    return g > 1 ? 1 : g < 0 ? 0 : g;
  }, v = function(g) {
    for (var b = g > 1 ? 1 : g, w = b, O = 0; O < 8; ++O) {
      var y = f(w) - b, x = p(w);
      if (Math.abs(y - b) < Ko || x < Ko)
        return d(w);
      w = m(w - y / x);
    }
    return d(w);
  };
  return v.isStepper = !1, v;
}, e9 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, i = t.damping, a = i === void 0 ? 8 : i, o = t.dt, s = o === void 0 ? 17 : o, u = function(l, f, d) {
    var p = -(l - f) * n, m = d * a, v = d + (p - m) * s / 1e3, h = d * s / 1e3 + l;
    return Math.abs(h - f) < Ko && Math.abs(v) < Ko ? [f, 0] : [h, v];
  };
  return u.isStepper = !0, u.dt = s, u;
}, t9 = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return mx(i);
      case "spring":
        return e9();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return mx(i);
        Vo(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof i == "function" ? i : (Vo(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function pa(e) {
  "@babel/helpers - typeof";
  return pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pa(e);
}
function gx(e) {
  return i9(e) || n9(e) || WS(e) || r9();
}
function r9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function n9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function i9(e) {
  if (Array.isArray(e)) return hp(e);
}
function bx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ge(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bx(Object(r), !0).forEach(function(n) {
      pp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pp(e, t, r) {
  return t = a9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function a9(e) {
  var t = o9(e, "string");
  return pa(t) === "symbol" ? t : String(t);
}
function o9(e, t) {
  if (pa(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (pa(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function s9(e, t) {
  return l9(e) || c9(e, t) || WS(e, t) || u9();
}
function u9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WS(e, t) {
  if (e) {
    if (typeof e == "string") return hp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return hp(e, t);
  }
}
function hp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function c9(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function l9(e) {
  if (Array.isArray(e)) return e;
}
var Yo = function(t, r, n) {
  return t + (r - t) * n;
}, vp = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, f9 = function e(t, r, n) {
  var i = Ri(function(a, o) {
    if (vp(o)) {
      var s = t(o.from, o.to, o.velocity), u = s9(s, 2), c = u[0], l = u[1];
      return Ge(Ge({}, o), {}, {
        from: c,
        velocity: l
      });
    }
    return o;
  }, r);
  return n < 1 ? Ri(function(a, o) {
    return vp(o) ? Ge(Ge({}, o), {}, {
      velocity: Yo(o.velocity, i[a].velocity, n),
      from: Yo(o.from, i[a].from, n)
    }) : o;
  }, r) : e(t, i, n - 1);
};
const d9 = function(e, t, r, n, i) {
  var a = FD(e, t), o = a.reduce(function(h, g) {
    return Ge(Ge({}, h), {}, pp({}, g, [e[g], t[g]]));
  }, {}), s = a.reduce(function(h, g) {
    return Ge(Ge({}, h), {}, pp({}, g, {
      from: e[g],
      velocity: 0,
      to: t[g]
    }));
  }, {}), u = -1, c, l, f = function() {
    return null;
  }, d = function() {
    return Ri(function(g, b) {
      return b.from;
    }, s);
  }, p = function() {
    return !Object.values(s).filter(vp).length;
  }, m = function(g) {
    c || (c = g);
    var b = g - c, w = b / r.dt;
    s = f9(r, s, w), i(Ge(Ge(Ge({}, e), t), d())), c = g, p() || (u = requestAnimationFrame(f));
  }, v = function(g) {
    l || (l = g);
    var b = (g - l) / n, w = Ri(function(y, x) {
      return Yo.apply(void 0, gx(x).concat([r(b)]));
    }, o);
    if (i(Ge(Ge(Ge({}, e), t), w)), b < 1)
      u = requestAnimationFrame(f);
    else {
      var O = Ri(function(y, x) {
        return Yo.apply(void 0, gx(x).concat([r(1)]));
      }, o);
      i(Ge(Ge(Ge({}, e), t), O));
    }
  };
  return f = r.isStepper ? m : v, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(u);
    };
  };
};
function Dn(e) {
  "@babel/helpers - typeof";
  return Dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dn(e);
}
var p9 = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function h9(e, t) {
  if (e == null) return {};
  var r = v9(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function v9(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function Vf(e) {
  return b9(e) || g9(e) || m9(e) || y9();
}
function y9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m9(e, t) {
  if (e) {
    if (typeof e == "string") return yp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return yp(e, t);
  }
}
function g9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function b9(e) {
  if (Array.isArray(e)) return yp(e);
}
function yp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function xx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xx(Object(r), !0).forEach(function(n) {
      ki(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ki(e, t, r) {
  return t = US(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function x9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function w9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, US(n.key), n);
  }
}
function O9(e, t, r) {
  return t && w9(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function US(e) {
  var t = _9(e, "string");
  return Dn(t) === "symbol" ? t : String(t);
}
function _9(e, t) {
  if (Dn(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Dn(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function S9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && mp(e, t);
}
function mp(e, t) {
  return mp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, mp(e, t);
}
function A9(e) {
  var t = P9();
  return function() {
    var n = Xo(e), i;
    if (t) {
      var a = Xo(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return gp(this, i);
  };
}
function gp(e, t) {
  if (t && (Dn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return bp(e);
}
function bp(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function P9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xo(e) {
  return Xo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Xo(e);
}
var Mt = /* @__PURE__ */ function(e) {
  S9(r, e);
  var t = A9(r);
  function r(n, i) {
    var a;
    x9(this, r), a = t.call(this, n, i);
    var o = a.props, s = o.isActive, u = o.attributeName, c = o.from, l = o.to, f = o.steps, d = o.children, p = o.duration;
    if (a.handleStyleChange = a.handleStyleChange.bind(bp(a)), a.changeStyle = a.changeStyle.bind(bp(a)), !s || p <= 0)
      return a.state = {
        style: {}
      }, typeof d == "function" && (a.state = {
        style: l
      }), gp(a);
    if (f && f.length)
      a.state = {
        style: f[0].style
      };
    else if (c) {
      if (typeof d == "function")
        return a.state = {
          style: c
        }, gp(a);
      a.state = {
        style: u ? ki({}, u, c) : c
      };
    } else
      a.state = {
        style: {}
      };
    return a;
  }
  return O9(r, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, a = i.isActive, o = i.canBegin;
      this.mounted = !0, !(!a || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var a = this.props, o = a.isActive, s = a.canBegin, u = a.attributeName, c = a.shouldReAnimate, l = a.to, f = a.from, d = this.state.style;
      if (s) {
        if (!o) {
          var p = {
            style: u ? ki({}, u, l) : l
          };
          this.state && d && (u && d[u] !== l || !u && d !== l) && this.setState(p);
          return;
        }
        if (!(jD(i.to, l) && i.canBegin && i.isActive)) {
          var m = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = m || c ? f : i.to;
          if (this.state && d) {
            var h = {
              style: u ? ki({}, u, v) : v
            };
            (u && d[u] !== v || !u && d !== v) && this.setState(h);
          }
          this.runAnimation(Ot(Ot({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var a = this, o = i.from, s = i.to, u = i.duration, c = i.easing, l = i.begin, f = i.onAnimationEnd, d = i.onAnimationStart, p = d9(o, s, t9(c), u, this.changeStyle), m = function() {
        a.stopJSAnimation = p();
      };
      this.manager.start([d, l, m, u, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var a = this, o = i.steps, s = i.begin, u = i.onAnimationStart, c = o[0], l = c.style, f = c.duration, d = f === void 0 ? 0 : f, p = function(v, h, g) {
        if (g === 0)
          return v;
        var b = h.duration, w = h.easing, O = w === void 0 ? "ease" : w, y = h.style, x = h.properties, _ = h.onAnimationEnd, P = g > 0 ? o[g - 1] : h, E = x || Object.keys(y);
        if (typeof O == "function" || O === "spring")
          return [].concat(Vf(v), [a.runJSAnimation.bind(a, {
            from: P.style,
            to: y,
            duration: b,
            easing: O
          }), b]);
        var M = vx(E, b, O), C = Ot(Ot(Ot({}, P.style), y), {}, {
          transition: M
        });
        return [].concat(Vf(v), [C, b, _]).filter(zD);
      };
      return this.manager.start([u].concat(Vf(o.reduce(p, [l, Math.max(d, s)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = LD());
      var a = i.begin, o = i.duration, s = i.attributeName, u = i.to, c = i.easing, l = i.onAnimationStart, f = i.onAnimationEnd, d = i.steps, p = i.children, m = this.manager;
      if (this.unSubscribe = m.subscribe(this.handleStyleChange), typeof c == "function" || typeof p == "function" || c === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (d.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var v = s ? ki({}, s, u) : u, h = vx(Object.keys(v), o, c);
      m.start([l, a, Ot(Ot({}, v), {}, {
        transition: h
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, a = i.children;
      i.begin;
      var o = i.duration;
      i.attributeName, i.easing;
      var s = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var u = h9(i, p9), c = Br.count(a), l = this.state.style;
      if (typeof a == "function")
        return a(l);
      if (!s || c === 0 || o <= 0)
        return a;
      var f = function(p) {
        var m = p.props, v = m.style, h = v === void 0 ? {} : v, g = m.className, b = /* @__PURE__ */ De(p, Ot(Ot({}, u), {}, {
          style: Ot(Ot({}, h), l),
          className: g
        }));
        return b;
      };
      return c === 1 ? f(Br.only(a)) : /* @__PURE__ */ S.createElement("div", null, Br.map(a, function(d) {
        return f(d);
      }));
    }
  }]), r;
}(bt);
Mt.displayName = "Animate";
Mt.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Mt.propTypes = {
  from: ge.oneOfType([ge.object, ge.string]),
  to: ge.oneOfType([ge.object, ge.string]),
  attributeName: ge.string,
  // animation duration
  duration: ge.number,
  begin: ge.number,
  easing: ge.oneOfType([ge.string, ge.func]),
  steps: ge.arrayOf(ge.shape({
    duration: ge.number.isRequired,
    style: ge.object.isRequired,
    easing: ge.oneOfType([ge.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), ge.func]),
    // transition css properties(dash case), optional
    properties: ge.arrayOf("string"),
    onAnimationEnd: ge.func
  })),
  children: ge.oneOfType([ge.node, ge.func]),
  isActive: ge.bool,
  canBegin: ge.bool,
  onAnimationEnd: ge.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: ge.bool,
  onAnimationStart: ge.func,
  onAnimationReStart: ge.func
};
function ha(e) {
  "@babel/helpers - typeof";
  return ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ha(e);
}
function Zo() {
  return Zo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zo.apply(this, arguments);
}
function T9(e, t) {
  return j9(e) || M9(e, t) || C9(e, t) || E9();
}
function E9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C9(e, t) {
  if (e) {
    if (typeof e == "string") return wx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wx(e, t);
  }
}
function wx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function M9(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function j9(e) {
  if (Array.isArray(e)) return e;
}
function Ox(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _x(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ox(Object(r), !0).forEach(function(n) {
      k9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ox(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function k9(e, t, r) {
  return t = $9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $9(e) {
  var t = N9(e, "string");
  return ha(t) == "symbol" ? t : t + "";
}
function N9(e, t) {
  if (ha(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ha(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Sx = function(t, r, n, i, a) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(i) / 2), s = i >= 0 ? 1 : -1, u = n >= 0 ? 1 : -1, c = i >= 0 && n >= 0 || i < 0 && n < 0 ? 1 : 0, l;
  if (o > 0 && a instanceof Array) {
    for (var f = [0, 0, 0, 0], d = 0, p = 4; d < p; d++)
      f[d] = a[d] > o ? o : a[d];
    l = "M".concat(t, ",").concat(r + s * f[0]), f[0] > 0 && (l += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(c, ",").concat(t + u * f[0], ",").concat(r)), l += "L ".concat(t + n - u * f[1], ",").concat(r), f[1] > 0 && (l += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(c, `,
        `).concat(t + n, ",").concat(r + s * f[1])), l += "L ".concat(t + n, ",").concat(r + i - s * f[2]), f[2] > 0 && (l += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(c, `,
        `).concat(t + n - u * f[2], ",").concat(r + i)), l += "L ".concat(t + u * f[3], ",").concat(r + i), f[3] > 0 && (l += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(r + i - s * f[3])), l += "Z";
  } else if (o > 0 && a === +a && a > 0) {
    var m = Math.min(o, a);
    l = "M ".concat(t, ",").concat(r + s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + u * m, ",").concat(r, `
            L `).concat(t + n - u * m, ",").concat(r, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n, ",").concat(r + s * m, `
            L `).concat(t + n, ",").concat(r + i - s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t + n - u * m, ",").concat(r + i, `
            L `).concat(t + u * m, ",").concat(r + i, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(t, ",").concat(r + i - s * m, " Z");
  } else
    l = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(i, " h ").concat(-n, " Z");
  return l;
}, I9 = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, i = t.y, a = r.x, o = r.y, s = r.width, u = r.height;
  if (Math.abs(s) > 0 && Math.abs(u) > 0) {
    var c = Math.min(a, a + s), l = Math.max(a, a + s), f = Math.min(o, o + u), d = Math.max(o, o + u);
    return n >= c && n <= l && i >= f && i <= d;
  }
  return !1;
}, R9 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, av = function(t) {
  var r = _x(_x({}, R9), t), n = An(), i = Vt(-1), a = T9(i, 2), o = a[0], s = a[1];
  Sa(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var O = n.current.getTotalLength();
        O && s(O);
      } catch {
      }
  }, []);
  var u = r.x, c = r.y, l = r.width, f = r.height, d = r.radius, p = r.className, m = r.animationEasing, v = r.animationDuration, h = r.animationBegin, g = r.isAnimationActive, b = r.isUpdateAnimationActive;
  if (u !== +u || c !== +c || l !== +l || f !== +f || l === 0 || f === 0)
    return null;
  var w = ue("recharts-rectangle", p);
  return b ? /* @__PURE__ */ S.createElement(Mt, {
    canBegin: o > 0,
    from: {
      width: l,
      height: f,
      x: u,
      y: c
    },
    to: {
      width: l,
      height: f,
      x: u,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: b
  }, function(O) {
    var y = O.width, x = O.height, _ = O.x, P = O.y;
    return /* @__PURE__ */ S.createElement(Mt, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: h,
      duration: v,
      isActive: g,
      easing: m
    }, /* @__PURE__ */ S.createElement("path", Zo({}, Q(r, !0), {
      className: w,
      d: Sx(_, P, y, x, d),
      ref: n
    })));
  }) : /* @__PURE__ */ S.createElement("path", Zo({}, Q(r, !0), {
    className: w,
    d: Sx(u, c, l, f, d)
  }));
}, D9 = ["points", "className", "baseLinePoints", "connectNulls"];
function vn() {
  return vn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vn.apply(this, arguments);
}
function L9(e, t) {
  if (e == null) return {};
  var r = q9(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function q9(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Ax(e) {
  return W9(e) || z9(e) || F9(e) || B9();
}
function B9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F9(e, t) {
  if (e) {
    if (typeof e == "string") return xp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return xp(e, t);
  }
}
function z9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function W9(e) {
  if (Array.isArray(e)) return xp(e);
}
function xp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Px = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, U9 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    Px(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), Px(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, Di = function(t, r) {
  var n = U9(t);
  r && (n = [n.reduce(function(a, o) {
    return [].concat(Ax(a), Ax(o));
  }, [])]);
  var i = n.map(function(a) {
    return a.reduce(function(o, s, u) {
      return "".concat(o).concat(u === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(i, "Z") : i;
}, G9 = function(t, r, n) {
  var i = Di(t, n);
  return "".concat(i.slice(-1) === "Z" ? i.slice(0, -1) : i, "L").concat(Di(r.reverse(), n).slice(1));
}, H9 = function(t) {
  var r = t.points, n = t.className, i = t.baseLinePoints, a = t.connectNulls, o = L9(t, D9);
  if (!r || !r.length)
    return null;
  var s = ue("recharts-polygon", n);
  if (i && i.length) {
    var u = o.stroke && o.stroke !== "none", c = G9(r, i, a);
    return /* @__PURE__ */ S.createElement("g", {
      className: s
    }, /* @__PURE__ */ S.createElement("path", vn({}, Q(o, !0), {
      fill: c.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: c
    })), u ? /* @__PURE__ */ S.createElement("path", vn({}, Q(o, !0), {
      fill: "none",
      d: Di(r, a)
    })) : null, u ? /* @__PURE__ */ S.createElement("path", vn({}, Q(o, !0), {
      fill: "none",
      d: Di(i, a)
    })) : null);
  }
  var l = Di(r, a);
  return /* @__PURE__ */ S.createElement("path", vn({}, Q(o, !0), {
    fill: l.slice(-1) === "Z" ? o.fill : "none",
    className: s,
    d: l
  }));
};
function wp() {
  return wp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wp.apply(this, arguments);
}
var Ia = function(t) {
  var r = t.cx, n = t.cy, i = t.r, a = t.className, o = ue("recharts-dot", a);
  return r === +r && n === +n && i === +i ? /* @__PURE__ */ K.createElement("circle", wp({}, Q(t, !1), mo(t), {
    className: o,
    cx: r,
    cy: n,
    r: i
  })) : null;
};
function va(e) {
  "@babel/helpers - typeof";
  return va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, va(e);
}
var V9 = ["x", "y", "top", "left", "width", "height", "className"];
function Op() {
  return Op = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Op.apply(this, arguments);
}
function Tx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function K9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tx(Object(r), !0).forEach(function(n) {
      Y9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Y9(e, t, r) {
  return t = X9(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function X9(e) {
  var t = Z9(e, "string");
  return va(t) == "symbol" ? t : t + "";
}
function Z9(e, t) {
  if (va(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (va(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function J9(e, t) {
  if (e == null) return {};
  var r = Q9(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Q9(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var eL = function(t, r, n, i, a, o) {
  return "M".concat(t, ",").concat(a, "v").concat(i, "M").concat(o, ",").concat(r, "h").concat(n);
}, tL = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, i = t.y, a = i === void 0 ? 0 : i, o = t.top, s = o === void 0 ? 0 : o, u = t.left, c = u === void 0 ? 0 : u, l = t.width, f = l === void 0 ? 0 : l, d = t.height, p = d === void 0 ? 0 : d, m = t.className, v = J9(t, V9), h = K9({
    x: n,
    y: a,
    top: s,
    left: c,
    width: f,
    height: p
  }, v);
  return !U(n) || !U(a) || !U(f) || !U(p) || !U(s) || !U(c) ? null : /* @__PURE__ */ S.createElement("path", Op({}, Q(h, !0), {
    className: ue("recharts-cross", m),
    d: eL(n, a, f, p, s, c)
  }));
}, Kf, Ex;
function rL() {
  if (Ex) return Kf;
  Ex = 1;
  var e = Us(), t = nS(), r = Ft();
  function n(i, a) {
    return i && i.length ? e(i, r(a, 2), t) : void 0;
  }
  return Kf = n, Kf;
}
var nL = rL();
const iL = /* @__PURE__ */ xe(nL);
var Yf, Cx;
function aL() {
  if (Cx) return Yf;
  Cx = 1;
  var e = Us(), t = Ft(), r = iS();
  function n(i, a) {
    return i && i.length ? e(i, t(a, 2), r) : void 0;
  }
  return Yf = n, Yf;
}
var oL = aL();
const sL = /* @__PURE__ */ xe(oL);
var uL = ["cx", "cy", "angle", "ticks", "axisLine"], cL = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function Ln(e) {
  "@babel/helpers - typeof";
  return Ln = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ln(e);
}
function Li() {
  return Li = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Li.apply(this, arguments);
}
function Mx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mx(Object(r), !0).forEach(function(n) {
      Ks(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jx(e, t) {
  if (e == null) return {};
  var r = lL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function lL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function fL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function kx(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, HS(n.key), n);
  }
}
function dL(e, t, r) {
  return t && kx(e.prototype, t), r && kx(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function pL(e, t, r) {
  return t = Jo(t), hL(e, GS() ? Reflect.construct(t, r || [], Jo(e).constructor) : t.apply(e, r));
}
function hL(e, t) {
  if (t && (Ln(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return vL(e);
}
function vL(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function GS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (GS = function() {
    return !!e;
  })();
}
function Jo(e) {
  return Jo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Jo(e);
}
function yL(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _p(e, t);
}
function _p(e, t) {
  return _p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, _p(e, t);
}
function Ks(e, t, r) {
  return t = HS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function HS(e) {
  var t = mL(e, "string");
  return Ln(t) == "symbol" ? t : t + "";
}
function mL(e, t) {
  if (Ln(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ln(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ys = /* @__PURE__ */ function(e) {
  function t() {
    return fL(this, t), pL(this, t, arguments);
  }
  return yL(t, e), dL(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var i = n.coordinate, a = this.props, o = a.angle, s = a.cx, u = a.cy;
        return Ae(s, u, i, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, i;
      switch (n) {
        case "left":
          i = "end";
          break;
        case "right":
          i = "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.angle, s = n.ticks, u = iL(s, function(l) {
        return l.coordinate || 0;
      }), c = sL(s, function(l) {
        return l.coordinate || 0;
      });
      return {
        cx: i,
        cy: a,
        startAngle: o,
        endAngle: o,
        innerRadius: c.coordinate || 0,
        outerRadius: u.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.angle, s = n.ticks, u = n.axisLine, c = jx(n, uL), l = s.reduce(function(m, v) {
        return [Math.min(m[0], v.coordinate), Math.max(m[1], v.coordinate)];
      }, [1 / 0, -1 / 0]), f = Ae(i, a, l[0], o), d = Ae(i, a, l[1], o), p = Er(Er(Er({}, Q(c, !1)), {}, {
        fill: "none"
      }, Q(u, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: d.x,
        y2: d.y
      });
      return /* @__PURE__ */ S.createElement("line", Li({
        className: "recharts-polar-radius-axis-line"
      }, p));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, i = this.props, a = i.ticks, o = i.tick, s = i.angle, u = i.tickFormatter, c = i.stroke, l = jx(i, cL), f = this.getTickTextAnchor(), d = Q(l, !1), p = Q(o, !1), m = a.map(function(v, h) {
        var g = n.getTickValueCoord(v), b = Er(Er(Er(Er({
          textAnchor: f,
          transform: "rotate(".concat(90 - s, ", ").concat(g.x, ", ").concat(g.y, ")")
        }, d), {}, {
          stroke: "none",
          fill: c
        }, p), {}, {
          index: h
        }, g), {}, {
          payload: v
        });
        return /* @__PURE__ */ S.createElement(le, Li({
          className: ue("recharts-polar-radius-axis-tick", kS(o)),
          key: "tick-".concat(v.coordinate)
        }, Vr(n.props, v, h)), t.renderTickItem(o, b, u ? u(v.value, h) : v.value));
      });
      return /* @__PURE__ */ S.createElement(le, {
        className: "recharts-polar-radius-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.ticks, a = n.axisLine, o = n.tick;
      return !i || !i.length ? null : /* @__PURE__ */ S.createElement(le, {
        className: ue("recharts-polar-radius-axis", this.props.className)
      }, a && this.renderAxisLine(), o && this.renderTicks(), ze.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o;
      return /* @__PURE__ */ S.isValidElement(n) ? o = /* @__PURE__ */ S.cloneElement(n, i) : ie(n) ? o = n(i) : o = /* @__PURE__ */ S.createElement(Kr, Li({}, i, {
        className: "recharts-polar-radius-axis-tick-value"
      }), a), o;
    }
  }]);
}(bt);
Ks(Ys, "displayName", "PolarRadiusAxis");
Ks(Ys, "axisType", "radiusAxis");
Ks(Ys, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function qn(e) {
  "@babel/helpers - typeof";
  return qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qn(e);
}
function $r() {
  return $r = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $r.apply(this, arguments);
}
function $x(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $x(Object(r), !0).forEach(function(n) {
      Xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $x(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nx(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KS(n.key), n);
  }
}
function bL(e, t, r) {
  return t && Nx(e.prototype, t), r && Nx(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xL(e, t, r) {
  return t = Qo(t), wL(e, VS() ? Reflect.construct(t, r || [], Qo(e).constructor) : t.apply(e, r));
}
function wL(e, t) {
  if (t && (qn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return OL(e);
}
function OL(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VS = function() {
    return !!e;
  })();
}
function Qo(e) {
  return Qo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Qo(e);
}
function _L(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sp(e, t);
}
function Sp(e, t) {
  return Sp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Sp(e, t);
}
function Xs(e, t, r) {
  return t = KS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KS(e) {
  var t = SL(e, "string");
  return qn(t) == "symbol" ? t : t + "";
}
function SL(e, t) {
  if (qn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (qn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var AL = Math.PI / 180, Ix = 1e-5, Zs = /* @__PURE__ */ function(e) {
  function t() {
    return gL(this, t), xL(this, t, arguments);
  }
  return _L(t, e), bL(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var i = this.props, a = i.cx, o = i.cy, s = i.radius, u = i.orientation, c = i.tickSize, l = c || 8, f = Ae(a, o, s, n.coordinate), d = Ae(a, o, s + (u === "inner" ? -1 : 1) * l, n.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: d.x,
          y2: d.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var i = this.props.orientation, a = Math.cos(-n.coordinate * AL), o;
      return a > Ix ? o = i === "outer" ? "start" : "end" : a < -Ix ? o = i === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.radius, s = n.axisLine, u = n.axisLineType, c = Cr(Cr({}, Q(this.props, !1)), {}, {
        fill: "none"
      }, Q(s, !1));
      if (u === "circle")
        return /* @__PURE__ */ S.createElement(Ia, $r({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: i,
          cy: a,
          r: o
        }));
      var l = this.props.ticks, f = l.map(function(d) {
        return Ae(i, a, o, d.coordinate);
      });
      return /* @__PURE__ */ S.createElement(H9, $r({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, i = this.props, a = i.ticks, o = i.tick, s = i.tickLine, u = i.tickFormatter, c = i.stroke, l = Q(this.props, !1), f = Q(o, !1), d = Cr(Cr({}, l), {}, {
        fill: "none"
      }, Q(s, !1)), p = a.map(function(m, v) {
        var h = n.getTickLineCoord(m), g = n.getTickTextAnchor(m), b = Cr(Cr(Cr({
          textAnchor: g
        }, l), {}, {
          stroke: "none",
          fill: c
        }, f), {}, {
          index: v,
          payload: m,
          x: h.x2,
          y: h.y2
        });
        return /* @__PURE__ */ S.createElement(le, $r({
          className: ue("recharts-polar-angle-axis-tick", kS(o)),
          key: "tick-".concat(m.coordinate)
        }, Vr(n.props, m, v)), s && /* @__PURE__ */ S.createElement("line", $r({
          className: "recharts-polar-angle-axis-tick-line"
        }, d, h)), o && t.renderTickItem(o, b, u ? u(m.value, v) : m.value));
      });
      return /* @__PURE__ */ S.createElement(le, {
        className: "recharts-polar-angle-axis-ticks"
      }, p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.ticks, a = n.radius, o = n.axisLine;
      return a <= 0 || !i || !i.length ? null : /* @__PURE__ */ S.createElement(le, {
        className: ue("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o;
      return /* @__PURE__ */ S.isValidElement(n) ? o = /* @__PURE__ */ S.cloneElement(n, i) : ie(n) ? o = n(i) : o = /* @__PURE__ */ S.createElement(Kr, $r({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), a), o;
    }
  }]);
}(bt);
Xs(Zs, "displayName", "PolarAngleAxis");
Xs(Zs, "axisType", "angleAxis");
Xs(Zs, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var Xf, Rx;
function PL() {
  if (Rx) return Xf;
  Rx = 1;
  var e = n_(), t = e(Object.getPrototypeOf, Object);
  return Xf = t, Xf;
}
var Zf, Dx;
function TL() {
  if (Dx) return Zf;
  Dx = 1;
  var e = ir(), t = PL(), r = ar(), n = "[object Object]", i = Function.prototype, a = Object.prototype, o = i.toString, s = a.hasOwnProperty, u = o.call(Object);
  function c(l) {
    if (!r(l) || e(l) != n)
      return !1;
    var f = t(l);
    if (f === null)
      return !0;
    var d = s.call(f, "constructor") && f.constructor;
    return typeof d == "function" && d instanceof d && o.call(d) == u;
  }
  return Zf = c, Zf;
}
var EL = TL();
const CL = /* @__PURE__ */ xe(EL);
var Jf, Lx;
function ML() {
  if (Lx) return Jf;
  Lx = 1;
  var e = ir(), t = ar(), r = "[object Boolean]";
  function n(i) {
    return i === !0 || i === !1 || t(i) && e(i) == r;
  }
  return Jf = n, Jf;
}
var jL = ML();
const kL = /* @__PURE__ */ xe(jL);
function ya(e) {
  "@babel/helpers - typeof";
  return ya = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ya(e);
}
function es() {
  return es = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, es.apply(this, arguments);
}
function $L(e, t) {
  return DL(e) || RL(e, t) || IL(e, t) || NL();
}
function NL() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IL(e, t) {
  if (e) {
    if (typeof e == "string") return qx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qx(e, t);
  }
}
function qx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function RL(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function DL(e) {
  if (Array.isArray(e)) return e;
}
function Bx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bx(Object(r), !0).forEach(function(n) {
      LL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function LL(e, t, r) {
  return t = qL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qL(e) {
  var t = BL(e, "string");
  return ya(t) == "symbol" ? t : t + "";
}
function BL(e, t) {
  if (ya(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ya(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zx = function(t, r, n, i, a) {
  var o = n - i, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - o / 2, ",").concat(r + a), s += "L ".concat(t + n - o / 2 - i, ",").concat(r + a), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, FL = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, zL = function(t) {
  var r = Fx(Fx({}, FL), t), n = An(), i = Vt(-1), a = $L(i, 2), o = a[0], s = a[1];
  Sa(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var u = r.x, c = r.y, l = r.upperWidth, f = r.lowerWidth, d = r.height, p = r.className, m = r.animationEasing, v = r.animationDuration, h = r.animationBegin, g = r.isUpdateAnimationActive;
  if (u !== +u || c !== +c || l !== +l || f !== +f || d !== +d || l === 0 && f === 0 || d === 0)
    return null;
  var b = ue("recharts-trapezoid", p);
  return g ? /* @__PURE__ */ S.createElement(Mt, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: d,
      x: u,
      y: c
    },
    to: {
      upperWidth: l,
      lowerWidth: f,
      height: d,
      x: u,
      y: c
    },
    duration: v,
    animationEasing: m,
    isActive: g
  }, function(w) {
    var O = w.upperWidth, y = w.lowerWidth, x = w.height, _ = w.x, P = w.y;
    return /* @__PURE__ */ S.createElement(Mt, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: h,
      duration: v,
      easing: m
    }, /* @__PURE__ */ S.createElement("path", es({}, Q(r, !0), {
      className: b,
      d: zx(_, P, O, y, x),
      ref: n
    })));
  }) : /* @__PURE__ */ S.createElement("g", null, /* @__PURE__ */ S.createElement("path", es({}, Q(r, !0), {
    className: b,
    d: zx(u, c, l, f, d)
  })));
}, WL = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function ma(e) {
  "@babel/helpers - typeof";
  return ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ma(e);
}
function UL(e, t) {
  if (e == null) return {};
  var r = GL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function GL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Wx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ts(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wx(Object(r), !0).forEach(function(n) {
      HL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function HL(e, t, r) {
  return t = VL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function VL(e) {
  var t = KL(e, "string");
  return ma(t) == "symbol" ? t : t + "";
}
function KL(e, t) {
  if (ma(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ma(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function YL(e, t) {
  return ts(ts({}, t), e);
}
function XL(e, t) {
  return e === "symbols";
}
function Ux(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ S.createElement(av, r);
    case "trapezoid":
      return /* @__PURE__ */ S.createElement(zL, r);
    case "sector":
      return /* @__PURE__ */ S.createElement(IS, r);
    case "symbols":
      if (XL(t))
        return /* @__PURE__ */ S.createElement(_h, r);
      break;
    default:
      return null;
  }
}
function ZL(e) {
  return /* @__PURE__ */ Pt(e) ? e.props : e;
}
function YS(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, i = n === void 0 ? YL : n, a = e.activeClassName, o = a === void 0 ? "recharts-active-shape" : a, s = e.isActive, u = UL(e, WL), c;
  if (/* @__PURE__ */ Pt(t))
    c = /* @__PURE__ */ De(t, ts(ts({}, u), ZL(t)));
  else if (ie(t))
    c = t(u);
  else if (CL(t) && !kL(t)) {
    var l = i(t, u);
    c = /* @__PURE__ */ S.createElement(Ux, {
      shapeType: r,
      elementProps: l
    });
  } else {
    var f = u;
    c = /* @__PURE__ */ S.createElement(Ux, {
      shapeType: r,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ S.createElement(le, {
    className: o
  }, c) : c;
}
function Js(e, t) {
  return t != null && "trapezoids" in e.props;
}
function Qs(e, t) {
  return t != null && "sectors" in e.props;
}
function ga(e, t) {
  return t != null && "points" in e.props;
}
function JL(e, t) {
  var r, n, i = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, a = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return i && a;
}
function QL(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function eq(e, t) {
  var r = e.x === t.x, n = e.y === t.y, i = e.z === t.z;
  return r && n && i;
}
function tq(e, t) {
  var r;
  return Js(e, t) ? r = JL : Qs(e, t) ? r = QL : ga(e, t) && (r = eq), r;
}
function rq(e, t) {
  var r;
  return Js(e, t) ? r = "trapezoids" : Qs(e, t) ? r = "sectors" : ga(e, t) && (r = "points"), r;
}
function nq(e, t) {
  if (Js(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (Qs(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return ga(e, t) ? t.payload : {};
}
function iq(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, i = rq(r, t), a = nq(r, t), o = n.filter(function(u, c) {
    var l = Yr(a, u), f = r.props[i].filter(function(m) {
      var v = tq(r, t);
      return v(m, t);
    }), d = r.props[i].indexOf(f[f.length - 1]), p = c === d;
    return l && p;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var co;
function Bn(e) {
  "@babel/helpers - typeof";
  return Bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bn(e);
}
function yn() {
  return yn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yn.apply(this, arguments);
}
function Gx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gx(Object(r), !0).forEach(function(n) {
      yt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Hx(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZS(n.key), n);
  }
}
function oq(e, t, r) {
  return t && Hx(e.prototype, t), r && Hx(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function sq(e, t, r) {
  return t = rs(t), uq(e, XS() ? Reflect.construct(t, r || [], rs(e).constructor) : t.apply(e, r));
}
function uq(e, t) {
  if (t && (Bn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cq(e);
}
function cq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function XS() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (XS = function() {
    return !!e;
  })();
}
function rs(e) {
  return rs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, rs(e);
}
function lq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ap(e, t);
}
function Ap(e, t) {
  return Ap = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ap(e, t);
}
function yt(e, t, r) {
  return t = ZS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ZS(e) {
  var t = fq(e, "string");
  return Bn(t) == "symbol" ? t : t + "";
}
function fq(e, t) {
  if (Bn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Bn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var sr = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return aq(this, t), n = sq(this, t, [r]), yt(n, "pieRef", null), yt(n, "sectorRefs", []), yt(n, "id", tn("recharts-pie-")), yt(n, "handleAnimationEnd", function() {
      var i = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ie(i) && i();
    }), yt(n, "handleAnimationStart", function() {
      var i = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ie(i) && i();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return lq(t, e), oq(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var i = this.props.activeIndex;
      return Array.isArray(i) ? i.indexOf(n) !== -1 : n === i;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.label, s = a.labelLine, u = a.dataKey, c = a.valueKey, l = Q(this.props, !1), f = Q(o, !1), d = Q(s, !1), p = o && o.offsetRadius || 20, m = n.map(function(v, h) {
        var g = (v.startAngle + v.endAngle) / 2, b = Ae(v.cx, v.cy, v.outerRadius + p, g), w = _e(_e(_e(_e({}, l), v), {}, {
          stroke: "none"
        }, f), {}, {
          index: h,
          textAnchor: t.getTextAnchor(b.x, v.cx)
        }, b), O = _e(_e(_e(_e({}, l), v), {}, {
          fill: "none",
          stroke: v.fill
        }, d), {}, {
          index: h,
          points: [Ae(v.cx, v.cy, v.outerRadius, g), b]
        }), y = u;
        return se(u) && se(c) ? y = "value" : se(u) && (y = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ S.createElement(le, {
          key: "label-".concat(v.startAngle, "-").concat(v.endAngle, "-").concat(v.midAngle, "-").concat(h)
        }, s && t.renderLabelLineItem(s, O, "line"), t.renderLabelItem(o, w, ke(v, y)));
      });
      return /* @__PURE__ */ S.createElement(le, {
        className: "recharts-pie-labels"
      }, m);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var i = this, a = this.props, o = a.activeShape, s = a.blendStroke, u = a.inactiveShape;
      return n.map(function(c, l) {
        if (c?.startAngle === 0 && c?.endAngle === 0 && n.length !== 1) return null;
        var f = i.isActiveIndex(l), d = u && i.hasActiveIndex() ? u : null, p = f ? o : d, m = _e(_e({}, c), {}, {
          stroke: s ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ S.createElement(le, yn({
          ref: function(h) {
            h && !i.sectorRefs.includes(h) && i.sectorRefs.push(h);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, Vr(i.props, c, l), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c?.startAngle, "-").concat(c?.endAngle, "-").concat(c.midAngle, "-").concat(l)
        }), /* @__PURE__ */ S.createElement(YS, yn({
          option: p,
          isActive: f,
          shapeType: "sector"
        }, m)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, i = this.props, a = i.sectors, o = i.isAnimationActive, s = i.animationBegin, u = i.animationDuration, c = i.animationEasing, l = i.animationId, f = this.state, d = f.prevSectors, p = f.prevIsAnimationActive;
      return /* @__PURE__ */ S.createElement(Mt, {
        begin: s,
        duration: u,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(l, "-").concat(p),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(m) {
        var v = m.t, h = [], g = a && a[0], b = g.startAngle;
        return a.forEach(function(w, O) {
          var y = d && d[O], x = O > 0 ? ut(w, "paddingAngle", 0) : 0;
          if (y) {
            var _ = Le(y.endAngle - y.startAngle, w.endAngle - w.startAngle), P = _e(_e({}, w), {}, {
              startAngle: b + x,
              endAngle: b + _(v) + x
            });
            h.push(P), b = P.endAngle;
          } else {
            var E = w.endAngle, M = w.startAngle, C = Le(0, E - M), T = C(v), k = _e(_e({}, w), {}, {
              startAngle: b + x,
              endAngle: b + T + x
            });
            h.push(k), b = k.endAngle;
          }
        }), /* @__PURE__ */ S.createElement(le, null, n.renderSectorsStatically(h));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var i = this;
      n.onkeydown = function(a) {
        if (!a.altKey)
          switch (a.key) {
            case "ArrowLeft": {
              var o = ++i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[o].focus(), i.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var s = --i.state.sectorToFocus < 0 ? i.sectorRefs.length - 1 : i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[s].focus(), i.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              i.sectorRefs[i.state.sectorToFocus].blur(), i.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, i = n.sectors, a = n.isAnimationActive, o = this.state.prevSectors;
      return a && i && i.length && (!o || !Yr(o, i)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(i);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.hide, o = i.sectors, s = i.className, u = i.label, c = i.cx, l = i.cy, f = i.innerRadius, d = i.outerRadius, p = i.isAnimationActive, m = this.state.isAnimationFinished;
      if (a || !o || !o.length || !U(c) || !U(l) || !U(f) || !U(d))
        return null;
      var v = ue("recharts-pie", s);
      return /* @__PURE__ */ S.createElement(le, {
        tabIndex: this.props.rootTabIndex,
        className: v,
        ref: function(g) {
          n.pieRef = g;
        }
      }, this.renderSectors(), u && this.renderLabels(o), ze.renderCallByParent(this.props, null, !1), (!p || m) && Dt.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return i.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: i.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== i.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, i) {
      return n > i ? "start" : n < i ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, i, a) {
      if (/* @__PURE__ */ S.isValidElement(n))
        return /* @__PURE__ */ S.cloneElement(n, i);
      if (ie(n))
        return n(i);
      var o = ue("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ S.createElement(Ur, yn({}, i, {
        key: a,
        type: "linear",
        className: o
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, i, a) {
      if (/* @__PURE__ */ S.isValidElement(n))
        return /* @__PURE__ */ S.cloneElement(n, i);
      var o = a;
      if (ie(n) && (o = n(i), /* @__PURE__ */ S.isValidElement(o)))
        return o;
      var s = ue("recharts-pie-label-text", typeof n != "boolean" && !ie(n) ? n.className : "");
      return /* @__PURE__ */ S.createElement(Kr, yn({}, i, {
        alignmentBaseline: "middle",
        className: s
      }), o);
    }
  }]);
}(bt);
co = sr;
yt(sr, "displayName", "Pie");
yt(sr, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !wr.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
yt(sr, "parseDeltaAngle", function(e, t) {
  var r = Ye(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
yt(sr, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = Q(e, !1), i = ct(r, Ds);
  return t && t.length ? t.map(function(a, o) {
    return _e(_e(_e({
      payload: a
    }, n), a), i && i[o] && i[o].props);
  }) : i && i.length ? i.map(function(a) {
    return _e(_e({}, n), a.props);
  }) : [];
});
yt(sr, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, i = t.width, a = t.height, o = jS(i, a), s = n + Xe(e.cx, i, i / 2), u = r + Xe(e.cy, a, a / 2), c = Xe(e.innerRadius, o, 0), l = Xe(e.outerRadius, o, o * 0.8), f = e.maxRadius || Math.sqrt(i * i + a * a) / 2;
  return {
    cx: s,
    cy: u,
    innerRadius: c,
    outerRadius: l,
    maxRadius: f
  };
});
yt(sr, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? _e(_e({}, t.type.defaultProps), t.props) : t.props, i = co.getRealPieData(n);
  if (!i || !i.length)
    return null;
  var a = n.cornerRadius, o = n.startAngle, s = n.endAngle, u = n.paddingAngle, c = n.dataKey, l = n.nameKey, f = n.valueKey, d = n.tooltipType, p = Math.abs(n.minAngle), m = co.parseCoordinateOfPie(n, r), v = co.parseDeltaAngle(o, s), h = Math.abs(v), g = c;
  se(c) && se(f) ? (Et(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), g = "value") : se(c) && (Et(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), g = f);
  var b = i.filter(function(P) {
    return ke(P, g, 0) !== 0;
  }).length, w = (h >= 360 ? b : b - 1) * u, O = h - b * p - w, y = i.reduce(function(P, E) {
    var M = ke(E, g, 0);
    return P + (U(M) ? M : 0);
  }, 0), x;
  if (y > 0) {
    var _;
    x = i.map(function(P, E) {
      var M = ke(P, g, 0), C = ke(P, l, E), T = (U(M) ? M : 0) / y, k;
      E ? k = _.endAngle + Ye(v) * u * (M !== 0 ? 1 : 0) : k = o;
      var N = k + Ye(v) * ((M !== 0 ? p : 0) + T * O), I = (k + N) / 2, R = (m.innerRadius + m.outerRadius) / 2, q = [{
        name: C,
        value: M,
        payload: P,
        dataKey: g,
        type: d
      }], W = Ae(m.cx, m.cy, R, I);
      return _ = _e(_e(_e({
        percent: T,
        cornerRadius: a,
        name: C,
        tooltipPayload: q,
        midAngle: I,
        middleRadius: R,
        tooltipPosition: W
      }, P), m), {}, {
        value: ke(P, g),
        startAngle: k,
        endAngle: N,
        payload: P,
        paddingAngle: Ye(v) * u
      }), _;
    });
  }
  return _e(_e({}, m), {}, {
    sectors: x,
    data: i
  });
});
var Qf, Vx;
function dq() {
  if (Vx) return Qf;
  Vx = 1;
  var e = Math.ceil, t = Math.max;
  function r(n, i, a, o) {
    for (var s = -1, u = t(e((i - n) / (a || 1)), 0), c = Array(u); u--; )
      c[o ? u : ++s] = n, n += a;
    return c;
  }
  return Qf = r, Qf;
}
var ed, Kx;
function JS() {
  if (Kx) return ed;
  Kx = 1;
  var e = b_(), t = 1 / 0, r = 17976931348623157e292;
  function n(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = e(i), i === t || i === -t) {
      var a = i < 0 ? -1 : 1;
      return a * r;
    }
    return i === i ? i : 0;
  }
  return ed = n, ed;
}
var td, Yx;
function pq() {
  if (Yx) return td;
  Yx = 1;
  var e = dq(), t = Rs(), r = JS();
  function n(i) {
    return function(a, o, s) {
      return s && typeof s != "number" && t(a, o, s) && (o = s = void 0), a = r(a), o === void 0 ? (o = a, a = 0) : o = r(o), s = s === void 0 ? a < o ? 1 : -1 : r(s), e(a, o, s, i);
    };
  }
  return td = n, td;
}
var rd, Xx;
function hq() {
  if (Xx) return rd;
  Xx = 1;
  var e = pq(), t = e();
  return rd = t, rd;
}
var vq = hq();
const ns = /* @__PURE__ */ xe(vq);
function ba(e) {
  "@babel/helpers - typeof";
  return ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ba(e);
}
function Zx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zx(Object(r), !0).forEach(function(n) {
      QS(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function QS(e, t, r) {
  return t = yq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yq(e) {
  var t = mq(e, "string");
  return ba(t) == "symbol" ? t : t + "";
}
function mq(e, t) {
  if (ba(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ba(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gq = ["Webkit", "Moz", "O", "ms"], bq = function(t, r) {
  var n = t.replace(/(\w)/, function(a) {
    return a.toUpperCase();
  }), i = gq.reduce(function(a, o) {
    return Jx(Jx({}, a), {}, QS({}, o + n, r));
  }, {});
  return i[t] = r, i;
};
function Fn(e) {
  "@babel/helpers - typeof";
  return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fn(e);
}
function is() {
  return is = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, is.apply(this, arguments);
}
function Qx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qx(Object(r), !0).forEach(function(n) {
      at(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ew(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tA(n.key), n);
  }
}
function wq(e, t, r) {
  return t && ew(e.prototype, t), r && ew(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Oq(e, t, r) {
  return t = as(t), _q(e, eA() ? Reflect.construct(t, r || [], as(e).constructor) : t.apply(e, r));
}
function _q(e, t) {
  if (t && (Fn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Sq(e);
}
function Sq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function eA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (eA = function() {
    return !!e;
  })();
}
function as(e) {
  return as = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, as(e);
}
function Aq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Pp(e, t);
}
function Pp(e, t) {
  return Pp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Pp(e, t);
}
function at(e, t, r) {
  return t = tA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function tA(e) {
  var t = Pq(e, "string");
  return Fn(t) == "symbol" ? t : t + "";
}
function Pq(e, t) {
  if (Fn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Fn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Tq = function(t) {
  var r = t.data, n = t.startIndex, i = t.endIndex, a = t.x, o = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var u = r.length, c = Ni().domain(ns(0, u)).range([a, a + o - s]), l = c.domain().map(function(f) {
    return c(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(i),
    scale: c,
    scaleValues: l
  };
}, tw = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, zn = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return xq(this, t), n = Oq(this, t, [r]), at(n, "handleDrag", function(i) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(i) : n.state.isSlideMoving && n.handleSlideDrag(i);
    }), at(n, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && n.handleDrag(i.changedTouches[0]);
    }), at(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = n.props, a = i.endIndex, o = i.onDragEnd, s = i.startIndex;
        o?.({
          endIndex: a,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), at(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), at(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), at(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), at(n, "handleSlideDragStart", function(i) {
      var a = tw(i) ? i.changedTouches[0] : i;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: a.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return Aq(t, e), wq(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var i = n.startX, a = n.endX, o = this.state.scaleValues, s = this.props, u = s.gap, c = s.data, l = c.length - 1, f = Math.min(i, a), d = Math.max(i, a), p = t.getIndexInRange(o, f), m = t.getIndexInRange(o, d);
      return {
        startIndex: p - p % u,
        endIndex: m === l ? l : m - m % u
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var i = this.props, a = i.data, o = i.tickFormatter, s = i.dataKey, u = ke(a[n], s, n);
      return ie(o) ? o(u, n) : u;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var i = this.state, a = i.slideMoveStartX, o = i.startX, s = i.endX, u = this.props, c = u.x, l = u.width, f = u.travellerWidth, d = u.startIndex, p = u.endIndex, m = u.onChange, v = n.pageX - a;
      v > 0 ? v = Math.min(v, c + l - f - s, c + l - f - o) : v < 0 && (v = Math.max(v, c - o, c - s));
      var h = this.getIndex({
        startX: o + v,
        endX: s + v
      });
      (h.startIndex !== d || h.endIndex !== p) && m && m(h), this.setState({
        startX: o + v,
        endX: s + v,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, i) {
      var a = tw(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: a.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var i = this.state, a = i.brushMoveStartX, o = i.movingTravellerId, s = i.endX, u = i.startX, c = this.state[o], l = this.props, f = l.x, d = l.width, p = l.travellerWidth, m = l.onChange, v = l.gap, h = l.data, g = {
        startX: this.state.startX,
        endX: this.state.endX
      }, b = n.pageX - a;
      b > 0 ? b = Math.min(b, f + d - p - c) : b < 0 && (b = Math.max(b, f - c)), g[o] = c + b;
      var w = this.getIndex(g), O = w.startIndex, y = w.endIndex, x = function() {
        var P = h.length - 1;
        return o === "startX" && (s > u ? O % v === 0 : y % v === 0) || s < u && y === P || o === "endX" && (s > u ? y % v === 0 : O % v === 0) || s > u && y === P;
      };
      this.setState(at(at({}, o, c + b), "brushMoveStartX", n.pageX), function() {
        m && x() && m(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, i) {
      var a = this, o = this.state, s = o.scaleValues, u = o.startX, c = o.endX, l = this.state[i], f = s.indexOf(l);
      if (f !== -1) {
        var d = f + n;
        if (!(d === -1 || d >= s.length)) {
          var p = s[d];
          i === "startX" && p >= c || i === "endX" && p <= u || this.setState(at({}, i, p), function() {
            a.props.onChange(a.getIndex({
              startX: a.state.startX,
              endX: a.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, s = n.height, u = n.fill, c = n.stroke;
      return /* @__PURE__ */ S.createElement("rect", {
        stroke: c,
        fill: u,
        x: i,
        y: a,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, s = n.height, u = n.data, c = n.children, l = n.padding, f = Br.only(c);
      return f ? /* @__PURE__ */ S.cloneElement(f, {
        x: i,
        y: a,
        width: o,
        height: s,
        margin: l,
        compact: !0,
        data: u
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, i) {
      var a, o, s = this, u = this.props, c = u.y, l = u.travellerWidth, f = u.height, d = u.traveller, p = u.ariaLabel, m = u.data, v = u.startIndex, h = u.endIndex, g = Math.max(n, this.props.x), b = nd(nd({}, Q(this.props, !1)), {}, {
        x: g,
        y: c,
        width: l,
        height: f
      }), w = p || "Min value: ".concat((a = m[v]) === null || a === void 0 ? void 0 : a.name, ", Max value: ").concat((o = m[h]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ S.createElement(le, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(y) {
          ["ArrowLeft", "ArrowRight"].includes(y.key) && (y.preventDefault(), y.stopPropagation(), s.handleTravellerMoveKeyboard(y.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(d, b));
    }
  }, {
    key: "renderSlide",
    value: function(n, i) {
      var a = this.props, o = a.y, s = a.height, u = a.stroke, c = a.travellerWidth, l = Math.min(n, i) + c, f = Math.max(Math.abs(i - n) - c, 0);
      return /* @__PURE__ */ S.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: u,
        fillOpacity: 0.2,
        x: l,
        y: o,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, i = n.startIndex, a = n.endIndex, o = n.y, s = n.height, u = n.travellerWidth, c = n.stroke, l = this.state, f = l.startX, d = l.endX, p = 5, m = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ S.createElement(le, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ S.createElement(Kr, is({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, d) - p,
        y: o + s / 2
      }, m), this.getTextOfTick(i)), /* @__PURE__ */ S.createElement(Kr, is({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, d) + u + p,
        y: o + s / 2
      }, m), this.getTextOfTick(a)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.data, a = n.className, o = n.children, s = n.x, u = n.y, c = n.width, l = n.height, f = n.alwaysShowText, d = this.state, p = d.startX, m = d.endX, v = d.isTextActive, h = d.isSlideMoving, g = d.isTravellerMoving, b = d.isTravellerFocused;
      if (!i || !i.length || !U(s) || !U(u) || !U(c) || !U(l) || c <= 0 || l <= 0)
        return null;
      var w = ue("recharts-brush", a), O = S.Children.count(o) === 1, y = bq("userSelect", "none");
      return /* @__PURE__ */ S.createElement(le, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: y
      }, this.renderBackground(), O && this.renderPanorama(), this.renderSlide(p, m), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(m, "endX"), (v || h || g || b || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var i = n.x, a = n.y, o = n.width, s = n.height, u = n.stroke, c = Math.floor(a + s / 2) - 1;
      return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement("rect", {
        x: i,
        y: a,
        width: o,
        height: s,
        fill: u,
        stroke: "none"
      }), /* @__PURE__ */ S.createElement("line", {
        x1: i + 1,
        y1: c,
        x2: i + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ S.createElement("line", {
        x1: i + 1,
        y1: c + 2,
        x2: i + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, i) {
      var a;
      return /* @__PURE__ */ S.isValidElement(n) ? a = /* @__PURE__ */ S.cloneElement(n, i) : ie(n) ? a = n(i) : a = t.renderDefaultTraveller(i), a;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      var a = n.data, o = n.width, s = n.x, u = n.travellerWidth, c = n.updateId, l = n.startIndex, f = n.endIndex;
      if (a !== i.prevData || c !== i.prevUpdateId)
        return nd({
          prevData: a,
          prevTravellerWidth: u,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o
        }, a && a.length ? Tq({
          data: a,
          width: o,
          x: s,
          travellerWidth: u,
          startIndex: l,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (o !== i.prevWidth || s !== i.prevX || u !== i.prevTravellerWidth)) {
        i.scale.range([s, s + o - u]);
        var d = i.scale.domain().map(function(p) {
          return i.scale(p);
        });
        return {
          prevData: a,
          prevTravellerWidth: u,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o,
          startX: i.scale(n.startIndex),
          endX: i.scale(n.endIndex),
          scaleValues: d
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, i) {
      for (var a = n.length, o = 0, s = a - 1; s - o > 1; ) {
        var u = Math.floor((o + s) / 2);
        n[u] > i ? s = u : o = u;
      }
      return i >= n[s] ? s : o;
    }
  }]);
}(bt);
at(zn, "displayName", "Brush");
at(zn, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var id, rw;
function Eq() {
  if (rw) return id;
  rw = 1;
  var e = Mh();
  function t(r, n) {
    var i;
    return e(r, function(a, o, s) {
      return i = n(a, o, s), !i;
    }), !!i;
  }
  return id = t, id;
}
var ad, nw;
function Cq() {
  if (nw) return ad;
  nw = 1;
  var e = XO(), t = Ft(), r = Eq(), n = nt(), i = Rs();
  function a(o, s, u) {
    var c = n(o) ? e : r;
    return u && i(o, s, u) && (s = void 0), c(o, t(s, 3));
  }
  return ad = a, ad;
}
var Mq = Cq();
const jq = /* @__PURE__ */ xe(Mq);
var Lt = function(t, r) {
  var n = t.alwaysShow, i = t.ifOverflow;
  return n && (i = "extendDomain"), i === r;
}, od, iw;
function kq() {
  if (iw) return od;
  iw = 1;
  var e = h_();
  function t(r, n, i) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : r[n] = i;
  }
  return od = t, od;
}
var sd, aw;
function $q() {
  if (aw) return sd;
  aw = 1;
  var e = kq(), t = d_(), r = Ft();
  function n(i, a) {
    var o = {};
    return a = r(a, 3), t(i, function(s, u, c) {
      e(o, u, a(s, u, c));
    }), o;
  }
  return sd = n, sd;
}
var Nq = $q();
const Iq = /* @__PURE__ */ xe(Nq);
var ud, ow;
function Rq() {
  if (ow) return ud;
  ow = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
      if (!r(t[n], n, t))
        return !1;
    return !0;
  }
  return ud = e, ud;
}
var cd, sw;
function Dq() {
  if (sw) return cd;
  sw = 1;
  var e = Mh();
  function t(r, n) {
    var i = !0;
    return e(r, function(a, o, s) {
      return i = !!n(a, o, s), i;
    }), i;
  }
  return cd = t, cd;
}
var ld, uw;
function Lq() {
  if (uw) return ld;
  uw = 1;
  var e = Rq(), t = Dq(), r = Ft(), n = nt(), i = Rs();
  function a(o, s, u) {
    var c = n(o) ? e : t;
    return u && i(o, s, u) && (s = void 0), c(o, r(s, 3));
  }
  return ld = a, ld;
}
var qq = Lq();
const rA = /* @__PURE__ */ xe(qq);
var Bq = ["x", "y"];
function Wn(e) {
  "@babel/helpers - typeof";
  return Wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wn(e);
}
function Tp() {
  return Tp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tp.apply(this, arguments);
}
function cw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cw(Object(r), !0).forEach(function(n) {
      Fq(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Fq(e, t, r) {
  return t = zq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zq(e) {
  var t = Wq(e, "string");
  return Wn(t) == "symbol" ? t : t + "";
}
function Wq(e, t) {
  if (Wn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Wn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Uq(e, t) {
  if (e == null) return {};
  var r = Gq(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Gq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Hq(e, t) {
  var r = e.x, n = e.y, i = Uq(e, Bq), a = "".concat(r), o = parseInt(a, 10), s = "".concat(n), u = parseInt(s, 10), c = "".concat(t.height || i.height), l = parseInt(c, 10), f = "".concat(t.width || i.width), d = parseInt(f, 10);
  return Pi(Pi(Pi(Pi(Pi({}, t), i), o ? {
    x: o
  } : {}), u ? {
    y: u
  } : {}), {}, {
    height: l,
    width: d,
    name: t.name,
    radius: t.radius
  });
}
function lw(e) {
  return /* @__PURE__ */ S.createElement(YS, Tp({
    shapeType: "rectangle",
    propTransformer: Hq,
    activeClassName: "recharts-active-bar"
  }, e));
}
var Vq = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, i) {
    if (typeof t == "number") return t;
    var a = U(n) || u3(n);
    return a ? t(n, i) : (a || (process.env.NODE_ENV !== "production" ? tt(!1, "minPointSize callback function received a value with type of ".concat(Wn(n), ". Currently only numbers or null/undefined are supported.")) : tt()), r);
  };
}, Kq = ["value", "background"], nA;
function Un(e) {
  "@babel/helpers - typeof";
  return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Un(e);
}
function Yq(e, t) {
  if (e == null) return {};
  var r = Xq(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Xq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function os() {
  return os = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, os.apply(this, arguments);
}
function fw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fw(Object(r), !0).forEach(function(n) {
      mr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Zq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aA(n.key), n);
  }
}
function Jq(e, t, r) {
  return t && dw(e.prototype, t), r && dw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Qq(e, t, r) {
  return t = ss(t), eB(e, iA() ? Reflect.construct(t, r || [], ss(e).constructor) : t.apply(e, r));
}
function eB(e, t) {
  if (t && (Un(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return tB(e);
}
function tB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function iA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (iA = function() {
    return !!e;
  })();
}
function ss(e) {
  return ss = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ss(e);
}
function rB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ep(e, t);
}
function Ep(e, t) {
  return Ep = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ep(e, t);
}
function mr(e, t, r) {
  return t = aA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aA(e) {
  var t = nB(e, "string");
  return Un(t) == "symbol" ? t : t + "";
}
function nB(e, t) {
  if (Un(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Un(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ar = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    Zq(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = Qq(this, t, [].concat(i)), mr(r, "state", {
      isAnimationFinished: !1
    }), mr(r, "id", tn("recharts-bar-")), mr(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), mr(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return rB(t, e), Jq(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var i = this, a = this.props, o = a.shape, s = a.dataKey, u = a.activeIndex, c = a.activeBar, l = Q(this.props, !1);
      return n && n.map(function(f, d) {
        var p = d === u, m = p ? c : o, v = $e($e($e({}, l), f), {}, {
          isActive: p,
          option: m,
          index: d,
          dataKey: s,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ S.createElement(le, os({
          className: "recharts-bar-rectangle"
        }, Vr(i.props, f, d), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(f?.x, "-").concat(f?.y, "-").concat(f?.value, "-").concat(d)
        }), /* @__PURE__ */ S.createElement(lw, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, i = this.props, a = i.data, o = i.layout, s = i.isAnimationActive, u = i.animationBegin, c = i.animationDuration, l = i.animationEasing, f = i.animationId, d = this.state.prevData;
      return /* @__PURE__ */ S.createElement(Mt, {
        begin: u,
        duration: c,
        isActive: s,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var m = p.t, v = a.map(function(h, g) {
          var b = d && d[g];
          if (b) {
            var w = Le(b.x, h.x), O = Le(b.y, h.y), y = Le(b.width, h.width), x = Le(b.height, h.height);
            return $e($e({}, h), {}, {
              x: w(m),
              y: O(m),
              width: y(m),
              height: x(m)
            });
          }
          if (o === "horizontal") {
            var _ = Le(0, h.height), P = _(m);
            return $e($e({}, h), {}, {
              y: h.y + h.height - P,
              height: P
            });
          }
          var E = Le(0, h.width), M = E(m);
          return $e($e({}, h), {}, {
            width: M
          });
        });
        return /* @__PURE__ */ S.createElement(le, null, n.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, i = n.data, a = n.isAnimationActive, o = this.state.prevData;
      return a && i && i.length && (!o || !Yr(o, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, i = this.props, a = i.data, o = i.dataKey, s = i.activeIndex, u = Q(this.props.background, !1);
      return a.map(function(c, l) {
        c.value;
        var f = c.background, d = Yq(c, Kq);
        if (!f)
          return null;
        var p = $e($e($e($e($e({}, d), {}, {
          fill: "#eee"
        }, f), u), Vr(n.props, c, l)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: l,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ S.createElement(lw, os({
          key: "background-bar-".concat(l),
          option: n.props.background,
          isActive: l === s
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.data, s = a.xAxis, u = a.yAxis, c = a.layout, l = a.children, f = ct(l, Na);
      if (!f)
        return null;
      var d = c === "vertical" ? o[0].height / 2 : o[0].width / 2, p = function(h, g) {
        var b = Array.isArray(h.value) ? h.value[1] : h.value;
        return {
          x: h.x,
          y: h.y,
          value: b,
          errorVal: ke(h, g)
        };
      }, m = {
        clipPath: n ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ S.createElement(le, m, f.map(function(v) {
        return /* @__PURE__ */ S.cloneElement(v, {
          key: "error-bar-".concat(i, "-").concat(v.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: u,
          layout: c,
          offset: d,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.hide, a = n.data, o = n.className, s = n.xAxis, u = n.yAxis, c = n.left, l = n.top, f = n.width, d = n.height, p = n.isAnimationActive, m = n.background, v = n.id;
      if (i || !a || !a.length)
        return null;
      var h = this.state.isAnimationFinished, g = ue("recharts-bar", o), b = s && s.allowDataOverflow, w = u && u.allowDataOverflow, O = b || w, y = se(v) ? this.id : v;
      return /* @__PURE__ */ S.createElement(le, {
        className: g
      }, b || w ? /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-".concat(y)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: b ? c : c - f / 2,
        y: w ? l : l - d / 2,
        width: b ? f : f * 2,
        height: w ? d : d * 2
      }))) : null, /* @__PURE__ */ S.createElement(le, {
        className: "recharts-bar-rectangles",
        clipPath: O ? "url(#clipPath-".concat(y, ")") : null
      }, m ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(O, y), (!p || h) && Dt.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: i.curData
      } : n.data !== i.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(bt);
nA = Ar;
mr(Ar, "displayName", "Bar");
mr(Ar, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !wr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
mr(Ar, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, i = e.bandSize, a = e.xAxis, o = e.yAxis, s = e.xAxisTicks, u = e.yAxisTicks, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, p = _2(n, r);
  if (!p)
    return null;
  var m = t.layout, v = r.type.defaultProps, h = v !== void 0 ? $e($e({}, v), r.props) : r.props, g = h.dataKey, b = h.children, w = h.minPointSize, O = m === "horizontal" ? o : a, y = c ? O.scale.domain() : null, x = M2({
    numericAxis: O
  }), _ = ct(b, Ds), P = f.map(function(E, M) {
    var C, T, k, N, I, R;
    c ? C = S2(c[l + M], y) : (C = ke(E, g), Array.isArray(C) || (C = [x, C]));
    var q = Vq(w, nA.defaultProps.minPointSize)(C[1], M);
    if (m === "horizontal") {
      var W, H = [o.scale(C[0]), o.scale(C[1])], $ = H[0], L = H[1];
      T = $0({
        axis: a,
        ticks: s,
        bandSize: i,
        offset: p.offset,
        entry: E,
        index: M
      }), k = (W = L ?? $) !== null && W !== void 0 ? W : void 0, N = p.size;
      var B = $ - L;
      if (I = Number.isNaN(B) ? 0 : B, R = {
        x: T,
        y: o.y,
        width: N,
        height: o.height
      }, Math.abs(q) > 0 && Math.abs(I) < Math.abs(q)) {
        var V = Ye(I || q) * (Math.abs(q) - Math.abs(I));
        k -= V, I += V;
      }
    } else {
      var X = [a.scale(C[0]), a.scale(C[1])], te = X[0], re = X[1];
      if (T = te, k = $0({
        axis: o,
        ticks: u,
        bandSize: i,
        offset: p.offset,
        entry: E,
        index: M
      }), N = re - te, I = p.size, R = {
        x: a.x,
        y: k,
        width: a.width,
        height: I
      }, Math.abs(q) > 0 && Math.abs(N) < Math.abs(q)) {
        var oe = Ye(N || q) * (Math.abs(q) - Math.abs(N));
        N += oe;
      }
    }
    return $e($e($e({}, E), {}, {
      x: T,
      y: k,
      width: N,
      height: I,
      value: c ? C : C[1],
      payload: E,
      background: R
    }, _ && _[M] && _[M].props), {}, {
      tooltipPayload: [CS(r, E)],
      tooltipPosition: {
        x: T + N / 2,
        y: k + I / 2
      }
    });
  });
  return $e({
    data: P,
    layout: m
  }, d);
});
function xa(e) {
  "@babel/helpers - typeof";
  return xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xa(e);
}
function iB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, oA(n.key), n);
  }
}
function aB(e, t, r) {
  return t && pw(e.prototype, t), r && pw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function hw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hw(Object(r), !0).forEach(function(n) {
      eu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function eu(e, t, r) {
  return t = oA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oA(e) {
  var t = oB(e, "string");
  return xa(t) == "symbol" ? t : t + "";
}
function oB(e, t) {
  if (xa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ov = function(t, r, n, i, a) {
  var o = t.width, s = t.height, u = t.layout, c = t.children, l = Object.keys(r), f = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, d = !!ot(c, Ar);
  return l.reduce(function(p, m) {
    var v = r[m], h = v.orientation, g = v.domain, b = v.padding, w = b === void 0 ? {} : b, O = v.mirror, y = v.reversed, x = "".concat(h).concat(O ? "Mirror" : ""), _, P, E, M, C;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var T = g[1] - g[0], k = 1 / 0, N = v.categoricalDomain.sort(f3);
      if (N.forEach(function(X, te) {
        te > 0 && (k = Math.min((X || 0) - (N[te - 1] || 0), k));
      }), Number.isFinite(k)) {
        var I = k / T, R = v.layout === "vertical" ? n.height : n.width;
        if (v.padding === "gap" && (_ = I * R / 2), v.padding === "no-gap") {
          var q = Xe(t.barCategoryGap, I * R), W = I * R / 2;
          _ = W - q - (W - q) / R * q;
        }
      }
    }
    i === "xAxis" ? P = [n.left + (w.left || 0) + (_ || 0), n.left + n.width - (w.right || 0) - (_ || 0)] : i === "yAxis" ? P = u === "horizontal" ? [n.top + n.height - (w.bottom || 0), n.top + (w.top || 0)] : [n.top + (w.top || 0) + (_ || 0), n.top + n.height - (w.bottom || 0) - (_ || 0)] : P = v.range, y && (P = [P[1], P[0]]);
    var H = AS(v, a, d), $ = H.scale, L = H.realScaleType;
    $.domain(g).range(P), PS($);
    var B = TS($, _t(_t({}, v), {}, {
      realScaleType: L
    }));
    i === "xAxis" ? (C = h === "top" && !O || h === "bottom" && O, E = n.left, M = f[x] - C * v.height) : i === "yAxis" && (C = h === "left" && !O || h === "right" && O, E = f[x] - C * v.width, M = n.top);
    var V = _t(_t(_t({}, v), B), {}, {
      realScaleType: L,
      x: E,
      y: M,
      scale: $,
      width: i === "xAxis" ? n.width : v.width,
      height: i === "yAxis" ? n.height : v.height
    });
    return V.bandSize = Wo(V, B), !v.hide && i === "xAxis" ? f[x] += (C ? -1 : 1) * V.height : v.hide || (f[x] += (C ? -1 : 1) * V.width), _t(_t({}, p), {}, eu({}, m, V));
  }, {});
}, sA = function(t, r) {
  var n = t.x, i = t.y, a = r.x, o = r.y;
  return {
    x: Math.min(n, a),
    y: Math.min(i, o),
    width: Math.abs(a - n),
    height: Math.abs(o - i)
  };
}, sB = function(t) {
  var r = t.x1, n = t.y1, i = t.x2, a = t.y2;
  return sA({
    x: r,
    y: n
  }, {
    x: i,
    y: a
  });
}, uA = /* @__PURE__ */ function() {
  function e(t) {
    iB(this, e), this.scale = t;
  }
  return aB(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.bandAware, a = n.position;
      if (r !== void 0) {
        if (a)
          switch (a) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (i) {
          var u = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + u;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), i = n[0], a = n[n.length - 1];
      return i <= a ? r >= i && r <= a : r >= a && r <= i;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
}();
eu(uA, "EPS", 1e-4);
var sv = function(t) {
  var r = Object.keys(t).reduce(function(n, i) {
    return _t(_t({}, n), {}, eu({}, i, uA.create(t[i])));
  }, {});
  return _t(_t({}, r), {}, {
    apply: function(i) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.bandAware, s = a.position;
      return Iq(i, function(u, c) {
        return r[c].apply(u, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(i) {
      return rA(i, function(a, o) {
        return r[o].isInRange(a);
      });
    }
  });
};
function uB(e) {
  return (e % 180 + 180) % 180;
}
var cB = function(t) {
  var r = t.width, n = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = uB(i), o = a * Math.PI / 180, s = Math.atan(n / r), u = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(u);
}, fd, vw;
function lB() {
  if (vw) return fd;
  vw = 1;
  var e = Ft(), t = Ca(), r = Ns();
  function n(i) {
    return function(a, o, s) {
      var u = Object(a);
      if (!t(a)) {
        var c = e(o, 3);
        a = r(a), o = function(f) {
          return c(u[f], f, u);
        };
      }
      var l = i(a, o, s);
      return l > -1 ? u[c ? a[l] : l] : void 0;
    };
  }
  return fd = n, fd;
}
var dd, yw;
function fB() {
  if (yw) return dd;
  yw = 1;
  var e = JS();
  function t(r) {
    var n = e(r), i = n % 1;
    return n === n ? i ? n - i : n : 0;
  }
  return dd = t, dd;
}
var pd, mw;
function dB() {
  if (mw) return pd;
  mw = 1;
  var e = s_(), t = Ft(), r = fB(), n = Math.max;
  function i(a, o, s) {
    var u = a == null ? 0 : a.length;
    if (!u)
      return -1;
    var c = s == null ? 0 : r(s);
    return c < 0 && (c = n(u + c, 0)), e(a, t(o, 3), c);
  }
  return pd = i, pd;
}
var hd, gw;
function pB() {
  if (gw) return hd;
  gw = 1;
  var e = lB(), t = dB(), r = e(t);
  return hd = r, hd;
}
var hB = pB();
const vB = /* @__PURE__ */ xe(hB);
var yB = OO();
const mB = /* @__PURE__ */ xe(yB);
var gB = mB(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function us(e) {
  "@babel/helpers - typeof";
  return us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, us(e);
}
var uv = /* @__PURE__ */ Jr(void 0), cv = /* @__PURE__ */ Jr(void 0), cA = /* @__PURE__ */ Jr(void 0), lA = /* @__PURE__ */ Jr({}), fA = /* @__PURE__ */ Jr(void 0), dA = /* @__PURE__ */ Jr(0), pA = /* @__PURE__ */ Jr(0), bw = function(t) {
  var r = t.state, n = r.xAxisMap, i = r.yAxisMap, a = r.offset, o = t.clipPathId, s = t.children, u = t.width, c = t.height, l = gB(a);
  return /* @__PURE__ */ S.createElement(uv.Provider, {
    value: n
  }, /* @__PURE__ */ S.createElement(cv.Provider, {
    value: i
  }, /* @__PURE__ */ S.createElement(lA.Provider, {
    value: a
  }, /* @__PURE__ */ S.createElement(cA.Provider, {
    value: l
  }, /* @__PURE__ */ S.createElement(fA.Provider, {
    value: o
  }, /* @__PURE__ */ S.createElement(dA.Provider, {
    value: c
  }, /* @__PURE__ */ S.createElement(pA.Provider, {
    value: u
  }, s)))))));
}, bB = function() {
  return nr(fA);
};
function hA(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var vA = function(t) {
  var r = nr(uv);
  r == null && (process.env.NODE_ENV !== "production" ? tt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : tt());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? tt(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(us(t), "]. ").concat(hA(r))) : tt()), n;
}, xB = function() {
  var t = nr(uv);
  return vr(t);
}, wB = function() {
  var t = nr(cv), r = vB(t, function(n) {
    return rA(n.domain, Number.isFinite);
  });
  return r || vr(t);
}, yA = function(t) {
  var r = nr(cv);
  r == null && (process.env.NODE_ENV !== "production" ? tt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : tt());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? tt(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(us(t), "]. ").concat(hA(r))) : tt()), n;
}, OB = function() {
  var t = nr(cA);
  return t;
}, _B = function() {
  return nr(lA);
}, lv = function() {
  return nr(pA);
}, fv = function() {
  return nr(dA);
};
function Gn(e) {
  "@babel/helpers - typeof";
  return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gn(e);
}
function SB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function AB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gA(n.key), n);
  }
}
function PB(e, t, r) {
  return t && AB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function TB(e, t, r) {
  return t = cs(t), EB(e, mA() ? Reflect.construct(t, r || [], cs(e).constructor) : t.apply(e, r));
}
function EB(e, t) {
  if (t && (Gn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return CB(e);
}
function CB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function mA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mA = function() {
    return !!e;
  })();
}
function cs(e) {
  return cs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, cs(e);
}
function MB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Cp(e, t);
}
function Cp(e, t) {
  return Cp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Cp(e, t);
}
function xw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ww(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xw(Object(r), !0).forEach(function(n) {
      dv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dv(e, t, r) {
  return t = gA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gA(e) {
  var t = jB(e, "string");
  return Gn(t) == "symbol" ? t : t + "";
}
function jB(e, t) {
  if (Gn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Gn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function kB(e, t) {
  return RB(e) || IB(e, t) || NB(e, t) || $B();
}
function $B() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NB(e, t) {
  if (e) {
    if (typeof e == "string") return Ow(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ow(e, t);
  }
}
function Ow(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function IB(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function RB(e) {
  if (Array.isArray(e)) return e;
}
function Mp() {
  return Mp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mp.apply(this, arguments);
}
var DB = function(t, r) {
  var n;
  return /* @__PURE__ */ S.isValidElement(t) ? n = /* @__PURE__ */ S.cloneElement(t, r) : ie(t) ? n = t(r) : n = /* @__PURE__ */ S.createElement("line", Mp({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, LB = function(t, r, n, i, a, o, s, u, c) {
  var l = a.x, f = a.y, d = a.width, p = a.height;
  if (n) {
    var m = c.y, v = t.y.apply(m, {
      position: o
    });
    if (Lt(c, "discard") && !t.y.isInRange(v))
      return null;
    var h = [{
      x: l + d,
      y: v
    }, {
      x: l,
      y: v
    }];
    return u === "left" ? h.reverse() : h;
  }
  if (r) {
    var g = c.x, b = t.x.apply(g, {
      position: o
    });
    if (Lt(c, "discard") && !t.x.isInRange(b))
      return null;
    var w = [{
      x: b,
      y: f + p
    }, {
      x: b,
      y: f
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (i) {
    var O = c.segment, y = O.map(function(x) {
      return t.apply(x, {
        position: o
      });
    });
    return Lt(c, "discard") && jq(y, function(x) {
      return !t.isInRange(x);
    }) ? null : y;
  }
  return null;
};
function qB(e) {
  var t = e.x, r = e.y, n = e.segment, i = e.xAxisId, a = e.yAxisId, o = e.shape, s = e.className, u = e.alwaysShow, c = bB(), l = vA(i), f = yA(a), d = OB();
  if (!c || !d)
    return null;
  Et(u === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = sv({
    x: l.scale,
    y: f.scale
  }), m = qe(t), v = qe(r), h = n && n.length === 2, g = LB(p, m, v, h, d, e.position, l.orientation, f.orientation, e);
  if (!g)
    return null;
  var b = kB(g, 2), w = b[0], O = w.x, y = w.y, x = b[1], _ = x.x, P = x.y, E = Lt(e, "hidden") ? "url(#".concat(c, ")") : void 0, M = ww(ww({
    clipPath: E
  }, Q(e, !0)), {}, {
    x1: O,
    y1: y,
    x2: _,
    y2: P
  });
  return /* @__PURE__ */ S.createElement(le, {
    className: ue("recharts-reference-line", s)
  }, DB(o, M), ze.renderCallByParent(e, sB({
    x1: O,
    y1: y,
    x2: _,
    y2: P
  })));
}
var pv = /* @__PURE__ */ function(e) {
  function t() {
    return SB(this, t), TB(this, t, arguments);
  }
  return MB(t, e), PB(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ S.createElement(qB, this.props);
    }
  }]);
}(S.Component);
dv(pv, "displayName", "ReferenceLine");
dv(pv, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function jp() {
  return jp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jp.apply(this, arguments);
}
function Hn(e) {
  "@babel/helpers - typeof";
  return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hn(e);
}
function _w(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Sw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _w(Object(r), !0).forEach(function(n) {
      tu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _w(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function BB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function FB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xA(n.key), n);
  }
}
function zB(e, t, r) {
  return t && FB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function WB(e, t, r) {
  return t = ls(t), UB(e, bA() ? Reflect.construct(t, r || [], ls(e).constructor) : t.apply(e, r));
}
function UB(e, t) {
  if (t && (Hn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return GB(e);
}
function GB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bA = function() {
    return !!e;
  })();
}
function ls(e) {
  return ls = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ls(e);
}
function HB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && kp(e, t);
}
function kp(e, t) {
  return kp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, kp(e, t);
}
function tu(e, t, r) {
  return t = xA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xA(e) {
  var t = VB(e, "string");
  return Hn(t) == "symbol" ? t : t + "";
}
function VB(e, t) {
  if (Hn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Hn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var KB = function(t) {
  var r = t.x, n = t.y, i = t.xAxis, a = t.yAxis, o = sv({
    x: i.scale,
    y: a.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Lt(t, "discard") && !o.isInRange(s) ? null : s;
}, ru = /* @__PURE__ */ function(e) {
  function t() {
    return BB(this, t), WB(this, t, arguments);
  }
  return HB(t, e), zB(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.r, s = n.alwaysShow, u = n.clipPathId, c = qe(i), l = qe(a);
      if (Et(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !l)
        return null;
      var f = KB(this.props);
      if (!f)
        return null;
      var d = f.x, p = f.y, m = this.props, v = m.shape, h = m.className, g = Lt(this.props, "hidden") ? "url(#".concat(u, ")") : void 0, b = Sw(Sw({
        clipPath: g
      }, Q(this.props, !0)), {}, {
        cx: d,
        cy: p
      });
      return /* @__PURE__ */ S.createElement(le, {
        className: ue("recharts-reference-dot", h)
      }, t.renderDot(v, b), ze.renderCallByParent(this.props, {
        x: d - o,
        y: p - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(S.Component);
tu(ru, "displayName", "ReferenceDot");
tu(ru, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
tu(ru, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ S.isValidElement(e) ? r = /* @__PURE__ */ S.cloneElement(e, t) : ie(e) ? r = e(t) : r = /* @__PURE__ */ S.createElement(Ia, jp({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function $p() {
  return $p = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $p.apply(this, arguments);
}
function Vn(e) {
  "@babel/helpers - typeof";
  return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vn(e);
}
function Aw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Aw(Object(r), !0).forEach(function(n) {
      nu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Aw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function YB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function XB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OA(n.key), n);
  }
}
function ZB(e, t, r) {
  return t && XB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function JB(e, t, r) {
  return t = fs(t), QB(e, wA() ? Reflect.construct(t, r || [], fs(e).constructor) : t.apply(e, r));
}
function QB(e, t) {
  if (t && (Vn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return eF(e);
}
function eF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wA = function() {
    return !!e;
  })();
}
function fs(e) {
  return fs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fs(e);
}
function tF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Np(e, t);
}
function Np(e, t) {
  return Np = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Np(e, t);
}
function nu(e, t, r) {
  return t = OA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function OA(e) {
  var t = rF(e, "string");
  return Vn(t) == "symbol" ? t : t + "";
}
function rF(e, t) {
  if (Vn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Vn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var nF = function(t, r, n, i, a) {
  var o = a.x1, s = a.x2, u = a.y1, c = a.y2, l = a.xAxis, f = a.yAxis;
  if (!l || !f) return null;
  var d = sv({
    x: l.scale,
    y: f.scale
  }), p = {
    x: t ? d.x.apply(o, {
      position: "start"
    }) : d.x.rangeMin,
    y: n ? d.y.apply(u, {
      position: "start"
    }) : d.y.rangeMin
  }, m = {
    x: r ? d.x.apply(s, {
      position: "end"
    }) : d.x.rangeMax,
    y: i ? d.y.apply(c, {
      position: "end"
    }) : d.y.rangeMax
  };
  return Lt(a, "discard") && (!d.isInRange(p) || !d.isInRange(m)) ? null : sA(p, m);
}, iu = /* @__PURE__ */ function(e) {
  function t() {
    return YB(this, t), JB(this, t, arguments);
  }
  return tF(t, e), ZB(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.x1, a = n.x2, o = n.y1, s = n.y2, u = n.className, c = n.alwaysShow, l = n.clipPathId;
      Et(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = qe(i), d = qe(a), p = qe(o), m = qe(s), v = this.props.shape;
      if (!f && !d && !p && !m && !v)
        return null;
      var h = nF(f, d, p, m, this.props);
      if (!h && !v)
        return null;
      var g = Lt(this.props, "hidden") ? "url(#".concat(l, ")") : void 0;
      return /* @__PURE__ */ S.createElement(le, {
        className: ue("recharts-reference-area", u)
      }, t.renderRect(v, Pw(Pw({
        clipPath: g
      }, Q(this.props, !0)), h)), ze.renderCallByParent(this.props, h));
    }
  }]);
}(S.Component);
nu(iu, "displayName", "ReferenceArea");
nu(iu, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
nu(iu, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ S.isValidElement(e) ? r = /* @__PURE__ */ S.cloneElement(e, t) : ie(e) ? r = e(t) : r = /* @__PURE__ */ S.createElement(av, $p({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function _A(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], i = 0; i < e.length; i += t)
    n.push(e[i]);
  return n;
}
function iF(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return cB(n, r);
}
function aF(e, t, r) {
  var n = r === "width", i = e.x, a = e.y, o = e.width, s = e.height;
  return t === 1 ? {
    start: n ? i : a,
    end: n ? i + o : a + s
  } : {
    start: n ? i + o : a + s,
    end: n ? i : a
  };
}
function ds(e, t, r, n, i) {
  if (e * t < e * n || e * t > e * i)
    return !1;
  var a = r();
  return e * (t - e * a / 2 - n) >= 0 && e * (t + e * a / 2 - i) <= 0;
}
function oF(e, t) {
  return _A(e, t + 1);
}
function sF(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = t.start, s = t.end, u = 0, c = 1, l = o, f = function() {
    var m = n?.[u];
    if (m === void 0)
      return {
        v: _A(n, c)
      };
    var v = u, h, g = function() {
      return h === void 0 && (h = r(m, v)), h;
    }, b = m.coordinate, w = u === 0 || ds(e, b, g, l, s);
    w || (u = 0, l = o, c += 1), w && (l = b + e * (g() / 2 + i), u += c);
  }, d; c <= a.length; )
    if (d = f(), d) return d.v;
  return [];
}
function wa(e) {
  "@babel/helpers - typeof";
  return wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wa(e);
}
function Tw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function He(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tw(Object(r), !0).forEach(function(n) {
      uF(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uF(e, t, r) {
  return t = cF(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cF(e) {
  var t = lF(e, "string");
  return wa(t) == "symbol" ? t : t + "";
}
function lF(e, t) {
  if (wa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fF(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = a.length, s = t.start, u = t.end, c = function(d) {
    var p = a[d], m, v = function() {
      return m === void 0 && (m = r(p, d)), m;
    };
    if (d === o - 1) {
      var h = e * (p.coordinate + e * v() / 2 - u);
      a[d] = p = He(He({}, p), {}, {
        tickCoord: h > 0 ? p.coordinate - h * e : p.coordinate
      });
    } else
      a[d] = p = He(He({}, p), {}, {
        tickCoord: p.coordinate
      });
    var g = ds(e, p.tickCoord, v, s, u);
    g && (u = p.tickCoord - e * (v() / 2 + i), a[d] = He(He({}, p), {}, {
      isShow: !0
    }));
  }, l = o - 1; l >= 0; l--)
    c(l);
  return a;
}
function dF(e, t, r, n, i, a) {
  var o = (n || []).slice(), s = o.length, u = t.start, c = t.end;
  if (a) {
    var l = n[s - 1], f = r(l, s - 1), d = e * (l.coordinate + e * f / 2 - c);
    o[s - 1] = l = He(He({}, l), {}, {
      tickCoord: d > 0 ? l.coordinate - d * e : l.coordinate
    });
    var p = ds(e, l.tickCoord, function() {
      return f;
    }, u, c);
    p && (c = l.tickCoord - e * (f / 2 + i), o[s - 1] = He(He({}, l), {}, {
      isShow: !0
    }));
  }
  for (var m = a ? s - 1 : s, v = function(b) {
    var w = o[b], O, y = function() {
      return O === void 0 && (O = r(w, b)), O;
    };
    if (b === 0) {
      var x = e * (w.coordinate - e * y() / 2 - u);
      o[b] = w = He(He({}, w), {}, {
        tickCoord: x < 0 ? w.coordinate - x * e : w.coordinate
      });
    } else
      o[b] = w = He(He({}, w), {}, {
        tickCoord: w.coordinate
      });
    var _ = ds(e, w.tickCoord, y, u, c);
    _ && (u = w.tickCoord + e * (y() / 2 + i), o[b] = He(He({}, w), {}, {
      isShow: !0
    }));
  }, h = 0; h < m; h++)
    v(h);
  return o;
}
function hv(e, t, r) {
  var n = e.tick, i = e.ticks, a = e.viewBox, o = e.minTickGap, s = e.orientation, u = e.interval, c = e.tickFormatter, l = e.unit, f = e.angle;
  if (!i || !i.length || !n)
    return [];
  if (U(u) || wr.isSsr)
    return oF(i, typeof u == "number" && U(u) ? u : 0);
  var d = [], p = s === "top" || s === "bottom" ? "width" : "height", m = l && p === "width" ? $i(l, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, v = function(w, O) {
    var y = ie(c) ? c(w.value, O) : w.value;
    return p === "width" ? iF($i(y, {
      fontSize: t,
      letterSpacing: r
    }), m, f) : $i(y, {
      fontSize: t,
      letterSpacing: r
    })[p];
  }, h = i.length >= 2 ? Ye(i[1].coordinate - i[0].coordinate) : 1, g = aF(a, h, p);
  return u === "equidistantPreserveStart" ? sF(h, g, v, i, o) : (u === "preserveStart" || u === "preserveStartEnd" ? d = dF(h, g, v, i, o, u === "preserveStartEnd") : d = fF(h, g, v, i, o), d.filter(function(b) {
    return b.isShow;
  }));
}
var pF = ["viewBox"], hF = ["viewBox"], vF = ["ticks"];
function Kn(e) {
  "@babel/helpers - typeof";
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kn(e);
}
function mn() {
  return mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mn.apply(this, arguments);
}
function Ew(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ie(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ew(Object(r), !0).forEach(function(n) {
      vv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ew(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vd(e, t) {
  if (e == null) return {};
  var r = yF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function yF(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function mF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Cw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, AA(n.key), n);
  }
}
function gF(e, t, r) {
  return t && Cw(e.prototype, t), r && Cw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bF(e, t, r) {
  return t = ps(t), xF(e, SA() ? Reflect.construct(t, r || [], ps(e).constructor) : t.apply(e, r));
}
function xF(e, t) {
  if (t && (Kn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return wF(e);
}
function wF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function SA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (SA = function() {
    return !!e;
  })();
}
function ps(e) {
  return ps = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ps(e);
}
function OF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ip(e, t);
}
function Ip(e, t) {
  return Ip = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ip(e, t);
}
function vv(e, t, r) {
  return t = AA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function AA(e) {
  var t = _F(e, "string");
  return Kn(t) == "symbol" ? t : t + "";
}
function _F(e, t) {
  if (Kn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Kn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var li = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return mF(this, t), n = bF(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return OF(t, e), gF(t, [{
    key: "shouldComponentUpdate",
    value: function(n, i) {
      var a = n.viewBox, o = vd(n, pF), s = this.props, u = s.viewBox, c = vd(s, hF);
      return !wn(a, u) || !wn(o, c) || !wn(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var i = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var i = this.props, a = i.x, o = i.y, s = i.width, u = i.height, c = i.orientation, l = i.tickSize, f = i.mirror, d = i.tickMargin, p, m, v, h, g, b, w = f ? -1 : 1, O = n.tickSize || l, y = U(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          p = m = n.coordinate, h = o + +!f * u, v = h - w * O, b = v - w * d, g = y;
          break;
        case "left":
          v = h = n.coordinate, m = a + +!f * s, p = m - w * O, g = p - w * d, b = y;
          break;
        case "right":
          v = h = n.coordinate, m = a + +f * s, p = m + w * O, g = p + w * d, b = y;
          break;
        default:
          p = m = n.coordinate, h = o + +f * u, v = h + w * O, b = v + w * d, g = y;
          break;
      }
      return {
        line: {
          x1: p,
          y1: v,
          x2: m,
          y2: h
        },
        tick: {
          x: g,
          y: b
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, i = n.orientation, a = n.mirror, o;
      switch (i) {
        case "left":
          o = a ? "start" : "end";
          break;
        case "right":
          o = a ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, i = n.orientation, a = n.mirror, o = "end";
      switch (i) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = a ? "start" : "end";
          break;
        default:
          o = a ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, s = n.height, u = n.orientation, c = n.mirror, l = n.axisLine, f = Ie(Ie(Ie({}, Q(this.props, !1)), Q(l, !1)), {}, {
        fill: "none"
      });
      if (u === "top" || u === "bottom") {
        var d = +(u === "top" && !c || u === "bottom" && c);
        f = Ie(Ie({}, f), {}, {
          x1: i,
          y1: a + d * s,
          x2: i + o,
          y2: a + d * s
        });
      } else {
        var p = +(u === "left" && !c || u === "right" && c);
        f = Ie(Ie({}, f), {}, {
          x1: i + p * o,
          y1: a,
          x2: i + p * o,
          y2: a + s
        });
      }
      return /* @__PURE__ */ S.createElement("line", mn({}, f, {
        className: ue("recharts-cartesian-axis-line", ut(l, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, i, a) {
        var o = this, s = this.props, u = s.tickLine, c = s.stroke, l = s.tick, f = s.tickFormatter, d = s.unit, p = hv(Ie(Ie({}, this.props), {}, {
          ticks: n
        }), i, a), m = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), h = Q(this.props, !1), g = Q(l, !1), b = Ie(Ie({}, h), {}, {
          fill: "none"
        }, Q(u, !1)), w = p.map(function(O, y) {
          var x = o.getTickLineCoord(O), _ = x.line, P = x.tick, E = Ie(Ie(Ie(Ie({
            textAnchor: m,
            verticalAnchor: v
          }, h), {}, {
            stroke: "none",
            fill: c
          }, g), P), {}, {
            index: y,
            payload: O,
            visibleTicksCount: p.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ S.createElement(le, mn({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(O.value, "-").concat(O.coordinate, "-").concat(O.tickCoord)
          }, Vr(o.props, O, y)), u && /* @__PURE__ */ S.createElement("line", mn({}, b, _, {
            className: ue("recharts-cartesian-axis-tick-line", ut(u, "className"))
          })), l && t.renderTickItem(l, E, "".concat(ie(f) ? f(O.value, y) : O.value).concat(d || "")));
        });
        return /* @__PURE__ */ S.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.axisLine, o = i.width, s = i.height, u = i.ticksGenerator, c = i.className, l = i.hide;
      if (l)
        return null;
      var f = this.props, d = f.ticks, p = vd(f, vF), m = d;
      return ie(u) && (m = d && d.length > 0 ? u(this.props) : u(p)), o <= 0 || s <= 0 || !m || !m.length ? null : /* @__PURE__ */ S.createElement(le, {
        className: ue("recharts-cartesian-axis", c),
        ref: function(h) {
          n.layerReference = h;
        }
      }, a && this.renderAxisLine(), this.renderTicks(m, this.state.fontSize, this.state.letterSpacing), ze.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o, s = ue(i.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ S.isValidElement(n) ? o = /* @__PURE__ */ S.cloneElement(n, Ie(Ie({}, i), {}, {
        className: s
      })) : ie(n) ? o = n(Ie(Ie({}, i), {}, {
        className: s
      })) : o = /* @__PURE__ */ S.createElement(Kr, mn({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), a), o;
    }
  }]);
}(Xw);
vv(li, "displayName", "CartesianAxis");
vv(li, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var SF = ["x1", "y1", "x2", "y2", "key"], AF = ["offset"];
function Zr(e) {
  "@babel/helpers - typeof";
  return Zr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zr(e);
}
function Mw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mw(Object(r), !0).forEach(function(n) {
      PF(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function PF(e, t, r) {
  return t = TF(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function TF(e) {
  var t = EF(e, "string");
  return Zr(t) == "symbol" ? t : t + "";
}
function EF(e, t) {
  if (Zr(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Zr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lr() {
  return Lr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lr.apply(this, arguments);
}
function jw(e, t) {
  if (e == null) return {};
  var r = CF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function CF(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var MF = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, i = t.x, a = t.y, o = t.width, s = t.height, u = t.ry;
  return /* @__PURE__ */ S.createElement("rect", {
    x: i,
    y: a,
    ry: u,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function PA(e, t) {
  var r;
  if (/* @__PURE__ */ S.isValidElement(e))
    r = /* @__PURE__ */ S.cloneElement(e, t);
  else if (ie(e))
    r = e(t);
  else {
    var n = t.x1, i = t.y1, a = t.x2, o = t.y2, s = t.key, u = jw(t, SF), c = Q(u, !1);
    c.offset;
    var l = jw(c, AF);
    r = /* @__PURE__ */ S.createElement("line", Lr({}, l, {
      x1: n,
      y1: i,
      x2: a,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function jF(e) {
  var t = e.x, r = e.width, n = e.horizontal, i = n === void 0 ? !0 : n, a = e.horizontalPoints;
  if (!i || !a || !a.length)
    return null;
  var o = a.map(function(s, u) {
    var c = Ke(Ke({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(u),
      index: u
    });
    return PA(i, c);
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function kF(e) {
  var t = e.y, r = e.height, n = e.vertical, i = n === void 0 ? !0 : n, a = e.verticalPoints;
  if (!i || !a || !a.length)
    return null;
  var o = a.map(function(s, u) {
    var c = Ke(Ke({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(u),
      index: u
    });
    return PA(i, c);
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function $F(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, i = e.y, a = e.width, o = e.height, s = e.horizontalPoints, u = e.horizontal, c = u === void 0 ? !0 : u;
  if (!c || !t || !t.length)
    return null;
  var l = s.map(function(d) {
    return Math.round(d + i - i);
  }).sort(function(d, p) {
    return d - p;
  });
  i !== l[0] && l.unshift(0);
  var f = l.map(function(d, p) {
    var m = !l[p + 1], v = m ? i + o - d : l[p + 1] - d;
    if (v <= 0)
      return null;
    var h = p % t.length;
    return /* @__PURE__ */ S.createElement("rect", {
      key: "react-".concat(p),
      y: d,
      x: n,
      height: v,
      width: a,
      stroke: "none",
      fill: t[h],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function NF(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, i = e.fillOpacity, a = e.x, o = e.y, s = e.width, u = e.height, c = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var l = c.map(function(d) {
    return Math.round(d + a - a);
  }).sort(function(d, p) {
    return d - p;
  });
  a !== l[0] && l.unshift(0);
  var f = l.map(function(d, p) {
    var m = !l[p + 1], v = m ? a + s - d : l[p + 1] - d;
    if (v <= 0)
      return null;
    var h = p % n.length;
    return /* @__PURE__ */ S.createElement("rect", {
      key: "react-".concat(p),
      x: d,
      y: o,
      width: v,
      height: u,
      stroke: "none",
      fill: n[h],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var IF = function(t, r) {
  var n = t.xAxis, i = t.width, a = t.height, o = t.offset;
  return SS(hv(Ke(Ke(Ke({}, li.defaultProps), n), {}, {
    ticks: Zt(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: a
    }
  })), o.left, o.left + o.width, r);
}, RF = function(t, r) {
  var n = t.yAxis, i = t.width, a = t.height, o = t.offset;
  return SS(hv(Ke(Ke(Ke({}, li.defaultProps), n), {}, {
    ticks: Zt(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: a
    }
  })), o.top, o.top + o.height, r);
}, dn = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function sn(e) {
  var t, r, n, i, a, o, s = lv(), u = fv(), c = _B(), l = Ke(Ke({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : dn.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : dn.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : dn.horizontal,
    horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : dn.horizontalFill,
    vertical: (a = e.vertical) !== null && a !== void 0 ? a : dn.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : dn.verticalFill,
    x: U(e.x) ? e.x : c.left,
    y: U(e.y) ? e.y : c.top,
    width: U(e.width) ? e.width : c.width,
    height: U(e.height) ? e.height : c.height
  }), f = l.x, d = l.y, p = l.width, m = l.height, v = l.syncWithTicks, h = l.horizontalValues, g = l.verticalValues, b = xB(), w = wB();
  if (!U(p) || p <= 0 || !U(m) || m <= 0 || !U(f) || f !== +f || !U(d) || d !== +d)
    return null;
  var O = l.verticalCoordinatesGenerator || IF, y = l.horizontalCoordinatesGenerator || RF, x = l.horizontalPoints, _ = l.verticalPoints;
  if ((!x || !x.length) && ie(y)) {
    var P = h && h.length, E = y({
      yAxis: w ? Ke(Ke({}, w), {}, {
        ticks: P ? h : w.ticks
      }) : void 0,
      width: s,
      height: u,
      offset: c
    }, P ? !0 : v);
    Et(Array.isArray(E), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Zr(E), "]")), Array.isArray(E) && (x = E);
  }
  if ((!_ || !_.length) && ie(O)) {
    var M = g && g.length, C = O({
      xAxis: b ? Ke(Ke({}, b), {}, {
        ticks: M ? g : b.ticks
      }) : void 0,
      width: s,
      height: u,
      offset: c
    }, M ? !0 : v);
    Et(Array.isArray(C), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Zr(C), "]")), Array.isArray(C) && (_ = C);
  }
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ S.createElement(MF, {
    fill: l.fill,
    fillOpacity: l.fillOpacity,
    x: l.x,
    y: l.y,
    width: l.width,
    height: l.height,
    ry: l.ry
  }), /* @__PURE__ */ S.createElement(jF, Lr({}, l, {
    offset: c,
    horizontalPoints: x,
    xAxis: b,
    yAxis: w
  })), /* @__PURE__ */ S.createElement(kF, Lr({}, l, {
    offset: c,
    verticalPoints: _,
    xAxis: b,
    yAxis: w
  })), /* @__PURE__ */ S.createElement($F, Lr({}, l, {
    horizontalPoints: x
  })), /* @__PURE__ */ S.createElement(NF, Lr({}, l, {
    verticalPoints: _
  })));
}
sn.displayName = "CartesianGrid";
var DF = ["type", "layout", "connectNulls", "ref"], LF = ["key"];
function Yn(e) {
  "@babel/helpers - typeof";
  return Yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yn(e);
}
function kw(e, t) {
  if (e == null) return {};
  var r = qF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function qF(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function qi() {
  return qi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qi.apply(this, arguments);
}
function $w(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function it(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $w(Object(r), !0).forEach(function(n) {
      St(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $w(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pn(e) {
  return WF(e) || zF(e) || FF(e) || BF();
}
function BF() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FF(e, t) {
  if (e) {
    if (typeof e == "string") return Rp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Rp(e, t);
  }
}
function zF(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function WF(e) {
  if (Array.isArray(e)) return Rp(e);
}
function Rp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function UF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EA(n.key), n);
  }
}
function GF(e, t, r) {
  return t && Nw(e.prototype, t), r && Nw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function HF(e, t, r) {
  return t = hs(t), VF(e, TA() ? Reflect.construct(t, r || [], hs(e).constructor) : t.apply(e, r));
}
function VF(e, t) {
  if (t && (Yn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return KF(e);
}
function KF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function TA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (TA = function() {
    return !!e;
  })();
}
function hs(e) {
  return hs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, hs(e);
}
function YF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Dp(e, t);
}
function Dp(e, t) {
  return Dp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Dp(e, t);
}
function St(e, t, r) {
  return t = EA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function EA(e) {
  var t = XF(e, "string");
  return Yn(t) == "symbol" ? t : t + "";
}
function XF(e, t) {
  if (Yn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Yn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var fi = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    UF(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = HF(this, t, [].concat(i)), St(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), St(r, "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), St(r, "getStrokeDasharray", function(o, s, u) {
      var c = u.reduce(function(g, b) {
        return g + b;
      });
      if (!c)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var l = Math.floor(o / c), f = o % c, d = s - o, p = [], m = 0, v = 0; m < u.length; v += u[m], ++m)
        if (v + u[m] > f) {
          p = [].concat(pn(u.slice(0, m)), [f - v]);
          break;
        }
      var h = p.length % 2 === 0 ? [0, d] : [d];
      return [].concat(pn(t.repeat(u, l)), pn(p), h).map(function(g) {
        return "".concat(g, "px");
      }).join(", ");
    }), St(r, "id", tn("recharts-line-")), St(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), St(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), St(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return YF(t, e), GF(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.points, s = a.xAxis, u = a.yAxis, c = a.layout, l = a.children, f = ct(l, Na);
      if (!f)
        return null;
      var d = function(v, h) {
        return {
          x: v.x,
          y: v.y,
          value: v.value,
          errorVal: ke(v.payload, h)
        };
      }, p = {
        clipPath: n ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ S.createElement(le, p, f.map(function(m) {
        return /* @__PURE__ */ S.cloneElement(m, {
          key: "bar-".concat(m.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: u,
          layout: c,
          dataPointFormatter: d
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, i, a) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, u = s.dot, c = s.points, l = s.dataKey, f = Q(this.props, !1), d = Q(u, !0), p = c.map(function(v, h) {
        var g = it(it(it({
          key: "dot-".concat(h),
          r: 3
        }, f), d), {}, {
          index: h,
          cx: v.x,
          cy: v.y,
          value: v.value,
          dataKey: l,
          payload: v.payload,
          points: c
        });
        return t.renderDotItem(u, g);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(a, ")") : null
      };
      return /* @__PURE__ */ S.createElement(le, qi({
        className: "recharts-line-dots",
        key: "dots"
      }, m), p);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, i, a, o) {
      var s = this.props, u = s.type, c = s.layout, l = s.connectNulls;
      s.ref;
      var f = kw(s, DF), d = it(it(it({}, Q(f, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: i ? "url(#clipPath-".concat(a, ")") : null,
        points: n
      }, o), {}, {
        type: u,
        layout: c,
        connectNulls: l
      });
      return /* @__PURE__ */ S.createElement(Ur, qi({}, d, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, i) {
      var a = this, o = this.props, s = o.points, u = o.strokeDasharray, c = o.isAnimationActive, l = o.animationBegin, f = o.animationDuration, d = o.animationEasing, p = o.animationId, m = o.animateNewValues, v = o.width, h = o.height, g = this.state, b = g.prevPoints, w = g.totalLength;
      return /* @__PURE__ */ S.createElement(Mt, {
        begin: l,
        duration: f,
        isActive: c,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(O) {
        var y = O.t;
        if (b) {
          var x = b.length / s.length, _ = s.map(function(T, k) {
            var N = Math.floor(k * x);
            if (b[N]) {
              var I = b[N], R = Le(I.x, T.x), q = Le(I.y, T.y);
              return it(it({}, T), {}, {
                x: R(y),
                y: q(y)
              });
            }
            if (m) {
              var W = Le(v * 2, T.x), H = Le(h / 2, T.y);
              return it(it({}, T), {}, {
                x: W(y),
                y: H(y)
              });
            }
            return it(it({}, T), {}, {
              x: T.x,
              y: T.y
            });
          });
          return a.renderCurveStatically(_, n, i);
        }
        var P = Le(0, w), E = P(y), M;
        if (u) {
          var C = "".concat(u).split(/[,\s]+/gim).map(function(T) {
            return parseFloat(T);
          });
          M = a.getStrokeDasharray(E, w, C);
        } else
          M = a.generateSimpleStrokeDasharray(w, E);
        return a.renderCurveStatically(s, n, i, {
          strokeDasharray: M
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, i) {
      var a = this.props, o = a.points, s = a.isAnimationActive, u = this.state, c = u.prevPoints, l = u.totalLength;
      return s && o && o.length && (!c && l > 0 || !Yr(c, o)) ? this.renderCurveWithAnimation(n, i) : this.renderCurveStatically(o, n, i);
    }
  }, {
    key: "render",
    value: function() {
      var n, i = this.props, a = i.hide, o = i.dot, s = i.points, u = i.className, c = i.xAxis, l = i.yAxis, f = i.top, d = i.left, p = i.width, m = i.height, v = i.isAnimationActive, h = i.id;
      if (a || !s || !s.length)
        return null;
      var g = this.state.isAnimationFinished, b = s.length === 1, w = ue("recharts-line", u), O = c && c.allowDataOverflow, y = l && l.allowDataOverflow, x = O || y, _ = se(h) ? this.id : h, P = (n = Q(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, E = P.r, M = E === void 0 ? 3 : E, C = P.strokeWidth, T = C === void 0 ? 2 : C, k = TO(o) ? o : {}, N = k.clipDot, I = N === void 0 ? !0 : N, R = M * 2 + T;
      return /* @__PURE__ */ S.createElement(le, {
        className: w
      }, O || y ? /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: O ? d : d - p / 2,
        y: y ? f : f - m / 2,
        width: O ? p : p * 2,
        height: y ? m : m * 2
      })), !I && /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-dots-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: d - R / 2,
        y: f - R / 2,
        width: p + R,
        height: m + R
      }))) : null, !b && this.renderCurve(x, _), this.renderErrorBar(x, _), (b || o) && this.renderDots(x, I, _), (!v || g) && Dt.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: i.curPoints
      } : n.points !== i.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, i) {
      for (var a = n.length % 2 !== 0 ? [].concat(pn(n), [0]) : n, o = [], s = 0; s < i; ++s)
        o = [].concat(pn(o), pn(a));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, i) {
      var a;
      if (/* @__PURE__ */ S.isValidElement(n))
        a = /* @__PURE__ */ S.cloneElement(n, i);
      else if (ie(n))
        a = n(i);
      else {
        var o = i.key, s = kw(i, LF), u = ue("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        a = /* @__PURE__ */ S.createElement(Ia, qi({
          key: o
        }, s, {
          className: u
        }));
      }
      return a;
    }
  }]);
}(bt);
St(fi, "displayName", "Line");
St(fi, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !wr.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
St(fi, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, i = e.xAxisTicks, a = e.yAxisTicks, o = e.dataKey, s = e.bandSize, u = e.displayedData, c = e.offset, l = t.layout, f = u.map(function(d, p) {
    var m = ke(d, o);
    return l === "horizontal" ? {
      x: zo({
        axis: r,
        ticks: i,
        bandSize: s,
        entry: d,
        index: p
      }),
      y: se(m) ? null : n.scale(m),
      value: m,
      payload: d
    } : {
      x: se(m) ? null : r.scale(m),
      y: zo({
        axis: n,
        ticks: a,
        bandSize: s,
        entry: d,
        index: p
      }),
      value: m,
      payload: d
    };
  });
  return it({
    points: f,
    layout: l
  }, c);
});
var ZF = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], JF = ["key"], CA;
function Xn(e) {
  "@babel/helpers - typeof";
  return Xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xn(e);
}
function MA(e, t) {
  if (e == null) return {};
  var r = QF(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function QF(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function qr() {
  return qr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qr.apply(this, arguments);
}
function Iw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Iw(Object(r), !0).forEach(function(n) {
      It(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Iw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function e8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Rw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kA(n.key), n);
  }
}
function t8(e, t, r) {
  return t && Rw(e.prototype, t), r && Rw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function r8(e, t, r) {
  return t = vs(t), n8(e, jA() ? Reflect.construct(t, r || [], vs(e).constructor) : t.apply(e, r));
}
function n8(e, t) {
  if (t && (Xn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return i8(e);
}
function i8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jA = function() {
    return !!e;
  })();
}
function vs(e) {
  return vs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, vs(e);
}
function a8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lp(e, t);
}
function Lp(e, t) {
  return Lp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Lp(e, t);
}
function It(e, t, r) {
  return t = kA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kA(e) {
  var t = o8(e, "string");
  return Xn(t) == "symbol" ? t : t + "";
}
function o8(e, t) {
  if (Xn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Xn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ur = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    e8(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = r8(this, t, [].concat(i)), It(r, "state", {
      isAnimationFinished: !0
    }), It(r, "id", tn("recharts-area-")), It(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), ie(o) && o();
    }), It(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), ie(o) && o();
    }), r;
  }
  return a8(t, e), t8(t, [{
    key: "renderDots",
    value: function(n, i, a) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var u = this.props, c = u.dot, l = u.points, f = u.dataKey, d = Q(this.props, !1), p = Q(c, !0), m = l.map(function(h, g) {
        var b = pr(pr(pr({
          key: "dot-".concat(g),
          r: 3
        }, d), p), {}, {
          index: g,
          cx: h.x,
          cy: h.y,
          dataKey: f,
          value: h.value,
          payload: h.payload,
          points: l
        });
        return t.renderDotItem(c, b);
      }), v = {
        clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(a, ")") : null
      };
      return /* @__PURE__ */ S.createElement(le, qr({
        className: "recharts-area-dots"
      }, v), m);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var i = this.props, a = i.baseLine, o = i.points, s = i.strokeWidth, u = o[0].x, c = o[o.length - 1].x, l = n * Math.abs(u - c), f = yr(o.map(function(d) {
        return d.y || 0;
      }));
      return U(a) && typeof a == "number" ? f = Math.max(a, f) : a && Array.isArray(a) && a.length && (f = Math.max(yr(a.map(function(d) {
        return d.y || 0;
      })), f)), U(f) ? /* @__PURE__ */ S.createElement("rect", {
        x: u < c ? u : u - l,
        y: 0,
        width: l,
        height: Math.floor(f + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var i = this.props, a = i.baseLine, o = i.points, s = i.strokeWidth, u = o[0].y, c = o[o.length - 1].y, l = n * Math.abs(u - c), f = yr(o.map(function(d) {
        return d.x || 0;
      }));
      return U(a) && typeof a == "number" ? f = Math.max(a, f) : a && Array.isArray(a) && a.length && (f = Math.max(yr(a.map(function(d) {
        return d.x || 0;
      })), f)), U(f) ? /* @__PURE__ */ S.createElement("rect", {
        x: 0,
        y: u < c ? u : u - l,
        width: f + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(l)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var i = this.props.layout;
      return i === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, i, a, o) {
      var s = this.props, u = s.layout, c = s.type, l = s.stroke, f = s.connectNulls, d = s.isRange;
      s.ref;
      var p = MA(s, ZF);
      return /* @__PURE__ */ S.createElement(le, {
        clipPath: a ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ S.createElement(Ur, qr({}, Q(p, !0), {
        points: n,
        connectNulls: f,
        type: c,
        baseLine: i,
        layout: u,
        stroke: "none",
        className: "recharts-area-area"
      })), l !== "none" && /* @__PURE__ */ S.createElement(Ur, qr({}, Q(this.props, !1), {
        className: "recharts-area-curve",
        layout: u,
        type: c,
        connectNulls: f,
        fill: "none",
        points: n
      })), l !== "none" && d && /* @__PURE__ */ S.createElement(Ur, qr({}, Q(this.props, !1), {
        className: "recharts-area-curve",
        layout: u,
        type: c,
        connectNulls: f,
        fill: "none",
        points: i
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, i) {
      var a = this, o = this.props, s = o.points, u = o.baseLine, c = o.isAnimationActive, l = o.animationBegin, f = o.animationDuration, d = o.animationEasing, p = o.animationId, m = this.state, v = m.prevPoints, h = m.prevBaseLine;
      return /* @__PURE__ */ S.createElement(Mt, {
        begin: l,
        duration: f,
        isActive: c,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(g) {
        var b = g.t;
        if (v) {
          var w = v.length / s.length, O = s.map(function(P, E) {
            var M = Math.floor(E * w);
            if (v[M]) {
              var C = v[M], T = Le(C.x, P.x), k = Le(C.y, P.y);
              return pr(pr({}, P), {}, {
                x: T(b),
                y: k(b)
              });
            }
            return P;
          }), y;
          if (U(u) && typeof u == "number") {
            var x = Le(h, u);
            y = x(b);
          } else if (se(u) || ai(u)) {
            var _ = Le(h, 0);
            y = _(b);
          } else
            y = u.map(function(P, E) {
              var M = Math.floor(E * w);
              if (h[M]) {
                var C = h[M], T = Le(C.x, P.x), k = Le(C.y, P.y);
                return pr(pr({}, P), {}, {
                  x: T(b),
                  y: k(b)
                });
              }
              return P;
            });
          return a.renderAreaStatically(O, y, n, i);
        }
        return /* @__PURE__ */ S.createElement(le, null, /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
          id: "animationClipPath-".concat(i)
        }, a.renderClipRect(b))), /* @__PURE__ */ S.createElement(le, {
          clipPath: "url(#animationClipPath-".concat(i, ")")
        }, a.renderAreaStatically(s, u, n, i)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, i) {
      var a = this.props, o = a.points, s = a.baseLine, u = a.isAnimationActive, c = this.state, l = c.prevPoints, f = c.prevBaseLine, d = c.totalLength;
      return u && o && o.length && (!l && d > 0 || !Yr(l, o) || !Yr(f, s)) ? this.renderAreaWithAnimation(n, i) : this.renderAreaStatically(o, s, n, i);
    }
  }, {
    key: "render",
    value: function() {
      var n, i = this.props, a = i.hide, o = i.dot, s = i.points, u = i.className, c = i.top, l = i.left, f = i.xAxis, d = i.yAxis, p = i.width, m = i.height, v = i.isAnimationActive, h = i.id;
      if (a || !s || !s.length)
        return null;
      var g = this.state.isAnimationFinished, b = s.length === 1, w = ue("recharts-area", u), O = f && f.allowDataOverflow, y = d && d.allowDataOverflow, x = O || y, _ = se(h) ? this.id : h, P = (n = Q(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, E = P.r, M = E === void 0 ? 3 : E, C = P.strokeWidth, T = C === void 0 ? 2 : C, k = TO(o) ? o : {}, N = k.clipDot, I = N === void 0 ? !0 : N, R = M * 2 + T;
      return /* @__PURE__ */ S.createElement(le, {
        className: w
      }, O || y ? /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: O ? l : l - p / 2,
        y: y ? c : c - m / 2,
        width: O ? p : p * 2,
        height: y ? m : m * 2
      })), !I && /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-dots-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: l - R / 2,
        y: c - R / 2,
        width: p + R,
        height: m + R
      }))) : null, b ? null : this.renderArea(x, _), (o || b) && this.renderDots(x, I, _), (!v || g) && Dt.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: i.curPoints,
        prevBaseLine: i.curBaseLine
      } : n.points !== i.curPoints || n.baseLine !== i.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(bt);
CA = ur;
It(ur, "displayName", "Area");
It(ur, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !wr.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
It(ur, "getBaseValue", function(e, t, r, n) {
  var i = e.layout, a = e.baseValue, o = t.props.baseValue, s = o ?? a;
  if (U(s) && typeof s == "number")
    return s;
  var u = i === "horizontal" ? n : r, c = u.scale.domain();
  if (u.type === "number") {
    var l = Math.max(c[0], c[1]), f = Math.min(c[0], c[1]);
    return s === "dataMin" ? f : s === "dataMax" || l < 0 ? l : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
It(ur, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, i = e.yAxis, a = e.xAxisTicks, o = e.yAxisTicks, s = e.bandSize, u = e.dataKey, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, p = t.layout, m = c && c.length, v = CA.getBaseValue(t, r, n, i), h = p === "horizontal", g = !1, b = f.map(function(O, y) {
    var x;
    m ? x = c[l + y] : (x = ke(O, u), Array.isArray(x) ? g = !0 : x = [v, x]);
    var _ = x[1] == null || m && ke(O, u) == null;
    return h ? {
      x: zo({
        axis: n,
        ticks: a,
        bandSize: s,
        entry: O,
        index: y
      }),
      y: _ ? null : i.scale(x[1]),
      value: x,
      payload: O
    } : {
      x: _ ? null : n.scale(x[1]),
      y: zo({
        axis: i,
        ticks: o,
        bandSize: s,
        entry: O,
        index: y
      }),
      value: x,
      payload: O
    };
  }), w;
  return m || g ? w = b.map(function(O) {
    var y = Array.isArray(O.value) ? O.value[0] : null;
    return h ? {
      x: O.x,
      y: y != null && O.y != null ? i.scale(y) : null
    } : {
      x: y != null ? n.scale(y) : null,
      y: O.y
    };
  }) : w = h ? i.scale(v) : n.scale(v), pr({
    points: b,
    baseLine: w,
    layout: p,
    isRange: g
  }, d);
});
It(ur, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ S.isValidElement(e))
    r = /* @__PURE__ */ S.cloneElement(e, t);
  else if (ie(e))
    r = e(t);
  else {
    var n = ue("recharts-area-dot", typeof e != "boolean" ? e.className : ""), i = t.key, a = MA(t, JF);
    r = /* @__PURE__ */ S.createElement(Ia, qr({}, a, {
      key: i,
      className: n
    }));
  }
  return r;
});
function Zn(e) {
  "@babel/helpers - typeof";
  return Zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zn(e);
}
function s8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function u8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, IA(n.key), n);
  }
}
function c8(e, t, r) {
  return t && u8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function l8(e, t, r) {
  return t = ys(t), f8(e, $A() ? Reflect.construct(t, r || [], ys(e).constructor) : t.apply(e, r));
}
function f8(e, t) {
  if (t && (Zn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return d8(e);
}
function d8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $A() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($A = function() {
    return !!e;
  })();
}
function ys(e) {
  return ys = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ys(e);
}
function p8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qp(e, t);
}
function qp(e, t) {
  return qp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, qp(e, t);
}
function NA(e, t, r) {
  return t = IA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function IA(e) {
  var t = h8(e, "string");
  return Zn(t) == "symbol" ? t : t + "";
}
function h8(e, t) {
  if (Zn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Zn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Bp() {
  return Bp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bp.apply(this, arguments);
}
function v8(e) {
  var t = e.xAxisId, r = lv(), n = fv(), i = vA(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ K.createElement(li, Bp({}, i, {
      className: ue("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return Zt(o, !0);
      }
    }))
  );
}
var kt = /* @__PURE__ */ function(e) {
  function t() {
    return s8(this, t), l8(this, t, arguments);
  }
  return p8(t, e), c8(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ K.createElement(v8, this.props);
    }
  }]);
}(K.Component);
NA(kt, "displayName", "XAxis");
NA(kt, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Jn(e) {
  "@babel/helpers - typeof";
  return Jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jn(e);
}
function y8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function m8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, LA(n.key), n);
  }
}
function g8(e, t, r) {
  return t && m8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function b8(e, t, r) {
  return t = ms(t), x8(e, RA() ? Reflect.construct(t, r || [], ms(e).constructor) : t.apply(e, r));
}
function x8(e, t) {
  if (t && (Jn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return w8(e);
}
function w8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function RA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (RA = function() {
    return !!e;
  })();
}
function ms(e) {
  return ms = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ms(e);
}
function O8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fp(e, t);
}
function Fp(e, t) {
  return Fp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Fp(e, t);
}
function DA(e, t, r) {
  return t = LA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function LA(e) {
  var t = _8(e, "string");
  return Jn(t) == "symbol" ? t : t + "";
}
function _8(e, t) {
  if (Jn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Jn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function zp() {
  return zp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zp.apply(this, arguments);
}
var S8 = function(t) {
  var r = t.yAxisId, n = lv(), i = fv(), a = yA(r);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ K.createElement(li, zp({}, a, {
      className: ue("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: i
      },
      ticksGenerator: function(s) {
        return Zt(s, !0);
      }
    }))
  );
}, $t = /* @__PURE__ */ function(e) {
  function t() {
    return y8(this, t), b8(this, t, arguments);
  }
  return O8(t, e), g8(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ K.createElement(S8, this.props);
    }
  }]);
}(K.Component);
DA($t, "displayName", "YAxis");
DA($t, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function Dw(e) {
  return E8(e) || T8(e) || P8(e) || A8();
}
function A8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function P8(e, t) {
  if (e) {
    if (typeof e == "string") return Wp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Wp(e, t);
  }
}
function T8(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function E8(e) {
  if (Array.isArray(e)) return Wp(e);
}
function Wp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Up = function(t, r, n, i, a) {
  var o = ct(t, pv), s = ct(t, ru), u = [].concat(Dw(o), Dw(s)), c = ct(t, iu), l = "".concat(i, "Id"), f = i[0], d = r;
  if (u.length && (d = u.reduce(function(v, h) {
    if (h.props[l] === n && Lt(h.props, "extendDomain") && U(h.props[f])) {
      var g = h.props[f];
      return [Math.min(v[0], g), Math.max(v[1], g)];
    }
    return v;
  }, d)), c.length) {
    var p = "".concat(f, "1"), m = "".concat(f, "2");
    d = c.reduce(function(v, h) {
      if (h.props[l] === n && Lt(h.props, "extendDomain") && U(h.props[p]) && U(h.props[m])) {
        var g = h.props[p], b = h.props[m];
        return [Math.min(v[0], g, b), Math.max(v[1], g, b)];
      }
      return v;
    }, d);
  }
  return a && a.length && (d = a.reduce(function(v, h) {
    return U(h) ? [Math.min(v[0], h), Math.max(v[1], h)] : v;
  }, d)), d;
}, yd = { exports: {} }, Lw;
function C8() {
  return Lw || (Lw = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function i(u, c, l) {
      this.fn = u, this.context = c, this.once = l || !1;
    }
    function a(u, c, l, f, d) {
      if (typeof l != "function")
        throw new TypeError("The listener must be a function");
      var p = new i(l, f || u, d), m = r ? r + c : c;
      return u._events[m] ? u._events[m].fn ? u._events[m] = [u._events[m], p] : u._events[m].push(p) : (u._events[m] = p, u._eventsCount++), u;
    }
    function o(u, c) {
      --u._eventsCount === 0 ? u._events = new n() : delete u._events[c];
    }
    function s() {
      this._events = new n(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var c = [], l, f;
      if (this._eventsCount === 0) return c;
      for (f in l = this._events)
        t.call(l, f) && c.push(r ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(l)) : c;
    }, s.prototype.listeners = function(c) {
      var l = r ? r + c : c, f = this._events[l];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var d = 0, p = f.length, m = new Array(p); d < p; d++)
        m[d] = f[d].fn;
      return m;
    }, s.prototype.listenerCount = function(c) {
      var l = r ? r + c : c, f = this._events[l];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(c, l, f, d, p, m) {
      var v = r ? r + c : c;
      if (!this._events[v]) return !1;
      var h = this._events[v], g = arguments.length, b, w;
      if (h.fn) {
        switch (h.once && this.removeListener(c, h.fn, void 0, !0), g) {
          case 1:
            return h.fn.call(h.context), !0;
          case 2:
            return h.fn.call(h.context, l), !0;
          case 3:
            return h.fn.call(h.context, l, f), !0;
          case 4:
            return h.fn.call(h.context, l, f, d), !0;
          case 5:
            return h.fn.call(h.context, l, f, d, p), !0;
          case 6:
            return h.fn.call(h.context, l, f, d, p, m), !0;
        }
        for (w = 1, b = new Array(g - 1); w < g; w++)
          b[w - 1] = arguments[w];
        h.fn.apply(h.context, b);
      } else {
        var O = h.length, y;
        for (w = 0; w < O; w++)
          switch (h[w].once && this.removeListener(c, h[w].fn, void 0, !0), g) {
            case 1:
              h[w].fn.call(h[w].context);
              break;
            case 2:
              h[w].fn.call(h[w].context, l);
              break;
            case 3:
              h[w].fn.call(h[w].context, l, f);
              break;
            case 4:
              h[w].fn.call(h[w].context, l, f, d);
              break;
            default:
              if (!b) for (y = 1, b = new Array(g - 1); y < g; y++)
                b[y - 1] = arguments[y];
              h[w].fn.apply(h[w].context, b);
          }
      }
      return !0;
    }, s.prototype.on = function(c, l, f) {
      return a(this, c, l, f, !1);
    }, s.prototype.once = function(c, l, f) {
      return a(this, c, l, f, !0);
    }, s.prototype.removeListener = function(c, l, f, d) {
      var p = r ? r + c : c;
      if (!this._events[p]) return this;
      if (!l)
        return o(this, p), this;
      var m = this._events[p];
      if (m.fn)
        m.fn === l && (!d || m.once) && (!f || m.context === f) && o(this, p);
      else {
        for (var v = 0, h = [], g = m.length; v < g; v++)
          (m[v].fn !== l || d && !m[v].once || f && m[v].context !== f) && h.push(m[v]);
        h.length ? this._events[p] = h.length === 1 ? h[0] : h : o(this, p);
      }
      return this;
    }, s.prototype.removeAllListeners = function(c) {
      var l;
      return c ? (l = r ? r + c : c, this._events[l] && o(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
  }(yd)), yd.exports;
}
var M8 = C8();
const j8 = /* @__PURE__ */ xe(M8);
var md = new j8(), gd = "recharts.syncMouseEvents";
function Oa(e) {
  "@babel/helpers - typeof";
  return Oa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oa(e);
}
function k8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qA(n.key), n);
  }
}
function N8(e, t, r) {
  return t && $8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bd(e, t, r) {
  return t = qA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qA(e) {
  var t = I8(e, "string");
  return Oa(t) == "symbol" ? t : t + "";
}
function I8(e, t) {
  if (Oa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Oa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var R8 = /* @__PURE__ */ function() {
  function e() {
    k8(this, e), bd(this, "activeIndex", 0), bd(this, "coordinateList", []), bd(this, "layout", "horizontal");
  }
  return N8(e, [{
    key: "setDetails",
    value: function(r) {
      var n, i = r.coordinateList, a = i === void 0 ? null : i, o = r.container, s = o === void 0 ? null : o, u = r.layout, c = u === void 0 ? null : u, l = r.offset, f = l === void 0 ? null : l, d = r.mouseHandlerCallback, p = d === void 0 ? null : d;
      this.coordinateList = (n = a ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), a = i.x, o = i.y, s = i.height, u = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = a + u + c, d = o + this.offset.top + s / 2 + l;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: d
        });
      }
    }
  }]);
}();
function D8(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e?.[0], i = e?.[1];
    if (n && i && U(n) && U(i))
      return !0;
  }
  return !1;
}
function L8(e, t, r, n) {
  var i = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - i,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function BA(e) {
  var t = e.cx, r = e.cy, n = e.radius, i = e.startAngle, a = e.endAngle, o = Ae(t, r, n, i), s = Ae(t, r, n, a);
  return {
    points: [o, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: i,
    endAngle: a
  };
}
function q8(e, t, r) {
  var n, i, a, o;
  if (e === "horizontal")
    n = t.x, a = n, i = r.top, o = r.top + r.height;
  else if (e === "vertical")
    i = t.y, o = i, n = r.left, a = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, u = t.cy, c = t.innerRadius, l = t.outerRadius, f = t.angle, d = Ae(s, u, c, f), p = Ae(s, u, l, f);
      n = d.x, i = d.y, a = p.x, o = p.y;
    } else
      return BA(t);
  return [{
    x: n,
    y: i
  }, {
    x: a,
    y: o
  }];
}
function _a(e) {
  "@babel/helpers - typeof";
  return _a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _a(e);
}
function qw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ao(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qw(Object(r), !0).forEach(function(n) {
      B8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function B8(e, t, r) {
  return t = F8(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function F8(e) {
  var t = z8(e, "string");
  return _a(t) == "symbol" ? t : t + "";
}
function z8(e, t) {
  if (_a(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_a(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function W8(e) {
  var t, r, n = e.element, i = e.tooltipEventType, a = e.isActive, o = e.activeCoordinate, s = e.activePayload, u = e.offset, c = e.activeTooltipIndex, l = e.tooltipAxisBandSize, f = e.layout, d = e.chartName, p = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !p || !a || !o || d !== "ScatterChart" && i !== "axis")
    return null;
  var m, v = Ur;
  if (d === "ScatterChart")
    m = o, v = tL;
  else if (d === "BarChart")
    m = L8(f, o, u, l), v = av;
  else if (f === "radial") {
    var h = BA(o), g = h.cx, b = h.cy, w = h.radius, O = h.startAngle, y = h.endAngle;
    m = {
      cx: g,
      cy: b,
      startAngle: O,
      endAngle: y,
      innerRadius: w,
      outerRadius: w
    }, v = IS;
  } else
    m = {
      points: q8(f, o, u)
    }, v = Ur;
  var x = ao(ao(ao(ao({
    stroke: "#ccc",
    pointerEvents: "none"
  }, u), m), Q(p, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: ue("recharts-tooltip-cursor", p.className)
  });
  return /* @__PURE__ */ Pt(p) ? /* @__PURE__ */ De(p, x) : /* @__PURE__ */ Bi(v, x);
}
var U8 = ["item"], G8 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Qn(e) {
  "@babel/helpers - typeof";
  return Qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qn(e);
}
function gn() {
  return gn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gn.apply(this, arguments);
}
function Bw(e, t) {
  return K8(e) || V8(e, t) || zA(e, t) || H8();
}
function H8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function V8(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], u = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); u = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!u && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function K8(e) {
  if (Array.isArray(e)) return e;
}
function Fw(e, t) {
  if (e == null) return {};
  var r = Y8(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Y8(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function X8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Z8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WA(n.key), n);
  }
}
function J8(e, t, r) {
  return t && Z8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Q8(e, t, r) {
  return t = gs(t), ez(e, FA() ? Reflect.construct(t, r || [], gs(e).constructor) : t.apply(e, r));
}
function ez(e, t) {
  if (t && (Qn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return tz(e);
}
function tz(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (FA = function() {
    return !!e;
  })();
}
function gs(e) {
  return gs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gs(e);
}
function rz(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Gp(e, t);
}
function Gp(e, t) {
  return Gp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Gp(e, t);
}
function ei(e) {
  return az(e) || iz(e) || zA(e) || nz();
}
function nz() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zA(e, t) {
  if (e) {
    if (typeof e == "string") return Hp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hp(e, t);
  }
}
function iz(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function az(e) {
  if (Array.isArray(e)) return Hp(e);
}
function Hp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function zw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function D(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zw(Object(r), !0).forEach(function(n) {
      ne(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ne(e, t, r) {
  return t = WA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WA(e) {
  var t = oz(e, "string");
  return Qn(t) == "symbol" ? t : t + "";
}
function oz(e, t) {
  if (Qn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Qn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var sz = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, uz = {
  width: "100%",
  height: "100%"
}, UA = {
  x: 0,
  y: 0
};
function oo(e) {
  return e;
}
var cz = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, lz = function(t, r, n, i) {
  var a = r.find(function(l) {
    return l && l.index === n;
  });
  if (a) {
    if (t === "horizontal")
      return {
        x: a.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: a.coordinate
      };
    if (t === "centric") {
      var o = a.coordinate, s = i.radius;
      return D(D(D({}, i), Ae(i.cx, i.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var u = a.coordinate, c = i.angle;
    return D(D(D({}, i), Ae(i.cx, i.cy, u, c)), {}, {
      angle: c,
      radius: u
    });
  }
  return UA;
}, au = function(t, r) {
  var n = r.graphicalItems, i = r.dataStartIndex, a = r.dataEndIndex, o = (n ?? []).reduce(function(s, u) {
    var c = u.props.data;
    return c && c.length ? [].concat(ei(s), ei(c)) : s;
  }, []);
  return o.length > 0 ? o : t && t.length && U(i) && U(a) ? t.slice(i, a + 1) : [];
};
function GA(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Vp = function(t, r, n, i) {
  var a = t.graphicalItems, o = t.tooltipAxis, s = au(r, t);
  return n < 0 || !a || !a.length || n >= s.length ? null : a.reduce(function(u, c) {
    var l, f = (l = c.props.data) !== null && l !== void 0 ? l : r;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var d;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var p = f === void 0 ? s : f;
      d = yo(p, o.dataKey, i);
    } else
      d = f && f[n] || s[n];
    return d ? [].concat(ei(u), [CS(c, d)]) : u;
  }, []);
}, Ww = function(t, r, n, i) {
  var a = i || {
    x: t.chartX,
    y: t.chartY
  }, o = cz(a, n), s = t.orderedTooltipTicks, u = t.tooltipAxis, c = t.tooltipTicks, l = m2(o, s, c, u);
  if (l >= 0 && c) {
    var f = c[l] && c[l].value, d = Vp(t, r, l, f), p = lz(n, s, l, a);
    return {
      activeTooltipIndex: l,
      activeLabel: f,
      activePayload: d,
      activeCoordinate: p
    };
  }
  return null;
}, fz = function(t, r) {
  var n = r.axes, i = r.graphicalItems, a = r.axisType, o = r.axisIdKey, s = r.stackGroups, u = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = t.stackOffset, p = _S(l, a);
  return n.reduce(function(m, v) {
    var h, g = v.type.defaultProps !== void 0 ? D(D({}, v.type.defaultProps), v.props) : v.props, b = g.type, w = g.dataKey, O = g.allowDataOverflow, y = g.allowDuplicatedCategory, x = g.scale, _ = g.ticks, P = g.includeHidden, E = g[o];
    if (m[E])
      return m;
    var M = au(t.data, {
      graphicalItems: i.filter(function(B) {
        var V, X = o in B.props ? B.props[o] : (V = B.type.defaultProps) === null || V === void 0 ? void 0 : V[o];
        return X === E;
      }),
      dataStartIndex: u,
      dataEndIndex: c
    }), C = M.length, T, k, N;
    D8(g.domain, O, b) && (T = op(g.domain, null, O), p && (b === "number" || x !== "auto") && (N = Ii(M, w, "category")));
    var I = GA(b);
    if (!T || T.length === 0) {
      var R, q = (R = g.domain) !== null && R !== void 0 ? R : I;
      if (w) {
        if (T = Ii(M, w, b), b === "category" && p) {
          var W = l3(T);
          y && W ? (k = T, T = ns(0, C)) : y || (T = R0(q, T, v).reduce(function(B, V) {
            return B.indexOf(V) >= 0 ? B : [].concat(ei(B), [V]);
          }, []));
        } else if (b === "category")
          y ? T = T.filter(function(B) {
            return B !== "" && !se(B);
          }) : T = R0(q, T, v).reduce(function(B, V) {
            return B.indexOf(V) >= 0 || V === "" || se(V) ? B : [].concat(ei(B), [V]);
          }, []);
        else if (b === "number") {
          var H = O2(M, i.filter(function(B) {
            var V, X, te = o in B.props ? B.props[o] : (V = B.type.defaultProps) === null || V === void 0 ? void 0 : V[o], re = "hide" in B.props ? B.props.hide : (X = B.type.defaultProps) === null || X === void 0 ? void 0 : X.hide;
            return te === E && (P || !re);
          }), w, a, l);
          H && (T = H);
        }
        p && (b === "number" || x !== "auto") && (N = Ii(M, w, "category"));
      } else p ? T = ns(0, C) : s && s[E] && s[E].hasStack && b === "number" ? T = d === "expand" ? [0, 1] : ES(s[E].stackGroups, u, c) : T = OS(M, i.filter(function(B) {
        var V = o in B.props ? B.props[o] : B.type.defaultProps[o], X = "hide" in B.props ? B.props.hide : B.type.defaultProps.hide;
        return V === E && (P || !X);
      }), b, l, !0);
      if (b === "number")
        T = Up(f, T, E, a, _), q && (T = op(q, T, O));
      else if (b === "category" && q) {
        var $ = q, L = T.every(function(B) {
          return $.indexOf(B) >= 0;
        });
        L && (T = $);
      }
    }
    return D(D({}, m), {}, ne({}, E, D(D({}, g), {}, {
      axisType: a,
      domain: T,
      categoricalDomain: N,
      duplicateDomain: k,
      originalDomain: (h = g.domain) !== null && h !== void 0 ? h : I,
      isCategorical: p,
      layout: l
    })));
  }, {});
}, dz = function(t, r) {
  var n = r.graphicalItems, i = r.Axis, a = r.axisType, o = r.axisIdKey, s = r.stackGroups, u = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = au(t.data, {
    graphicalItems: n,
    dataStartIndex: u,
    dataEndIndex: c
  }), p = d.length, m = _S(l, a), v = -1;
  return n.reduce(function(h, g) {
    var b = g.type.defaultProps !== void 0 ? D(D({}, g.type.defaultProps), g.props) : g.props, w = b[o], O = GA("number");
    if (!h[w]) {
      v++;
      var y;
      return m ? y = ns(0, p) : s && s[w] && s[w].hasStack ? (y = ES(s[w].stackGroups, u, c), y = Up(f, y, w, a)) : (y = op(O, OS(d, n.filter(function(x) {
        var _, P, E = o in x.props ? x.props[o] : (_ = x.type.defaultProps) === null || _ === void 0 ? void 0 : _[o], M = "hide" in x.props ? x.props.hide : (P = x.type.defaultProps) === null || P === void 0 ? void 0 : P.hide;
        return E === w && !M;
      }), "number", l), i.defaultProps.allowDataOverflow), y = Up(f, y, w, a)), D(D({}, h), {}, ne({}, w, D(D({
        axisType: a
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: ut(sz, "".concat(a, ".").concat(v % 2), null),
        domain: y,
        originalDomain: O,
        isCategorical: m,
        layout: l
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return h;
  }, {});
}, pz = function(t, r) {
  var n = r.axisType, i = n === void 0 ? "xAxis" : n, a = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, u = r.dataStartIndex, c = r.dataEndIndex, l = t.children, f = "".concat(i, "Id"), d = ct(l, a), p = {};
  return d && d.length ? p = fz(t, {
    axes: d,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: u,
    dataEndIndex: c
  }) : o && o.length && (p = dz(t, {
    Axis: a,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: u,
    dataEndIndex: c
  })), p;
}, hz = function(t) {
  var r = vr(t), n = Zt(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: jh(n, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Wo(r, n)
  };
}, Uw = function(t) {
  var r = t.children, n = t.defaultShowTooltip, i = ot(r, zn), a = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (a = i.props.startIndex), i.props.endIndex >= 0 && (o = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: a,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, vz = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Jt(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, Gw = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, yz = function(t, r) {
  var n = t.props, i = t.graphicalItems, a = t.xAxisMap, o = a === void 0 ? {} : a, s = t.yAxisMap, u = s === void 0 ? {} : s, c = n.width, l = n.height, f = n.children, d = n.margin || {}, p = ot(f, zn), m = ot(f, On), v = Object.keys(u).reduce(function(y, x) {
    var _ = u[x], P = _.orientation;
    return !_.mirror && !_.hide ? D(D({}, y), {}, ne({}, P, y[P] + _.width)) : y;
  }, {
    left: d.left || 0,
    right: d.right || 0
  }), h = Object.keys(o).reduce(function(y, x) {
    var _ = o[x], P = _.orientation;
    return !_.mirror && !_.hide ? D(D({}, y), {}, ne({}, P, ut(y, "".concat(P)) + _.height)) : y;
  }, {
    top: d.top || 0,
    bottom: d.bottom || 0
  }), g = D(D({}, h), v), b = g.bottom;
  p && (g.bottom += p.props.height || zn.defaultProps.height), m && r && (g = x2(g, i, n, r));
  var w = c - g.left - g.right, O = l - g.top - g.bottom;
  return D(D({
    brushBottom: b
  }, g), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(O, 0)
  });
}, mz = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, ou = function(t) {
  var r = t.chartName, n = t.GraphicalChild, i = t.defaultTooltipEventType, a = i === void 0 ? "axis" : i, o = t.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, u = t.axisComponents, c = t.legendContent, l = t.formatAxisMap, f = t.defaultProps, d = function(g, b) {
    var w = b.graphicalItems, O = b.stackGroups, y = b.offset, x = b.updateId, _ = b.dataStartIndex, P = b.dataEndIndex, E = g.barSize, M = g.layout, C = g.barGap, T = g.barCategoryGap, k = g.maxBarSize, N = Gw(M), I = N.numericAxisName, R = N.cateAxisName, q = vz(w), W = [];
    return w.forEach(function(H, $) {
      var L = au(g.data, {
        graphicalItems: [H],
        dataStartIndex: _,
        dataEndIndex: P
      }), B = H.type.defaultProps !== void 0 ? D(D({}, H.type.defaultProps), H.props) : H.props, V = B.dataKey, X = B.maxBarSize, te = B["".concat(I, "Id")], re = B["".concat(R, "Id")], oe = {}, ae = u.reduce(function(Pr, zt) {
        var su, uu, cu = b["".concat(zt.axisType, "Map")], mv = B["".concat(zt.axisType, "Id")];
        cu && cu[mv] || zt.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? tt(!1, "Specifying a(n) ".concat(zt.axisType, "Id requires a corresponding ").concat(
          zt.axisType,
          "Id on the targeted graphical component "
        ).concat((su = H == null || (uu = H.type) === null || uu === void 0 ? void 0 : uu.displayName) !== null && su !== void 0 ? su : "")) : tt());
        var gv = cu[mv];
        return D(D({}, Pr), {}, ne(ne({}, zt.axisType, gv), "".concat(zt.axisType, "Ticks"), Zt(gv)));
      }, oe), F = ae[R], Y = ae["".concat(R, "Ticks")], ee = O && O[te] && O[te].hasStack && j2(H, O[te].stackGroups), j = Jt(H.type).indexOf("Bar") >= 0, fe = Wo(F, Y), G = [], Oe = q && g2({
        barSize: E,
        stackGroups: O,
        totalSize: mz(ae, R)
      });
      if (j) {
        var Ee, Ue, cr = se(X) ? k : X, un = (Ee = (Ue = Wo(F, Y, !0)) !== null && Ue !== void 0 ? Ue : cr) !== null && Ee !== void 0 ? Ee : 0;
        G = b2({
          barGap: C,
          barCategoryGap: T,
          bandSize: un !== fe ? un : fe,
          sizeList: Oe[re],
          maxBarSize: cr
        }), un !== fe && (G = G.map(function(Pr) {
          return D(D({}, Pr), {}, {
            position: D(D({}, Pr.position), {}, {
              offset: Pr.position.offset - un / 2
            })
          });
        }));
      }
      var Da = H && H.type && H.type.getComposedData;
      Da && W.push({
        props: D(D({}, Da(D(D({}, ae), {}, {
          displayedData: L,
          props: g,
          dataKey: V,
          item: H,
          bandSize: fe,
          barPosition: G,
          offset: y,
          stackedData: ee,
          layout: M,
          dataStartIndex: _,
          dataEndIndex: P
        }))), {}, ne(ne(ne({
          key: H.key || "item-".concat($)
        }, I, ae[I]), R, ae[R]), "animationId", x)),
        childIndex: O3(H, g.children),
        item: H
      });
    }), W;
  }, p = function(g, b) {
    var w = g.props, O = g.dataStartIndex, y = g.dataEndIndex, x = g.updateId;
    if (!Zy({
      props: w
    }))
      return null;
    var _ = w.children, P = w.layout, E = w.stackOffset, M = w.data, C = w.reverseStackOrder, T = Gw(P), k = T.numericAxisName, N = T.cateAxisName, I = ct(_, n), R = C2(M, I, "".concat(k, "Id"), "".concat(N, "Id"), E, C), q = u.reduce(function(B, V) {
      var X = "".concat(V.axisType, "Map");
      return D(D({}, B), {}, ne({}, X, pz(w, D(D({}, V), {}, {
        graphicalItems: I,
        stackGroups: V.axisType === k && R,
        dataStartIndex: O,
        dataEndIndex: y
      }))));
    }, {}), W = yz(D(D({}, q), {}, {
      props: w,
      graphicalItems: I
    }), b?.legendBBox);
    Object.keys(q).forEach(function(B) {
      q[B] = l(w, q[B], W, B.replace("Map", ""), r);
    });
    var H = q["".concat(N, "Map")], $ = hz(H), L = d(w, D(D({}, q), {}, {
      dataStartIndex: O,
      dataEndIndex: y,
      updateId: x,
      graphicalItems: I,
      stackGroups: R,
      offset: W
    }));
    return D(D({
      formattedGraphicalItems: L,
      graphicalItems: I,
      offset: W,
      stackGroups: R
    }, $), q);
  }, m = /* @__PURE__ */ function(h) {
    function g(b) {
      var w, O, y;
      return X8(this, g), y = Q8(this, g, [b]), ne(y, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), ne(y, "accessibilityManager", new R8()), ne(y, "handleLegendBBoxUpdate", function(x) {
        if (x) {
          var _ = y.state, P = _.dataStartIndex, E = _.dataEndIndex, M = _.updateId;
          y.setState(D({
            legendBBox: x
          }, p({
            props: y.props,
            dataStartIndex: P,
            dataEndIndex: E,
            updateId: M
          }, D(D({}, y.state), {}, {
            legendBBox: x
          }))));
        }
      }), ne(y, "handleReceiveSyncEvent", function(x, _, P) {
        if (y.props.syncId === x) {
          if (P === y.eventEmitterSymbol && typeof y.props.syncMethod != "function")
            return;
          y.applySyncEvent(_);
        }
      }), ne(y, "handleBrushChange", function(x) {
        var _ = x.startIndex, P = x.endIndex;
        if (_ !== y.state.dataStartIndex || P !== y.state.dataEndIndex) {
          var E = y.state.updateId;
          y.setState(function() {
            return D({
              dataStartIndex: _,
              dataEndIndex: P
            }, p({
              props: y.props,
              dataStartIndex: _,
              dataEndIndex: P,
              updateId: E
            }, y.state));
          }), y.triggerSyncEvent({
            dataStartIndex: _,
            dataEndIndex: P
          });
        }
      }), ne(y, "handleMouseEnter", function(x) {
        var _ = y.getMouseInfo(x);
        if (_) {
          var P = D(D({}, _), {}, {
            isTooltipActive: !0
          });
          y.setState(P), y.triggerSyncEvent(P);
          var E = y.props.onMouseEnter;
          ie(E) && E(P, x);
        }
      }), ne(y, "triggeredAfterMouseMove", function(x) {
        var _ = y.getMouseInfo(x), P = _ ? D(D({}, _), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        y.setState(P), y.triggerSyncEvent(P);
        var E = y.props.onMouseMove;
        ie(E) && E(P, x);
      }), ne(y, "handleItemMouseEnter", function(x) {
        y.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: x,
            activePayload: x.tooltipPayload,
            activeCoordinate: x.tooltipPosition || {
              x: x.cx,
              y: x.cy
            }
          };
        });
      }), ne(y, "handleItemMouseLeave", function() {
        y.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), ne(y, "handleMouseMove", function(x) {
        x.persist(), y.throttleTriggeredAfterMouseMove(x);
      }), ne(y, "handleMouseLeave", function(x) {
        y.throttleTriggeredAfterMouseMove.cancel();
        var _ = {
          isTooltipActive: !1
        };
        y.setState(_), y.triggerSyncEvent(_);
        var P = y.props.onMouseLeave;
        ie(P) && P(_, x);
      }), ne(y, "handleOuterEvent", function(x) {
        var _ = w3(x), P = ut(y.props, "".concat(_));
        if (_ && ie(P)) {
          var E, M;
          /.*touch.*/i.test(_) ? M = y.getMouseInfo(x.changedTouches[0]) : M = y.getMouseInfo(x), P((E = M) !== null && E !== void 0 ? E : {}, x);
        }
      }), ne(y, "handleClick", function(x) {
        var _ = y.getMouseInfo(x);
        if (_) {
          var P = D(D({}, _), {}, {
            isTooltipActive: !0
          });
          y.setState(P), y.triggerSyncEvent(P);
          var E = y.props.onClick;
          ie(E) && E(P, x);
        }
      }), ne(y, "handleMouseDown", function(x) {
        var _ = y.props.onMouseDown;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "handleMouseUp", function(x) {
        var _ = y.props.onMouseUp;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "handleTouchMove", function(x) {
        x.changedTouches != null && x.changedTouches.length > 0 && y.throttleTriggeredAfterMouseMove(x.changedTouches[0]);
      }), ne(y, "handleTouchStart", function(x) {
        x.changedTouches != null && x.changedTouches.length > 0 && y.handleMouseDown(x.changedTouches[0]);
      }), ne(y, "handleTouchEnd", function(x) {
        x.changedTouches != null && x.changedTouches.length > 0 && y.handleMouseUp(x.changedTouches[0]);
      }), ne(y, "handleDoubleClick", function(x) {
        var _ = y.props.onDoubleClick;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "handleContextMenu", function(x) {
        var _ = y.props.onContextMenu;
        if (ie(_)) {
          var P = y.getMouseInfo(x);
          _(P, x);
        }
      }), ne(y, "triggerSyncEvent", function(x) {
        y.props.syncId !== void 0 && md.emit(gd, y.props.syncId, x, y.eventEmitterSymbol);
      }), ne(y, "applySyncEvent", function(x) {
        var _ = y.props, P = _.layout, E = _.syncMethod, M = y.state.updateId, C = x.dataStartIndex, T = x.dataEndIndex;
        if (x.dataStartIndex !== void 0 || x.dataEndIndex !== void 0)
          y.setState(D({
            dataStartIndex: C,
            dataEndIndex: T
          }, p({
            props: y.props,
            dataStartIndex: C,
            dataEndIndex: T,
            updateId: M
          }, y.state)));
        else if (x.activeTooltipIndex !== void 0) {
          var k = x.chartX, N = x.chartY, I = x.activeTooltipIndex, R = y.state, q = R.offset, W = R.tooltipTicks;
          if (!q)
            return;
          if (typeof E == "function")
            I = E(W, x);
          else if (E === "value") {
            I = -1;
            for (var H = 0; H < W.length; H++)
              if (W[H].value === x.activeLabel) {
                I = H;
                break;
              }
          }
          var $ = D(D({}, q), {}, {
            x: q.left,
            y: q.top
          }), L = Math.min(k, $.x + $.width), B = Math.min(N, $.y + $.height), V = W[I] && W[I].value, X = Vp(y.state, y.props.data, I), te = W[I] ? {
            x: P === "horizontal" ? W[I].coordinate : L,
            y: P === "horizontal" ? B : W[I].coordinate
          } : UA;
          y.setState(D(D({}, x), {}, {
            activeLabel: V,
            activeCoordinate: te,
            activePayload: X,
            activeTooltipIndex: I
          }));
        } else
          y.setState(x);
      }), ne(y, "renderCursor", function(x) {
        var _, P = y.state, E = P.isTooltipActive, M = P.activeCoordinate, C = P.activePayload, T = P.offset, k = P.activeTooltipIndex, N = P.tooltipAxisBandSize, I = y.getTooltipEventType(), R = (_ = x.props.active) !== null && _ !== void 0 ? _ : E, q = y.props.layout, W = x.key || "_recharts-cursor";
        return /* @__PURE__ */ S.createElement(W8, {
          key: W,
          activeCoordinate: M,
          activePayload: C,
          activeTooltipIndex: k,
          chartName: r,
          element: x,
          isActive: R,
          layout: q,
          offset: T,
          tooltipAxisBandSize: N,
          tooltipEventType: I
        });
      }), ne(y, "renderPolarAxis", function(x, _, P) {
        var E = ut(x, "type.axisType"), M = ut(y.state, "".concat(E, "Map")), C = x.type.defaultProps, T = C !== void 0 ? D(D({}, C), x.props) : x.props, k = M && M[T["".concat(E, "Id")]];
        return /* @__PURE__ */ De(x, D(D({}, k), {}, {
          className: ue(E, k.className),
          key: x.key || "".concat(_, "-").concat(P),
          ticks: Zt(k, !0)
        }));
      }), ne(y, "renderPolarGrid", function(x) {
        var _ = x.props, P = _.radialLines, E = _.polarAngles, M = _.polarRadius, C = y.state, T = C.radiusAxisMap, k = C.angleAxisMap, N = vr(T), I = vr(k), R = I.cx, q = I.cy, W = I.innerRadius, H = I.outerRadius;
        return /* @__PURE__ */ De(x, {
          polarAngles: Array.isArray(E) ? E : Zt(I, !0).map(function($) {
            return $.coordinate;
          }),
          polarRadius: Array.isArray(M) ? M : Zt(N, !0).map(function($) {
            return $.coordinate;
          }),
          cx: R,
          cy: q,
          innerRadius: W,
          outerRadius: H,
          key: x.key || "polar-grid",
          radialLines: P
        });
      }), ne(y, "renderLegend", function() {
        var x = y.state.formattedGraphicalItems, _ = y.props, P = _.children, E = _.width, M = _.height, C = y.props.margin || {}, T = E - (C.left || 0) - (C.right || 0), k = xS({
          children: P,
          formattedGraphicalItems: x,
          legendWidth: T,
          legendContent: c
        });
        if (!k)
          return null;
        var N = k.item, I = Fw(k, U8);
        return /* @__PURE__ */ De(N, D(D({}, I), {}, {
          chartWidth: E,
          chartHeight: M,
          margin: C,
          onBBoxUpdate: y.handleLegendBBoxUpdate
        }));
      }), ne(y, "renderTooltip", function() {
        var x, _ = y.props, P = _.children, E = _.accessibilityLayer, M = ot(P, Ve);
        if (!M)
          return null;
        var C = y.state, T = C.isTooltipActive, k = C.activeCoordinate, N = C.activePayload, I = C.activeLabel, R = C.offset, q = (x = M.props.active) !== null && x !== void 0 ? x : T;
        return /* @__PURE__ */ De(M, {
          viewBox: D(D({}, R), {}, {
            x: R.left,
            y: R.top
          }),
          active: q,
          label: I,
          payload: q ? N : [],
          coordinate: k,
          accessibilityLayer: E
        });
      }), ne(y, "renderBrush", function(x) {
        var _ = y.props, P = _.margin, E = _.data, M = y.state, C = M.offset, T = M.dataStartIndex, k = M.dataEndIndex, N = M.updateId;
        return /* @__PURE__ */ De(x, {
          key: x.key || "_recharts-brush",
          onChange: Qa(y.handleBrushChange, x.props.onChange),
          data: E,
          x: U(x.props.x) ? x.props.x : C.left,
          y: U(x.props.y) ? x.props.y : C.top + C.height + C.brushBottom - (P.bottom || 0),
          width: U(x.props.width) ? x.props.width : C.width,
          startIndex: T,
          endIndex: k,
          updateId: "brush-".concat(N)
        });
      }), ne(y, "renderReferenceElement", function(x, _, P) {
        if (!x)
          return null;
        var E = y, M = E.clipPathId, C = y.state, T = C.xAxisMap, k = C.yAxisMap, N = C.offset, I = x.type.defaultProps || {}, R = x.props, q = R.xAxisId, W = q === void 0 ? I.xAxisId : q, H = R.yAxisId, $ = H === void 0 ? I.yAxisId : H;
        return /* @__PURE__ */ De(x, {
          key: x.key || "".concat(_, "-").concat(P),
          xAxis: T[W],
          yAxis: k[$],
          viewBox: {
            x: N.left,
            y: N.top,
            width: N.width,
            height: N.height
          },
          clipPathId: M
        });
      }), ne(y, "renderActivePoints", function(x) {
        var _ = x.item, P = x.activePoint, E = x.basePoint, M = x.childIndex, C = x.isRange, T = [], k = _.props.key, N = _.item.type.defaultProps !== void 0 ? D(D({}, _.item.type.defaultProps), _.item.props) : _.item.props, I = N.activeDot, R = N.dataKey, q = D(D({
          index: M,
          dataKey: R,
          cx: P.x,
          cy: P.y,
          r: 4,
          fill: nv(_.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: P.payload,
          value: P.value
        }, Q(I, !1)), mo(I));
        return T.push(g.renderActiveDot(I, q, "".concat(k, "-activePoint-").concat(M))), E ? T.push(g.renderActiveDot(I, D(D({}, q), {}, {
          cx: E.x,
          cy: E.y
        }), "".concat(k, "-basePoint-").concat(M))) : C && T.push(null), T;
      }), ne(y, "renderGraphicChild", function(x, _, P) {
        var E = y.filterFormatItem(x, _, P);
        if (!E)
          return null;
        var M = y.getTooltipEventType(), C = y.state, T = C.isTooltipActive, k = C.tooltipAxis, N = C.activeTooltipIndex, I = C.activeLabel, R = y.props.children, q = ot(R, Ve), W = E.props, H = W.points, $ = W.isRange, L = W.baseLine, B = E.item.type.defaultProps !== void 0 ? D(D({}, E.item.type.defaultProps), E.item.props) : E.item.props, V = B.activeDot, X = B.hide, te = B.activeBar, re = B.activeShape, oe = !!(!X && T && q && (V || te || re)), ae = {};
        M !== "axis" && q && q.props.trigger === "click" ? ae = {
          onClick: Qa(y.handleItemMouseEnter, x.props.onClick)
        } : M !== "axis" && (ae = {
          onMouseLeave: Qa(y.handleItemMouseLeave, x.props.onMouseLeave),
          onMouseEnter: Qa(y.handleItemMouseEnter, x.props.onMouseEnter)
        });
        var F = /* @__PURE__ */ De(x, D(D({}, E.props), ae));
        function Y(zt) {
          return typeof k.dataKey == "function" ? k.dataKey(zt.payload) : null;
        }
        if (oe)
          if (N >= 0) {
            var ee, j;
            if (k.dataKey && !k.allowDuplicatedCategory) {
              var fe = typeof k.dataKey == "function" ? Y : "payload.".concat(k.dataKey.toString());
              ee = yo(H, fe, I), j = $ && L && yo(L, fe, I);
            } else
              ee = H?.[N], j = $ && L && L[N];
            if (re || te) {
              var G = x.props.activeIndex !== void 0 ? x.props.activeIndex : N;
              return [/* @__PURE__ */ De(x, D(D(D({}, E.props), ae), {}, {
                activeIndex: G
              })), null, null];
            }
            if (!se(ee))
              return [F].concat(ei(y.renderActivePoints({
                item: E,
                activePoint: ee,
                basePoint: j,
                childIndex: N,
                isRange: $
              })));
          } else {
            var Oe, Ee = (Oe = y.getItemByXY(y.state.activeCoordinate)) !== null && Oe !== void 0 ? Oe : {
              graphicalItem: F
            }, Ue = Ee.graphicalItem, cr = Ue.item, un = cr === void 0 ? x : cr, Da = Ue.childIndex, Pr = D(D(D({}, E.props), ae), {}, {
              activeIndex: Da
            });
            return [/* @__PURE__ */ De(un, Pr), null, null];
          }
        return $ ? [F, null, null] : [F, null];
      }), ne(y, "renderCustomized", function(x, _, P) {
        return /* @__PURE__ */ De(x, D(D({
          key: "recharts-customized-".concat(P)
        }, y.props), y.state));
      }), ne(y, "renderMap", {
        CartesianGrid: {
          handler: oo,
          once: !0
        },
        ReferenceArea: {
          handler: y.renderReferenceElement
        },
        ReferenceLine: {
          handler: oo
        },
        ReferenceDot: {
          handler: y.renderReferenceElement
        },
        XAxis: {
          handler: oo
        },
        YAxis: {
          handler: oo
        },
        Brush: {
          handler: y.renderBrush,
          once: !0
        },
        Bar: {
          handler: y.renderGraphicChild
        },
        Line: {
          handler: y.renderGraphicChild
        },
        Area: {
          handler: y.renderGraphicChild
        },
        Radar: {
          handler: y.renderGraphicChild
        },
        RadialBar: {
          handler: y.renderGraphicChild
        },
        Scatter: {
          handler: y.renderGraphicChild
        },
        Pie: {
          handler: y.renderGraphicChild
        },
        Funnel: {
          handler: y.renderGraphicChild
        },
        Tooltip: {
          handler: y.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: y.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: y.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: y.renderPolarAxis
        },
        Customized: {
          handler: y.renderCustomized
        }
      }), y.clipPathId = "".concat((w = b.id) !== null && w !== void 0 ? w : tn("recharts"), "-clip"), y.throttleTriggeredAfterMouseMove = x_(y.triggeredAfterMouseMove, (O = b.throttleDelay) !== null && O !== void 0 ? O : 1e3 / 60), y.state = {}, y;
    }
    return rz(g, h), J8(g, [{
      key: "componentDidMount",
      value: function() {
        var w, O;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
            top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var w = this.props, O = w.children, y = w.data, x = w.height, _ = w.layout, P = ot(O, Ve);
        if (P) {
          var E = P.props.defaultIndex;
          if (!(typeof E != "number" || E < 0 || E > this.state.tooltipTicks.length - 1)) {
            var M = this.state.tooltipTicks[E] && this.state.tooltipTicks[E].value, C = Vp(this.state, y, E, M), T = this.state.tooltipTicks[E].coordinate, k = (this.state.offset.top + x) / 2, N = _ === "horizontal", I = N ? {
              x: T,
              y: k
            } : {
              y: T,
              x: k
            }, R = this.state.formattedGraphicalItems.find(function(W) {
              var H = W.item;
              return H.type.name === "Scatter";
            });
            R && (I = D(D({}, I), R.props.points[E].tooltipPosition), C = R.props.points[E].tooltipPayload);
            var q = {
              activeTooltipIndex: E,
              isTooltipActive: !0,
              activeLabel: M,
              activePayload: C,
              activeCoordinate: I
            };
            this.setState(q), this.renderCursor(P), this.accessibilityManager.setIndex(E);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(w, O) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== O.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== w.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== w.margin) {
          var y, x;
          this.accessibilityManager.setDetails({
            offset: {
              left: (y = this.props.margin.left) !== null && y !== void 0 ? y : 0,
              top: (x = this.props.margin.top) !== null && x !== void 0 ? x : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(w) {
        Ed([ot(w.children, Ve)], [ot(this.props.children, Ve)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var w = ot(this.props.children, Ve);
        if (w && typeof w.props.shared == "boolean") {
          var O = w.props.shared ? "axis" : "item";
          return s.indexOf(O) >= 0 ? O : a;
        }
        return a;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(w) {
        if (!this.container)
          return null;
        var O = this.container, y = O.getBoundingClientRect(), x = ck(y), _ = {
          chartX: Math.round(w.pageX - x.left),
          chartY: Math.round(w.pageY - x.top)
        }, P = y.width / O.offsetWidth || 1, E = this.inRange(_.chartX, _.chartY, P);
        if (!E)
          return null;
        var M = this.state, C = M.xAxisMap, T = M.yAxisMap, k = this.getTooltipEventType(), N = Ww(this.state, this.props.data, this.props.layout, E);
        if (k !== "axis" && C && T) {
          var I = vr(C).scale, R = vr(T).scale, q = I && I.invert ? I.invert(_.chartX) : null, W = R && R.invert ? R.invert(_.chartY) : null;
          return D(D({}, _), {}, {
            xValue: q,
            yValue: W
          }, N);
        }
        return N ? D(D({}, _), N) : null;
      }
    }, {
      key: "inRange",
      value: function(w, O) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, x = this.props.layout, _ = w / y, P = O / y;
        if (x === "horizontal" || x === "vertical") {
          var E = this.state.offset, M = _ >= E.left && _ <= E.left + E.width && P >= E.top && P <= E.top + E.height;
          return M ? {
            x: _,
            y: P
          } : null;
        }
        var C = this.state, T = C.angleAxisMap, k = C.radiusAxisMap;
        if (T && k) {
          var N = vr(T);
          return q0({
            x: _,
            y: P
          }, N);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var w = this.props.children, O = this.getTooltipEventType(), y = ot(w, Ve), x = {};
        y && O === "axis" && (y.props.trigger === "click" ? x = {
          onClick: this.handleClick
        } : x = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var _ = mo(this.props, this.handleOuterEvent);
        return D(D({}, _), x);
      }
    }, {
      key: "addListener",
      value: function() {
        md.on(gd, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        md.removeListener(gd, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(w, O, y) {
        for (var x = this.state.formattedGraphicalItems, _ = 0, P = x.length; _ < P; _++) {
          var E = x[_];
          if (E.item === w || E.props.key === w.key || O === Jt(E.item.type) && y === E.childIndex)
            return E;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var w = this.clipPathId, O = this.state.offset, y = O.left, x = O.top, _ = O.height, P = O.width;
        return /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
          id: w
        }, /* @__PURE__ */ S.createElement("rect", {
          x: y,
          y: x,
          height: _,
          width: P
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var w = this.state.xAxisMap;
        return w ? Object.entries(w).reduce(function(O, y) {
          var x = Bw(y, 2), _ = x[0], P = x[1];
          return D(D({}, O), {}, ne({}, _, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var w = this.state.yAxisMap;
        return w ? Object.entries(w).reduce(function(O, y) {
          var x = Bw(y, 2), _ = x[0], P = x[1];
          return D(D({}, O), {}, ne({}, _, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(w) {
        var O;
        return (O = this.state.xAxisMap) === null || O === void 0 || (O = O[w]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(w) {
        var O;
        return (O = this.state.yAxisMap) === null || O === void 0 || (O = O[w]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(w) {
        var O = this.state, y = O.formattedGraphicalItems, x = O.activeItem;
        if (y && y.length)
          for (var _ = 0, P = y.length; _ < P; _++) {
            var E = y[_], M = E.props, C = E.item, T = C.type.defaultProps !== void 0 ? D(D({}, C.type.defaultProps), C.props) : C.props, k = Jt(C.type);
            if (k === "Bar") {
              var N = (M.data || []).find(function(W) {
                return I9(w, W);
              });
              if (N)
                return {
                  graphicalItem: E,
                  payload: N
                };
            } else if (k === "RadialBar") {
              var I = (M.data || []).find(function(W) {
                return q0(w, W);
              });
              if (I)
                return {
                  graphicalItem: E,
                  payload: I
                };
            } else if (Js(E, x) || Qs(E, x) || ga(E, x)) {
              var R = iq({
                graphicalItem: E,
                activeTooltipItem: x,
                itemData: T.data
              }), q = T.activeIndex === void 0 ? R : T.activeIndex;
              return {
                graphicalItem: D(D({}, E), {}, {
                  childIndex: q
                }),
                payload: ga(E, x) ? T.data[R] : E.props.data[R]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this;
        if (!Zy(this))
          return null;
        var O = this.props, y = O.children, x = O.className, _ = O.width, P = O.height, E = O.style, M = O.compact, C = O.title, T = O.desc, k = Fw(O, G8), N = Q(k, !1);
        if (M)
          return /* @__PURE__ */ S.createElement(bw, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ S.createElement(Md, gn({}, N, {
            width: _,
            height: P,
            title: C,
            desc: T
          }), this.renderClipPath(), Qy(y, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var I, R;
          N.tabIndex = (I = this.props.tabIndex) !== null && I !== void 0 ? I : 0, N.role = (R = this.props.role) !== null && R !== void 0 ? R : "application", N.onKeyDown = function(W) {
            w.accessibilityManager.keyboardEvent(W);
          }, N.onFocus = function() {
            w.accessibilityManager.focus();
          };
        }
        var q = this.parseEventsOfWrapper();
        return /* @__PURE__ */ S.createElement(bw, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ S.createElement("div", gn({
          className: ue("recharts-wrapper", x),
          style: D({
            position: "relative",
            cursor: "default",
            width: _,
            height: P
          }, E)
        }, q, {
          ref: function(H) {
            w.container = H;
          }
        }), /* @__PURE__ */ S.createElement(Md, gn({}, N, {
          width: _,
          height: P,
          title: C,
          desc: T,
          style: uz
        }), this.renderClipPath(), Qy(y, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Xw);
  ne(m, "displayName", r), ne(m, "defaultProps", D({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), ne(m, "getDerivedStateFromProps", function(h, g) {
    var b = h.dataKey, w = h.data, O = h.children, y = h.width, x = h.height, _ = h.layout, P = h.stackOffset, E = h.margin, M = g.dataStartIndex, C = g.dataEndIndex;
    if (g.updateId === void 0) {
      var T = Uw(h);
      return D(D(D({}, T), {}, {
        updateId: 0
      }, p(D(D({
        props: h
      }, T), {}, {
        updateId: 0
      }), g)), {}, {
        prevDataKey: b,
        prevData: w,
        prevWidth: y,
        prevHeight: x,
        prevLayout: _,
        prevStackOffset: P,
        prevMargin: E,
        prevChildren: O
      });
    }
    if (b !== g.prevDataKey || w !== g.prevData || y !== g.prevWidth || x !== g.prevHeight || _ !== g.prevLayout || P !== g.prevStackOffset || !wn(E, g.prevMargin)) {
      var k = Uw(h), N = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: g.chartX,
        chartY: g.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: g.isTooltipActive
      }, I = D(D({}, Ww(g, w, _)), {}, {
        updateId: g.updateId + 1
      }), R = D(D(D({}, k), N), I);
      return D(D(D({}, R), p(D({
        props: h
      }, R), g)), {}, {
        prevDataKey: b,
        prevData: w,
        prevWidth: y,
        prevHeight: x,
        prevLayout: _,
        prevStackOffset: P,
        prevMargin: E,
        prevChildren: O
      });
    }
    if (!Ed(O, g.prevChildren)) {
      var q, W, H, $, L = ot(O, zn), B = L && (q = (W = L.props) === null || W === void 0 ? void 0 : W.startIndex) !== null && q !== void 0 ? q : M, V = L && (H = ($ = L.props) === null || $ === void 0 ? void 0 : $.endIndex) !== null && H !== void 0 ? H : C, X = B !== M || V !== C, te = !se(w), re = te && !X ? g.updateId : g.updateId + 1;
      return D(D({
        updateId: re
      }, p(D(D({
        props: h
      }, g), {}, {
        updateId: re,
        dataStartIndex: B,
        dataEndIndex: V
      }), g)), {}, {
        prevChildren: O,
        dataStartIndex: B,
        dataEndIndex: V
      });
    }
    return null;
  }), ne(m, "renderActiveDot", function(h, g, b) {
    var w;
    return /* @__PURE__ */ Pt(h) ? w = /* @__PURE__ */ De(h, g) : ie(h) ? w = h(g) : w = /* @__PURE__ */ S.createElement(Ia, g), /* @__PURE__ */ S.createElement(le, {
      className: "recharts-active-dot",
      key: b
    }, w);
  });
  var v = /* @__PURE__ */ bs(function(g, b) {
    return /* @__PURE__ */ S.createElement(m, gn({}, g, {
      ref: b
    }));
  });
  return v.displayName = m.displayName, v;
}, HA = ou({
  chartName: "LineChart",
  GraphicalChild: fi,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: kt
  }, {
    axisType: "yAxis",
    AxisComp: $t
  }],
  formatAxisMap: ov
}), VA = ou({
  chartName: "BarChart",
  GraphicalChild: Ar,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: kt
  }, {
    axisType: "yAxis",
    AxisComp: $t
  }],
  formatAxisMap: ov
}), gz = ou({
  chartName: "PieChart",
  GraphicalChild: sr,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Zs
  }, {
    axisType: "radiusAxis",
    AxisComp: Ys
  }],
  formatAxisMap: F2,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), KA = ou({
  chartName: "AreaChart",
  GraphicalChild: ur,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: kt
  }, {
    axisType: "yAxis",
    AxisComp: $t
  }],
  formatAxisMap: ov
});
const bz = (e) => Number.isFinite(e) ? String(Math.round(e)) : "", di = (e) => e ? {
  allowDecimals: !1,
  tickFormatter: bz
} : {}, xz = "rgb(var(--color-muted) / 1)", yv = (e) => `rgb(var(--color-chart-${e % 5 + 1}) / 1)`, uW = [0, 1, 2, 3, 4].map(yv), Ra = yv(0), cW = ({
  data: e,
  className: t,
  height: r = 240,
  color: n = Ra,
  integerTicks: i = !0,
  compact: a = !1
}) => /* @__PURE__ */ A("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ A(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ J(
  VA,
  {
    data: e,
    margin: a ? { top: 0, right: 0, left: 0, bottom: 0 } : void 0,
    children: [
      a ? null : /* @__PURE__ */ A(sn, { strokeDasharray: "3 3", vertical: !1 }),
      a ? null : /* @__PURE__ */ A(kt, { dataKey: "label", tick: { fontSize: 11 } }),
      a ? null : /* @__PURE__ */ A(
        $t,
        {
          tick: { fontSize: 11 },
          width: 40,
          ...di(i)
        }
      ),
      a ? null : /* @__PURE__ */ A(Ve, {}),
      /* @__PURE__ */ A(Ar, { dataKey: "value", fill: n, radius: [4, 4, 0, 0] })
    ]
  }
) }) }), lW = ({
  data: e,
  className: t,
  height: r = 240,
  color: n = Ra,
  integerTicks: i = !0,
  compact: a = !1
}) => /* @__PURE__ */ A("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ A(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ J(
  HA,
  {
    data: e,
    margin: a ? { top: 0, right: 0, left: 0, bottom: 0 } : void 0,
    children: [
      a ? null : /* @__PURE__ */ A(sn, { strokeDasharray: "3 3", vertical: !1 }),
      a ? null : /* @__PURE__ */ A(kt, { dataKey: "label", tick: { fontSize: 11 } }),
      a ? null : /* @__PURE__ */ A(
        $t,
        {
          tick: { fontSize: 11 },
          width: 40,
          ...di(i)
        }
      ),
      a ? null : /* @__PURE__ */ A(Ve, {}),
      /* @__PURE__ */ A(
        fi,
        {
          type: "monotone",
          dataKey: "value",
          stroke: n,
          strokeWidth: 2,
          dot: !1
        }
      )
    ]
  }
) }) }), fW = ({
  data: e,
  className: t,
  height: r = 240,
  color: n = Ra,
  integerTicks: i = !0,
  compact: a = !1
}) => /* @__PURE__ */ A("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ A(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ J(
  KA,
  {
    data: e,
    margin: a ? { top: 0, right: 0, left: 0, bottom: 0 } : void 0,
    children: [
      a ? null : /* @__PURE__ */ A(sn, { strokeDasharray: "3 3", vertical: !1 }),
      a ? null : /* @__PURE__ */ A(kt, { dataKey: "label", tick: { fontSize: 11 } }),
      a ? null : /* @__PURE__ */ A(
        $t,
        {
          tick: { fontSize: 11 },
          width: 40,
          ...di(i)
        }
      ),
      a ? null : /* @__PURE__ */ A(Ve, {}),
      /* @__PURE__ */ A(
        ur,
        {
          type: "monotone",
          dataKey: "value",
          stroke: n,
          fill: n,
          fillOpacity: 0.2
        }
      )
    ]
  }
) }) }), dW = ({
  data: e,
  series: t,
  className: r,
  height: n = 260,
  integerTicks: i = !0
}) => /* @__PURE__ */ A("div", { className: z("w-full min-w-0", r), style: { height: n }, children: /* @__PURE__ */ A(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ J(VA, { data: e, margin: { top: 8, right: 8, left: 0, bottom: 0 }, children: [
  /* @__PURE__ */ A(sn, { strokeDasharray: "3 3", vertical: !1 }),
  /* @__PURE__ */ A(kt, { dataKey: "label", tick: { fontSize: 11 } }),
  /* @__PURE__ */ A(
    $t,
    {
      tick: { fontSize: 11 },
      width: 40,
      ...di(i)
    }
  ),
  /* @__PURE__ */ A(Ve, {}),
  t.map((a, o) => /* @__PURE__ */ A(
    Ar,
    {
      dataKey: a.key,
      name: a.label,
      stackId: "stack",
      fill: a.color,
      radius: o === t.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0]
    },
    a.key
  ))
] }) }) }), pW = ({
  data: e,
  series: t,
  className: r,
  height: n = 280,
  integerTicks: i = !0
}) => /* @__PURE__ */ A("div", { className: z("w-full min-w-0", r), style: { height: n }, children: /* @__PURE__ */ A(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ J(HA, { data: e, margin: { top: 8, right: 8, left: 0, bottom: 0 }, children: [
  /* @__PURE__ */ A(sn, { strokeDasharray: "3 3", vertical: !1 }),
  /* @__PURE__ */ A(kt, { dataKey: "label", tick: { fontSize: 11 } }),
  /* @__PURE__ */ A(
    $t,
    {
      tick: { fontSize: 11 },
      width: 40,
      ...di(i)
    }
  ),
  /* @__PURE__ */ A(Ve, {}),
  t.map((a) => /* @__PURE__ */ A(
    fi,
    {
      type: "monotone",
      dataKey: a.key,
      name: a.label,
      stroke: a.color,
      strokeWidth: 2,
      dot: !1
    },
    a.key
  ))
] }) }) }), hW = ({
  data: e,
  series: t,
  className: r,
  height: n = 280,
  integerTicks: i = !0
}) => /* @__PURE__ */ A("div", { className: z("w-full min-w-0", r), style: { height: n }, children: /* @__PURE__ */ A(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ J(KA, { data: e, margin: { top: 8, right: 8, left: 0, bottom: 0 }, children: [
  /* @__PURE__ */ A(sn, { strokeDasharray: "3 3", vertical: !1 }),
  /* @__PURE__ */ A(kt, { dataKey: "label", tick: { fontSize: 11 } }),
  /* @__PURE__ */ A(
    $t,
    {
      tick: { fontSize: 11 },
      width: 40,
      ...di(i)
    }
  ),
  /* @__PURE__ */ A(Ve, {}),
  t.map((a) => /* @__PURE__ */ A(
    ur,
    {
      type: "monotone",
      dataKey: a.key,
      name: a.label,
      stackId: "stack",
      stroke: a.color,
      fill: a.color,
      fillOpacity: 0.55,
      strokeWidth: 1.5
    },
    a.key
  ))
] }) }) }), vW = ({
  data: e,
  className: t,
  height: r = 240
}) => /* @__PURE__ */ A("div", { className: z("w-full min-w-0", t), style: { height: r }, children: /* @__PURE__ */ A(rn, { width: "100%", height: "100%", children: /* @__PURE__ */ J(gz, { children: [
  /* @__PURE__ */ A(
    sr,
    {
      data: e,
      dataKey: "value",
      nameKey: "label",
      innerRadius: "55%",
      outerRadius: "80%",
      children: e.map((n, i) => /* @__PURE__ */ A(
        Ds,
        {
          fill: n.color ?? yv(i)
        },
        n.label
      ))
    }
  ),
  /* @__PURE__ */ A(Ve, {})
] }) }) }), yW = ({
  data: e,
  className: t
}) => {
  const r = Math.max(1, ...e.map((a) => a.value)), n = Array.from(
    { length: 7 },
    (a, o) => Array.from({ length: 24 }, (s, u) => e.find((l) => l.dow === o && l.hour === u)?.value ?? 0)
  ), i = ["S", "M", "T", "W", "T", "F", "S"];
  return /* @__PURE__ */ A("div", { className: z("overflow-x-auto", t), children: /* @__PURE__ */ J("div", { className: "inline-grid grid-cols-[auto_repeat(24,minmax(0,1fr))] gap-0.5", children: [
    /* @__PURE__ */ A("div", {}),
    Array.from({ length: 24 }, (a, o) => /* @__PURE__ */ A(
      "div",
      {
        className: "text-muted-foreground text-center text-[10px]",
        children: o % 3 === 0 ? o : ""
      },
      o
    )),
    n.map((a, o) => /* @__PURE__ */ J(QA, { children: [
      /* @__PURE__ */ A("div", { className: "text-muted-foreground pr-1 text-right text-[10px] leading-4", children: i[o] }),
      a.map((s, u) => /* @__PURE__ */ A(
        "div",
        {
          title: `${i[o]} ${u}:00 — ${s}`,
          className: "h-4 w-4 rounded-sm",
          style: {
            backgroundColor: `color-mix(in srgb, ${Ra} ${Math.round(s / r * 100)}%, transparent)`
          }
        },
        `${o}-${u}`
      ))
    ] }, `row-${o}`))
  ] }) });
}, wz = (e, t) => {
  if (e <= 0) return xz;
  const r = Math.max(18, Math.round(e / t * 100));
  return `color-mix(in srgb, ${Ra} ${r}%, transparent)`;
}, mW = ({
  data: e,
  className: t
}) => {
  if (e.length === 0)
    return /* @__PURE__ */ A("p", { className: z("text-muted-foreground text-sm", t), children: "No data yet" });
  const r = Math.max(1, ...e.map((p) => p.value)), n = e[0].day, i = e[e.length - 1].day, a = new Map(e.map((p) => [p.day, p.value])), o = /* @__PURE__ */ new Date(`${n}T00:00:00.000Z`), s = /* @__PURE__ */ new Date(`${i}T00:00:00.000Z`), u = (o.getUTCDay() + 6) % 7;
  o.setUTCDate(o.getUTCDate() - u);
  const c = (s.getUTCDay() + 6) % 7;
  s.setUTCDate(s.getUTCDate() + (6 - c));
  const l = [];
  for (let p = new Date(o.getTime()); p.getTime() <= s.getTime(); p = new Date(p.getTime() + 864e5)) {
    const m = p.toISOString().slice(0, 10), v = m >= n && m <= i;
    l.push({
      day: v ? m : null,
      value: v ? a.get(m) ?? 0 : 0,
      inRange: v
    });
  }
  const f = [];
  for (let p = 0; p < l.length; p += 7)
    f.push(l.slice(p, p + 7));
  const d = ["M", "T", "W", "T", "F", "S", "S"];
  return /* @__PURE__ */ J("div", { className: z("w-full min-w-0", t), children: [
    /* @__PURE__ */ J("div", { className: "flex h-28 gap-1 sm:h-32", children: [
      /* @__PURE__ */ A("div", { className: "text-muted-foreground flex w-3 shrink-0 flex-col justify-between py-0.5 text-[9px] leading-none", children: d.map((p, m) => /* @__PURE__ */ A("span", { className: "flex flex-1 items-center", children: m % 2 === 0 ? p : "" }, `${p}-${m}`)) }),
      /* @__PURE__ */ A("div", { className: "flex min-w-0 flex-1 gap-[3px]", children: f.map((p, m) => /* @__PURE__ */ A("div", { className: "flex min-w-0 flex-1 flex-col gap-[3px]", children: p.map((v, h) => /* @__PURE__ */ A(
        "div",
        {
          title: v.day ? `${v.day} — ${v.value}` : void 0,
          className: z(
            "min-h-0 flex-1 rounded-[2px]",
            !v.inRange && "opacity-0"
          ),
          style: v.inRange ? { backgroundColor: wz(v.value, r) } : void 0
        },
        v.day ?? `pad-${m}-${h}`
      )) }, m)) })
    ] }),
    /* @__PURE__ */ J("div", { className: "text-muted-foreground mt-2 flex justify-between text-[10px]", children: [
      /* @__PURE__ */ A("span", { children: n }),
      /* @__PURE__ */ A("span", { children: i })
    ] })
  ] });
}, Hw = (e) => {
  const t = e.replaceAll("##", "#"), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  if (!r) return null;
  const [, n, i, a] = r;
  return { r: parseInt(n, 16), g: parseInt(i, 16), b: parseInt(a, 16) };
}, Oz = (e) => {
  const t = e.replaceAll("##", "#"), r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
  if (!r) return "(invalid)";
  const [, n, i, a] = r;
  return `${parseInt(n, 16)} ${parseInt(i, 16)} ${parseInt(a, 16)}`;
}, Vw = (e) => {
  const t = [e.r, e.g, e.b].map((r) => {
    const n = r / 255;
    return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  });
  return t[0] * 0.2126 + t[1] * 0.7152 + t[2] * 0.0722;
}, Kw = (e, t) => {
  const r = Vw(Hw(e)), n = Vw(Hw(t));
  return r > n ? (n + 0.05) / (r + 0.05) : (r + 0.05) / (n + 0.05);
}, _z = (e) => {
  const t = Kw(e, "#000000"), r = Kw(e, "#FFFFFF");
  return t < r ? "0 0 0" : "255 255 255";
}, YA = {
  id: "Inter",
  family: "Inter",
  cssFamily: "'Inter', system-ui, sans-serif"
}, Kp = [
  YA,
  {
    id: "Space Grotesk",
    family: "Space Grotesk",
    cssFamily: "'Space Grotesk', system-ui, sans-serif"
  },
  {
    id: "JetBrains Mono",
    family: "JetBrains Mono",
    cssFamily: "'JetBrains Mono', ui-monospace, monospace"
  },
  {
    id: "Playfair Display",
    family: "Playfair Display",
    cssFamily: "'Playfair Display', Georgia, serif"
  },
  {
    id: "Fraunces",
    family: "Fraunces",
    cssFamily: "'Fraunces', Georgia, serif"
  },
  {
    id: "Syne",
    family: "Syne",
    cssFamily: "'Syne', system-ui, sans-serif"
  },
  {
    id: "Fredoka",
    family: "Fredoka",
    cssFamily: "'Fredoka', system-ui, sans-serif"
  },
  {
    id: "Patrick Hand",
    family: "Patrick Hand",
    cssFamily: "'Patrick Hand', 'Comic Sans MS', cursive"
  },
  {
    id: "Baloo 2",
    family: "Baloo 2",
    cssFamily: "'Baloo 2', system-ui, sans-serif"
  },
  {
    id: "Amatic SC",
    family: "Amatic SC",
    cssFamily: "'Amatic SC', 'Comic Sans MS', cursive"
  }
], Sz = YA, so = (e) => e.trim().toLowerCase(), XA = (e) => {
  const t = e?.trim();
  if (!t) return;
  const r = so(t);
  return Kp.find(
    (n) => so(n.id) === r || so(n.family) === r
  ) ?? Kp.find((n) => r.includes(so(n.family)));
}, Az = (e) => XA(e) ?? Sz, Pz = (e) => {
  if (e?.trim())
    return XA(e)?.cssFamily ?? e.trim();
}, gW = ({
  value: e,
  onChange: t,
  className: r,
  id: n,
  "aria-label": i
}) => {
  const a = Az(e);
  return /* @__PURE__ */ A(
    "select",
    {
      id: n,
      "aria-label": i,
      className: r,
      value: a.id,
      style: { fontFamily: a.cssFamily },
      onChange: (o) => t(o.target.value),
      children: Kp.map((o) => /* @__PURE__ */ A(
        "option",
        {
          value: o.id,
          style: { fontFamily: o.cssFamily },
          children: o.family
        },
        o.id
      ))
    }
  );
}, Yw = (e, t) => {
  const r = Oz(t);
  if (r === "(invalid)") return "";
  const n = _z(t.startsWith("#") ? t : `#${t}`);
  return `--color-${e}: ${r};
	--color-${e}-foreground: ${n};
	`;
}, Tz = (e, t) => {
  const {
    primaryHex: r,
    secondaryHex: n,
    fontFamily: i,
    buttonRadius: a,
    radius: o,
    background: s = ""
  } = t, u = Pz(i), c = [
    Yw("primary", r),
    n ? Yw("secondary", n) : "",
    u ? `--theme-font-family-base: ${u};
	--theme-font-family-heading: ${u};
	` : "",
    a ? `--theme-rounded-base: ${a};
	` : "",
    o ? `--theme-rounded-container: ${o};
	` : ""
  ].join(""), l = s ? `background-image: url(${s});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;` : "";
  return `<style>
:root, [data-theme='${e}'] {
${c}
}
body {
  scrollbar-color: rgb(var(--color-primary) / 0.5) transparent;
  ${l}
}
</style>`;
}, bW = (e, t, r) => Tz(e, { primaryHex: t, background: r }), xW = (e) => {
  typeof document > "u" || document.body?.setAttribute("data-theme", e);
}, wW = (e) => {
  if (typeof document > "u" || typeof getComputedStyle != "function")
    return;
  const t = getComputedStyle(document.body || document.documentElement).getPropertyValue(e).trim();
  return t ? `rgb(${t})` : void 0;
};
export {
  uW as ANALYTICS_CHART_COLORS,
  HP as AlertDialog,
  h1 as AlertDialogAction,
  v1 as AlertDialogCancel,
  f1 as AlertDialogContent,
  p1 as AlertDialogDescription,
  xn as AlertDialogFooter,
  KP as AlertDialogHeader,
  Jp as AlertDialogOverlay,
  l1 as AlertDialogPortal,
  d1 as AlertDialogTitle,
  VP as AlertDialogTrigger,
  fW as AnalyticsAreaChart,
  cW as AnalyticsBarChart,
  mW as AnalyticsDayHeatmap,
  vW as AnalyticsDonutChart,
  yW as AnalyticsHeatmap,
  zT as AnalyticsInfoBadge,
  lW as AnalyticsLineChart,
  pW as AnalyticsMultiLineChart,
  hW as AnalyticsStackedAreaChart,
  dW as AnalyticsStackedBarChart,
  y1 as Avatar,
  g1 as AvatarFallback,
  m1 as AvatarImage,
  OT as Badge,
  Dz as Badges,
  Wz as Blur,
  Tt as Button,
  b1 as Card,
  _1 as CardContent,
  O1 as CardDescription,
  S1 as CardFooter,
  x1 as CardHeader,
  w1 as CardTitle,
  A1 as Checkbox,
  Sz as DEFAULT_THEME_FONT,
  sW as DateRangeFilter,
  lo as Dialog,
  XP as DialogActions,
  Sv as DialogClose,
  Wi as DialogContent,
  _d as DialogDescription,
  xn as DialogFooter,
  po as DialogHeader,
  zi as DialogOverlay,
  fo as DialogPortal,
  ho as DialogTitle,
  _v as DialogTrigger,
  eh as DropdownMenu,
  ws as DropdownMenuContent,
  P1 as DropdownMenuItem,
  T1 as DropdownMenuLabel,
  E1 as DropdownMenuSeparator,
  th as DropdownMenuTrigger,
  Fz as ExpandableBox,
  hT as Form,
  L1 as FormControl,
  q1 as FormDescription,
  vT as FormField,
  R1 as FormItem,
  D1 as FormLabel,
  B1 as FormMessage,
  Nz as IconButton,
  Gz as InfiniteScrollContainer,
  sh as Input,
  PT as Label,
  Hz as Link,
  NT as Loader,
  Vz as LoadingIcon,
  Os as LoadingSpinner,
  oW as MetricCard,
  Kz as Modal,
  xn as ModalFooter,
  Xz as ModalHeader,
  Yz as ModalWrapper,
  F1 as Popover,
  yT as PopoverAnchor,
  uh as PopoverContent,
  z1 as PopoverTrigger,
  Zz as PopupMenu,
  Qz as PopupMenuButton,
  eW as PopupSection,
  tW as PopupSeparator,
  W1 as RadioGroup,
  U1 as RadioGroupItem,
  zz as RadioSelect,
  G1 as ScrollArea,
  ch as ScrollBar,
  jv as ScrollObserver,
  rW as SearchAndFilterBar,
  mT as Select,
  V1 as SelectContent,
  bT as SelectGroup,
  K1 as SelectItem,
  H1 as SelectTrigger,
  gT as SelectValue,
  Y1 as Separator,
  YP as ShadcnBadge,
  oh as ShadcnLabel,
  lo as Sheet,
  Sv as SheetClose,
  Wi as SheetContent,
  _d as SheetDescription,
  xn as SheetFooter,
  po as SheetHeader,
  zi as SheetOverlay,
  fo as SheetPortal,
  ho as SheetTitle,
  _v as SheetTrigger,
  xT as Skeleton,
  Jz as SplitButtonMenu,
  Uz as SquareStop,
  qz as StopWatch,
  X1 as Switch,
  Kp as THEME_FONTS,
  nW as Table,
  Q1 as TableBody,
  rO as TableCell,
  tO as TableHead,
  J1 as TableHeader,
  Z1 as TableRoot,
  eO as TableRow,
  wT as Tabs,
  aO as TabsContent,
  nO as TabsList,
  iO as TabsTrigger,
  Iz as TextButton,
  oO as Textarea,
  gW as ThemeFontSelect,
  Bz as Timespan,
  iW as Toast,
  aW as Tooltip,
  lh as TooltipContent,
  sO as TooltipProvider,
  uO as TooltipRoot,
  cO as TooltipTrigger,
  Lz as UpdatingDate,
  $T as WaitForQueries,
  yv as analyticsChartColor,
  Tz as applyThemeOverrides,
  Qp as badgeVariants,
  Pa as buttonVariants,
  z as cn,
  _T as dateFormatter,
  $P as deepGet,
  jz as deepSet,
  XA as findThemeFont,
  _z as generateA11yOnColor,
  Vw as getLuminance,
  DT as getModalManager,
  NP as getUniqueBy,
  Hw as hexToRgb,
  Oz as hexToTailwindRgbString,
  Az as matchThemeFont,
  Kt as modalStore,
  kz as preventDefault,
  Rz as primitives,
  wW as readCssColorVar,
  Pz as resolveThemeFontCss,
  xW as setTheme,
  $z as stopPropagation,
  ST as stopWatchFormatter,
  bW as themeStyleString,
  Ta as useFormField,
  IP as useInfiniteScroll,
  LT as useModalManager
};
//# sourceMappingURL=index.js.map
